webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "test", function() { return test; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mounted", function() { return mounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginUser", function() { return loginUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logoutUser", function() { return logoutUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveUser", function() { return saveUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDays", function() { return getDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMeasurementsDays", function() { return getMeasurementsDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDaysByType", function() { return getDaysByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHoursByType", function() { return getHoursByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedDayHours", function() { return getSelectedDayHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSelectedHour", function() { return setSelectedHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSelectedDay", function() { return setSelectedDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSidebarVisible", function() { return setSidebarVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStatus", function() { return getStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startAll", function() { return startAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopAll", function() { return stopAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startWeather", function() { return startWeather; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopWeather", function() { return stopWeather; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startNoise", function() { return startNoise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopNoise", function() { return stopNoise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startAdio", function() { return startAdio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopAdio", function() { return stopAdio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNoise", function() { return setNoise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restartNoise", function() { return restartNoise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sdFormatNoise", function() { return sdFormatNoise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sdFreeNoise", function() { return sdFreeNoise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testOptions", function() { return testOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWeather", function() { return setWeather; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testEmail", function() { return testEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ftpTestConn", function() { return ftpTestConn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rebootSys", function() { return rebootSys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFirmware", function() { return getFirmware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSystemStatus", function() { return getSystemStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDailyData", function() { return getDailyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRealTimeData", function() { return getRealTimeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHourlyData", function() { return getHourlyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRecDay", function() { return getRecDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRecHour", function() { return getRecHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAudioDay", function() { return getAudioDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAudioHour", function() { return getAudioHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVideoDay", function() { return getVideoDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVideoHour", function() { return getVideoHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postFileAction", function() { return postFileAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFilesAction", function() { return getFilesAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSelectedInterval", function() { return setSelectedInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRealtimeEnabled", function() { return setRealtimeEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDownloading", function() { return setDownloading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDownloadingProgress", function() { return setDownloadingProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocalSettings", function() { return getLocalSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveLocalSettings", function() { return saveLocalSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUnsavedLocalSettings", function() { return createUnsavedLocalSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettings", function() { return getSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveSettings", function() { return saveSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startAudioStream", function() { return startAudioStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopAudioStream", function() { return stopAudioStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startAudioRecording", function() { return startAudioRecording; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopAudioRecording", function() { return stopAudioRecording; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "increaseVolume", function() { return increaseVolume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decreaseVolume", function() { return decreaseVolume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatVideoSD", function() { return formatVideoSD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVideo", function() { return setVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logsList", function() { return logsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLogs", function() { return getLogs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteOnInterval", function() { return deleteOnInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setScreenSize", function() { return setScreenSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateStatisticsSettings", function() { return updateStatisticsSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateStartstopSettings", function() { return updateStartstopSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMarkersDay", function() { return getMarkersDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMarkersHour", function() { return getMarkersHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMarker", function() { return setMarker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteMarker", function() { return deleteMarker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveMarkerNote", function() { return saveMarkerNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultMarkers", function() { return getDefaultMarkers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDailyNote", function() { return getDailyNote; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(32);



var test = function test(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;
};

var mounted = function mounted(_ref2) {
    var commit = _ref2.commit;

    commit('storeMounted');
};

var loginUser = function loginUser(_ref3, username, password) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* loginUser */](username, password).then(function (data) {
            commit('storeUser', { username: data.data.username, type: data.data.us_type });
            resolve({ username: data.data.username, type: data.data.us_type, token: data.header });
        }).catch(function () {
            reject();
        });
    });
};

var logoutUser = function logoutUser(_ref4) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["b" /* logoutUser */]().then(function () {
            commit('storeUser', {});
            resolve();
        }).catch(function (err) {
            return reject(err);
        });
    });
};

var getUser = function getUser(_ref5) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["c" /* getUser */]().then(function (data) {
            if (data.username) {
                commit('storeUser', { username: data.username, userType: data.us_type });
                return resolve();
            }
            return reject();
        });
    });
};

var saveUser = function saveUser(_ref6, user) {
    var commit = _ref6.commit;

    commit('storeUser', user);
};

var getDays = function getDays(_ref7) {
    var commit = _ref7.commit;

    var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var activeDays = {};
        __WEBPACK_IMPORTED_MODULE_1__api__["d" /* getNoiseDays */]().then(function (data) {
            data.data.forEach(function (day) {
                if (!activeDays[day]) activeDays[day] = {};
                activeDays[day].noise = true;
            });
            return activeDays;
        }).catch(function (err) {
            console.log(err);
            return activeDays;
        }).then(function (activeDays) {
            return __WEBPACK_IMPORTED_MODULE_1__api__["e" /* getAudioDays */]().then(function (data) {
                data.data.forEach(function (day) {
                    if (!activeDays[day]) activeDays[day] = {};
                    activeDays[day].audio = true;
                });
                return activeDays;
            });
        }).catch(function (err) {
            console.log(err);
            return activeDays;
        }).then(function (activeDays) {
            return __WEBPACK_IMPORTED_MODULE_1__api__["f" /* getWeatherDays */]().then(function (data) {
                data.data.forEach(function (day) {
                    if (!activeDays[day]) activeDays[day] = {};
                    activeDays[day].weather = true;
                });
                resolve(activeDays);
            });
        }).catch(function (err) {
            console.log(err);
            resolve(activeDays);
        });
    });
    promise.then(function (activeDays) {
        commit('storeDays', activeDays);
    });
};

var getMeasurementsDays = function getMeasurementsDays(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (state.calendarQuery > 0) return;
        state.calendarQuery = 1;
        __WEBPACK_IMPORTED_MODULE_1__api__["g" /* getMeasurementsDays */]().then(function (data) {
            var activeDays = {};
            var noise = data.data.noise;
            if (noise) {
                noise.forEach(function (day) {
                    if (!activeDays[day]) activeDays[day] = {};
                    activeDays[day].noise = true;
                });
            }
            var audio = data.data.audio;
            if (audio) {
                audio.forEach(function (day) {
                    if (!activeDays[day]) activeDays[day] = {};
                    activeDays[day].audio = true;
                });
            }
            var weather = data.data.weather;
            if (weather) {
                weather.forEach(function (day) {
                    if (!activeDays[day]) activeDays[day] = {};
                    activeDays[day].weather = true;
                });
            }
            var video = data.data.video;
            if (video) {
                video.forEach(function (day) {
                    if (!activeDays[day]) activeDays[day] = {};
                    activeDays[day].video = true;
                });
            }
            var adio = data.data.adio;
            if (adio) {
                adio.forEach(function (day) {
                    if (!activeDays[day]) activeDays[day] = {};
                    activeDays[day].adio = true;
                });
            }
            commit('storeDays', activeDays);
            resolve(activeDays);
        });
    });
};

var getDaysByType = function getDaysByType(_ref9, type) {
    var commit = _ref9.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["h" /* getDays */](type);
};

var getHoursByType = function getHoursByType(_ref10, type, selectedDay) {
    var commit = _ref10.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["i" /* getArchiveHours */](type, selectedDay);
};

var getSelectedDayHours = function getSelectedDayHours(_ref11, selectedDay) {
    var commit = _ref11.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["j" /* getMeasurementsHours */](selectedDay).then(function (data) {
            var activeHours = { values: [] };
            var noise = data.data.noise;
            if (noise) {
                noise.forEach(function (hour) {
                    if (!activeHours[hour]) {
                        activeHours[hour] = {};
                        activeHours.values.push(hour);
                    }
                    activeHours[hour].noise = true;
                });
            }
            var audio = data.data.audio;
            if (audio) {
                audio.forEach(function (hour) {
                    if (!activeHours[hour]) {
                        activeHours[hour] = {};
                        activeHours.values.push(hour);
                    }
                    activeHours[hour].audio = true;
                });
            }
            var weather = data.data.weather;
            if (weather) {
                weather.forEach(function (hour) {
                    if (!activeHours[hour]) {
                        activeHours[hour] = {};
                        activeHours.values.push(hour);
                    }
                    activeHours[hour].weather = true;
                });
            }
            var video = data.data.video;
            if (video) {
                video.forEach(function (hour) {
                    if (!activeHours[hour]) {
                        activeHours[hour] = {};
                        activeHours.values.push(hour);
                    }
                    activeHours[hour].video = true;
                });
            }
            var adio = data.data.adio;
            if (adio) {
                adio.forEach(function (hour) {
                    if (!activeHours[hour]) {
                        activeHours[hour] = {};
                        activeHours.values.push(hour);
                    }
                    activeHours[hour].adio = true;
                });
            }
            activeHours.values.sort();
            commit('storeSelectedDayHours', activeHours);
            resolve(activeHours);
        }).catch(function (err) {
            console.log(err);
            resolve({ headers: [], data: [] });
        });
    });
};
var setSelectedHour = function setSelectedHour(_ref12, hour) {
    var commit = _ref12.commit;
    var loading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return commit('storeSelectedHour', { hour: hour, loading: loading });
};
var setSelectedDay = function setSelectedDay(_ref13, day) {
    var commit = _ref13.commit;
    var loading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return commit('storeSelectedDay', { day: day, loading: loading });
};
var setSidebarVisible = function setSidebarVisible(_ref14, visible) {
    var commit = _ref14.commit;
    return commit('storeSidebarVisible', visible);
};

var getStatus = function getStatus(_ref15) {
    var commit = _ref15.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["k" /* getStatus */]().then(function (response) {
        commit('storeStatus', response.data);
    });
};

var startAll = function startAll(_ref16) {
    var commit = _ref16.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["l" /* startAll */]().then(function () {
        commit('storeWeatherStatus', true);
        commit('storeNoiseStatus', true);
    });
};

var stopAll = function stopAll(_ref17) {
    var commit = _ref17.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["m" /* stopAll */]().then(function () {
        commit('storeWeatherStatus', false);
        commit('storeNoiseStatus', false);
    });
};

var startWeather = function startWeather(_ref18) {
    var commit = _ref18.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["n" /* startWeather */]().then(function (_) {
        commit('storeWeatherStatus', true);
    });
};

var stopWeather = function stopWeather(_ref19) {
    var commit = _ref19.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["o" /* stopWeather */]().then(function (_) {
        commit('storeWeatherStatus', false);
    });
};

var startNoise = function startNoise(_ref20) {
    var commit = _ref20.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["p" /* startNoise */]().then(function (_) {
        commit('storeNoiseStatus', true);
    });
};

var stopNoise = function stopNoise(_ref21) {
    var commit = _ref21.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["q" /* stopNoise */]().then(function (_) {
        commit('storeNoiseStatus', false);
    });
};

var startAdio = function startAdio(_ref22) {
    var commit = _ref22.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["r" /* startAdio */]().then(function (_) {
        commit('storeAdioStatus', true);
    });
};

var stopAdio = function stopAdio(_ref23) {
    var commit = _ref23.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["s" /* stopAdio */]().then(function (_) {
        commit('storeAdioStatus', false);
    });
};
/* ADDED NEW STUFF */
/* ADDED NEW STUFF */
/* ADDED NEW STUFF */
/* ADDED NEW STUFF */
var setNoise = function setNoise(_ref24) {
    var commit = _ref24.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["t" /* setNoise */]();
};
var restartNoise = function restartNoise(_ref25) {
    var commit = _ref25.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["u" /* restartNoise */]();
};
var sdFormatNoise = function sdFormatNoise(_ref26) {
    var commit = _ref26.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["v" /* sdFormatNoise */]();
};
var sdFreeNoise = function sdFreeNoise(_ref27) {
    var commit = _ref27.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["w" /* sdFreeNoise */]();
};
var testOptions = function testOptions(_ref28) {
    var commit = _ref28.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["x" /* testOptions */]();
};

var setWeather = function setWeather(_ref29) {
    var commit = _ref29.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["y" /* setWeather */]();
};

var testEmail = function testEmail(_ref30, gr) {
    var commit = _ref30.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["z" /* testEmail */](gr);
};
var ftpTestConn = function ftpTestConn(_ref31, address, auth, user, pwd) {
    var commit = _ref31.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["A" /* ftpTestConn */](address, auth, user, pwd);
};

var rebootSys = function rebootSys(_ref32) {
    var commit = _ref32.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["B" /* rebootSys */]();
};

var getFirmware = function getFirmware(_ref33) {
    var commit = _ref33.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["C" /* getFirmWare */]().then(function (response) {
            commit('storeFirmware', response.data);
            resolve(response.data);
        });
    });
};
/* ----------- */
/* ----------- */
/* ----------- */
/* ----------- */
var getSystemStatus = function getSystemStatus(_ref34) {
    var commit = _ref34.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["D" /* getSystemStatus */]().then(function (response) {
            commit('storeSystemStatus', response.data);
        });
    });
};

var getDailyData = function getDailyData(_ref35) {
    var commit = _ref35.commit;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'noise';
    var selectedDay = arguments[2];
    var start = arguments[3];
    var end = arguments[4];

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["E" /* getDayData */](type, selectedDay, start, end).then(function (data) {
            resolve(data);
        }).catch(function (err) {
            console.log('Error getDailyData', err);
            reject(err);
        });
    });
};

var getRealTimeData = function getRealTimeData(_ref36) {
    var commit = _ref36.commit;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'noise';
    var count = arguments[2];

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["F" /* getRealTimeData */](type, count).then(function (data) {
            resolve(data);
        }).catch(function (err) {
            //console.log('Error getting real time data',err);
            resolve({ headers: [], data: [] });
        });
    });
};

/*export const getDailyData = ({commit}, selectedDay, start, end) =>{
    return new Promise(function(resolve, reject){
        api.getDayNoise(selectedDay, start, end)
        .then(data=>{
            resolve(data);
        })
        .catch(err=>{
            console.log("1",err);
            resolve({headers:[], data:[]});
        })
    })
}*/

var getHourlyData = function getHourlyData(_ref37) {
    var commit = _ref37.commit;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'noise';
    var selectedHour = arguments[2];
    var start = arguments[3];
    var end = arguments[4];

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["G" /* getData */](type, selectedHour, start, end).then(function (data) {
            resolve(data);
        }).catch(function (err) {
            reject(err);
        });
    });
};

/** AUDIO */
var getRecDay = function getRecDay(_ref38, date) {
    var commit = _ref38.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["H" /* getRecDay */](date);
};

var getRecHour = function getRecHour(_ref39, date) {
    var commit = _ref39.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["I" /* getRecHour */](date);
};

var getAudioDay = function getAudioDay(_ref40, date) {
    var commit = _ref40.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["J" /* getAudioDay */](date);
};

var getAudioHour = function getAudioHour(_ref41, date) {
    var commit = _ref41.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["K" /* getAudioHour */](date);
};

/* VIDEO */
var getVideoDay = function getVideoDay(_ref42, date) {
    var commit = _ref42.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["L" /* getVideoDay */](date);
};

var getVideoHour = function getVideoHour(_ref43, date) {
    var commit = _ref43.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["M" /* getVideoHour */](date);
};

/* DOWNLOAD */

var postFileAction = function postFileAction(_ref44, action, type, data) {
    var commit = _ref44.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["N" /* postFileAction */](action, type, data);
};

var getFilesAction = function getFilesAction(_ref45, type, data) {
    var commit = _ref45.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["O" /* getFilesAction */](type, data);
};

var setSelectedInterval = function setSelectedInterval(_ref46, start, end, source) {
    var commit = _ref46.commit;

    var selectedInterval = {
        start: start,
        end: end,
        source: source
    };
    commit('storeSelectedInterval', selectedInterval);
};

var setRealtimeEnabled = function setRealtimeEnabled(_ref47, enabled) {
    var commit = _ref47.commit;

    commit('storeRealtimeEnabled', enabled);
};

var setDownloading = function setDownloading(_ref48, isDownloading) {
    var commit = _ref48.commit;

    commit('storeDownloading', isDownloading);
};
var setDownloadingProgress = function setDownloadingProgress(_ref49, progress) {
    var commit = _ref49.commit;

    commit('storeDownloadingProgress', progress);
};

/*SETTINGS */
var getLocalSettings = function getLocalSettings(_ref50) {
    var commit = _ref50.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["P" /* getDefaultLocalSettings */]().then(function (settings) {
            //commit('storeLocalSettings',settings);
            resolve(settings);
        });
    });
};
var saveLocalSettings = function saveLocalSettings(_ref51, localStorage, settings) {
    var commit = _ref51.commit;

    commit('storeLocalSettings', { localStorage: localStorage, settings: settings });
};
var createUnsavedLocalSettings = function createUnsavedLocalSettings(_ref52) {
    var commit = _ref52.commit;

    commit('createUnsavedLocalSettings');
};

var getSettings = function getSettings(_ref53) {
    var commit = _ref53.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__api__["Q" /* getSettings */]().then(function (settings) {
            commit('storeSettings', settings);
            resolve(settings);
        });
    });
};

var saveSettings = function saveSettings(_ref54, settings) {
    var commit = _ref54.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["R" /* saveSettings */](settings);
};

var startAudioStream = function startAudioStream(_ref55) {
    var commit = _ref55.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["S" /* startAudioStream */]();
};

var stopAudioStream = function stopAudioStream(_ref56) {
    var commit = _ref56.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["T" /* stopAudioStream */]();
};

var startAudioRecording = function startAudioRecording(_ref57) {
    var commit = _ref57.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["U" /* startAudioRecording */]();
};

var stopAudioRecording = function stopAudioRecording(_ref58) {
    var commit = _ref58.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["V" /* stopAudioRecording */]();
};

var increaseVolume = function increaseVolume(_ref59) {
    var commit = _ref59.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["W" /* increaseVolume */]();
};

var decreaseVolume = function decreaseVolume(_ref60) {
    var commit = _ref60.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["X" /* decreaseVolume */]();
};

var formatVideoSD = function formatVideoSD(_ref61) {
    var commit = _ref61.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["Y" /* formatVideoSD */]();
};

var setVideo = function setVideo(_ref62) {
    var commit = _ref62.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["Z" /* setVideo */]();
};

var logsList = function logsList(_ref63) {
    var commit = _ref63.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["_0" /* logsList */]();
};

var getLogs = function getLogs(_ref64, type) {
    var commit = _ref64.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["_1" /* getLogs */](type);
};

var deleteOnInterval = function deleteOnInterval(_ref65, del_date) {
    var commit = _ref65.commit;


    var from = del_date.From;
    var to = del_date.To;
    var values = del_date.Values;
    from.setHours(12);
    to.setHours(12);
    return __WEBPACK_IMPORTED_MODULE_1__api__["_2" /* deleteOnInterval */](from, to, values);
};

var setScreenSize = function setScreenSize(_ref66, size) {
    var commit = _ref66.commit;

    commit('storeScreenSize', size);
};

var updateStatisticsSettings = function updateStatisticsSettings(_ref67, settings) {
    var commit = _ref67.commit;

    commit('updateStatisticsSettings', settings);
};

var updateStartstopSettings = function updateStartstopSettings(_ref68, settings) {
    var commit = _ref68.commit;

    commit('updateStartstopSettings', settings);
};

//MARKERS

var getMarkersDay = function getMarkersDay(_ref69, request) {
    var commit = _ref69.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["_3" /* getMarkersDay */](request.from);
};
var getMarkersHour = function getMarkersHour(_ref70, request) {
    var commit = _ref70.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["_4" /* getMarkersHour */](request.from);
};

var setMarker = function setMarker(_ref71, request) {
    var commit = _ref71.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["_5" /* setMarker */](request);
};

var deleteMarker = function deleteMarker(_ref72, request) {
    var commit = _ref72.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["_6" /* deleteMarker */](request);
};

var saveMarkerNote = function saveMarkerNote(_ref73, request) {
    var commit = _ref73.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["_7" /* setMarkerNote */](request);
};

var getDefaultMarkers = function getDefaultMarkers(_ref74) {
    var commit = _ref74.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["_8" /* getDefaultMarkers */]().then(function (response) {
        var data = response.data;

        var header = data.headers;
        if (header) {
            var _hID = header.indexOf('ID');
            var _hName = header.indexOf('Name');
            var _hColor = header.indexOf('Color');
            var _hType = header.indexOf('Type');
        } else {
            var _hID2 = 0;
            var _hName2 = 0;
            var _hColor2 = 0;
            var _hType2 = 0;
        }
        var markers = [];
        if (data.data) {
            data.data.forEach(function (m) {
                markers.push({
                    id: m[hID],
                    name: m[hName],
                    color: m[hColor],
                    type: m[hType]
                });
            });
        }

        return markers;
    });
};

var getDailyNote = function getDailyNote(_ref75, request) {
    var commit = _ref75.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["_9" /* getDailyNote */](request);
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(469),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = doubleDigit;
/* harmony export (immutable) */ __webpack_exports__["f"] = getUrlEncodedDateTime;
/* harmony export (immutable) */ __webpack_exports__["g"] = getUrlEncodedMeasurementHourFile;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUrlEncodedMeasurementDayFile;
/* harmony export (immutable) */ __webpack_exports__["d"] = addDays;
/* harmony export (immutable) */ __webpack_exports__["h"] = getWeekDays;
/* harmony export (immutable) */ __webpack_exports__["e"] = mutateLocalSettings;
/* harmony export (immutable) */ __webpack_exports__["b"] = demutateSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);



function doubleDigit(value) {
    if ((value + '').length == 2) {
        return value + '';
    } else {
        return '0' + value;
    }
}

function getUrlEncodedDateTime(date) {
    var output = date.getUTCFullYear() + '-' + doubleDigit(date.getUTCMonth() + 1) + '-' + doubleDigit(date.getUTCDate()) + ' ' + doubleDigit(date.getUTCHours()) + ':' + doubleDigit(date.getUTCMinutes()) + ':' + doubleDigit(date.getUTCSeconds());
    return output;
}

function getUrlEncodedMeasurementHourFile(date) {
    var output = date.getUTCFullYear() + '-' + doubleDigit(date.getUTCMonth() + 1) + '-' + doubleDigit(date.getUTCDate()) + '-' + doubleDigit(date.getUTCHours());
    return output;
}

function getUrlEncodedMeasurementDayFile(date) {
    var output = date.getUTCFullYear() + '-' + doubleDigit(date.getUTCMonth() + 1) + '-' + doubleDigit(date.getUTCDate()); //tule
    return output;
}

function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

function getWeekDays(day) {
    //var day = new Date();
    var weekDay = day.getDay();
    if (weekDay == 0) {
        weekDay = 7;
    }
    var days = [];
    for (var i = 0; i < 7; i++) {
        days.push(getUrlEncodedMeasurementDayFile(addDays(day, i + 1 - weekDay)));
    }
    return days;
}

/* SETTINGS */

function mutateLocalSettings(settings, screenSize) {
    //region interface
    settings.interface.syncgraphs = settings.interface.syncgraphs == 1 ? true : false;

    settings.interface.rtvaluesPicker = new Date(2017, 1, 1, 0, 0, settings.interface.rtvalues);

    settings.interface.RangNOtype = settings.interface.RangNOtype;
    settings.interface.RangNO = settings.interface.RangNO.split(',');

    settings.interface.RangSPtype = settings.interface.RangSPtype;
    settings.interface.RangSP = settings.interface.RangSP.split(',');

    settings.interface.RangWEtype = settings.interface.RangWEtype;
    settings.interface.RangWE = settings.interface.RangWE.split(',');

    settings.interface.RangADIOtype = settings.interface.RangADIOtype;
    settings.interface.RangADIO = settings.interface.RangADIO.split(',');

    settings.interface.noise = 1;
    settings.interface.adio = 1;
    settings.interface.statistics = 1;

    /*Mobile preload*/
    console.log('Screen size', screenSize);
    if (screenSize < 2) {
        settings.interface.preloadNoise = 1;
        settings.interface.preloadAdio = 1;
        settings.interface.preloadWeather = 1;
        settings.interface.preloadStatistics = 1;
        settings.interface.preloadSpectrum = 1;
    } else {
        settings.interface.preloadNoise = 0;
        settings.interface.preloadAdio = 0;
        settings.interface.preloadWeather = 0;
        settings.interface.preloadStatistics = 0;
        settings.interface.preloadSpectrum = 0;
    }

    settings.interface.colorsweath = settings.interface.colorsweath.split(',');
    settings.interface.colorsnoise = settings.interface.colorsnoise.split(',');
    settings.interface.colorsspecial = settings.interface.colorsspecial.split(',');
    var colorsnoiseCount = settings.interface.colorsnoise.length;
    if (colorsnoiseCount < 17) {
        for (var i = 0; i < 17 - colorsnoiseCount; i++) {
            settings.interface.colorsnoise.push(settings.interface.colorsnoise[i % colorsnoiseCount]);
        }
    }
    settings.interface.showNoiseTriggerLevel = true;
    settings.interface.showSpectrumTriggerLevel = true;
    //endregion 

    /*Statistics download */
    settings.download.statistics = {
        mapping: {}
    };

    settings.download.downlnoise = settings.download.downlnoise.split(',');
    var downlnoise = {};
    settings.download.downlnoise.forEach(function (item) {
        downlnoise[item] = true;
    });
    settings.download.downlnoise = downlnoise;

    settings.download.downlweath = settings.download.downlweath.split(',');
    var downlweath = {};
    settings.download.downlweath.forEach(function (item) {
        downlweath[item] = true;
    });
    settings.download.downlweath = downlweath;

    //settings.download.downlGlobal = settings.download.downlGlobal.split(',');
    var downlGlobal = {};
    //settings.download.downlGlobal.forEach(item=>{
    //    downlGlobal[item] = true;
    //})
    settings.download.downlGlobal = downlGlobal;

    settings.download.audio = false;
    if (settings.download.downlaudio == 1) {
        settings.download.audio = true;
    }
    settings.download.video = false;
    if (settings.download.downlvideo == 1) {
        settings.download.video = true;
    }
    settings.download.markers = false;
}

function demutateSettings(settings) {
    var settings = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(settings));

    demutateFTP(settings.ftp);
    demutateDevice(settings.device);
    demutateWeather(settings.weather);
    demutateAudio(settings.audio);
    demutateSystem(settings.system);
    demutateSpecval(settings.specval);
    demutateAlerts(settings.alerts);
    demutateVideo(settings.video);
    demutateStatistics(settings.statistics);
    demutateStartstop(settings.startstop);

    return settings;
}

function demutateFTP(s) {
    s.valall = s.valall.join(',');
    s.valsel = s.valsel.filter(function (val) {
        return val.enabled;
    }).map(function (val) {
        return val.name;
    }).join(',');
    delete s.oldValsel;
}

function demutateDevice(s) {
    var valsel = '';
    s.valall.forEach(function (val) {
        if (s.valsel.indexOf(val) > -1) {
            valsel += ',' + val;
        }
    });
    s.valall = s.valall.join(',');
    s.valsel = valsel.substring(1);
    delete s.valuesAll;
}

function demutateWeather(s) {
    if (s.valall.constructor !== Array) return;

    s.valall = s.valall.join(',');
    s.valsel = s.valsel.filter(function (val) {
        return val.enabled;
    }).map(function (val) {
        return val.name;
    }).join(',');
    switch (s.windsptrigtype) {
        case 0:
            {
                s.windsptrig = [-100, -100];break;
            }
        case 1:
            {
                s.windsptrig[1] = -100;break;
            }
        case 2:
            {
                s.windsptrig[0] = -100;break;
            }
    }
    s.windsptrig = s.windsptrig.join(',');

    switch (s.temptrigtype) {
        case 0:
            {
                s.temptrig = [-100, -100];break;
            }
        case 1:
            {
                s.temptrig[1] = -100;break;
            }
        case 2:
            {
                s.temptrig[0] = -100;break;
            }
    }
    s.temptrig = s.temptrig.join(',');

    switch (s.humidtrigtype) {
        case 0:
            {
                s.humidtrig = [-100, -100];break;
            }
        case 1:
            {
                s.humidtrig[1] = -100;break;
            }
        case 2:
            {
                s.humidtrig[0] = -100;break;
            }
    }
    s.humidtrig = s.humidtrig.join(',');

    switch (s.airprtrigtype) {
        case 0:
            {
                s.airprtrig = [-100, -100];break;
            }
        case 1:
            {
                s.airprtrig[1] = -100;break;
            }
        case 2:
            {
                s.airprtrig[0] = -100;break;
            }
    }
    s.airprtrig = s.airprtrig.join(',');

    switch (s.precipittrigtype) {
        case 0:
            {
                s.precipittrig = [-100, -100];break;
            }
        case 1:
            {
                s.precipittrig[1] = -100;break;
            }
        case 2:
            {
                s.precipittrig[0] = -100;break;
            }
    }
    s.precipittrig = s.precipittrig.join(',');

    if (s.device == 'NaN') {
        s.present = 0;
    } else {
        s.present = 1;
    }

    delete s.oldValsel;

    var rectimeTime = new Date(s.rectimePicker);
    s.rectime = rectimeTime.getHours() * 3600 + rectimeTime.getMinutes() * 60 + rectimeTime.getSeconds();
    delete s.rectimePicker;
}

//DEMUTATE AUDIO MAYBE DOES NOT WORK CORRECTLY FIX IT.
function demutateAudio(s) {
    switch (s.threshold1type) {
        case 0:
            {
                s.threshold1 = [-100, 140];s.time1 = '';s.time1stop = '';break;
            }
        case 1:
            {
                s.threshold1[1] = 140;break;
            }
        case 2:
            {
                s.threshold1[0] = -100;break;
            }
    }
    s.threshold1 = s.threshold1.join(',');

    switch (s.threshold2type) {
        case 0:
            {
                s.threshold2 = [-100, 140];s.time2 = '';s.time2stop = '';break;
            }
        case 1:
            {
                s.threshold2[1] = 140;break;
            }
        case 2:
            {
                s.threshold2[0] = -100;break;
            }
    }
    s.threshold2 = s.threshold2.join(',');
    s.time2 = s.time1stop;
    s.time2stop = s.time1;

    switch (s.threshold3type) {
        case 0:
            {
                s.threshold3 = [-100, 140];s.time3 = '';s.time3stop = '';break;
            }
        case 1:
            {
                s.threshold3[1] = 140;break;
            }
        case 2:
            {
                s.threshold3[0] = -100;break;
            }
    }
    s.threshold3 = s.threshold3.join(',');

    switch (s.threshold4type) {
        case 0:
            {
                s.threshold4 = [-100, 140];s.time4 = '';s.time4stop = '';break;
            }
        case 1:
            {
                s.threshold4[1] = 140;break;
            }
        case 2:
            {
                s.threshold4[0] = -100;break;
            }
    }
    s.threshold4 = s.threshold4.join(',');

    var duration1Time = new Date(s.duration1Picker);
    s.duration1 = duration1Time.getHours() * 3600 + duration1Time.getMinutes() * 60 + duration1Time.getSeconds();
    delete s.duration1Picker;

    var duration2Time = new Date(s.duration2Picker);
    s.duration2 = duration2Time.getHours() * 3600 + duration2Time.getMinutes() * 60 + duration2Time.getSeconds();
    delete s.duration2Picker;

    var duration3Time = new Date(s.duration3Picker);
    s.duration3 = duration3Time.getHours() * 3600 + duration3Time.getMinutes() * 60 + duration3Time.getSeconds();
    delete s.duration3Picker;

    var duration4Time = new Date(s.duration4Picker);
    s.duration4 = duration4Time.getHours() * 3600 + duration4Time.getMinutes() * 60 + duration4Time.getSeconds();
    delete s.duration4Picker;
}

function demutateSystem(s) {
    s.delvalall = s.delvalall.join(',');
    s.delvalsel = s.delvalsel.filter(function (val) {
        return val.enabled;
    }).map(function (val) {
        return val.name;
    }).join(',');
    delete s.delvalselOld;
}

function demutateSpecval(s) {
    s.valallsp = s.valallsp.join(',');
    s.valselsp = s.valselsp.filter(function (val) {
        return val.enabled;
    }).map(function (val) {
        return val.name;
    }).join(',');
    s.global = s.global.join(',');

    switch (s.mavalltype) {
        case 0:
            {
                s.mavallevel = [-100, -100];break;
            }
        case 1:
            {
                s.mavallevel[1] = -100;break;
            }
        case 2:
            {
                s.mavallevel[0] = -100;break;
            }
    }
    s.mavallevel = s.mavallevel.join(',');

    delete s.oldvalselsp;

    var mavaldurationTime = new Date(s.mavaldurationPicker);
    s.mavalduration = mavaldurationTime.getHours() * 3600 + mavaldurationTime.getMinutes() * 60 + mavaldurationTime.getSeconds();
    delete s.mavaldurationPicker;
}

function demutateAlerts(s) {
    s.groups.forEach(function (g) {
        var id = g.replace('gr', '');

        s['recpg' + id] = s['recpg' + id].join(',');

        var alg = [];
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(s['alg' + id]).forEach(function (k) {
            if (s['alg' + id][k]) {
                alg.push(k);
            }
        });
        s['alg' + id] = alg.join(',');

        s['leqdg' + id] = s['leqdg' + id].join(',');
        delete s['del' + id];

        s['repg' + id] = s['repg' + id].join(',');

        s['lqtg' + id] = s['lqtg' + id].join(',');

        //s['recpg'+id] = s['recpg'+id].join(',');
    });
    s.groups = s.groups.join(',');
}

function demutateVideo(s) {}

function demutateStatistics(s) {
    if (!s) return;
    s.groups = s.allgroups.join(',');

    s.allgroups.forEach(function (g) {
        var id = g.replace('st', '');
        s['dayss' + id] = s['dayss' + id].join(',');
        s['ranges' + id] = s['ranges' + id].join(',');
    });

    delete s.allgroups;
}

function demutateStartstop(s) {

    s.groups.forEach(function (g) {
        s['days' + g] = s['days' + g].join(',');
        s['types' + g] = s['types' + g].join(',');
        s['enable' + g] = s['enable' + g] ? '1' : '0';
    });

    s.groups = s.groups.join(',');
}

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loginUser;
/* harmony export (immutable) */ __webpack_exports__["b"] = logoutUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUser;
/* unused harmony export getRealTimeNoise */
/* unused harmony export getRealTimeWeather */
/* unused harmony export getRealTimeSpectrum */
/* harmony export (immutable) */ __webpack_exports__["F"] = getRealTimeData;
/* unused harmony export getNoise */
/* unused harmony export getSpectrum */
/* unused harmony export getWeather */
/* harmony export (immutable) */ __webpack_exports__["G"] = getData;
/* unused harmony export getDayNoise */
/* unused harmony export getDayWeather */
/* harmony export (immutable) */ __webpack_exports__["E"] = getDayData;
/* harmony export (immutable) */ __webpack_exports__["d"] = getNoiseDays;
/* harmony export (immutable) */ __webpack_exports__["f"] = getWeatherDays;
/* harmony export (immutable) */ __webpack_exports__["e"] = getAudioDays;
/* harmony export (immutable) */ __webpack_exports__["g"] = getMeasurementsDays;
/* harmony export (immutable) */ __webpack_exports__["h"] = getDays;
/* unused harmony export getNoiseHours */
/* unused harmony export getWeatherHours */
/* unused harmony export getAudioHours */
/* harmony export (immutable) */ __webpack_exports__["j"] = getMeasurementsHours;
/* unused harmony export getHours */
/* harmony export (immutable) */ __webpack_exports__["i"] = getArchiveHours;
/* harmony export (immutable) */ __webpack_exports__["H"] = getRecDay;
/* harmony export (immutable) */ __webpack_exports__["I"] = getRecHour;
/* harmony export (immutable) */ __webpack_exports__["J"] = getAudioDay;
/* harmony export (immutable) */ __webpack_exports__["K"] = getAudioHour;
/* unused harmony export getAudioFile */
/* unused harmony export getAudio */
/* harmony export (immutable) */ __webpack_exports__["y"] = setWeather;
/* harmony export (immutable) */ __webpack_exports__["C"] = getFirmWare;
/* harmony export (immutable) */ __webpack_exports__["t"] = setNoise;
/* harmony export (immutable) */ __webpack_exports__["u"] = restartNoise;
/* harmony export (immutable) */ __webpack_exports__["v"] = sdFormatNoise;
/* harmony export (immutable) */ __webpack_exports__["w"] = sdFreeNoise;
/* harmony export (immutable) */ __webpack_exports__["x"] = testOptions;
/* harmony export (immutable) */ __webpack_exports__["z"] = testEmail;
/* harmony export (immutable) */ __webpack_exports__["A"] = ftpTestConn;
/* harmony export (immutable) */ __webpack_exports__["B"] = rebootSys;
/* harmony export (immutable) */ __webpack_exports__["L"] = getVideoDay;
/* harmony export (immutable) */ __webpack_exports__["M"] = getVideoHour;
/* unused harmony export getVideo */
/* harmony export (immutable) */ __webpack_exports__["N"] = postFileAction;
/* harmony export (immutable) */ __webpack_exports__["O"] = getFilesAction;
/* harmony export (immutable) */ __webpack_exports__["_10"] = getFileAction;
/* harmony export (immutable) */ __webpack_exports__["k"] = getStatus;
/* harmony export (immutable) */ __webpack_exports__["p"] = startNoise;
/* harmony export (immutable) */ __webpack_exports__["q"] = stopNoise;
/* harmony export (immutable) */ __webpack_exports__["r"] = startAdio;
/* harmony export (immutable) */ __webpack_exports__["s"] = stopAdio;
/* harmony export (immutable) */ __webpack_exports__["l"] = startAll;
/* harmony export (immutable) */ __webpack_exports__["m"] = stopAll;
/* harmony export (immutable) */ __webpack_exports__["n"] = startWeather;
/* harmony export (immutable) */ __webpack_exports__["o"] = stopWeather;
/* harmony export (immutable) */ __webpack_exports__["D"] = getSystemStatus;
/* harmony export (immutable) */ __webpack_exports__["P"] = getDefaultLocalSettings;
/* harmony export (immutable) */ __webpack_exports__["Q"] = getSettings;
/* harmony export (immutable) */ __webpack_exports__["R"] = saveSettings;
/* harmony export (immutable) */ __webpack_exports__["W"] = increaseVolume;
/* harmony export (immutable) */ __webpack_exports__["X"] = decreaseVolume;
/* harmony export (immutable) */ __webpack_exports__["S"] = startAudioStream;
/* harmony export (immutable) */ __webpack_exports__["T"] = stopAudioStream;
/* harmony export (immutable) */ __webpack_exports__["U"] = startAudioRecording;
/* harmony export (immutable) */ __webpack_exports__["V"] = stopAudioRecording;
/* harmony export (immutable) */ __webpack_exports__["Y"] = formatVideoSD;
/* harmony export (immutable) */ __webpack_exports__["Z"] = setVideo;
/* harmony export (immutable) */ __webpack_exports__["_0"] = logsList;
/* harmony export (immutable) */ __webpack_exports__["_1"] = getLogs;
/* harmony export (immutable) */ __webpack_exports__["_2"] = deleteOnInterval;
/* harmony export (immutable) */ __webpack_exports__["_3"] = getMarkersDay;
/* harmony export (immutable) */ __webpack_exports__["_4"] = getMarkersHour;
/* harmony export (immutable) */ __webpack_exports__["_5"] = setMarker;
/* harmony export (immutable) */ __webpack_exports__["_6"] = deleteMarker;
/* harmony export (immutable) */ __webpack_exports__["_7"] = setMarkerNote;
/* harmony export (immutable) */ __webpack_exports__["_9"] = getDailyNote;
/* harmony export (immutable) */ __webpack_exports__["_8"] = getDefaultMarkers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(16);






__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

function loginUser(username, password) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        //http://localhost:8080/api/login
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/login', __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify({ username: username, password: password, login: "1" })).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            reject(err);
        });

        /*
        if(username == 'admin' && password == 'admin123'){
            return resolve({
                username:'admin',
                type:3
            });
        }
        return reject();
        */
    });
}

function logoutUser() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/login?logout=1').then(function (response) {
            resolve();
        }).catch(function (err) {
            return reject(err);
        });
    });
}

function getUser() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-users' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //reject(err);
        });
    });
}

/* REAL TIME DATA */
function getRealTimeNoise() {
    return getRealTimeData('noise');
}

function getRealTimeWeather() {
    return getRealTimeData('weath');
}

function getRealTimeSpectrum() {
    return getRealTimeData('spect');
}

function getRealTimeData(type, count) {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-rt-' + type + '&val=' + count + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
        //return Promise.reject({message:'errorConnecting', err:err});
    }).then(handleApiResponse);
}

/* DATA */
function getNoise(measurementTime, startTime, stopTime) {
    return getData('noise', measurementTime, startTime, stopTime);
}

function getSpectrum(measurementTime, startTime, stopTime) {
    return getData('spect', measurementTime, startTime, stopTime);
}

function getWeather(measurementTime, startTime, stopTime) {
    return getData('weath', measurementTime, startTime, stopTime);
}

function getData(type, measurementTime, startTime, stopTime) {
    //http://89.212.28.252:8888/api/get-noise&measurement=2017-07-26-14&start=2017-07-26 14:10:22&stop=2017-07-26 14:20:00
    var date = getUrlEncodedMeasurementHourFile(measurementTime);
    var startValue = startTime ? getUrlEncodedDateTime(startTime) : undefined;
    var stopValue = stopTime ? getUrlEncodedDateTime(stopTime) : undefined;

    var token = getToken();

    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(('/api/get-' + type + '&measurement=' + date + '&start=' + startValue + '&stop=' + stopValue).replace(/ /g, '_') + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

/* Day Data */

function getDayNoise(measurementTime, startTime, stopTime) {

    return getDayData('noise', measurementTime, startTime, stopTime);
}

function getDayWeather(measurementTime, startTime, stopTime) {
    return getDayData('weath', measurementTime, startTime, stopTime);
}

function getDayData(type, measurementTime, startTime, stopTime) {
    var date = getUrlEncodedMeasurementDayFile(measurementTime);
    var startValue = startTime ? getUrlEncodedDateTime(startTime) : undefined;
    var stopValue = stopTime ? getUrlEncodedDateTime(stopTime) : undefined;

    var token = getToken();

    if (type == 'statistics') {
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(('/api/get-' + type + '&measurement=' + date).replace(/ /g, '_') + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
        }).then(handleApiResponse);
    } else {
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(('/api/get-day-' + type + '&measurement=' + date + '&start=' + startValue + '&stop=' + stopValue).replace(/ /g, '_') + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
        }).then(handleApiResponse);
    }
}

/* DAYS LIST */
function getNoiseDays() {
    return getDays('noise');
}

function getWeatherDays() {
    return getDays('weather');
}

function getAudioDays() {
    return getDays('audio');
}

function getMeasurementsDays() {
    return getDays('measurements');
}

function getDays(type) {
    //http://localhost:8080/api/get-days&type=noise
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-days&type=' + type + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

/* DAY HOURS LIST */
function getNoiseHours(date) {
    return getHours('noise', date);
}

function getWeatherHours(date) {
    return getHours('weather', date);
}

function getAudioHours(date) {
    return getHours('audio', date);
}

function getMeasurementsHours(date) {
    return getHours('measurements', date);
}

function getHours(type, date) {
    var dateValue = getUrlEncodedMeasurementDayFile(date);
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-day-list&day=' + dateValue + '&type=' + type + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}
function getArchiveHours(type, date) {
    var dateValue = getUrlEncodedMeasurementDayFile(date);
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/file-list&date=' + dateValue + '&type=' + type + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

/* AUDIO */
function getRecDay(date) {
    var dateValue = getUrlEncodedMeasurementDayFile(date);
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-rec-day&date=' + dateValue + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

function getRecHour(date) {
    var dateValue = getUrlEncodedMeasurementHourFile(date);
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-rec-hour&date=' + dateValue + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

function getAudioDay(date) {
    //api/get-audio-day&date=2017-07-26
    var dateValue = getUrlEncodedMeasurementDayFile(date);
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-rec-day&date=' + dateValue + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

function getAudioHour(date) {
    var dateValue = getUrlEncodedMeasurementHourFile(date);
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-audio-hour&date=' + dateValue + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

function getAudioFile(file) {
    return getAudio(file);
}

function getAudio(dateValue) {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-audio-day&date=' + dateValue + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}
/* NEW API CALLS*/
function setWeather() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/set-weather' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //return Promise.reject({message:'errorConnecting', err:err})
        });
    });
}

function getFirmWare() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/firmware' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
        });
    });
}

function setNoise() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/set-noise' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //return Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

function restartNoise() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/restart-noise' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

function sdFormatNoise() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/sdformat-noise' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //return Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

function sdFreeNoise() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/sdfree-noise' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //reject({message:'errorConnecting', err:err});
        });
    });
}

function testOptions() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/options-noise' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //reject({message:'errorConnecting', err:err});
        });
    });
}

function testEmail(group) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/test-email&group=' + group + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //reject({message:'errorConnecting', err:err});
        });
    });
}

function ftpTestConn(address, auth, user, pwd) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/ftpTest&address=' + address + '&auth=' + auth + '&user=' + user + '&pwd=' + pwd + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //reject({message:'errorConnecting', err:err});
        });
    });
}

function rebootSys() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/reboot' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //return Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

/* ----------- */
/* ----------- */
/* ----------- */
/* ----------- */
/* ----------- */

/* VIDEO */
function getVideoDay(date) {
    var dateValue = getUrlEncodedMeasurementDayFile(date);

    return getVideo(dateValue);
}

function getVideoHour(date) {
    var dateValue = getUrlEncodedMeasurementHourFile(date);
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-rec-hour&date=' + dateValue + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

function getVideo(dateValue) {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-rec-day&date=' + dateValue + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}
/**Download */

function postFileAction(action, type, data) {
    //api/file-action&action=download&data=noise
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/file-action&action=' + action + '&data=' + type + '&time=' + Date.now(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Token': token } }).then(function (data) {
        return data.data;
    }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
        //return Promise.reject({message:'errorConnecting', err:err});
    });
}

function getFilesAction(type, data) {
    ///api/file-action&&action=download&type="+ this.type +"&files="+ newHour;
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/file-action&action=download&type=' + type + '&file=' + data + '&time=' + Date.now(), { headers: { 'Token': token } });
}

function getFileAction(url) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
    var postData = arguments[2];
    var downloadProgress = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();

        __WEBPACK_IMPORTED_MODULE_2_axios___default()({
            url: url,
            method: method,
            responseType: 'blob', // important
            headers: {
                'Token': token
            },
            data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
            onDownloadProgress: downloadProgress
        }).then(function (response) {
            if (response.headers['content-type'].includes("application/json")) {
                resolve();
            } else {
                var filename = response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '');
                var _url = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = _url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                resolve();
            }
        });
    });
}

/* STATUS & START/STOP */
function getStatus() {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/status' + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
        //return Promise.reject({message:'errorConnecting', err:err});
    }).then(handleApiResponse);
}

/*export function startMeasuring(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/start', {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve()
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    });
}

export function stopMeasuring(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axiso.get('/api/stop', {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve();
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    });
}*/

function startNoise() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/start-noise' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            switch (response.data.error) {
                case 111:
                    return resolve();
                case 110:
                    return reject();
            }
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

function stopNoise() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/stop-noise' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            switch (response.data.error) {
                case 111:
                    return resolve();
                case 110:
                    return reject();
            }
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

function startAdio() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/start-adio' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            switch (response.data.error) {
                case 111:
                    return resolve();
                case 110:
                    return reject();
            }
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

function stopAdio() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/stop-adio' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            switch (response.data.error) {
                case 111:
                    return resolve();
                case 110:
                    return reject();
            }
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            // Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

function startAll() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/start' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            switch (response.data.error) {
                case 111:
                    return resolve();
                case 110:
                    return reject();
            }
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

function stopAll() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/stop' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            switch (response.data.error) {
                case 111:
                    return resolve();
                case 110:
                    return reject();
            }
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

function startWeather() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/start-weath' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            switch (response.data.error) {
                case 111:
                    return resolve();
                case 110:
                    return reject();
            }
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

function stopWeather() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/stop-weath' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            switch (response.data.error) {
                case 111:
                    return resolve();
                case 110:
                    return reject();
            }
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //Promise.reject({message:'errorConnecting', err:err});
        });
    });
}

function getSystemStatus() {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/machine_stats' + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
    //return Promise.reject({message:'errorConnecting', where:'/api/machine_stats', err:err});
}

/* SETTINGS */
function getDefaultLocalSettings() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/default-local' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
        });
    });
}

function getSettings() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/settings&action=get' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
        });
    });
}

function saveSettings(settings) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        //debugger;
        //if(true){
        //    return resolve();
        //}
        var token = getToken();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/settings?action=save' + '&time=' + Date.now(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(settings), { headers: { 'Token': token } }).then(function (response) {
            resolve();
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //reject(err);
        });
    });
}

function increaseVolume() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/inc-volume' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //reject(err);
        });
    });
}

function decreaseVolume() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/dec-volume' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //reject(err);
        });
    });
}

/*STREAM */
function startAudioStream() {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/start_audioStream' + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

function stopAudioStream() {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/stop_audioStream' + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

function startAudioRecording() {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/start-audioMan' + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

function stopAudioRecording() {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/stop-audioMan' + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    }).then(handleApiResponse);
}

/* VIDEO */
function formatVideoSD() {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/sdformat-video' + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    });
}

function setVideo() {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/set-video' + '&time=' + Date.now(), { headers: { 'Token': token } }).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    });
}

function logsList() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/logs-list' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            // reject(err)
        });
    });
}

function getLogs(type) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var token = getToken();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/logs-cont&file=' + type + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //reject(err)
        });
    });
}

function deleteOnInterval(from, to, values) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        from = getUrlEncodedMeasurementDayFile(from);
        to = getUrlEncodedMeasurementDayFile(to);
        var token = getToken();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/delete-manual&from=' + from + '&to=' + to + '&valsel=' + values + '&time=' + Date.now(), { headers: { 'Token': token } }).then(function (response) {
            resolve(response.data);
        }).catch(function (err) {
            if (err.request.status == 401) {
                if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
            }
            //reject(err)
        });
    });
}

/* MARKERS */

function getMarkersDay(date) {
    var dateValue = getUrlEncodedMeasurementDayFile(date);
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-markers&from=' + dateValue + '&time=' + Date.now(), { headers: { 'Token': token } }).then(handleApiResponse).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    });
}

function getMarkersHour(date) {
    var dateValue = getUrlEncodedMeasurementHourFile(date);
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-markers&from=' + dateValue + '&time=' + Date.now(), { headers: { 'Token': token } }).then(handleApiResponse).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    });
}

function setMarker(data) {
    var fromDate = new Date(data.from);

    var marker = {
        ID: data.id,
        Name: data.name,
        Color: data.color,
        Note: data.note,
        Type: data.type ? 'Toggle' : 'Single',
        DateTimeStart: getUrlEncodedDateTime(new Date(data.from)),
        DateTimeStop: getUrlEncodedDateTime(new Date(data.to)),
        Notes: data.notes ? data.notes : ''
    };
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/set-markers&action=set-markers' + '&time=' + Date.now(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(marker));
}

function deleteMarker(data) {
    var id = data.id;
    var date = getUrlEncodedMeasurementDayFile(new Date(data.from));

    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/delete-markers&id=' + id + '&date=' + date + '&time=' + Date.now());
}

function setMarkerNote(data) {
    var date = getUrlEncodedMeasurementDayFile(new Date(data.date));

    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/update-markers' + '&time=' + Date.now(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        id: data.id,
        notes: data.note,
        date: date
    }));
}

function getDailyNote(date) {
    var dateValue = getUrlEncodedMeasurementDayFile(date);
    var token = getToken();

    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/get-markers-day&from=' + dateValue + '&time=' + Date.now(), { headers: { 'Token': token } }).then(handleApiResponse).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    });
}

function getDefaultMarkers() {
    var token = getToken();
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/default-markers' + '&time=' + Date.now(), { headers: { 'Token': token } }).then(handleApiResponse).catch(function (err) {
        if (err.request.status == 401) {
            if (window.location.href.indexOf('/login') == -1) window.location.href = '/login';
        }
    });
}

function makePostReady(object) {
    var sentence = "";
    for (var key in object) {
        var sentenceAdd = key + '=' + object[key] + '&';
        sentence = sentence + sentenceAdd;
    }
    //console.log( 'sentence: ' + sentence );
    return sentence;
}

function handleApiResponse(response) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (response.data) {
            if (typeof response.data === 'string' || response.data instanceof String) try {
                response.data = JSON.parse(response.data);
            } catch (err) {}
            //if(Math.random()*10 < 3)
            //    response.data.error = 102;

            switch (response.data.error) {
                //TODO- other errors
                case 101:
                    {
                        if (response.data.threshold) {
                            var threshold = { name: response.data.thr_header, value: response.data.threshold.split(',') };
                            return resolve({ headers: response.data.headers, data: response.data.data, threshold: threshold });
                        }
                        return resolve({ headers: response.data.headers, data: response.data.data });
                    }
                case 102:
                    {
                        return reject({ error: 'noData' });
                    }
            }
        }
        return reject({ message: 'errorNoData', err: '' });
    });
}

function getUrlEncodedDateTime(date) {
    var output = date.getUTCFullYear() + '-' + __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* doubleDigit */](date.getUTCMonth() + 1) + '-' + __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* doubleDigit */](date.getUTCDate()) + ' ' + __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* doubleDigit */](date.getUTCHours()) + ':' + __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* doubleDigit */](date.getUTCMinutes()) + ':' + __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* doubleDigit */](date.getUTCSeconds());
    return output;
}

function getUrlEncodedMeasurementHourFile(date) {
    var output = date.getUTCFullYear() + '-' + __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* doubleDigit */](date.getUTCMonth() + 1) + '-' + __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* doubleDigit */](date.getUTCDate()) + '-' + __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* doubleDigit */](date.getUTCHours());
    return output;
}

function getUrlEncodedMeasurementDayFile(date) {

    var output = date.getUTCFullYear() + '-' + __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* doubleDigit */](date.getUTCMonth() + 1) + '-' + __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* doubleDigit */](date.getUTCDate());
    return output;
}

function getToken() {
    var token = localStorage.getItem('token');
    return token;
}

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(470),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(477),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translations__ = __webpack_require__(261);



var Localization = {
  store: undefined,
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install: function install(Vue, options) {
    Vue.prototype.elementUILang = options.locale;
    Vue.prototype.elementUILangEN = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.EN));
    Vue.prototype.elementUILangAT = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.AT));
    Vue.prototype.elementUILangDE = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.DE));
    Vue.prototype.elementUILangFR = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.FR));
    Vue.prototype.elementUILangSL = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.SL));

    Vue.prototype.$switch = function (lang) {
      if (lang == 'en') {
        this.elementUILang.el.datepicker = this.elementUILangEN.el.datepicker;
      } else if (lang == 'at') {
        this.elementUILang.el.datepicker = this.elementUILangDE.el.datepicker;
      } else if (lang == 'de') {
        this.elementUILang.el.datepicker = this.elementUILangDE.el.datepicker;
      } else if (lang == 'fr') {
        this.elementUILang.el.datepicker = this.elementUILangFR.el.datepicker;
      } else if (lang == 'sl') {
        this.elementUILang.el.datepicker = this.elementUILangSL.el.datepicker;
      }
    };

    Vue.prototype.$l = function (input, lang, capital) {
      if (!lang) lang = 'en';

      try {
        lang = this.$store.getters.getLocalSettings.interface.language;
      } catch (err) {
        lang = 'en';
      }

      var output = getWord(input, lang);

      if (capital) {
        return output.toUpperCase();
      }
      return output;
    };

    Vue.prototype.$localSupport = function (type) {
      if (type == '') return '';
      var lang = this.$store.getters.getLang;
      lang = lang + 'Support';
      return getWord(type, lang);
    };

    function getWord(input, lang) {
      var sections = input.split('/');
      var word = __WEBPACK_IMPORTED_MODULE_1__translations__["a" /* default */][lang];
      try {
        sections.forEach(function (section) {
          word = word[section];
        });
      } catch (e) {
        word = undefined;
      } finally {
        if (word) return word;else {
          console.log(input + " missing translation");
          return "N_T " + input;
        }
      }
    }
  },
  getTranslations: function getTranslations() {
    return __WEBPACK_IMPORTED_MODULE_1__translations__["a" /* default */];
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Localization);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_Main__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_main_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_login_Login__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_settings_Settings__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_settings_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_settings_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_settings_categories_AlertMessaging__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_settings_categories_AlertMessaging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_settings_categories_AlertMessaging__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_settings_categories_AudioRecording__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_settings_categories_AudioRecording___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_settings_categories_AudioRecording__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_settings_categories_Delete__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_settings_categories_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_settings_categories_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_settings_categories_Device__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_settings_categories_Device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_settings_categories_Device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_settings_categories_Download__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_settings_categories_Download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_settings_categories_Download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_settings_categories_DynamicDns__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_settings_categories_DynamicDns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_settings_categories_DynamicDns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_settings_categories_FTPSending__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_settings_categories_FTPSending___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_settings_categories_FTPSending__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_settings_categories_GeoPos__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_settings_categories_GeoPos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_settings_categories_GeoPos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_settings_categories_Interface__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_settings_categories_Interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_settings_categories_Interface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_settings_categories_Status__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_settings_categories_Status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_settings_categories_Status__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_settings_categories_Weather__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_settings_categories_Weather___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_settings_categories_Weather__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_settings_categories_Video__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_settings_categories_Video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_settings_categories_Video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_settings_categories_Adio__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_settings_categories_Adio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_settings_categories_Adio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_settings_categories_NorCloud__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_settings_categories_NorCloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_settings_categories_NorCloud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_settings_categories_Statistics__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_settings_categories_Statistics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_settings_categories_Statistics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_settings_Archive__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_settings_Archive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_settings_Archive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_graphs_Graphs__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_graphs_Graphs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_graphs_Graphs__);



//componets
























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: '/',
		name: 'Main',
		component: __WEBPACK_IMPORTED_MODULE_3__components_main_Main___default.a,
		children: [{
			path: '',
			component: __WEBPACK_IMPORTED_MODULE_22__components_graphs_Graphs___default.a
		}, {
			path: '/statistics',
			component: __WEBPACK_IMPORTED_MODULE_22__components_graphs_Graphs___default.a
		}, {
			path: '/realtime',
			component: __WEBPACK_IMPORTED_MODULE_22__components_graphs_Graphs___default.a
		}, {
			path: '/archives/:type/',
			component: __WEBPACK_IMPORTED_MODULE_21__components_settings_Archive___default.a
		}, {
			path: '/archives/:type/:day',
			component: __WEBPACK_IMPORTED_MODULE_21__components_settings_Archive___default.a
		}, {
			path: '/settings',
			name: 'settings',
			component: __WEBPACK_IMPORTED_MODULE_5__components_settings_Settings___default.a,
			children: [{
				path: '/settings/alertMessaging',
				component: __WEBPACK_IMPORTED_MODULE_6__components_settings_categories_AlertMessaging___default.a
			}, {
				path: '/settings/audioRecording',
				component: __WEBPACK_IMPORTED_MODULE_7__components_settings_categories_AudioRecording___default.a
			}, {
				path: '/settings/delete',
				component: __WEBPACK_IMPORTED_MODULE_8__components_settings_categories_Delete___default.a
			}, {
				path: '/settings/device',
				component: __WEBPACK_IMPORTED_MODULE_9__components_settings_categories_Device___default.a
			}, {
				path: '/settings/download',
				component: __WEBPACK_IMPORTED_MODULE_10__components_settings_categories_Download___default.a
			}, {
				path: '/settings/dynamicDns',
				component: __WEBPACK_IMPORTED_MODULE_11__components_settings_categories_DynamicDns___default.a
			}, {
				path: '/settings/FTPSending',
				component: __WEBPACK_IMPORTED_MODULE_12__components_settings_categories_FTPSending___default.a
			}, {
				path: '/settings/geographicPosition',
				component: __WEBPACK_IMPORTED_MODULE_13__components_settings_categories_GeoPos___default.a
			}, {
				path: '/settings/interface',
				component: __WEBPACK_IMPORTED_MODULE_14__components_settings_categories_Interface___default.a
			}, {
				path: '/settings/status',
				component: __WEBPACK_IMPORTED_MODULE_15__components_settings_categories_Status___default.a
			}, {
				path: '/settings/weather',
				component: __WEBPACK_IMPORTED_MODULE_16__components_settings_categories_Weather___default.a
			}, {
				path: '/settings/video',
				component: __WEBPACK_IMPORTED_MODULE_17__components_settings_categories_Video___default.a
			}, {
				path: '/settings/adio',
				component: __WEBPACK_IMPORTED_MODULE_18__components_settings_categories_Adio___default.a
			}, {
				path: '/settings/norcloud',
				component: __WEBPACK_IMPORTED_MODULE_19__components_settings_categories_NorCloud___default.a
			}, {
				path: '/settings/statistics',
				component: __WEBPACK_IMPORTED_MODULE_20__components_settings_categories_Statistics___default.a
			}]
		}]
	}, {
		path: '/login',
		name: 'login',
		component: __WEBPACK_IMPORTED_MODULE_4__components_login_Login___default.a
	}]
}));

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(269);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var state = {
    mounted: false,
    user: {},
    calendarQuery: 0,
    activeDays: [],
    selectedDayHours: [],
    selectedHour: '',
    selectedDay: {},
    selectedInterval: { start: undefined, end: undefined, source: undefined },
    sidebarVisible: true,
    status: {
        noise: false,
        weather: false
    },
    systemStatus: {},
    settings: {},
    localSettings: {},
    unsavedLocalSettings: {},
    realtimeEnabled: false,
    firmware: {},
    screenSize: 2,
    isDownloading: {
        enabled: false,
        progress: 0
    }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
    state: state,
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__admin__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__operator__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__guest__ = __webpack_require__(271);




var Users = {
    install: function install(Vue, options) {
        Vue.prototype.$p = function (input) {
            return getPermission(input, this.$store.getters.getUser.type);
        };

        function getPermission(input, type) {
            var permissions = __WEBPACK_IMPORTED_MODULE_2__guest__["a" /* default */];
            switch (type) {
                case 'admin':
                    permissions = __WEBPACK_IMPORTED_MODULE_0__admin__["a" /* default */];break;
                case 'operator':
                    permissions = __WEBPACK_IMPORTED_MODULE_1__operator__["a" /* default */];break;
                case 'guest':
                    permissions = __WEBPACK_IMPORTED_MODULE_2__guest__["a" /* default */];break;
            }

            var sections = input.split('/');

            try {
                sections.forEach(function (section) {
                    permissions = permissions[section];
                });
            } catch (e) {
                permissions = undefined;
            } finally {
                if (permissions != undefined) return permissions;
                return undefined;
            }
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Users);

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(459),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getLanguage'])),
  mounted: function mounted() {},
  watch: {
    getLanguage: function getLanguage(lang) {
      this.$switch(lang);
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(32);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['setDownloading', 'setDownloadingProgress']), {
        downloadClicked: function downloadClicked() {
            var _this = this;

            var url = '/api/file-action&&action=download&type=audio&files=' + this.data.name + '&start=' + this.data.selection[0] + '&stop=' + this.data.selection[1] + '&time=' + Date.now();
            this.setDownloading({ enabled: true, progress: 0 });
            __WEBPACK_IMPORTED_MODULE_2__api__["_10" /* getFileAction */](url, 'GET', '', function (progress) {
                var percentage = 100;
                if (progress.total != 0) {
                    var _percentage = Math.round(progress.loaded / progress.total * 100);
                }
                _this.setDownloadingProgress(percentage);
            }).then(function () {
                _this.setDownloading({ enabled: false, progress: 0 });
            }).catch(function () {
                _this.setDownloading({ enabled: false, progress: 0 });
            });
            //window.location.href = url;
            this.data.visible = false;
        }
    })
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['src'],
    data: function data() {
        return {
            show: true
        };
    },
    watch: {
        src: function src(data) {
            var _this = this;

            this.show = false;
            setTimeout(function () {
                _this.show = true;
            }, 100);
        }
    }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['src'],
    data: function data() {
        return {
            show: true
        };
    },
    watch: {
        src: function src(data) {
            var _this = this;

            this.show = false;
            setTimeout(function () {
                _this.show = true;
            }, 100);
        }
    }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalendarDay__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalendarDay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CalendarDay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CalendarHour__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CalendarHour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CalendarHour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CalendarLegendPopover__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CalendarLegendPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CalendarLegendPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['small', 'screenSize', 'current', 'selectedDay'],
    components: {
        'calendar-day': __WEBPACK_IMPORTED_MODULE_2__CalendarDay___default.a,
        'calendar-hour': __WEBPACK_IMPORTED_MODULE_3__CalendarHour___default.a,
        'calendar-legend-popover': __WEBPACK_IMPORTED_MODULE_4__CalendarLegendPopover___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])(['getSelectedDayHours', 'getSelectedDay', 'getLanguage']), {
        currentMonthName: function currentMonthName() {
            var monthNames = {
                en: ['January', 'Februar', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                sl: ['Januar', 'Februar', 'Marec', 'April', 'Maj', 'Junij', 'Julij', 'Avgust', 'September', 'Oktober', 'November', 'December'],
                at: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                de: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                fr: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']

            };
            return monthNames[this.getLanguage][this.current.month];
        },
        firstDayOffset: function firstDayOffset() {
            var offset = new Date(this.current.year, this.current.month, 1).getDay() - 1;
            if (offset <= 0) {
                offset += 7;
            }
            return offset;
        },

        calendarHoursContainerClass: function calendarHoursContainerClass() {
            if (this.small) return 'calendar-hours-container small';
            return 'calendar-hours-container';
        }

    }),
    methods: {
        getDate: function getDate(y, x) {
            var day = (y - 1) * 7 + x;
            day -= this.firstDayOffset;
            var date = new Date(this.current.year, this.current.month, day);
            return date;
        },
        nextYear: function nextYear() {
            var newDate = new Date(this.current.year + 1, this.current.month);
            this.current.year = newDate.getFullYear();
        },
        nextMonth: function nextMonth() {
            var newDate = new Date(this.current.year, this.current.month + 1);
            this.current.month = newDate.getMonth();
            this.current.year = newDate.getFullYear();
        },
        previousYear: function previousYear() {
            var newDate = new Date(this.current.year - 1, this.current.month);
            this.current.year = newDate.getFullYear();
        },
        previousMonth: function previousMonth() {
            var newDate = new Date(this.current.year, this.current.month - 1);
            this.current.month = newDate.getMonth();
            this.current.year = newDate.getFullYear();
        }
    }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Calendar__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Calendar__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//components


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['screenSize', 'sidebarVisible'],
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getSettingsDevice', 'getSystemStatus', 'getStatus', 'getSelectedDay', 'getMounted', 'getDownloading']), {
        isDownloading: function isDownloading() {
            return this.getDownloading.enabled;
        },
        contentClassname: function contentClassname() {
            return 'content' + (this.screenSize > 1 && this.sidebarVisible ? ' sidebar-visible' : '');
        },
        isSizeBelowLimit: function isSizeBelowLimit() {
            return this.roundDecimal <= parseInt(this.getSettingsDevice.sdfreelimit);
        },
        roundDecimal: function roundDecimal() {
            return Math.round((100 - this.getSystemStatus.n140_sd_percent) * 10) / 10;
        },
        statusMessage: function statusMessage() {
            return this.getStatus.noiseCode ? "n140:" + this.getStatus.noiseCode : this.getStatus.weatherCode ? "weather:" + this.getStatus.weatherCode : this.getStatus.adioCode ? "adio:" + this.getStatus.adioCode : '';
        },
        sdStatusMessage: function sdStatusMessage() {
            return this.statusMessage ? false : this.isSizeBelowLimit;
        },
        hddStatusMessage: function hddStatusMessage() {
            return this.statusMessage || this.sdStatusMessage ? false : this.isHddSizeBelowLimit;
        },
        statusSidebar: function statusSidebar() {
            return this.statusMessage ? 'error' : this.playButtonClass.ok ? 'running' : this.playButtonClass.danger ? 'notRunning' : this.playButtonClass.warning ? 'running' : 'notRunning';
        },
        playButtonClass: function playButtonClass() {
            var isError = this.getStatus.weatherError || this.getStatus.noiseError || this.getStatus.adioError;
            return {
                danger: !this.getStatus.noise && !this.getStatus.weather || isError,
                warning: (!this.getStatus.noise || !this.getStatus.weather || !this.getStatus.adio) && !isError,
                ok: (this.getStatus.noise && this.getStatus.weather || this.getStatus.adio) && !isError

            };
        },
        selectedDayString: function selectedDayString() {
            return this.getSelectedDay.year + '-' + this.getSelectedDay.month + '-' + this.getSelectedDay.day;
        },
        isStatistics: function isStatistics() {
            return this.$route.path.indexOf('/statistics') > -1;
        }
    }),
    components: {
        'calendar': __WEBPACK_IMPORTED_MODULE_3__Calendar___default.a
    },
    data: function data() {
        return {
            current: {
                month: 0,
                year: 2017
            },

            selectedDay: {
                month: 0,
                year: 2017,
                day: 1
            }
        };
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['getSelectedDayHours', 'getMeasurementsDays', 'setSelectedDay', 'getSelectedDayHours', 'setSelectedHour', 'mounted'])),
    mounted: function mounted() {
        var _this = this;

        var date = new Date();
        this.current.month = date.getMonth();
        this.current.year = date.getFullYear();

        date.setDate(1);

        this.getMeasurementsDays().then(function (activeDays) {
            var activeDaysNames = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(activeDays);
            if (activeDaysNames.length > 0) {
                activeDaysNames = activeDaysNames.sort();
                var lastDay = activeDaysNames[activeDaysNames.length - 1];
                var lastDayDate = new Date(lastDay);
                //if(!this.isRealtime)
                if (_this.isStatistics) _this.mounted();
                _this.setSelectedDay({ day: lastDayDate.getDate(), month: lastDayDate.getMonth(), year: lastDayDate.getFullYear() }, true);

                _this.getSelectedDayHours(lastDayDate).then(function (activeHours) {
                    _this.mounted();
                    var activeHourNames = activeHours.values;
                    if (activeHourNames.length > 0) {
                        activeHourNames = activeHourNames.sort();
                        var lastHour = activeHourNames[activeHourNames.length - 1];
                        //if(!this.isRealtime)
                        if (!_this.isStatistics) {

                            _this.setSelectedHour(lastHour.split('-')[3], true);
                        } else {
                            _this.setSelectedHour('', true);
                        }
                    }
                });
            }
        });
    },
    watch: {
        selectedDayString: function selectedDayString(a, b) {
            if (!this.getMounted) return;
            this.getSelectedDayHours(new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day)));
        },
        isStatistics: function isStatistics(stat) {
            if (stat) {
                this.setSelectedHour('');
            }
        }
    }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['date', 'current'],
    data: function data() {
        return {
            hasAudio: false,
            hasNoise: false,
            hasWeather: false,
            hasVideo: false,
            hasAdio: false,
            enabled: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getActiveDays', 'getSelectedDay']), {
        className: function className() {
            var searchableFormat = this.date.getFullYear() + '-' + __WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* doubleDigit */](this.date.getMonth() + 1) + '-' + __WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* doubleDigit */](this.date.getDate());

            var styleName = "calendar-item";
            if (this.getActiveDays[searchableFormat] && this.date.getMonth() == this.current.month) {
                styleName += ' enabled';
                this.enabled = true;
                this.hasNoise = this.getActiveDays[searchableFormat].noise;
                this.hasAudio = this.getActiveDays[searchableFormat].audio;
                this.hasWeather = this.getActiveDays[searchableFormat].weather;
                this.hasVideo = this.getActiveDays[searchableFormat].video;
                this.hasAdio = this.getActiveDays[searchableFormat].adio;
            } else {
                styleName += ' disabled';
                this.enabled = false;
                this.hasNoise = false;
                this.hasAudio = false;
                this.hasWeather = false;
                this.hasVideo = false;
                this.hasAdio = false;
            }
            if (this.date.getDate() == this.getSelectedDay.day && this.date.getMonth() == this.getSelectedDay.month && this.date.getFullYear() == this.getSelectedDay.year) styleName += ' current-day';
            return styleName;
        },
        title: function title() {
            var output = '';
            if (this.hasNoise) output = output + this.$l('calendar/noise') + '\n';
            if (this.hasAudio) output = output + this.$l('calendar/audio') + '\n';
            if (this.hasWeather) output = output + this.$l('calendar/weather') + '\n';
            if (this.hasVideo) output = output + this.$l('calendar/video') + '\n';
            if (this.hasAdio) output = output + this.$l('calendar/adio') + '\n';
            return output;
        }
    }),
    methods: {
        dayClicked: function dayClicked() {
            if (!this.enabled) return;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_actions__["setSelectedDay"])(this.$store, { day: this.date.getDate(), month: this.date.getMonth(), year: this.date.getFullYear() });
            if (this.$route.fullPath != '/' && this.$route.fullPath != '/statistics') this.$router.push('/');
            //this.selectedDay.day=this.date.getDate() 
            //this.selectedDay.month=this.date.getMonth();
            //this.selectedDay.year=this.date.getFullYear();
            //this.current.month=this.selectedDay.month;
            //this.current.year=this.selectedDay.year;
        }
    }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['hour'],
  data: function data() {
    return {
      hasAudio: false,
      hasNoise: false,
      hasWeather: false,
      hasVideo: false,
      hasAdio: false,
      enabled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getSelectedHour', 'getSelectedDay', 'getSelectedDayHours']), {
    value: function value() {
      var searchableFormat = this.getSelectedDay.year + '-' + __WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* doubleDigit */](this.getSelectedDay.month + 1) + '-' + __WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* doubleDigit */](this.getSelectedDay.day) + '-' + __WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* doubleDigit */](this.hour.split('-')[3]);
      if (this.getSelectedDayHours[searchableFormat]) {
        this.hasNoise = this.getSelectedDayHours[searchableFormat].noise;
        this.hasAudio = this.getSelectedDayHours[searchableFormat].audio;
        this.hasWeather = this.getSelectedDayHours[searchableFormat].weather;
        this.hasVideo = this.getSelectedDayHours[searchableFormat].video;
        this.hasAdio = this.getSelectedDayHours[searchableFormat].adio;
      } else {
        this.hasNoise = false;
        this.hasAudio = false;
        this.hasWeather = false;
        this.hasVideo = false;
        this.hasAdio = false;
      }
      return (/*this.getSelectedDay.day+'.'+this.getSelectedDay.month+'.'+this.getSelectedDay.year + ' - '+*/this.hour.split('-')[3] + ':00'
      );
    },
    className: function className() {
      var className = 'hour-value';
      if (this.getSelectedHour.trim() == this.hour.split('-')[3]) {
        className += ' selected';
      }
      return className;
    }
  }),
  methods: {
    onHourClick: function onHourClick() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_actions__["setSelectedHour"])(this.$store, this.hour.split('-')[3]);
      if (this.$route.fullPath != '/') this.$router.push('/');
    }
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['chart'],
    methods: {
        printChart: function printChart() {
            this.chart.chart.print();
        },
        downloadPNG: function downloadPNG() {
            var file_name = "chart_PNG";
            if (this.chart.chart.xAxis[0].dataMin > 0) {
                var date = new Date(this.chart.chart.xAxis[0].dataMin);
                file_name = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + __WEBPACK_IMPORTED_MODULE_0__common_utils__["a" /* doubleDigit */](date.getDate()) + "-" + __WEBPACK_IMPORTED_MODULE_0__common_utils__["a" /* doubleDigit */](date.getHours() - 1);
            }
            this.chart.chart.exportChart({
                filename: file_name,
                type: "image/png"
            });
        },
        downloadJPEG: function downloadJPEG() {
            var file_name = "chart_JPEG";
            if (this.chart.chart.xAxis[0].dataMin > 0) {
                var date = new Date(this.chart.chart.xAxis[0].dataMin);
                file_name = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + __WEBPACK_IMPORTED_MODULE_0__common_utils__["a" /* doubleDigit */](date.getDate()) + "-" + __WEBPACK_IMPORTED_MODULE_0__common_utils__["a" /* doubleDigit */](date.getHours() - 1);
            }
            this.chart.chart.exportChart({
                filename: file_name,
                type: "image/jpeg"
            });
        },
        downloadPDF: function downloadPDF() {
            var file_name = "chart_PDF";
            if (this.chart.chart.xAxis[0].dataMin > 0) {
                var date = new Date(this.chart.chart.xAxis[0].dataMin);
                file_name = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + __WEBPACK_IMPORTED_MODULE_0__common_utils__["a" /* doubleDigit */](date.getDate()) + "-" + __WEBPACK_IMPORTED_MODULE_0__common_utils__["a" /* doubleDigit */](date.getHours() - 1);
            }
            this.chart.chart.exportChart({
                filename: file_name,
                type: "application/pdf"
            });
        },
        downloadSVG: function downloadSVG() {
            var file_name = "chart_SVG";
            if (this.chart.chart.xAxis[0].dataMin > 0) {
                var date = new Date(this.chart.chart.xAxis[0].dataMin);
                file_name = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + __WEBPACK_IMPORTED_MODULE_0__common_utils__["a" /* doubleDigit */](date.getDate()) + "-" + __WEBPACK_IMPORTED_MODULE_0__common_utils__["a" /* doubleDigit */](date.getHours() - 1);
            }
            this.chart.chart.exportChart({
                filename: file_name,
                type: "image/svg"
            });
        }
    }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PlayAudioFileDialog__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PlayAudioFileDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PlayAudioFileDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExportGraph__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExportGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ExportGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MarkersPopover__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MarkersPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MarkersPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GraphNotes__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GraphNotes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__GraphNotes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_utils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(32);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'config', 'data', 'shared'],
    data: function data() {
        return {
            disabled: false,
            hidden: false,
            visible: true,
            chart: null,
            zoomLoading: false,
            realtimeActive: false,
            realtimePreparing: false,
            latestDataRealtime: [],
            test: '',
            savedAudios: [],
            savedVideos: [],
            playAudioDialog: { visible: false, filename: null },
            graphLoadingId: 0,
            noData: '',
            delayedLoading: false,
            delayedLoadingType: '',
            statform: {
                title: '',
                from: '',
                to: ''
            },
            activeToggleMarkers: {},
            graphMarkers: [],
            activeMarkerSelect: null,
            markersData: {
                visible: false
            },
            notesData: {
                value: '',
                id: '',
                date: null
            },
            notesHourlyData: {
                value: '',
                id: '',
                date: null
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])(['getSidebarVisible', 'getSelectedDay', 'getSelectedHour', 'getSelectedInterval', 'getRealtimeEnabled', 'getLocalSettings', 'getSettingsAddons', 'getStatus', 'getSettingsWeather']), {
        errorMessage: function errorMessage() {
            if (!this.getRealtimeEnabled) return;
            if (this.config.graphType == 'weath') {
                if (this.getStatus.weatherError) {
                    return 'graphs/errWeath';
                }
            } else if (this.config.graphType == 'noise') {
                if (this.getStatus.noiseError) {
                    return 'graphs/errNoise';
                }
            } else if (this.config.graphType == 'adio') {
                if (this.getStatus.adioError) {
                    return 'graphs/errAdio';
                }
            }
        },
        graphOptions: function graphOptions() {
            this.config.chart.events.selection = this.selection;
            if (this.config.plotOptions.series.events) this.config.plotOptions.series.events.legendItemClick = this.legendItemClick;

            if (this.config.chart.events.click) this.config.chart.events.click = this.graphClicked;
            if (this.config.plotOptions.series.events.click) this.config.plotOptions.series.events.click = this.graphClicked;

            return this.config;
        },
        sync: function sync() {
            return this.getLocalSettings.interface ? this.getLocalSettings.interface.syncgraphs : true;
        },
        isReset: function isReset() {
            return this.getSelectedInterval.source == this.config.graphType && (this.getSelectedInterval.start != undefined || this.getSelectedInterval.end);
        },
        isVisible: function isVisible() {
            if (!this.getLocalSettings.interface) return true;
            if (this.config.graphType == 'weath') {
                return this.getLocalSettings.interface.weather == 1;
            } else if (this.config.graphType == 'noise') {
                return this.getLocalSettings.interface.noise == 1;
            } else if (this.config.graphType == 'spect') {
                return this.getLocalSettings.interface.spectrum == 1;
            } else if (this.config.graphType == 'adio') {
                return this.getLocalSettings.interface.adio == 1;
            } else if (this.config.graphType == 'statistics') {
                return this.getLocalSettings.interface.statistics == 1;
            }
            return true;
        },
        isPreloading: function isPreloading() {
            if (!this.getLocalSettings.interface) return false;
            switch (this.config.graphType) {
                case 'weath':
                    return this.getLocalSettings.interface.preloadWeather == 1;
                case 'noise':
                    return this.getLocalSettings.interface.preloadNoise == 1;
                case 'spect':
                    return this.getLocalSettings.interface.preloadSpectrum == 1;
                case 'adio':
                    return this.getLocalSettings.interface.preloadAdio == 1;
                case 'statistics':
                    return this.getLocalSettings.interface.preloadStatistics == 1;
            }
        },
        selectedStatisticsTemplate: function selectedStatisticsTemplate() {
            if (!this.getLocalSettings.download) return;
            var output = this.getLocalSettings.download.downlStatistic;
            try {
                if (this.getLocalSettings.download.statistics.mapping[output]) {
                    return this.getLocalSettings.download.statistics.mapping[output];
                }
            } catch (err) {}
            return output;
        }
    }),
    components: {
        'export-graph': __WEBPACK_IMPORTED_MODULE_5__ExportGraph___default.a,
        'play-audio-dialog': __WEBPACK_IMPORTED_MODULE_4__PlayAudioFileDialog___default.a,
        'markers-popover': __WEBPACK_IMPORTED_MODULE_6__MarkersPopover___default.a,
        'graph-notes': __WEBPACK_IMPORTED_MODULE_7__GraphNotes___default.a
    },
    watch: {
        getSidebarVisible: function getSidebarVisible() {
            var chartRef = this.$refs.chart;
            if (chartRef) chartRef.chart.reflow();
        },

        getSelectedHour: function getSelectedHour(newHour) {},
        getSelectedInterval: function getSelectedInterval(newInterval) {
            var _this = this;

            if (!this.hidden && (newInterval.source == this.config.graphType || this.sync || newInterval.source == 'noise' && this.config.graphType == 'spect')) {
                this.zoomLoading = true;
                if (this.getSelectedHour == '') {
                    var selectedDay = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day));
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["getDailyData"])(this.$store, this.config.graphType, selectedDay, newInterval.start, newInterval.end).then(function (data) {
                        var currentGraphLoadingId = Date.now();
                        _this.graphLoadingId = currentGraphLoadingId;
                        _this.clearGraphData(_this.$refs.chart, currentGraphLoadingId);
                        _this.fillGraphData(_this.$refs.chart, data, currentGraphLoadingId);
                        _this.data.loading = false;
                        if (_this.config.graphType == 'noise') {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["getRecDay"])(_this.$store, selectedDay).then(function (data) {
                                _this.addAudioSerie(_this.$refs.chart, data.data.audio, currentGraphLoadingId);
                                _this.addVideoSerie(_this.$refs.chart, data.data.video, currentGraphLoadingId);
                            }).catch(function () {}).then(function () {
                                return _this.getMarkersDay({ from: selectedDay });
                            }).then(function (data) {
                                _this.addGraphMarkers(_this.$refs.chart, data.data, data.headers, currentGraphLoadingId);
                            }).catch(function (err) {});
                        }
                    }).catch(function (err) {
                        _this.data.loading = false;
                    }).then(function () {
                        _this.zoomLoading = false;
                    });
                } else {
                    var selectedHour = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day, this.getSelectedHour));
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["getHourlyData"])(this.$store, this.config.graphType, selectedHour, newInterval.start, newInterval.end).then(function (data) {
                        var currentGraphLoadingId = Date.now();
                        _this.graphLoadingId = currentGraphLoadingId;
                        _this.clearGraphData(_this.$refs.chart, currentGraphLoadingId);
                        _this.fillGraphData(_this.$refs.chart, data, currentGraphLoadingId);
                        _this.config.loading = false;
                        if (_this.config.graphType == 'noise') {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["getRecHour"])(_this.$store, selectedHour).then(function (data) {

                                _this.addAudioSerie(_this.$refs.chart, data.data.audio, currentGraphLoadingId);
                                _this.addVideoSerie(_this.$refs.chart, data.data.video, currentGraphLoadingId);
                            }).catch(function () {}).then(function () {
                                return _this.getMarkersHour({ from: selectedHour });
                            }).then(function (data) {
                                _this.addGraphMarkers(_this.$refs.chart, data.data, data.headers, currentGraphLoadingId);
                            }).catch(function (err) {});
                        }
                    }).catch(function (err) {
                        _this.config.loading = false;
                    }).then(function () {
                        _this.zoomLoading = false;
                    });
                }
            }
        },
        getRealtimeEnabled: function getRealtimeEnabled(enabled) {
            if (!enabled) {
                this.realtimeActive = false;
                this.realtimePreparing = false;
            }
        },
        getSettingsAddons: function getSettingsAddons(s) {
            if (this.config.graphType == 'noise') {
                this.disabled = s.noise == 0;
            }
            if (this.config.graphType == 'weath') {
                this.disabled = s.weather == 0;
            }
            if (this.config.graphType == 'adio') {
                this.disabled = s.adio == 0;
            }
            if (this.config.graphType == 'statistics') {
                this.disabled = s.statistics == 0;
            }
        }

    },
    methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapActions */])(['setDownloading', 'setDownloadingProgress', 'getMarkersDay', 'getMarkersHour', 'setMarker', 'deleteMarker', 'saveMarkerNote', 'getDailyNote']), {
        isNewGraph: function isNewGraph(currentGraphLoadingId) {
            return currentGraphLoadingId != this.graphLoadingId;
        },
        clearGraphData: function clearGraphData(chart, currentGraphLoadingId) {
            var resetZoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            if (this.config.graphType == 'spect' || this.config.graphType == 'statistics') chart.chart.update({ chart: { zoomType: '' } });else chart.chart.update({ chart: { zoomType: 'x' } });
            //if(this.config.graphType == 'spect' || !chart) return;
            while (chart.chart.series.length > 0) {
                if (this.isNewGraph(currentGraphLoadingId)) return;
                chart.chart.series[0].remove(false);
            }
            if (resetZoom) chart.chart.zoom();

            this.savedAudios = [];
            this.savedVideos = [];
            chart.chart.xAxis[0].removePlotBand('Video');
            chart.chart.xAxis[0].removePlotBand('Audio');
            chart.chart.xAxis[0].removePlotBand('Marker');

            chart.chart.yAxis[0].removePlotLine('thresholdValue');

            this.graphMarkers = [];
            this.notesData = {
                value: '',
                id: '',
                date: null
            };
            this.notesHourlyData = {
                value: '',
                id: '',
                date: null
            };

            setTimeout(function () {
                chart.chart.reflow();
            }, 1000);
        },
        fillGraphData: function fillGraphData(chart, data, currentGraphLoadingId) {
            if (!chart) return;
            if (data.data.length == 0) {

                this.visible = false;
                //return;
            }
            this.visible = true;
            var localSettings = this.getLocalSettings;
            var verticalExtremeName = 'NO';
            switch (this.config.graphType) {
                case 'weath':
                    verticalExtremeName = 'WE';break;
                case 'spect':
                    verticalExtremeName = 'SP';break;
                case 'adio':
                    verticalExtremeName = 'ADIO';break;
            }
            //chart.chart.events.selection = this.selection;
            if (this.config.graphType == 'spect') {
                var color = undefined;

                for (var i = 1; i < data.headers.length; i++) {
                    if (this.isNewGraph(currentGraphLoadingId)) return;
                    var visible = localSettings.graphs && localSettings.graphs[this.config.graphType] ? localSettings.graphs[this.config.graphType][data.headers[i]] : true;

                    if (data.headers[i].indexOf('-A') > -1) {
                        color = this.LightenDarkenColor(color, 100);
                    } else {
                        for (var c = 0; c < localSettings.interface.noiseValues.length; c++) {
                            if (localSettings.interface.noiseValues[c].indexOf(data.headers[i]) > -1) {
                                color = localSettings.interface.colorsnoise[c];
                                break;
                            }
                        }
                    }

                    chart.chart.addSeries({
                        name: data.headers[i],
                        visible: visible,
                        color: color
                    }, false);
                }
                for (var i = 1; i < data.headers.length; i++) {
                    var seriesData = [];
                    for (var k = 0; k < data.data.length; k++) {
                        if (this.isNewGraph(currentGraphLoadingId)) return;
                        seriesData.push([this.config.frequencies[k], parseFloat(data.data[k][i])]);
                    }
                    chart.chart.series[i - 1].setData(seriesData);
                }
                /*var type = this.config.graphType;
                chart.chart.series.forEach(serie=>{
                        var visible = (localSettings.graphs && localSettings.graphs[type])? (localSettings.graphs[type][serie.name]) :true;
                        serie.visible = visible;
                    })
                chart.chart.legend.update()
                var seriesData = [[],[]];
                for(var i = 0; i < data.data.length; i++){
                    seriesData[0].push([
                        this.config.frequencies[i],
                        parseFloat(data.data[i][1])
                    ])
                    seriesData[1].push([
                        this.config.frequencies[i],
                        parseFloat(data.data[i][2])
                    ])
                }
                chart.chart.series[0].setData(seriesData[0]);
                chart.chart.series[1].setData(seriesData[1]);*/
            } else if (this.config.graphType == 'statistics') {
                for (var i = 1; i < 4; i++) {
                    if (this.isNewGraph(currentGraphLoadingId)) return;
                    var visible = localSettings.graphs && localSettings.graphs[this.config.graphType] ? localSettings.graphs[this.config.graphType][data.headers[i]] : true;
                    var color = undefined;
                    /*if(this.config.graphType == 'weath'){
                        var index = Object.keys(localSettings.interface.colorsWeather).indexOf(data.headers[i])
                        color = localSettings.interface.colorsweath[index % localSettings.interface.colorsweath.length];
                    }
                    else if(this.config.graphType == 'noise' || this.config.graphType == 'spect'){
                        for(var c = 0; c < localSettings.interface.noiseValues.length; c++){
                            if(localSettings.interface.noiseValues[c].indexOf(data.headers[i]) > -1){
                                color = localSettings.interface.colorsnoise[c];
                                break;
                            }
                        }
                    }*/

                    chart.chart.addSeries({
                        step: data.headers[i],
                        lineWidth: 1,
                        name: data.headers[i],
                        visible: visible,
                        color: color,
                        yAxis: this.config.graphType == 'adio' && data.headers[i].indexOf('D') > -1 ? 1 : 0
                    }, false);
                }
                chart.chart.userOptions.plotOptions.series.pointStart = data.data[0][0].substring(0, 10);
                for (var i = 1; i < 4; i++) {
                    var seriesData = [];
                    for (var k = 0; k < data.data.length; k++) {
                        if (this.isNewGraph(currentGraphLoadingId)) return;
                        seriesData.push([data.data[k][0] * 1, parseFloat(data.data[k][i])]);
                    }
                    chart.chart.series[i - 1].setData(seriesData);
                }
            } else {
                for (var i = 1; i < data.headers.length; i++) {
                    if (this.isNewGraph(currentGraphLoadingId)) return;
                    var visible = localSettings.graphs && localSettings.graphs[this.config.graphType] ? localSettings.graphs[this.config.graphType][data.headers[i]] : true;
                    var color = undefined;
                    if (this.config.graphType == 'weath') {
                        var index = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(localSettings.interface.colorsWeather).indexOf(data.headers[i]);
                        color = localSettings.interface.colorsweath[index % localSettings.interface.colorsweath.length];
                    } else if (this.config.graphType == 'noise' || this.config.graphType == 'spect') {
                        for (var c = 0; c < localSettings.interface.noiseValues.length; c++) {
                            if (localSettings.interface.noiseValues[c].indexOf(data.headers[i]) > -1) {
                                color = localSettings.interface.colorsnoise[c];
                                break;
                            }
                        }
                    }
                    chart.chart.addSeries({
                        name: data.headers[i],
                        visible: visible,
                        color: color,
                        yAxis: this.config.graphType == 'adio' && data.headers[i].indexOf('D') > -1 ? 1 : 0
                    }, false);
                }
                for (var i = 1; i < data.headers.length; i++) {
                    var seriesData = [];
                    for (var k = 0; k < data.data.length; k++) {
                        if (this.isNewGraph(currentGraphLoadingId)) return;
                        seriesData.push([data.data[k][0] * 1, parseFloat(data.data[k][i])]);
                    }
                    chart.chart.series[i - 1].setData(seriesData);
                }
            }
            if (localSettings.interface['Rang' + verticalExtremeName + 'type'] == '0') {
                var extremes = localSettings.interface['Rang' + verticalExtremeName];
                var positions = this.yExtremCalc(extremes[0], extremes[1]);
                chart.chart.yAxis[0].update({
                    tickPositions: positions
                });
                chart.chart.yAxis[0].setExtremes(positions[0], positions[positions.length - 1]);
            }

            this.data.loading = false;
            //chart.chart.redraw();

        },
        audioClicked: function audioClicked(event, file) {
            this.playAudioDialog.visible = true;
            this.playAudioDialog.filename = file;
            //console.log(file);
        },
        addAudioSerie: function addAudioSerie(chart, data, currentGraphLoadingId) {
            var _this2 = this;

            if (data.length > 0) {
                // console.log(data);

                var color = 'rgba(255,0,0,0.5)';
                var visible = this.getLocalSettings && this.getLocalSettings.graphs && this.getLocalSettings.graphs[this.config.graphType] ? this.getLocalSettings.graphs[this.config.graphType]['Audio'] : true;

                this.savedAudios = [];
                if (this.isNewGraph(currentGraphLoadingId)) return;
                data.forEach(function (item) {

                    var timestamp = item[0];
                    var file = item[1];
                    var duration = item[2];
                    if (parseInt(duration) < 5) {
                        duration = "5";
                    }
                    var plotband = {
                        from: parseInt(timestamp),
                        to: parseInt(timestamp) + parseInt(duration) * 1000,
                        id: 'Audio',
                        color: color,
                        opacity: 0.5,
                        zIndex: 10,
                        events: {
                            click: function click(event) {
                                return _this2.audioClicked(event, file);
                            }
                        }
                    };

                    _this2.savedAudios.push(plotband);
                    if (visible) chart.chart.xAxis[0].addPlotBand(plotband);
                });

                chart.chart.addSeries({
                    type: 'line',
                    name: 'Audio',
                    lineWidth: '15px',
                    marker: { enabled: false },
                    color: color,
                    data: [],
                    visible: visible
                }, false);
                chart.chart.redraw();
            }
        },
        addVideoSerie: function addVideoSerie(chart, data, currentGraphLoadingId) {
            var _this3 = this;

            if (data.length > 0) {
                //console.log(data);

                var color = 'rgba(255,255,0,0.5)';
                var visible = this.getLocalSettings && this.getLocalSettings.graphs && this.getLocalSettings.graphs[this.config.graphType] ? this.getLocalSettings.graphs[this.config.graphType]['Video'] : true;
                this.savedVideos = [];
                if (this.isNewGraph(currentGraphLoadingId)) return;
                data.forEach(function (item) {
                    var timestamp = item[0];
                    var file = item[1];
                    var duration = item[2];
                    if (parseInt(duration) < 5) {
                        duration = "5";
                    }
                    var plotband = {
                        from: parseInt(timestamp),
                        to: parseInt(timestamp) + parseInt(duration) * 1000,
                        id: 'Video',
                        color: color,
                        opacity: 0.5,
                        zIndex: 10,
                        events: {
                            //click
                        }
                    };

                    _this3.savedVideos.push(plotband);
                    if (visible) chart.chart.xAxis[0].addPlotBand(plotband);
                });

                chart.chart.addSeries({
                    type: 'line',
                    name: 'Video',
                    lineWidth: '15px',
                    marker: { enabled: false },
                    color: color,
                    data: [],
                    visible: visible
                }, false);
                chart.chart.redraw();
            }
        },
        addDailyNote: function addDailyNote(chart, data, header, currentGraphLoadingId) {
            var _this4 = this;

            if (data.length > 0) {
                if (this.isNewGraph(currentGraphLoadingId)) return;

                var hID = header.indexOf('ID'); // ["ID", "Name", "Color", "Type", "DateTimeStart", "DateTimeStop"]"DateTimeStop"
                var hName = header.indexOf('Name');
                var hColor = header.indexOf('Color');
                var hType = header.indexOf('Type');
                var hDateTimeStart = header.indexOf('DateTimeStart');
                var hDateTimeStop = header.indexOf('DateTimeStop');
                var hNotes = header.indexOf('Notes');

                data.forEach(function (d) {
                    //let fromSplit = d[hDateTimeStart].split('-');
                    var fromDate = new Date(parseInt(d[hDateTimeStart]));

                    if (d[hDateTimeStart].indexOf('-') > -1) {
                        fromDate = new Date(d[hDateTimeStart]);
                    }

                    //let toSplit = d[hDateTimeStop].split('-');
                    var toDate = new Date(parseInt(d[hDateTimeStop]));
                    if (d[hDateTimeStop].indexOf('-') > -1) {
                        toDate = new Date(d[hDateTimeStop]);
                    }

                    var notes = hNotes > -1 ? d[hNotes] : '';

                    var marker = {
                        id: d[hID],
                        name: d[hName],
                        from: fromDate.getTime(),
                        to: toDate.getTime(),
                        type: 'Toggle' == d[hType],
                        color: d[hColor],
                        note: notes

                    };

                    if (marker.id.indexOf('Marker_day') > -1) {
                        _this4.notesData.value = marker.note;
                        _this4.notesData.id = marker.id;
                        _this4.notesData.date = marker.from;
                    }
                });
            }
        },
        addGraphMarkers: function addGraphMarkers(chart, data, header, currentGraphLoadingId) {
            var _this5 = this;

            if (data.length > 0) {
                if (this.isNewGraph(currentGraphLoadingId)) return;

                var hID = header.indexOf('ID'); // ["ID", "Name", "Color", "Type", "DateTimeStart", "DateTimeStop"]"DateTimeStop"
                var hName = header.indexOf('Name');
                var hColor = header.indexOf('Color');
                var hType = header.indexOf('Type');
                var hDateTimeStart = header.indexOf('DateTimeStart');
                var hDateTimeStop = header.indexOf('DateTimeStop');
                var hNotes = header.indexOf('Notes');

                data.forEach(function (d) {
                    //let fromSplit = d[hDateTimeStart].split('-');

                    var fromDate = new Date(parseInt(d[hDateTimeStart]));

                    if (d[hDateTimeStart].indexOf('-') > -1) {
                        fromDate = new Date(d[hDateTimeStart]);
                    }

                    //let toSplit = d[hDateTimeStop].split('-');
                    var toDate = new Date(parseInt(d[hDateTimeStop]));
                    if (d[hDateTimeStop].indexOf('-') > -1) {
                        toDate = new Date(d[hDateTimeStop]);
                    }

                    var notes = hNotes > -1 ? d[hNotes] : '';

                    var marker = {
                        id: d[hID],
                        name: d[hName],
                        from: fromDate.getTime(),
                        to: toDate.getTime(),
                        type: 'Toggle' == d[hType],
                        color: d[hColor],
                        note: notes
                    };
                    if (marker.id.indexOf('Marker_day') > -1 && _this5.getSelectedHour == '') {
                        _this5.notesData.value = marker.note;
                        _this5.notesData.id = marker.id;
                        _this5.notesData.date = marker.from;
                    } else if (marker.id.indexOf('Marker_hour') > -1 && _this5.getSelectedHour != '') {
                        if (new Date(marker.from).getUTCHours() == parseInt(_this5.getSelectedHour)) {
                            _this5.notesHourlyData.value = marker.note;
                            _this5.notesHourlyData.id = marker.id;
                            _this5.notesHourlyData.date = marker.from;
                        }
                    } else if (marker.id.indexOf('Marker_day') == -1 && marker.id.indexOf('Marker_hour') == -1) {
                        if (marker.from > chart.chart.xAxis[0].dataMin && marker.to < chart.chart.xAxis[0].dataMax) {
                            _this5.graphMarkers.push(marker);

                            var plotband = {
                                from: marker.from,
                                to: marker.to,
                                id: 'Marker',
                                name: marker.id,
                                color: marker.color,
                                opacity: 0.5,
                                zIndex: 0
                            };
                            chart.chart.xAxis[0].addPlotBand(plotband);
                        }
                    }
                });
                /*0: "11"
                1: "2018-11-12-19-00-30"
                2: "2018-11-12-19-00-35"
                3: "5"
                4: "Toggle"
                5: "Test"
                6: "#4286f4"
                */
            }
        },

        /*Graph events */
        selection: function selection(event) {
            event.preventDefault();
            if (this.activeMarkerSelect) {
                if (this.activeMarkerSelect.marker.type) {
                    var start, end;
                    if (event.xAxis) {
                        start = new Date(parseInt(event.xAxis[0].min));
                        end = new Date(parseInt(event.xAxis[0].max));

                        var markerId = this.activeMarkerSelect.marker.id;
                        //toggle
                        var timestamp = new Date().getTime();
                        var plotband = {
                            from: start,
                            to: end,
                            id: 'Marker',
                            color: this.activeMarkerSelect.marker.color,
                            opacity: 0.5,
                            zIndex: 0
                        };
                        this.$refs.chart.chart.xAxis[0].addPlotBand(plotband);

                        var marker = {
                            id: markerId + '-' + timestamp,
                            name: this.activeMarkerSelect.marker.name,
                            from: plotband.from,
                            to: plotband.to,
                            type: this.activeMarkerSelect.marker.type,
                            color: this.activeMarkerSelect.marker.color
                        };
                        this.graphMarkers.push(marker);

                        this.setMarker(marker);

                        return;
                    }
                }
            }
            if (this.config.graphType == 'spect' || this.config.graphType == 'statistics') return;
            var start, end;
            if (event.xAxis) {
                start = new Date(parseInt(event.xAxis[0].min));
                end = new Date(parseInt(event.xAxis[0].max));
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["setSelectedInterval"])(this.$store, start, end, this.config.graphType);
        },
        legendItemClick: function legendItemClick(event) {
            var name = event.target.name;
            var enabled = !event.target.visible;
            var localSettings = this.getLocalSettings;
            if (!localSettings.graphs) localSettings.graphs = {};
            if (!localSettings.graphs[this.config.graphType]) localSettings.graphs[this.config.graphType] = {};
            localSettings.graphs[this.config.graphType][name] = enabled;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, localSettings);

            if (name == 'Audio') {
                var chart = this.$refs.chart;
                if (!enabled) {
                    chart.chart.xAxis[0].removePlotBand(name);
                } else {
                    this.savedAudios.forEach(function (item) {
                        chart.chart.xAxis[0].addPlotBand(item);
                    });
                }
            } else if (name == 'Video') {
                var chart = this.$refs.chart;
                if (!enabled) {
                    chart.chart.xAxis[0].removePlotBand(name);
                } else {
                    this.savedVideos.forEach(function (item) {
                        chart.chart.xAxis[0].addPlotBand(item);
                    });
                }
            }
        },
        graphClicked: function graphClicked(event) {
            if (!this.realtimeActive && this.activeMarkerSelect && !this.activeMarkerSelect.marker.type) {

                var value = event.xAxis && event.xAxis[0] ? event.xAxis[0].value : event.point.x;

                var markerId = this.activeMarkerSelect.marker.id;
                //single
                var timestamp = new Date().getTime();
                var plotband = {
                    from: parseInt(value),
                    to: parseInt(value) + 2000,
                    id: 'Marker',
                    color: this.activeMarkerSelect.marker.color,
                    opacity: 0.5,
                    zIndex: 0
                };
                this.$refs.chart.chart.xAxis[0].addPlotBand(plotband);
                var marker = {
                    id: markerId + '-' + timestamp,
                    name: this.activeMarkerSelect.marker.name,
                    from: plotband.from,
                    to: plotband.to,
                    type: this.activeMarkerSelect.marker.type,
                    color: this.activeMarkerSelect.marker.color
                };
                this.graphMarkers.push(marker);

                this.setMarker(marker);
            }
        },

        /*REALTIME */
        prepareRealtime: function prepareRealtime(currentGraphLoadingId) {
            var _this6 = this;

            //console.log('Realtime prepare');
            this.realtimePreparing = true;
            this.latestDataRealtime = [];
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["getRealTimeData"])(this.$store, this.config.graphType, this.getLocalSettings.interface.rtvalues).then(function (data) {
                _this6.fillRealtimeGraph(_this6.$refs.chart, data, currentGraphLoadingId);
            });
        },

        fillRealtimeGraph: function fillRealtimeGraph(chart, data, currentGraphLoadingId) {

            this.clearGraphData(chart, currentGraphLoadingId);
            chart.chart.update({ chart: { zoomType: '' } });
            var localSettings = this.getLocalSettings;
            if (data.headers.length > 0 && data.data.length > 0) {
                var verticalExtremeName = 'NO';
                switch (this.config.graphType) {
                    case 'weath':
                        verticalExtremeName = 'WE';break;
                    case 'spect':
                        verticalExtremeName = 'SP';break;
                    case 'adio':
                        verticalExtremeName = 'ADIO';break;
                }
                if (this.config.graphType == 'noise') {

                    //set series
                    if (this.isNewGraph(currentGraphLoadingId)) return;
                    this.latestDataRealtime.push({ name: 'datetime' });
                    for (var i = 1; i < data.headers.length; i++) {

                        var visible = localSettings.graphs && localSettings.graphs[this.config.graphType] ? localSettings.graphs[this.config.graphType][data.headers[i]] : true;
                        var color = undefined;
                        for (var c = 0; c < localSettings.interface.noiseValues.length; c++) {
                            if (localSettings.interface.noiseValues[c].indexOf(data.headers[i]) > -1) {
                                color = localSettings.interface.colorsnoise[c];
                                break;
                            }
                        }
                        chart.chart.addSeries({
                            name: data.headers[i],
                            visible: visible,
                            color: color
                        });
                        this.latestDataRealtime.push({ name: data.headers[i] });
                    }
                    var k;
                    for (var i = 1; i < data.headers.length; i++) {
                        var seriesData = [];
                        for (k = 0; k < data.data.length; k++) {
                            seriesData.push([data.data[k][0] * 1, parseFloat(data.data[k][i])]);
                        }
                        chart.chart.series[i - 1].setData(seriesData);
                        this.latestDataRealtime[i].data = data.data[k - 1][i];
                    }
                    this.latestDataRealtime[0].data = data.data[k - 1][0];

                    chart.chart.xAxis[0].setExtremes(chart.chart.xAxis[0].getExtremes().dataMin, chart.chart.xAxis[0].getExtremes().dataMin + parseInt(this.getLocalSettings.interface.rtvalues) * 1000, false);

                    if (localSettings.interface.showNoiseTriggerLevel && data.threshold) {
                        var plotLines = [];
                        if (data.threshold.value[0] != '-100') {
                            var _plotLines$push;

                            plotLines.push((_plotLines$push = {
                                value: data.threshold.value[0],
                                color: 'green',
                                dashStyle: 'shortdash',
                                width: 2
                            }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_plotLines$push, 'color', 'green'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_plotLines$push, 'label', {
                                text: data.threshold.name,
                                align: 'right',
                                y: 15,
                                x: -20
                            }), _plotLines$push));
                        }
                        if (data.threshold.value[1] != '-100') {
                            var _plotLines$push2;

                            plotLines.push((_plotLines$push2 = {
                                id: 'thresholdValue',
                                value: data.threshold.value[1],
                                color: 'green',
                                dashStyle: 'shortdash',
                                width: 2
                            }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_plotLines$push2, 'color', 'green'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_plotLines$push2, 'label', {
                                text: data.threshold.name,
                                align: 'right',
                                y: 15,
                                x: -20
                            }), _plotLines$push2));
                        }

                        plotLines.forEach(function (line) {
                            chart.chart.yAxis[0].addPlotLine(line);
                        });
                    }

                    chart.chart.redraw();

                    setTimeout(function () {
                        chart.chart.reflow();
                    }, 500);
                } else if (this.config.graphType == 'weath') {
                    if (this.isNewGraph(currentGraphLoadingId)) return;
                    this.latestDataRealtime.push({ name: 'datetime' });
                    for (var i = 1; i < data.headers.length; i++) {
                        var visible = localSettings.graphs && localSettings.graphs[this.config.graphType] ? localSettings.graphs[this.config.graphType][data.headers[i]] : true;
                        var color = undefined;
                        color = localSettings.interface.colorsWeather[data.headers[i]];
                        chart.chart.addSeries({
                            name: data.headers[i],
                            color: color,
                            visibl: visible
                        });
                        this.latestDataRealtime.push({ name: data.headers[i] });
                    }
                    for (var i = 1; i < data.headers.length; i++) {
                        var seriesData = [];
                        for (k = 0; k < data.data.length; k++) {
                            seriesData.push([data.data[k][0] * 1, parseFloat(data.data[k][i])]);
                        }
                        chart.chart.series[i - 1].setData(seriesData);
                        this.latestDataRealtime[i].data = data.data[k - 1][i];
                    }
                    this.latestDataRealtime[0].data = data.data[k - 1][0];
                    chart.chart.redraw();
                } else if (this.config.graphType == 'spect') {
                    this.hidden = false;
                    var color = undefined;
                    for (var i = 1; i < data.headers.length; i++) {
                        if (this.isNewGraph(currentGraphLoadingId)) return;

                        var visible = localSettings.graphs && localSettings.graphs[this.config.graphType] ? localSettings.graphs[this.config.graphType][data.headers[i]] : true;

                        if (data.headers[i].indexOf('-A') > -1) {
                            color = this.LightenDarkenColor(color, 100);
                        } else {
                            for (var c = 0; c < localSettings.interface.noiseValues.length; c++) {
                                if (localSettings.interface.noiseValues[c].indexOf(data.headers[i]) > -1) {
                                    color = localSettings.interface.colorsnoise[c];
                                    break;
                                }
                            }
                        }

                        chart.chart.addSeries({
                            name: data.headers[i],
                            visible: visible,
                            color: color
                        }, false);
                    }
                    for (var i = 1; i < data.headers.length; i++) {
                        var seriesData = [];
                        for (var k = 0; k < data.data.length; k++) {
                            if (this.isNewGraph(currentGraphLoadingId)) return;
                            seriesData.push([this.config.frequencies[k], parseFloat(data.data[k][i])]);
                        }
                        chart.chart.series[i - 1].setData(seriesData);
                    }
                } else if (this.config.graphType == 'adio') {
                    this.latestDataRealtime.push({ name: 'datetime' });
                    for (var i = 1; i < data.headers.length; i++) {
                        if (this.isNewGraph(currentGraphLoadingId)) return;
                        var visible = localSettings.graphs && localSettings.graphs[this.config.graphType] ? localSettings.graphs[this.config.graphType][data.headers[i]] : true;

                        chart.chart.addSeries({
                            name: data.headers[i],
                            visible: visible,
                            color: color,
                            yAxis: this.config.graphType == 'adio' && data.headers[i].indexOf('D') > -1 ? 1 : 0
                        }, false);
                        this.latestDataRealtime.push({ name: data.headers[i] });
                    }
                    for (var i = 1; i < data.headers.length; i++) {
                        var seriesData = [];
                        for (var k = 0; k < data.data.length; k++) {
                            if (this.isNewGraph(currentGraphLoadingId)) return;
                            seriesData.push([data.data[k][0] * 1, parseFloat(data.data[k][i])]);
                        }
                        this.latestDataRealtime[i].data = data.data[k - 1][i];
                        chart.chart.series[i - 1].setData(seriesData);
                    }
                    this.latestDataRealtime[0].data = data.data[k - 1][0];
                }
            }
            if (localSettings.interface['Rang' + verticalExtremeName + 'type'] == '0') {
                var extremes = localSettings.interface['Rang' + verticalExtremeName];
                var positions = this.yExtremCalc(extremes[0], extremes[1]);
                chart.chart.yAxis[0].update({
                    tickPositions: positions
                });
                chart.chart.yAxis[0].setExtremes(positions[0], positions[positions.length - 1]);
            }
            this.realtimePreparing = false;
            this.realtimeActive = true;
        },

        reloadRealtime: function reloadRealtime(currentGraphLoadingId) {
            var _this7 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["getRealTimeData"])(this.$store, this.config.graphType, this.getLocalSettings.interface.rtvalues).then(function (data) {
                try {
                    _this7.reloadGraphData(_this7.$refs.chart, data, currentGraphLoadingId);
                } catch (err) {
                    console.log(err);
                };
            });
        },
        reloadGraphData: function reloadGraphData(chart, data) {
            var _this8 = this;

            if (data.length != 0) {
                if (this.config.graphType == 'noise') {
                    var rightOffset;
                    for (rightOffset = data.data.length - 1; rightOffset >= 0; rightOffset--) {
                        if (data.data[rightOffset][0].indexOf(chart.chart.xAxis[0].dataMax) > -1) {
                            rightOffset++;
                            break;
                        }
                    }

                    // console.log(data.data.length, rightOffset);
                    var elementsCount = (chart.chart.xAxis[0].getExtremes().dataMax - chart.chart.xAxis[0].getExtremes().dataMin) / 1000;
                    var shift = elementsCount > this.getLocalSettings.interface.rtvalues;

                    //  console.log(shift);
                    var offsetData = data.data.splice(rightOffset);
                    //console.log(data.data.length, offsetData.length);
                    for (var i = 1; i < data.headers.length; i++) {

                        for (var k = 0; k < offsetData.length; k++) {
                            chart.chart.series[i - 1].addPoint({
                                x: offsetData[k][0] * 1,
                                y: parseFloat(offsetData[k][i])
                            }, false, shift);
                        }
                        if (offsetData.length > 0) {
                            this.latestDataRealtime[i].data = offsetData[k - 1][i];
                            this.latestDataRealtime[0].data = offsetData[k - 1][0];
                            //this.test = offsetData[k-1][0];
                        }
                    }
                    this.latestDataRealtime = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.latestDataRealtime));

                    /*chart.chart.xAxis[0].setExtremes(
                        chart.chart.xAxis[0].getExtremes().dataMin+1000,
                        chart.chart.xAxis[0].getExtremes().dataMin+3600*1000,
                        false
                    )*/

                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.activeToggleMarkers).forEach(function (markerId) {
                        _this8.activeToggleMarkers[markerId].plotband.to = _this8.$refs.chart.chart.xAxis[0].dataMax;
                    });
                    chart.chart.xAxis[0].update();
                    chart.chart.xAxis[0].setExtremes(chart.chart.xAxis[0].getExtremes().dataMin + 1000, chart.chart.xAxis[0].getExtremes().dataMin + parseInt(this.getLocalSettings.interface.rtvalues) * 1000 + 8000, false);
                    chart.chart.redraw();
                } else if (this.config.graphType == 'weath' || this.config.graphType == 'adio') {
                    var rightOffset;
                    for (rightOffset = data.data.length - 1; rightOffset >= 0; rightOffset--) {
                        if (data.data[rightOffset][0].indexOf(chart.chart.xAxis[0].dataMax) > -1) {
                            rightOffset++;
                            break;
                        }
                    }

                    var elementsCount = (chart.chart.xAxis[0].getExtremes().dataMax - chart.chart.xAxis[0].getExtremes().dataMin) / 1000;
                    var shift = elementsCount > this.getLocalSettings.interface.rtvalues;

                    var offsetData = data.data.splice(rightOffset);
                    //console.log(data.data.length, offsetData.length);
                    for (var i = 1; i < data.headers.length; i++) {

                        for (var k = 0; k < offsetData.length; k++) {
                            chart.chart.series[i - 1].addPoint({
                                x: offsetData[k][0] * 1,
                                y: parseFloat(offsetData[k][i])
                            }, false, shift);
                        }
                        if (offsetData.length > 0) {
                            this.latestDataRealtime[i].data = offsetData[k - 1][i];
                            this.latestDataRealtime[0].data = offsetData[k - 1][0];
                        }
                    }
                    this.latestDataRealtime = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.latestDataRealtime));
                    chart.chart.xAxis[0].setExtremes(chart.chart.xAxis[0].getExtremes().dataMin + 1000, chart.chart.xAxis[0].getExtremes().dataMin + parseInt(this.getLocalSettings.interface.rtvalues) * 1000, false);
                    chart.chart.redraw();
                } else if (this.config.graphType == 'spect') {
                    this.clearGraphData(chart);
                    var seriesData = [[], []];
                    for (var i = 0; i < data.data.length; i++) {
                        seriesData[0].push([this.config.frequencies[i], parseFloat(data.data[i][1])]);
                        seriesData[1].push([this.config.frequencies[i], parseFloat(data.data[i][2])]);
                    }
                    chart.chart.series[0].setData(seriesData[0]);
                    chart.chart.series[1].setData(seriesData[1]);

                    chart.chart.redraw();
                }
            }
        },

        //EVENTS
        onSyncClicked: function onSyncClicked() {
            this.getLocalSettings.interface.syncgraphs = !this.getLocalSettings.interface.syncgraphs;
            //this.getLocalSettings.interface.syncgraphs = this.shared.sync;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, this.getLocalSettings);
        },

        onPreloadClicked: function onPreloadClicked() {
            var newValue = 1;
            if (this.isPreloading) {
                newValue = 0;
            }
            switch (this.config.graphType) {
                case 'weath':
                    this.getLocalSettings.interface.preloadWeather = newValue;
                    break;
                case 'noise':
                    this.getLocalSettings.interface.preloadNoise = newValue;
                    break;
                case 'spect':
                    this.getLocalSettings.interface.preloadSpectrum = newValue;
                    break;
                case 'adio':
                    this.getLocalSettings.interface.preloadAdio = newValue;
                    break;
                case 'statistics':
                    this.getLocalSettings.interface.preloadStatistics = newValue;
                    break;
            }

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, this.getLocalSettings);
        },

        onResetClicked: function onResetClicked() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["setSelectedInterval"])(this.$store, undefined, undefined, this.config.graphType);
        },

        checkIfEnabled: function checkIfEnabled() {
            if (this.getSettingsAddons && this.config.graphType == 'noise') {
                this.disabled = this.getSettingsAddons.noise == 0;
            }
            if (this.getSettingsAddons && this.config.graphType == 'weath') {
                this.disabled = this.getSettingsAddons.weather == 0;
            }
            if (this.getSettingsAddons && this.config.graphType == 'adio') {
                this.disabled = this.getSettingsAddons.adio == 0;
            }
            if (this.getSettingsAddons && this.config.graphType == 'statistics') {
                this.disabled = this.getSettingsAddons.statistics == 0;
            }
        },

        onHideGraphClicked: function onHideGraphClicked() {
            var _this9 = this;

            if (!this.isVisible) setTimeout(function () {
                return _this9.$refs.chart.chart.reflow();
            }, 500);
            if (this.config.graphType == 'weath') {
                var localSettings = this.getLocalSettings;
                localSettings.interface.weather = localSettings.interface.weather == 1 ? 0 : 1;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, localSettings);
            }
            if (this.config.graphType == 'noise') {
                var localSettings = this.getLocalSettings;
                localSettings.interface.noise = localSettings.interface.noise == 1 ? 0 : 1;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, localSettings);
            }
            if (this.config.graphType == 'spect') {
                var localSettings = this.getLocalSettings;
                localSettings.interface.spectrum = localSettings.interface.spectrum == 1 ? 0 : 1;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, localSettings);
            }
            if (this.config.graphType == 'adio') {
                var localSettings = this.getLocalSettings;
                localSettings.interface.adio = localSettings.interface.adio == 1 ? 0 : 1;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, localSettings);
            }
            if (this.config.graphType == 'statistics') {
                var localSettings = this.getLocalSettings;
                localSettings.interface.statistics = localSettings.interface.statistics == 1 ? 0 : 1;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, localSettings);
            }
        },
        yExtremCalc: function yExtremCalc(graph_min, graph_max) {
            var positions = [];
            var tick = Math.floor(graph_min);
            var divider = 10;
            if (Math.ceil(graph_max - graph_min) < 50) {
                divider = 5;
            }
            var increment = Math.ceil((graph_max - graph_min) / divider);
            if (graph_max !== null && graph_min !== null && increment > 0) {
                for (tick; tick - increment <= graph_max; tick += increment) {
                    positions.push(tick);
                }
            } else {
                positions.push(graph_min);
                positions.push(graph_max);
            }

            return positions;
        },
        LightenDarkenColor: function LightenDarkenColor(col, amt) {
            var usePound = false;
            if (col[0] == "#") {
                col = col.slice(1);
                usePound = true;
            }

            var num = parseInt(col, 16);

            var r = (num >> 16) + amt;

            if (r > 255) r = 255;else if (r < 0) r = 0;

            var b = (num >> 8 & 0x00FF) + amt;

            if (b > 255) b = 255;else if (b < 0) b = 0;

            var g = (num & 0x0000FF) + amt;

            if (g > 255) g = 255;else if (g < 0) g = 0;

            return (usePound ? "#" : "") + (g | b << 8 | r << 16).toString(16);
        },
        onDelayLoadingClick: function onDelayLoadingClick() {
            if (this.delayedLoadingType == 'loadDayGraph') {

                this.loadDayGraph();
            } else if (this.delayedLoadingType == 'loadHourGraph') {
                this.loadHourGraph();
            } else if (this.delayedLoadingType == 'realtimeReload') {
                try {
                    var currentGraphLoadingId = Date.now();
                    this.graphLoadingId = currentGraphLoadingId;
                    if (this.realtimeActive) {
                        this.reloadRealtime(this.graphLoadingId);
                    } else {
                        if (!this.realtimePreparing) this.prepareRealtime(this.graphLoadingId);
                    }
                } catch (err) {
                    console.log('Error realtime');
                }
                //this.prepareRealtime(this.graphLoadingId);
            }
            this.delayedLoading = false;
        },
        loadDayGraph: function loadDayGraph() {
            var _this10 = this;

            var currentGraphLoadingId = Date.now();
            this.graphLoadingId = currentGraphLoadingId;
            if (!this.config.showOnDay) {
                this.hidden = true;
                return;
            }
            var newDay = this.getSelectedDay;
            this.data.loading = true;
            this.hidden = false;
            var selectedDay = new Date(Date.UTC(newDay.year, newDay.month, newDay.day));
            this.noData = '';
            this.clearGraphData(this.$refs.chart, currentGraphLoadingId);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["getDailyData"])(this.$store, this.config.graphType, selectedDay, undefined, undefined).then(function (data) {
                _this10.fillGraphData(_this10.$refs.chart, data, currentGraphLoadingId);
                //this.data.loading = false;
            }).then(function () {
                if (_this10.config.graphType == 'noise') {

                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["getRecDay"])(_this10.$store, selectedDay).then(function (data) {
                        _this10.addAudioSerie(_this10.$refs.chart, data.data.audio, currentGraphLoadingId);
                        _this10.addVideoSerie(_this10.$refs.chart, data.data.video, currentGraphLoadingId);
                    }).catch(function () {}).then(function () {
                        return _this10.getMarkersDay({ from: selectedDay });
                    }).then(function (data) {
                        _this10.addGraphMarkers(_this10.$refs.chart, data.data, data.headers, currentGraphLoadingId);
                    }).catch(function (err) {});
                }
            }).catch(function (err) {
                if (err.error == 'noData') {
                    _this10.data.loading = false;
                    _this10.noData = 'graphs/nodata';
                }
            });
        },
        loadHourGraph: function loadHourGraph() {
            var _this11 = this;

            var currentGraphLoadingId = Date.now();
            this.graphLoadingId = currentGraphLoadingId;
            var newHour = this.getSelectedHour;
            this.data.loading = true;
            this.noData = '';
            if (newHour != '') {
                this.hidden = false;
                var selectedHour = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day, newHour));
                this.clearGraphData(this.$refs.chart, currentGraphLoadingId);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["getHourlyData"])(this.$store, this.config.graphType, selectedHour).then(function (data) {
                    return _this11.fillGraphData(_this11.$refs.chart, data, currentGraphLoadingId);
                }).then(function () {
                    _this11.data.loading = false;
                    if (_this11.config.graphType == 'noise') {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_actions__["getRecHour"])(_this11.$store, selectedHour).then(function (data) {
                            _this11.addAudioSerie(_this11.$refs.chart, data.data.audio, currentGraphLoadingId);
                            _this11.addVideoSerie(_this11.$refs.chart, data.data.video, currentGraphLoadingId);
                        }).catch(function () {}).then(function () {
                            return _this11.getMarkersHour({ from: selectedHour });
                        }).then(function (data) {
                            _this11.addGraphMarkers(_this11.$refs.chart, data.data, data.headers, currentGraphLoadingId);
                        }).catch(function () {}).then(function (data) {
                            return _this11.getDailyNote(selectedHour);
                        }).then(function (data) {
                            _this11.addDailyNote(_this11.$refs.chart, data.data, data.headers, currentGraphLoadingId);
                        }).catch(function (err) {});
                    }
                    return;
                }).catch(function (err) {
                    if (err.error == 'noData') {
                        _this11.data.loading = false;
                        _this11.noData = 'graphs/nodata';
                    }
                });
            }
        },
        statDayDownloadClicked: function statDayDownloadClicked() {
            var _this12 = this;

            var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day));
            var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_utils__["c" /* getUrlEncodedMeasurementDayFile */])(selectedTime);
            var url = '/api/reportWord-day&measurement=' + date + ('&time=' + Date.now());
            var title_data = {
                title: this.statform.title,
                templ: this.getLocalSettings.download.downlStatistic,
                lang: this.getLocalSettings.interface.language
            };
            this.setDownloading({ enabled: true, progress: 0, preparing: true });
            __WEBPACK_IMPORTED_MODULE_11__api__["_10" /* getFileAction */](url, 'POST', title_data, function (progress) {
                var percentage = 100;
                if (progress.total != 0) {
                    var _percentage = Math.round(progress.loaded / progress.total * 100);
                }
                _this12.setDownloadingProgress(percentage);
            }).then(function () {
                _this12.setDownloading({ enabled: false, progress: 0 });
            }).catch(function () {
                _this12.setDownloading({ enabled: false, progress: 0 });
            });

            // window.location.href = url;
        },
        stateRangeDownloadClicked: function stateRangeDownloadClicked() {
            var _this13 = this;

            var fromDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_utils__["c" /* getUrlEncodedMeasurementDayFile */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_utils__["d" /* addDays */])(this.statform.from, 1));
            var toDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_utils__["c" /* getUrlEncodedMeasurementDayFile */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_utils__["d" /* addDays */])(this.statform.to, 1));
            if (!fromDate || !toDate) return;

            var url = '/api/reportWord-range&fromDate=' + fromDate + '&toDate=' + toDate + ('&time=' + Date.now());
            var title_data = {
                title: this.statform.title,
                templ: this.getLocalSettings.download.downlStatistic,
                lang: this.getLocalSettings.interface.language
            };
            this.setDownloading({ enabled: true, progress: 0, preparing: true });
            __WEBPACK_IMPORTED_MODULE_11__api__["_10" /* getFileAction */](url, 'POST', title_data, function (progress) {
                var percentage = 100;
                if (progress.total != 0) {
                    var _percentage2 = Math.round(progress.loaded / progress.total * 100);
                }
                _this13.setDownloadingProgress(percentage);
            }).then(function () {
                _this13.setDownloading({ enabled: false, progress: 0 });
            }).catch(function () {
                _this13.setDownloading({ enabled: false, progress: 0 });
            });
            // window.location.href = url;
        },


        //Markers and stuff
        markerClicked: function markerClicked(markerId, callback) {
            var marker = this.getLocalSettings.markers.find(function (a) {
                return a.id == markerId;
            });
            if (!this.realtimeActive) {
                this.activeMarkerSelect = {
                    marker: marker,
                    callback: callback
                };
                callback(true, false);
            } else {
                var timestamp = new Date().getTime();
                if (!marker.type) {
                    //single
                    var plotband = {
                        from: this.$refs.chart.chart.xAxis[0].dataMax,
                        to: this.$refs.chart.chart.xAxis[0].dataMax + 2000,
                        id: 'Marker-' + markerId + '-' + timestamp,
                        color: marker.color,
                        opacity: 0.5,
                        zIndex: 0
                    };
                    this.$refs.chart.chart.xAxis[0].addPlotBand(plotband);
                    var markerD = {
                        id: markerId + '-' + timestamp,
                        name: marker.name,
                        from: plotband.from,
                        to: plotband.to,
                        type: marker.type,
                        color: marker.color
                    };
                    this.graphMarkers.push(markerD);
                    this.setMarker(markerD);
                } else {
                    var markerInstance = this.activeToggleMarkers[markerId];
                    if (markerInstance) {
                        var _plotband = this.activeToggleMarkers[markerId].plotband;
                        var _markerD = {
                            id: markerId + '-' + timestamp,
                            name: marker.name,
                            from: _plotband.from,
                            to: _plotband.to,
                            type: marker.type,
                            color: marker.color
                        };
                        this.graphMarkers.push(_markerD);
                        this.setMarker(_markerD);
                        delete this.activeToggleMarkers[markerId];
                        callback(false, true);
                    } else {
                        this.activeToggleMarkers[markerId] = {
                            plotband: {
                                from: this.$refs.chart.chart.xAxis[0].dataMax,
                                to: this.$refs.chart.chart.xAxis[0].dataMax + 2000,
                                id: 'Marker-' + markerId,
                                color: marker.color,
                                opacity: 0.1,
                                zIndex: 0
                            }
                        };

                        this.$refs.chart.chart.xAxis[0].addPlotBand(this.activeToggleMarkers[markerId].plotband);
                        callback(true, true);
                    }
                }
            }
        },
        removeMarker: function removeMarker(markerId) {
            var marker = this.graphMarkers.find(function (a) {
                return a.id == markerId;
            });
            var markerIndex = this.graphMarkers.indexOf(marker);
            this.graphMarkers.splice(markerIndex, 1);

            this.deleteMarker(marker);

            this.$refs.chart.chart.xAxis[0].plotLinesAndBands.forEach(function (pb) {
                if (pb.options.name == markerId) {
                    pb.destroy();
                }
            });
        },
        saveMarkerNoteClicked: function saveMarkerNoteClicked(markerId) {
            var marker = this.graphMarkers.find(function (a) {
                return a.id == markerId;
            });

            this.saveMarkerNote({ id: marker.id, note: marker.note, date: marker.from });
        },
        saveNoteClicked: function saveNoteClicked() {
            if (this.notesHourlyData.id != '') {
                if (this.getSelectedHour != '') {
                    //Hour
                    this.saveMarkerNote({ id: this.notesHourlyData.id, note: this.notesHourlyData.value, date: this.notesHourlyData.date });
                }
            } else {
                if (this.getSelectedHour != '') {
                    //Hour
                    var newDay = this.getSelectedDay;
                    var newHour = this.getSelectedHour;
                    var selectedDay = new Date(Date.UTC(newDay.year, newDay.month, newDay.day, newHour));

                    var marker = {
                        id: 'Marker_hour-' + selectedDay.getTime(),
                        name: 'Marker_hour',
                        from: selectedDay.getTime(),
                        to: selectedDay.getTime(),
                        type: 'Hour-Note',
                        color: '#ffffff',
                        notes: this.notesHourlyData.value
                    };

                    this.setMarker(marker);
                }
            }
        },
        saveDailyNoteClicked: function saveDailyNoteClicked() {
            if (this.notesData.id != '') this.saveMarkerNote({ id: this.notesData.id, note: this.notesData.value, date: this.notesData.date });else {
                var newDay = this.getSelectedDay;
                var selectedDay = new Date(Date.UTC(newDay.year, newDay.month, newDay.day, 1));

                var end = new Date(selectedDay);
                end.setHours(23, 59, 59);

                var marker = {
                    id: 'Marker_day-' + selectedDay.getTime(),
                    name: 'Marker_day',
                    from: selectedDay.getTime(),
                    to: end.getTime(),
                    type: 'Day-Note',
                    color: '#ffffff',
                    notes: this.notesData.value
                };

                this.setMarker(marker);
            }
        }
    }),
    mounted: function mounted() {
        this.checkIfEnabled();

        this.$on('realtimeReload', function (data) {
            this.hidden = false;
            if (!this.realtimeActive && !this.realtimePreparing) {
                if (this.isPreloading) {
                    this.delayedLoading = true;
                    this.delayedLoadingType = 'realtimeReload';
                    return;
                } else {
                    this.delayedLoading = false;
                }
            }

            this.noData = '';
            var currentGraphLoadingId = Date.now();
            if (!this.realtimeActive && this.realtimePreparing) {} else {
                this.graphLoadingId = currentGraphLoadingId;
            }

            if (this.config.graphType == 'noise') {

                //console.log('realtimeactive', this.realtimeActive)
                //console.log('realtimepreparing', this.realtimePreparing)
            }

            try {
                if (this.realtimeActive) {
                    this.reloadRealtime(currentGraphLoadingId);
                } else {
                    if (!this.realtimePreparing) this.prepareRealtime(currentGraphLoadingId);
                }
            } catch (err) {
                console.log('Error');
            }
        });

        this.$on('loadDayGraph', function (data) {
            if (!this.config.showOnDay) {
                this.hidden = true;
                return;
            }
            if (this.isPreloading) {
                this.delayedLoading = true;
                this.delayedLoadingType = 'loadDayGraph';
                return;
            } else {
                this.delayedLoading = false;
            }
            this.loadDayGraph();
        });

        this.$on('loadHourGraph', function (data) {
            this.hidden = false;
            if (this.isPreloading) {
                this.delayedLoading = true;
                this.delayedLoadingType = 'loadHourGraph';
                return;
            } else {
                this.delayedLoading = false;
            }
            this.loadHourGraph();
        });
    }

});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  data: function data() {
    return {
      previousValue: '',
      firstLoad: true
    };
  },
  methods: {
    saveClicked: function saveClicked() {
      this.$emit('saveClick');
      this.previousValue = this.data.value;
    }
  },
  mounted: function mounted() {
    //this.previousValue = data.value;
  },
  watch: {
    'data.value': function dataValue(value) {
      if (this.firstLoad) {
        this.firstLoad = false;
        this.previousValue = value;
      }
      if (value != this.previousValue) {}
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Graph__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Graph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Graph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExportGraph__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExportGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ExportGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graph_configs__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            options: __WEBPACK_IMPORTED_MODULE_3__graph_configs__["noise"],
            configs: __WEBPACK_IMPORTED_MODULE_3__graph_configs__,
            noiseVisible: true,
            noiseChart: null,
            noise: { loading: false },
            weather: { loading: false },
            spectogram: { loading: false },
            adio: { loading: false },
            statistics: { loading: false },
            shared: { sync: true, realtime: false },
            realtimeInterval: undefined,
            activateHour: false,
            mounted: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['getSidebarVisible', 'getSelectedDay', 'getSelectedHour', 'getRealtimeEnabled', 'getLocalSettings', 'getSelectedDayHours', 'getMounted', 'getSettingsAdio', 'getSettingsWeather', 'getScreenSize']), {
        containerClassName: function containerClassName() {
            return 'graphs-container' + (this.loading ? ' loading' : '');
        },
        graphsLoading: function graphsLoading() {
            return this.noise.loading || this.weather.loading;
        },
        isStatistics: function isStatistics() {
            return this.$route.path.indexOf('/statistics') > -1;
        }
    }),
    components: {
        'export-graph': __WEBPACK_IMPORTED_MODULE_2__ExportGraph___default.a,
        'graph': __WEBPACK_IMPORTED_MODULE_1__Graph___default.a
    },
    watch: {
        getRealtimeEnabled: function getRealtimeEnabled(enabled) {
            if (enabled) {
                clearInterval(this.realtimeInterval);
                this.realtimeInterval = setInterval(this.realtimeReload, 1000);
            } else {
                clearInterval(this.realtimeInterval);
                this.reloadGraphs();
            }
        },
        getSelectedDayHours: function getSelectedDayHours(hours) {

            if (this.activateHour && hours.length > 0) {
                this.activateHour = false;
                var lastHour = hours[hours.length - 1].split('-')[3];
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_actions__["setSelectedHour"])(this.$store, lastHour);
                this.sendToGraphs('loadHourGraph', lastHour);
            }
        },
        getSelectedHour: function getSelectedHour(newHour) {

            if (this.getMounted && !this.getRealtimeEnabled && newHour.replace(/ /g, '')) this.sendToGraphs('loadHourGraph');
        },
        getSelectedDay: function getSelectedDay(newDay) {
            if (this.getMounted && !this.getRealtimeEnabled) this.sendToGraphs('loadDayGraph');
        },
        isStatistics: function isStatistics(stat) {
            if (stat) {
                this.sendToGraphs('loadDayGraph');
            }
        }
    },
    methods: {
        sendToGraphs: function sendToGraphs(msg, data) {
            var delayedLoading = false;
            if (this.getScreenSize < 2) delayedLoading = true;
            if (this.$refs.noiseGraph) this.$refs.noiseGraph.$emit(msg, { data: data, delayedLoading: delayedLoading });
            if (this.$refs.spectGraph) this.$refs.spectGraph.$emit(msg, { data: data, delayedLoading: delayedLoading });
            if (this.$refs.weathGraph) this.$refs.weathGraph.$emit(msg, { data: data, delayedLoading: delayedLoading });
            if (this.$refs.adioGraph) this.$refs.adioGraph.$emit(msg, { data: data, delayedLoading: delayedLoading });
            if (this.isStatistics) this.$refs.statisticsGraph.$emit(msg, { data: data, delayedLoading: delayedLoading });
        },
        realtimeReload: function realtimeReload() {
            var delayedLoading = false;
            if (this.getScreenSize < 2) delayedLoading = true;
            if (this.$refs.noiseGraph) this.$refs.noiseGraph.$emit('realtimeReload', { delayedLoading: delayedLoading });
            if (this.$refs.spectGraph) this.$refs.spectGraph.$emit('realtimeReload', { delayedLoading: delayedLoading });
            if (this.$refs.weathGraph) this.$refs.weathGraph.$emit('realtimeReload', { delayedLoading: delayedLoading });
            if (this.$refs.adioGraph) this.$refs.adioGraph.$emit('realtimeReload', { delayedLoading: delayedLoading });
        },
        reloadGraphs: function reloadGraphs() {
            if (!this.getMounted) return;
            if (this.getSelectedHour != '' && !this.isStatistics && this.getSelectedDay) {
                this.sendToGraphs('loadHourGraph');
            } else if (this.getSelectedDay.year) {
                //setSelectedDay(this.$store, JSON.parse(JSON.stringify(this.getSelectedDay)));
                //if(this.getSelectedDayHours.length > 0){
                //    setSelectedHour(this.$store, this.getSelectedDayHours[this.getSelectedDayHours.length-1].split('-')[3]);
                //}
                this.sendToGraphs('loadDayGraph');
            } else {
                var date = new Date();
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_actions__["setSelectedDay"])(this.$store, { day: date.getDate(), month: date.getMonth(), year: date.getFullYear() });
                this.activateHour = true;
                this.sendToGraphs('loadDayGraph');
            }
            if (this.getLocalSettings.interface) {
                this.shared.sync = this.getLocalSettings.interface.syncgraphs;
            }
            //GraphConfigs.noise.chart.events.selection= (event)=>this.selection(this.$refs.noiseChart,event);
        }

    },
    mounted: function mounted() {
        if (this.getRealtimeEnabled) {
            this.realtimeInterval = setInterval(this.realtimeReload, 1000);
        } else {
            this.reloadGraphs();
        }
        /*if(this.$route.fullPath == '/realtime'){
             setRealtimeEnabled(this.$store, true);
        }else{
            setRealtimeEnabled(this.$store, false);
            this.reloadGraphs();
        }*/
        //setTimeout(()=>{
        //    this.mounted = true;
        //},500)
    },
    destroyed: function destroyed() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_actions__["setRealtimeEnabled"])(this.$store, false);
    }

});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['getLocalSettings'])),
    data: function data() {
        return {
            editingMarker: null,
            keys: ['a', 'b', 'c', 'č', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'r', 's', 'š', 't', 'u', 'v', 'z', 'ž', 'x', 'y', 'w', 'q', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'f10', 'f11', 'f12'],
            activeToggleMarkers: {}
        };
    },
    methods: {
        addMarkerClicked: function addMarkerClicked() {

            var markerId = new Date().getTime();

            var marker = {
                id: markerId,
                type: false, //false - single, true - toggle
                name: 'New Marker',
                color: '#ff0066',
                keyCombo: { modifier: 'alt', key: '1' }
            };

            this.getLocalSettings.markers.push(marker);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, this.getLocalSettings);
        },
        editMarker: function editMarker(markerId) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, this.getLocalSettings);
            if (this.editingMarker == markerId) {
                this.editingMarker = null;
                return;
            }
            this.editingMarker = markerId;
        },

        deleteClicked: function deleteClicked(markerId) {
            var marker = this.getLocalSettings.markers.find(function (a) {
                return a.id == markerId;
            });
            var markerIndex = this.getLocalSettings.markers.indexOf(marker);

            this.getLocalSettings.markers.splice(markerIndex, 1);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, this.getLocalSettings);
        },
        markerClicked: function markerClicked(markerId) {
            var _this = this;

            this.$emit('markerClicked', markerId, function (enabled, realtime) {
                if (!realtime) {
                    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.activeToggleMarkers).forEach(function (a) {
                        _this.activeToggleMarkers[a] = false;
                    });
                }
                _this.activeToggleMarkers[markerId] = enabled;
                _this.activeToggleMarkers = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.activeToggleMarkers));
            });
        }
    }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            imgSource: "",
            imgSourceBig: ""
        };
    },
    computed: {
        fileSource: function fileSource() {
            if (this.data.filename) {

                var filename = this.data.filename;
                //2017-08-18-09-41-02.mp3
                var date = filename.split('.')[0].split('-').slice(0, 3).join('-');
                //console.log('/audio/audio/'+date+'/'+this.data.filename)
                return '/audio/audio/' + date + '/' + this.data.filename;
            }
            return false;
        }
    },
    methods: {
        audioLoaded: function audioLoaded() {
            var audioController = this.$refs.audioController;
            audioController.currentTime = 0;
            this.imgSourceBig = false;
            this.imgSource = this.imgLoad();
        },
        imgLoad: function imgLoad() {
            if (this.data.filename) {
                var filename = this.data.filename.substring(0, this.data.filename.length - 4) + '.png';
                //2017-08-18-09-41-02.mp3
                var date = filename.split('.')[0].split('-').slice(0, 3).join('-');
                this.imgSourceBig = "";
                return '/audio/audio/' + date + '/thumbnails/' + filename;
            }
            return false;
        },
        setImgBig: function setImgBig() {
            if (this.data.filename) {
                var filename = this.data.filename.substring(0, this.data.filename.length - 4) + '.png';
                //2017-08-18-09-41-02.mp3
                var date = filename.split('.')[0].split('-').slice(0, 3).join('-');
                this.imgSourceBig = '/audio/audio/' + date + '/' + filename;
                this.imgSource = "";
            }
            return false;
        },
        close: function close() {
            this.data.visible = false;
            this.data.filename = undefined;
            this.imgSourceBig = "";
            this.imgSource = "";
        }
    },
    watch: {
        'data.visible': function dataVisible(value) {
            if (!value) {
                this.data.visible = false;
                this.data.filename = undefined;
                this.imgSourceBig = "";
                this.imgSource = "";
            }
            //this.data = JSON.parse(JSON.stringify(this.data));
            //console.log(this.fileSource);
        }
    }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loginData: {
                username: '',
                password: ''
            }
        };
    },
    methods: {
        loginSubmit: function loginSubmit() {
            var _this = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_actions__["loginUser"])(this.$store, this.loginData.username, this.loginData.password).then(function (data) {
                if (data.username) {
                    _this.$localStorage.set('token', data.token);
                    _this.$localStorage.set('useraccount', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
                    _this.$router.push('/');
                }
                window.location.reload();
            });
        },
        buttonKeypressed: function buttonKeypressed() {
            alert('ok');
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_actions__["getUser"])(this.$store).then(function (_) {
            _this2.$router.go(-1);
        });
    }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettingsAddons'])),
    methods: {
        clicked: function clicked(type) {
            var type_show = type;
            if (type == 'global') type_show = 'noise';
            if (this.getSettingsAddons[type_show] == '0') return;
            this.$router.push('/archives/' + type);
        },
        getClass: function getClass(menu) {
            if (this.getSettingsAddons[menu] == '0') return 'disabled-button';
            return '';
        }
    }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(32);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['getSelectedDay', 'getSelectedHour', 'getLocalSettings', 'getSelectedInterval']), {
        hasHours: function hasHours() {
            if (this.getSelectedHour != '') return true;else return false;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['setDownloading', 'setDownloadingProgress']), {
        xmlClicked: function xmlClicked() {
            var _this = this;

            var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day, this.getSelectedHour));
            var localSettings = this.getLocalSettings;
            var downloadNoise = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localSettings.download.downlnoise).forEach(function (key) {
                if (localSettings.download.downlnoise[key]) downloadNoise.push(key);
            });
            var downloadWeather = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localSettings.download.downlweath).forEach(function (key) {
                if (localSettings.download.downlweath[key]) downloadWeather.push(key);
            });

            var other_arr = [];
            // if(localSettings.download.audio && localSettings.download.video) other = '&othr=audio,video'
            // if(!localSettings.download.audio && localSettings.download.video) other = '&othr=video'
            // if(localSettings.download.audio && !localSettings.download.video) other = '&othr=audio'
            if (localSettings.download.video) other_arr.push("video");
            if (localSettings.download.audio) other_arr.push("audio");
            if (localSettings.download.markers) other_arr.push("markers");
            var other = "&othr=" + other_arr.toString();
            //./api/download-xml&measurement=yyyy-mm-dd--HH&param=Noise values&paramw=Weather values&other=audio/video
            var url = '';

            var startInt = undefined;
            var endInt = undefined;
            if (this.getSelectedInterval.start) {
                startInt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["f" /* getUrlEncodedDateTime */])(this.getSelectedInterval.start);
            }
            if (this.getSelectedInterval.end) {
                endInt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["f" /* getUrlEncodedDateTime */])(this.getSelectedInterval.end);
            }
            if (startInt !== undefined) {
                startInt += ".000";
            }
            if (endInt !== undefined) {
                endInt += ".000";
            }
            if (this.hasHours) {
                url = '/api/download-xml&measurement=' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["g" /* getUrlEncodedMeasurementHourFile */])(selectedTime) + '&param=' + downloadNoise.join(',') + '&paramw=' + downloadWeather.join(',') + other + '&start=' + startInt + '&stop=' + endInt + '&time=' + Date.now();
            } else {
                url = '/api/download-xml&measurement=' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["c" /* getUrlEncodedMeasurementDayFile */])(selectedTime) + '&param=' + downloadNoise.join(',') + '&paramw=' + downloadWeather.join(',') + other + '&start=' + startInt + '&stop=' + endInt + '&time=' + Date.now();
            }
            url = url.replace(/ /g, '_');
            this.setDownloading({ enabled: true, progress: 0, preparing: true });
            __WEBPACK_IMPORTED_MODULE_4__api__["_10" /* getFileAction */](url, 'GET', '', function (progress) {
                var percentage = 100;
                if (progress.total != 0) {
                    percentage = Math.round(progress.loaded / progress.total * 100);
                }
                _this.setDownloadingProgress(percentage);
            }).then(function () {
                _this.setDownloading({ enabled: false, progress: 0 });
            }).catch(function () {
                _this.setDownloading({ enabled: false, progress: 0 });
            });
            //window.location.href = url;
        },
        xmlWeeklyClicked: function xmlWeeklyClicked() {
            var _this2 = this;

            var selectedDay = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day, this.getSelectedHour));
            var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["h" /* getWeekDays */])(selectedDay).join(',');
            var localSettings = this.getLocalSettings;
            var downloadNoise = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localSettings.download.downlnoise).forEach(function (key) {
                if (localSettings.download.downlnoise[key]) downloadNoise.push(key);
            });
            var downloadWeather = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localSettings.download.downlweath).forEach(function (key) {
                if (localSettings.download.downlweath[key]) downloadWeather.push(key);
            });

            var other_arr = [];
            // if(localSettings.download.audio && localSettings.download.video) other = '&othr=audio,video'
            //if(!localSettings.download.audio && localSettings.download.video) other = '&othr=video'
            //if(localSettings.download.audio && !localSettings.download.video) other = '&othr=audio'

            if (localSettings.download.video) other_arr.push("video");
            if (localSettings.download.audio) other_arr.push("audio");
            if (localSettings.download.markers) other_arr.push("markers");
            var other = "&othr=" + other_arr.toString();

            var url = '/api/download-xml&measurement=' + days + '&param=' + downloadNoise.join(',') + '&paramw=' + downloadWeather.join(',') + other + '&time=' + Date.now();
            this.setDownloading({ enabled: true, progress: 0, preparing: true });
            __WEBPACK_IMPORTED_MODULE_4__api__["_10" /* getFileAction */](url, 'GET', '', function (progress) {
                var percentage = 100;
                if (progress.total != 0) {
                    percentage = Math.round(progress.loaded / progress.total * 100);
                }
                _this2.setDownloadingProgress(percentage);
            }).then(function () {
                _this2.setDownloading({ enabled: false, progress: 0 });
            }).catch(function () {
                _this2.setDownloading({ enabled: false, progress: 0 });
            });
            //window.location.href = url;
        },
        rawClicked: function rawClicked() {
            var _this3 = this;

            var date = '';

            var localSettings = this.getLocalSettings;
            var downloadNoise = [];
            var downloadWeather = [];

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localSettings.download.downlnoise).forEach(function (key) {
                if (localSettings.download.downlnoise[key]) downloadNoise.push(key);
            });
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localSettings.download.downlweath).forEach(function (key) {
                if (localSettings.download.downlweath[key]) downloadWeather.push(key);
            });

            if (!this.hasHours || this.getSelectedInterval.end && this.getSelectedInterval.start) {
                var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day));
                date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["c" /* getUrlEncodedMeasurementDayFile */])(selectedTime);
                var url = '';
                if (this.getSelectedInterval.end && this.getSelectedInterval.start) {
                    //./api/download-day &measurement=yyyy-mm-dd&param=Noise values&paramw=Weather values&start=yyyy-mm-dd HH:MM:SS.fff&stop=yyyy-mm-dd HH:MM:SS.fff&zip=0/1
                    var start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["f" /* getUrlEncodedDateTime */])(this.getSelectedInterval.start);
                    var end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["f" /* getUrlEncodedDateTime */])(this.getSelectedInterval.end);
                    if (start !== undefined) {
                        start += ".000";
                    }
                    if (end !== undefined) {
                        end += ".000";
                    }
                    url = '/api/download-day&measurement=' + date + '&param=' + downloadNoise.join(',') + '&paramw=' + downloadWeather.join(',') + '&start=' + start + '&stop=' + end + '&zip=' + localSettings.download.downlzip + '&time=' + Date.now();
                } else {
                    url = '/api/download-day&measurement=' + date + '&param=' + downloadNoise.join(',') + '&paramw=' + downloadWeather.join(',') + '&zip=' + localSettings.download.downlzip + '&time=' + Date.now();
                }

                url = url.replace(/ /g, '_');

                this.setDownloading({ enabled: true, progress: 0, preparing: true });
                __WEBPACK_IMPORTED_MODULE_4__api__["_10" /* getFileAction */](url, 'GET', '', function (progress) {
                    var percentage = 100;
                    if (progress.total != 0) {
                        percentage = Math.round(progress.loaded / progress.total * 100);
                    }
                    _this3.setDownloadingProgress(percentage);
                }).then(function () {
                    _this3.setDownloading({ enabled: false, progress: 0 });
                }).catch(function () {
                    _this3.setDownloading({ enabled: false, progress: 0 });
                });
                //window.location.href = (url.replace(/ /g, '_'));
            } else {
                var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day, this.getSelectedHour));
                date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["g" /* getUrlEncodedMeasurementHourFile */])(selectedTime);
                var url = '/api/download-raw&measurement=' + date + '&param=' + downloadNoise.join(',') + '&paramw=' + downloadWeather.join(',') + '&zip=' + localSettings.download.downlzip + '&time=' + Date.now();
                //alert(url);

                url = url.replace(/ /g, '_');

                this.setDownloading({ enabled: true, progress: 0, preparing: true });
                __WEBPACK_IMPORTED_MODULE_4__api__["_10" /* getFileAction */](url, 'GET', '', function (progress) {
                    var percentage = 100;
                    if (progress.total != 0) {
                        percentage = Math.round(progress.loaded / progress.total * 100);
                    }
                    _this3.setDownloadingProgress(percentage);
                }).then(function () {
                    _this3.setDownloading({ enabled: false, progress: 0 });
                }).catch(function () {
                    _this3.setDownloading({ enabled: false, progress: 0 });
                });
                //window.location.href = (url.replace(/ /g, '_'));                
            }

            //./api/download-raw&measurement=yyyy-mm-dd-HH&param=Noise values&paramw=Weather values&zip=0/1
        },
        globalClicked: function globalClicked() {
            var _this4 = this;

            var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day));
            var localSettings = this.getLocalSettings;
            var downloadGlobal = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localSettings.download.downlGlobal).forEach(function (key) {
                if (localSettings.download.downlGlobal[key]) downloadGlobal.push(key);
            });

            //./api/download-global&measurement=yyyy-mm-dd&param=Global values&zip=0/1

            var startInt = undefined;
            var endInt = undefined;
            if (this.getSelectedInterval.start) {
                startInt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["f" /* getUrlEncodedDateTime */])(this.getSelectedInterval.start);
            }
            if (this.getSelectedInterval.end) {
                endInt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["f" /* getUrlEncodedDateTime */])(this.getSelectedInterval.end);
            }
            if (startInt !== undefined) {
                startInt += ".000";
            }
            if (endInt !== undefined) {
                endInt += ".000";
            }

            var url = '/api/download-global&measurement=' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["c" /* getUrlEncodedMeasurementDayFile */])(selectedTime) + '&param=' + downloadGlobal.join(',') + '&zip=' + localSettings.download.downlzip + '&start=' + startInt + '&stop=' + endInt + '&time=' + Date.now();

            this.setDownloading({ enabled: true, progress: 0, preparing: true });
            __WEBPACK_IMPORTED_MODULE_4__api__["_10" /* getFileAction */](url, 'GET', '', function (progress) {
                var percentage = 100;
                if (progress.total != 0) {
                    percentage = Math.round(progress.loaded / progress.total * 100);
                }
                _this4.setDownloadingProgress(percentage);
            }).then(function () {
                _this4.setDownloading({ enabled: false, progress: 0 });
            }).catch(function () {
                _this4.setDownloading({ enabled: false, progress: 0 });
            });
            //window.location.href = url;
        },
        weathClicked: function weathClicked() {
            var _this5 = this;

            var date = '';

            var localSettings = this.getLocalSettings;
            var downloadWeather = [];

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localSettings.download.downlweath).forEach(function (key) {
                if (localSettings.download.downlweath[key]) downloadWeather.push(key);
            });

            if (!this.hasHours || this.getSelectedInterval.end && this.getSelectedInterval.start) {
                var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day));
                date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["c" /* getUrlEncodedMeasurementDayFile */])(selectedTime);
                var url = '';
                if (this.getSelectedInterval.end && this.getSelectedInterval.start) {
                    var start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["f" /* getUrlEncodedDateTime */])(this.getSelectedInterval.start);
                    var end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["f" /* getUrlEncodedDateTime */])(this.getSelectedInterval.end);
                    if (start !== undefined) {
                        start += ".000";
                    }
                    if (end !== undefined) {
                        end += ".000";
                    }
                    url = '/api/download-weather-day&measurement=' + date + '&paramw=' + downloadWeather.join(',') + '&start=' + start + '&stop=' + end + '&zip=' + localSettings.download.downlzip + '&time=' + Date.now();
                } else {
                    url = '/api/download-weather-day&measurement=' + date + '&paramw=' + downloadWeather.join(',') + '&zip=' + localSettings.download.downlzip + '&time=' + Date.now();
                }

                url = url.replace(/ /g, '_');
                this.setDownloading({ enabled: true, progress: 0, preparing: true });
                __WEBPACK_IMPORTED_MODULE_4__api__["_10" /* getFileAction */](url, 'GET', '', function (progress) {
                    var percentage = 100;
                    if (progress.total != 0) {
                        percentage = Math.round(progress.loaded / progress.total * 100);
                    }
                    _this5.setDownloadingProgress(percentage);
                }).then(function () {
                    _this5.setDownloading({ enabled: false, progress: 0 });
                }).catch(function () {
                    _this5.setDownloading({ enabled: false, progress: 0 });
                });
                //window.location.href = (url.replace(/ /g, '_'));
            } else {
                var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day, this.getSelectedHour));
                date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["g" /* getUrlEncodedMeasurementHourFile */])(selectedTime);
                var url = '/api/download-weather&measurement=' + date + '&paramw=' + downloadWeather.join(',') + '&zip=' + localSettings.download.downlzip + '&time=' + Date.now();
                //alert(url);
                url = url.replace(/ /g, '_');

                this.setDownloading({ enabled: true, progress: 0, preparing: true });
                __WEBPACK_IMPORTED_MODULE_4__api__["_10" /* getFileAction */](url, 'GET', '', function (progress) {
                    var percentage = 100;
                    if (progress.total != 0) {
                        percentage = Math.round(progress.loaded / progress.total * 100);
                    }
                    _this5.setDownloadingProgress(percentage);
                }).then(function () {
                    _this5.setDownloading({ enabled: false, progress: 0 });
                }).catch(function () {
                    _this5.setDownloading({ enabled: false, progress: 0 });
                });
                //window.location.href = (url.replace(/ /g, '_'));                
            }
        }
    })
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ArchivePopover__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ArchivePopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ArchivePopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlayPopover__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlayPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PlayPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DownloadPopover__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DownloadPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DownloadPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StreamPopover__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StreamPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__StreamPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__calendar_Calendar__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__calendar_Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__calendar_Calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__calendar_CalendarContainer__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__calendar_CalendarContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__calendar_CalendarContainer__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			//xs=0,sm=1,md=2,lg=3
			screenSize: 3,
			sidebarVisible: true,
			test: true
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['getStatus', 'getSystemStatus', 'getRealtimeEnabled', 'getSettingsDevice', 'getSettingsSystem', 'getUser', 'getSettingsAddons', 'getDownloading', 'getLocalSettings']), {
		isDownloading: function isDownloading() {
			return this.getDownloading.enabled;
		},
		contentClassname: function contentClassname() {
			return 'content' + (this.screenSize > 1 && this.sidebarVisible ? ' sidebar-visible' : '');
		},
		showDownloads: function showDownloads() {
			return this.$route.fullPath == '/' && !this.getRealtimeEnabled;
		},
		roundDecimal: function roundDecimal() {
			return Math.round((100 - this.getSystemStatus.n140_sd_percent) * 10) / 10;
		},
		roundDecimalHDD: function roundDecimalHDD() {
			return Math.round((100 - this.getSystemStatus.hdd_percent) * 10) / 10;
		},
		isSizeBelowLimit: function isSizeBelowLimit() {
			return this.roundDecimal <= parseInt(this.getSettingsDevice.sdfreelimit);
		},
		isHddSizeBelowLimit: function isHddSizeBelowLimit() {
			return this.roundDecimalHDD <= parseInt(this.getSettingsSystem.pchddlimit);
		},
		playButtonClass: function playButtonClass() {
			var isError = this.getStatus.weatherError || this.getStatus.noiseError || this.getStatus.adioError;
			return {
				danger: !this.getStatus.noise && !this.getStatus.weather && !this.getStatus.adio || isError,
				warning: (!this.getStatus.noise || !this.getStatus.weather || !this.getStatus.adio) && !isError,
				ok: this.getStatus.noise && (this.getStatus.weather || this.getStatus.adio) && !isError

			};
		},
		isSettings: function isSettings() {
			return this.$route.fullPath.indexOf('settings') > -1;
		},
		isArchives: function isArchives() {
			return this.$route.fullPath.indexOf('archives') > -1;
		},
		statusMessage: function statusMessage() {
			return this.getStatus.noiseCode ? "n140:" + this.getStatus.noiseCode : this.getStatus.weatherCode ? "weather:" + this.getStatus.weatherCode : this.getStatus.adioCode ? "adio:" + this.getStatus.adioCode : this.getSystemStatus.cam_sd_percent > 80 ? 'cameraSD' : '';
		},
		sdStatusMessage: function sdStatusMessage() {
			if (this.statusMessage) return false;
			return this.isSizeBelowLimit;
		},
		hddStatusMessage: function hddStatusMessage() {
			if (this.statusMessage || this.sdStatusMessage) return false;
			return this.isHddSizeBelowLimit;
		},
		statusSidebar: function statusSidebar() {
			return this.statusMessage ? 'error' : this.playButtonClass.ok ? 'running' : this.playButtonClass.danger ? 'notRunning' : this.playButtonClass.warning ? 'running' : 'notRunning';
		}
	}),
	components: {
		'calendar': __WEBPACK_IMPORTED_MODULE_9__calendar_Calendar___default.a,
		'calendar-container': __WEBPACK_IMPORTED_MODULE_10__calendar_CalendarContainer___default.a,
		'play-popover': __WEBPACK_IMPORTED_MODULE_6__PlayPopover___default.a,
		'download-popover': __WEBPACK_IMPORTED_MODULE_7__DownloadPopover___default.a,
		'stream-popover': __WEBPACK_IMPORTED_MODULE_8__StreamPopover___default.a,
		'archive-popover': __WEBPACK_IMPORTED_MODULE_5__ArchivePopover___default.a
	},
	watch: {
		'$mq.resize': 'screenResize',
		getStatus: function getStatus(newStatus) {},
		'$route': function $route(route) {
			if (route.fullPath == '/') {
				this.sidebarVisible = true;
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["setSidebarVisible"])(this.$store, this.sidebarVisible);
			}
			if (route.fullPath.indexOf('realtime') > -1) {
				this.setRealtimeEnabled(true);
			} else {
				this.setRealtimeEnabled(false);
			}
		},
		getSettingsSystem: function getSettingsSystem(settings) {
			document.title = 'Noise2Net » ' + settings.hostname;
		}
	},
	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['setRealtimeEnabled', 'getFirmware', 'setDownloading', 'getDefaultMarkers']), {
		screenResize: function screenResize() {
			if (this.$mq.below(768)) {
				this.screenSize = 0;
				this.sidebarVisible = false;
			} else if (this.$mq.above(1199)) {
				this.screenSize = 3;
			} else if (this.$mq.above(991)) {
				this.screenSize = 2;
			} else if (this.$mq.above(766)) {
				this.screenSize = 1;
				this.sidebarVisible = false;
			}
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["setScreenSize"])(this.$store, this.screenSize);
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["setSidebarVisible"])(this.$store, this.sidebarVisible);
		},
		menuOnClick: function menuOnClick() {
			this.sidebarVisible = !this.sidebarVisible;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["setSidebarVisible"])(this.$store, this.sidebarVisible);
			if (this.screenSize < 2) {
				window.scrollTo(0, 0);
			}
		},
		navigateToSettings: function navigateToSettings() {
			this.sidebarVisible = !this.sidebarVisible;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["setSidebarVisible"])(this.$store, this.sidebarVisible);
			if (this.$route.fullPath.indexOf('/settings/') > -1) {
				this.$router.push('/');
			} else {
				this.$router.push("/settings/interface");
			}
		},
		toggleRealtime: function toggleRealtime() {
			if (this.getRealtimeEnabled) this.$router.push('/');else this.$router.push('/realtime');
			//setRealtimeEnabled(this.$store, !this.getRealtimeEnabled);
			//this.$router.push('/realtime');
		},
		systemStatusReload: function systemStatusReload() {
			var _this = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["getSystemStatus"])(this.$store);
			setInterval(function () {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["getSystemStatus"])(_this.$store);
			}, 5000);
		},
		handleLocalSettings: function handleLocalSettings() {
			var _this2 = this;

			var vueInstance = this;
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this2.getFirmware().then(function (data) {
					return data.epoch;
				}).catch(function (err) {
					return Math.random();
				}).then(function (version) {
					var localSettingsVersion = vueInstance.$localStorage.get('settingsV', 1);
					var localSettings = vueInstance.$localStorage.get('settings', false);
					var isValid = true;
					try {
						localSettings = JSON.parse(localSettings);
					} catch (err) {
						isValid = false;
					}

					if (!localSettings || !isValid || localSettingsVersion != version) {
						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["getLocalSettings"])(vueInstance.$store).then(function (settings) {
							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils__["e" /* mutateLocalSettings */])(settings, _this2.screenSize);
							//vueInstance.$localStorage.set('settings', JSON.stringify(settings));
							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["saveLocalSettings"])(vueInstance.$store, vueInstance.$localStorage, settings);
							resolve(localSettings);
						}).catch(function (err) {
							reject(err);
						});
					} else {
						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["saveLocalSettings"])(vueInstance.$store, vueInstance.$localStorage, localSettings);
						resolve(localSettings);
					}
				});
			});
		},
		handleRemoteSettings: function handleRemoteSettings() {
			var _this3 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["getSettings"])(this.$store).then(function (settings) {
				//saveSettings(this.$store, settings);
				_this3.loading = false;
				//settings received
			});
		},
		goToManual: function goToManual() {
			window.open("/manual/");
		},
		logoutClicked: function logoutClicked() {
			var _this4 = this;

			this.$localStorage.set('useraccount', '');
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["logoutUser"])(this.$store).then(function () {
				_this4.$router.push('/login');
			});
		},
		onStatisticsClick: function onStatisticsClick() {
			if (this.getSettingsAddons.statistics == 1) {
				if (this.$route.path.indexOf('/statistics') > -1) {
					this.$router.push('/');
				} else {
					this.$router.push('/statistics');
				}
			}
		}
	}),
	beforeMount: function beforeMount() {

		if (this.$route.fullPath.indexOf('realtime') > -1) {
			if (!this.$p('realtime')) {
				return;
				this.$router.push('/');
			}
			this.setRealtimeEnabled(true);
		} else {
			this.setRealtimeEnabled(false);
		}

		if (!this.getUser.username) {
			var useraccount = this.$localStorage.get('useraccount');
			if (useraccount) {
				useraccount = JSON.parse(useraccount);
				if (!useraccount.username) {
					this.$router.push('/login');
					return;
				}
				//useraccount.type = 'guest'
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["saveUser"])(this.$store, useraccount);
			} else {
				this.$router.push('/login');
				return;
			}
		}
	},
	mounted: function mounted() {
		var _this5 = this;

		this.screenResize();
		this.handleLocalSettings().then(function () {
			_this5.handleRemoteSettings();
		}).catch(function () {}).then(function () {
			_this5.getDefaultMarkers().then(function (markers) {
				markers.forEach(function (m) {
					if (_this5.getLocalSettings.markers) {
						if (!_this5.getLocalSettings.markers.find(function (i) {
							return i.id == m.id;
						})) {
							_this5.getLocalSettings.markers.push({
								id: m.id,
								name: m.name,
								color: m.color,
								type: m.type == 'Toggle',
								keyCombo: {
									key: '1',
									modifier: 'alt'
								}
							});
						}
					}
				});

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_actions__["saveLocalSettings"])(_this5.$store, _this5.$localStorage, _this5.getLocalSettings);
			});
		});

		//getSystemStatus(this.$store);
		this.systemStatusReload();
	}
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getStatus']), {
        noiseActive: function noiseActive() {
            return this.getStatus ? this.getStatus.noise : false;
        },
        weatherActive: function weatherActive() {
            return this.getStatus ? this.getStatus.weather : false;
        },
        adioActive: function adioActive() {
            return this.getStatus ? this.getStatus.adio : false;
        },
        measuringActive: function measuringActive() {
            return this.noiseActive && this.weatherActive && this.adioActive;
        },
        weatherOnColor: function weatherOnColor() {
            return this.getStatus.weatherError ? '#e43a45' : '#20A0FF';
        },
        noiseOnColor: function noiseOnColor() {
            return this.getStatus.noiseError ? '#e43a45' : '#20A0FF';
        },
        adioOnColor: function adioOnColor() {
            return this.getStatus.adioError ? '#e43a45' : '#20A0FF';
        }

    }),
    data: function data() {
        return {
            test: true,
            getStatusLoop: undefined,
            isLoading: false
        };
    },

    methods: {
        onWeatherChanged: function onWeatherChanged() {
            var _this = this;

            this.isLoading = true;
            if (this.weatherActive) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["stopWeather"])(this.$store).then(function () {
                    _this.isLoading = false;
                });
            } else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["startWeather"])(this.$store).then(function () {
                    _this.isLoading = false;
                });
            }
        },
        onNoiseChanged: function onNoiseChanged() {
            var _this2 = this;

            this.isLoading = true;
            if (this.noiseActive) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["stopNoise"])(this.$store).then(function () {
                    _this2.isLoading = false;
                });
            } else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["startNoise"])(this.$store).then(function () {
                    _this2.isLoading = false;
                });
            }
        },
        onAdioChanged: function onAdioChanged() {
            var _this3 = this;

            this.isLoading = true;
            if (this.adioActive) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["stopAdio"])(this.$store).then(function () {
                    _this3.isLoading = false;
                });
            } else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["startAdio"])(this.$store).then(function () {
                    _this3.isLoading = false;
                });
            }
        },
        onMeasuringChanged: function onMeasuringChanged() {
            var _this4 = this;

            this.isLoading = true;
            if (this.measuringActive) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["stopAll"])(this.$store).then(function () {
                    _this4.isLoading = false;
                });
                /*if(this.weatherActive)
                    stopWeather(this.$store);
                if(this.noiseActive)
                    stopNoise(this.$store);
                */
            } else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["startAll"])(this.$store).then(function () {
                    _this4.isLoading = false;
                });
            }
        }
    },
    mounted: function mounted() {
        var _this5 = this;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["getStatus"])(this.$store);
        this.getStatusLoop = setInterval(function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["getStatus"])(_this5.$store).then(function () {
                _this5.isLoading = false;
            });
        }, 5000);
    },
    destroyed: function destroyed() {
        if (this.getStatusLoop) clearInterval(this.getStatusLoop);
    }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            url: undefined,
            audioPlaying: false,
            audioRecording: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettingsAddons']), {
        streamButtonText: function streamButtonText() {
            return this.audioPlaying ? 'streamPopover/StopStream' : 'streamPopover/StartStream';
        },
        recordingButtonText: function recordingButtonText() {
            return this.audioRecording ? 'streamPopover/StopManRec' : 'streamPopover/StartManRec';
        }

    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['startAudioStream', 'stopAudioStream', 'startAudioRecording', 'stopAudioRecording']), {
        audioClicked: function audioClicked() {
            var _this = this;

            if (!this.url) this.startAudioStream().then(function (data) {
                _this.audioPlaying = true;
                _this.url = data.data;
            });else this.url = undefined;
        },
        stopAudioStreamClicked: function stopAudioStreamClicked() {
            var _this2 = this;

            if (this.audioPlaying) {
                this.stopAudioStream(this.$store).then(function (data) {
                    _this2.audioPlaying = false;
                });
            } else {
                this.startAudioStream().then(function (data) {
                    _this2.audioPlaying = true;
                    _this2.url = data.data;
                });
            }
        },
        getClass: function getClass(menu) {
            if (this.getSettingsAddons[menu] == '0') return 'disabled-button';
            return '';
        },
        videoClicked: function videoClicked() {
            if (this.getSettingsAddons['video'] == '0') return;
            window.open('/video');
        },
        audioRecordingClicked: function audioRecordingClicked() {
            var _this3 = this;

            if (this.audioRecording) {
                this.stopAudioRecording().then(function (data) {
                    _this3.audioRecording = false;
                });
            } else {
                this.startAudioRecording().then(function (data) {
                    _this3.audioRecording = true;
                });
            }
        }
    }),
    destroyed: function destroyed() {
        this.url = undefined;
    }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_archives_AudioDownloadDialog__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_archives_AudioDownloadDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_archives_AudioDownloadDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_archives_AudioPlayer__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_archives_AudioPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_archives_AudioPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_archives_VideoPlayer__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_archives_VideoPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_archives_VideoPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(32);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//Components






// #E9EDEF #E5E5E5
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            Image: "",
            thumbnailVisible: false,
            downloadPart: false,
            visible: false,
            checkAllDays: false,
            checkAllHours: false,
            isIndeterminate: false,
            checkedDays: [],
            checkedHours: [],
            days: [],
            hours: [],
            manualOn: 0,
            startTime: -1,
            stopTime: -1,
            audioDownloadDialog: {
                visible: false,
                length: 10,
                selection: [0, 0]
            },
            hoursOffset: 0
        };
    },
    components: {
        'audio-download-dialog': __WEBPACK_IMPORTED_MODULE_4__components_archives_AudioDownloadDialog___default.a,
        'audio-player': __WEBPACK_IMPORTED_MODULE_5__components_archives_AudioPlayer___default.a,
        'video-player': __WEBPACK_IMPORTED_MODULE_6__components_archives_VideoPlayer___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        type: function type() {
            return this.$route.params.type;
        },
        day: function day() {
            return this.$route.params.day;
        },
        isHours: function isHours() {
            if (this.$route.params.day) {
                return true;
            }
            return false;
        },
        isAudio: function isAudio() {
            if (this.$route.params.type == 'audio') {
                return true;
            }
            return false;
        },
        isVideo: function isVideo() {
            if (this.$route.params.type == 'video') {
                return true;
            }
            return false;
        },
        isCompressed: function isCompressed() {
            return this.$route.params.type == 'compressed';
        },
        isGlobalValues: function isGlobalValues() {
            return this.$route.params.type == 'global';
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getSettingsDevice', 'getSettingsWeather', 'getLocalSettings']), {
        filterHours: function filterHours() {
            return this.hours.slice(this.hoursOffset * 24, (this.hoursOffset + 1) * 24);
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['setDownloading', 'setDownloadingProgress']), {
        goTo: function goTo(day) {
            this.hours = [];
            this.$router.push("/archives/" + this.type + "/" + day);
            this.isIndeterminate = false;
        },
        handleCheckAllChange: function handleCheckAllChange(event) {
            if (this.isHours) {
                this.checkedHours = event.target.checked ? this.hours.map(function (h) {
                    return h[0];
                }) : [];
                this.isIndeterminate = false;
            } else {
                this.checkedDays = event.target.checked ? this.days : [];
                this.isIndeterminate = false;
            }
        },
        fileNameWithoutType: function fileNameWithoutType(filename) {
            return filename.substring(0, filename.length - 4);
        },
        fileNameToPng: function fileNameToPng(filename) {
            if (this.isAudio) {
                return filename.substring(0, filename.length - 4) + ".png";
            } else if (this.isVideo) return filename.substring(0, filename.length - 4) + ".png";
        },
        getTitle: function getTitle(title) {
            return this.$l("archives/" + title);
        },
        handleCheckedChange: function handleCheckedChange(value) {
            //preimenuj v primeru da se spet uporabu
            //ne dela za ure
            if (this.isHours) {
                var checkedCount = value.length;
                this.checkAllHours = checkedCount === this.hours.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.hours.length;
            } else {
                var _checkedCount = value.length;
                this.checkAllDays = _checkedCount === this.days.length;
                this.isIndeterminate = _checkedCount > 0 && _checkedCount < this.days.length;
            }
        },
        downloadHour: function downloadHour(hour) {
            var _this = this;

            var url = "";
            var device = this.getSettingsDevice.valsel.join(',');
            var weather = this.getSettingsWeather.valsel.filter(function (val) {
                return val.enabled;
            }).map(function (val) {
                return val.name;
            }).join(',');
            var newHour = hour[0].substring(0, hour[0].indexOf('.'));

            switch (this.type) {
                case 'global':
                    url = "/api/download-global&measurement=" + hour + "&param=L1,L5,L10,L50,L90,L95,L99,LAEQ&zip=" + this.getLocalSettings.interface.compress + '&time=' + Date.now();break;
                case 'compressed':
                    url = "/api/file-action&&action=download&type=" + this.type + "&files=" + hour + '&time=' + Date.now();break;
                default:
                    url = "/api/file-action&&action=download&type=" + this.type + "&files=" + newHour + '&time=' + Date.now();break;
            }

            this.setDownloading({ enabled: true, progress: 0, preparing: true });
            __WEBPACK_IMPORTED_MODULE_7__api__["_10" /* getFileAction */](url, 'GET', '', function (progress) {
                var percentage = Math.round(progress.loaded / progress.total * 100);
                _this.setDownloadingProgress(percentage);
            }).then(function () {
                _this.setDownloading({ enabled: false, progress: 0 });
            }).catch(function () {
                _this.setDownloading({ enabled: false, progress: 0 });
            });
        },
        openDownloadAudioDialog: function openDownloadAudioDialog(hour) {
            var lengthSplit = hour[2].split(':');
            var length = parseInt(lengthSplit[0]) * 60 * 60 + parseInt(lengthSplit[1]) * 60 + parseInt(lengthSplit[2]);
            this.audioDownloadDialog.name = hour[0];
            this.audioDownloadDialog.length = length;
            this.audioDownloadDialog.visible = true;
            this.audioDownloadDialog.selection = [0, length];
        },
        downloadPartHour: function downloadPartHour() {
            //case 'audio': url="/api/file-action&&action=download&type="+ this.type +"&files="+ newHour + ".mp3"; break;
        },
        Delete: function Delete() {
            var _this2 = this;

            var data = {};
            var previouslyChecked = [];
            if (!this.isHours) {
                previouslyChecked = this.checkedDays;
                if (this.isCompressed) {
                    data.data = this.checkedDays.map(function (item) {
                        return item;
                    });
                } else {
                    data.data = this.checkedDays.map(function (item) {
                        return item.split('.')[0];
                    });
                }
            } else {
                previouslyChecked = this.checkedHours;
                if (this.isCompressed) {
                    data.data = this.checkedHours.map(function (item) {
                        return item;
                    });
                } else {
                    data.data = this.checkedHours.map(function (item) {
                        return item.split('.')[0];
                    });
                }
            }

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["postFileAction"])(this.$store, 'delete', this.type, data).then(function (_) {
                if (!_this2.isHours) {
                    data.data.forEach(function (date) {
                        var index = _this2.days.indexOf(date);
                        if (index > -1) _this2.days.splice(index, 1);
                    });
                } else {
                    data.data.forEach(function (date) {
                        var mapped = _this2.hours.map(function (d) {
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(d);
                        });
                        var index = mapped.indexOf(mapped.find(function (i) {
                            return i.indexOf(date) > -1;
                        }));
                        if (index > -1) _this2.hours.splice(index, 1);
                    });
                }
            });
        },
        Download: function Download() {
            var _this3 = this;

            var data = [];
            if (!this.isHours) {
                data = this.checkedDays.join(',');
            } else {
                data = this.checkedHours.join(',');
            }
            var url = "/api/file-action&&action=download&type=" + this.type + "&files=" + data + '&time=' + Date.now();

            this.setDownloading({ enabled: true, progress: 0, preparing: true });
            __WEBPACK_IMPORTED_MODULE_7__api__["_10" /* getFileAction */](url, 'GET', '', function (progress) {
                var percentage = Math.round(progress.loaded / progress.total * 100);
                _this3.setDownloadingProgress(percentage);
            }).then(function () {
                _this3.setDownloading({ enabled: false, progress: 0 });
            }).catch(function () {
                _this3.setDownloading({ enabled: false, progress: 0 });
            });
            //window.location.href = url;

            this.checkedDays = [];
            this.checkedHours = [];
        },
        setImageAudio: function setImageAudio(day, hour) {
            this.Image = "/audio/audio/" + day + "/" + this.fileNameToPng(hour);
        },
        setImageVideo: function setImageVideo(day, hour) {
            this.Image = "/video/video/" + day + "/" + this.fileNameToPng(hour);
        },
        goParentClicked: function goParentClicked() {
            this.$router.push("/archives/" + this.type + '/');
            this.isIndeterminate = false;
        },
        sortDaysByName: function sortDaysByName() {
            if (this.days.length == 0) return;

            var oldStart = this.days[0];
            this.days = this.days.sort(function (a, b) {
                return a < b ? -1 : a > b;
            });
            if (oldStart == this.days[0]) this.days = this.days.reverse();
        },
        sortHoursByName: function sortHoursByName() {
            if (this.hours.length == 0) return;

            var oldStart = this.hours[0][0];
            this.hours = this.hours.sort(function (a, b) {
                return a[0] < b[0] ? -1 : a[0] > b[0];
            });
            if (oldStart == this.hours[0][0]) this.hours = this.hours.reverse();
        },
        sortHoursBySize: function sortHoursBySize() {
            if (this.hours.length == 0) return;

            var oldStart = this.hours[0][1];
            this.hours = this.hours.sort(function (a, b) {
                return a[1] < b[1] ? -1 : a[1] > b[1];
            });
            if (oldStart == this.hours[0][1]) this.hours = this.hours.reverse();
        },
        sortHoursByDuration: function sortHoursByDuration() {
            if (this.hours.length == 0) return;

            var oldStart = this.hours[0][2];
            this.hours = this.hours.sort(function (a, b) {
                return a[2] < b[2] ? -1 : a[2] > b[2];
            });
            if (oldStart == this.hours[0][2]) this.hours = this.hours.reverse();
        },
        paginationBackClicked: function paginationBackClicked() {
            this.hoursOffset = this.hoursOffset - 1;
        },
        paginationNextClicked: function paginationNextClicked() {
            this.hoursOffset = this.hoursOffset + 1;
        }
    }),
    watch: {
        type: function type(newType) {
            var _this4 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["getDaysByType"])(this.$store, newType).then(function (data) {
                _this4.days = data.data[newType];
            }).catch(function () {
                _this4.days = [];
            });
            this.checkedDays = [];
            this.checkedHours = [];
        },
        day: function day(newDay) {
            var _this5 = this;

            if (!newDay) return;
            var day = new Date(newDay);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["getHoursByType"])(this.$store, this.type, day).then(function (data) {
                if (_this5.type == "audio") _this5.hours = data.data;else _this5.hours = data.data;
            }).catch(function () {
                _this5.hours = [];
            });
            this.checkedDays = [];
            this.checkedHours = [];
            this.hoursOffset = 0;
        },
        thumbnailVisible: function thumbnailVisible() {
            if (!this.thumbnailVisible) {
                this.image = "";
            }
        },
        downloadPart: function downloadPart() {
            if (!downloadHour) {
                startTime = 0;
                stopTime = 0;
            }
        }

    },
    mounted: function mounted() {
        var _this6 = this;

        if (!this.$p('archives')) {
            this.$router.push('/');
            return;
        }
        if (this.day) {
            var day = new Date(this.day);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["getHoursByType"])(this.$store, this.type, day).then(function (data) {
                if (_this6.type == "audio") _this6.hours = data.data;else _this6.hours = data.data;
            }).catch(function () {
                _this6.hours = [];
            });
        } else {
            var newType = this.type;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["getDaysByType"])(this.$store, newType).then(function (data) {
                _this6.days = data.data[newType];
            }).catch(function () {
                _this6.days = [];
            });
        }
    }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    data: function data() {
        return {
            activeMenu: "geographic-position",
            screenSize: 2,
            menuVisible: true,
            loading: false,
            loaded: false,
            saving: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getSettings', 'getSettingsAddons', 'getUnsavedLocalSettings', 'getUser']), {
        path: function path() {
            return this.$route.path.split('/')[2];
        },
        containerClass: function containerClass() {
            return 'settings-container' + (this.screenSize > 1 ? ' sidebar-margin' : '');
        }
    }),
    watch: {
        '$mq.resize': 'screenResize',
        'getSettings': function getSettings(newSettings) {
            if (newSettings.device) {
                this.loading = false;
                this.loaded = true;
            } else this.loading = true;
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['setScreenSize']), {
        screenResize: function screenResize() {
            if (this.$mq.below(768)) {
                this.screenSize = 0;
            } else if (this.$mq.above(1199)) {
                this.screenSize = 3;
            } else if (this.$mq.above(991)) {
                this.screenSize = 2;
            } else if (this.$mq.above(766)) {
                this.screenSize = 1;
            }
            this.setScreenSize(this.screenSize);
            this.menuVisible = false;
        },

        makeActive: function makeActive(name) {
            this.activeMenu = name; //Because I did not have 'this' word the code did not work correctly
        },
        getClass: function getClass(menu) {
            if (menu == this.path) return 'settingsMenuItemSelected';
            if (this.getSettingsAddons[menu] == '0') return 'settingsMenuItem disabled-button';
            return 'settingsMenuItem';
        },
        navigate: function navigate(name) {
            if (this.getSettingsAddons[name] == '0') return;
            this.menuVisible = false;
            this.$router.push("/settings/" + name);
        },
        saveClicked: function saveClicked() {
            var _this = this;

            this.saving = true;
            //Demutate local settings
            var rtvalueTime = new Date(this.getUnsavedLocalSettings.interface.rtvaluesPicker);
            this.getUnsavedLocalSettings.interface.rtvalues = rtvalueTime.getHours() * 3600 + rtvalueTime.getMinutes() * 60 + rtvalueTime.getSeconds();

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, this.getUnsavedLocalSettings);
            var settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* demutateSettings */])(this.getSettings);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["saveSettings"])(this.$store, settings);
            setTimeout(function () {
                _this.saving = false;
            }, 1000);
        }
    }),
    mounted: function mounted() {

        if (!this.$p('settings/enabled')) {
            this.$router.push('/');
            return;
        }
        if (this.$p('settings/' + this.path + '/enabled') !== undefined) {
            if (!this.$p('settings/' + this.path + '/enabled')) {
                this.$router.push('/');
                return;
            }
        } else {
            if (!this.$p('settings/' + this.path)) {
                this.$router.push('/');
                return;
            }
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["getFirmware"])(this.$store);
        this.screenResize();
        this.loading = true;
        if (this.getSettings.device) {
            this.loading = false;
            this.loaded = true;
        }
        //alert('ok')
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["createUnsavedLocalSettings"])(this.$store);
        /*getSettings(this.$store)
            .then((settings)=>{
                //saveSettings(this.$store, settings);
                this.loading = false;
                //settings received
            })
        */
    }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettingsAdio', 'getSettingsVideo']))
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedGroups: [],
            selectedEmail: '',
            selectedNumber: '',
            selectedDeleteRecipients: [],
            deleteGroup: '',
            deleteRecipientGroup: '',

            delayedLoading: { '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '7': 0, '8': 0, '9': 0, '10': 0 },

            newGroup: false,
            dialogVisible: false,
            dialogVisible1: false,
            visible: false,
            showPassword: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettingsAlertMessaging', 'getSettingsAddons', 'getSettingsSpecval', 'getSettingsEmail', 'getScreenSize'])),
    methods: {
        addGroup: function addGroup() {
            var allAlerts = ["threshday", "threshnight", "threshopt1", "threshopt2", "threshweath", "mav", "reboot", "n140", "ftperr", "n140sd", "discerr", "micerr", "battmode", "weather", "weatTrig", "videotrig", "videoerr", "leqday"];
            var id = 0;
            this.getSettingsAlertMessaging.groups.forEach(function (group) {
                var gId = parseInt(group.replace('gr', ''));
                if (id <= gId) id = gId + 1;
            });
            var alg = {};
            allAlerts.forEach(function (alert) {
                alg[alert] = true;
            });
            var del = '';
            var leqdg = [0, 0];
            var recpg = [];
            this.getSettingsAlertMessaging['alg' + id] = alg;
            this.getSettingsAlertMessaging['del' + id] = del;
            this.getSettingsAlertMessaging['leqdg' + id] = leqdg;
            this.getSettingsAlertMessaging['recpg' + id] = recpg;
            this.getSettingsAlertMessaging['repg' + id] = ["0", "0", "0", "0", "0", "0", "0"];
            this.getSettingsAlertMessaging['lqtg' + id] = [true, true, true];
            this.getSettingsAlertMessaging.groups.push('gr' + id);
        },
        addRecipientClicked: function addRecipientClicked() {
            var _this = this;

            if (this.selectedGroups.length == 0) {
                this.$message({
                    message: this.$l('settings/alertMessaging/groupsError'),
                    type: 'error',
                    customClass: 'error-message-one'

                });

                return;
            }
            this.selectedGroups.forEach(function (group) {
                if (_this.selectedEmail) {
                    var id = group.replace('gr', '');
                    if (_this.getSettingsAlertMessaging['recpg' + id].indexOf(_this.selectedEmail) == -1) _this.getSettingsAlertMessaging['recpg' + id].push(_this.selectedEmail);
                }
                if (_this.selectedNumber) {
                    var id = group.replace('gr', '');
                    if (_this.getSettingsAlertMessaging['recpg' + id].indexOf(_this.selectedNumber) == -1) _this.getSettingsAlertMessaging['recpg' + id].push(_this.selectedNumber);
                }
            });

            this.selectedGroups = [];
            this.selectedEmail = '';
            this.selectedNumber = '';
        },
        sendTestMail: function sendTestMail(group) {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["testEmail"])(this, group).then(function () {
                _this2.$message({
                    message: _this2.$l('settings/alertMessaging/emailSent'),
                    type: 'success'
                });
            });

            //api/test-email&email=""
        },
        removeGroup: function removeGroup(item) {
            var index = this.getSettingsAlertMessaging.groups.indexOf(item);
            if (index > -1) {
                this.getSettingsAlertMessaging.groups.splice(index, 1);
                var id = item.replace('gr', '');
                delete this.getSettingsAlertMessaging['alg' + id];
                delete this.getSettingsAlertMessaging['del' + id];
                delete this.getSettingsAlertMessaging['leqdg' + id];
                delete this.getSettingsAlertMessaging['recpg' + id];
                delete this.getSettingsAlertMessaging['repg' + id];
                delete this.getSettingsAlertMessaging['lqtg' + id];
            }
        },
        deleteRecipient: function deleteRecipient(group) {
            var id = group.replace('gr', '');
            var del = this.getSettingsAlertMessaging['del' + id];
            var index = this.getSettingsAlertMessaging['recpg' + id].indexOf(del);
            if (index > -1) {
                this.getSettingsAlertMessaging['recpg' + id].splice(index, 1);
            }
            this.getSettingsAlertMessaging['del' + id] = '';
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        setTimeout(function () {
            var counter = 0;
            var delayedLoadingInterval = setInterval(function () {
                _this3.delayedLoading[counter] = true;
                counter++;
                if (counter > 6) clearInterval(delayedLoadingInterval);
            }, 0);
        }, 500);
    }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            delayedLoading: { '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '7': 0, '8': 0, '9': 0, '10': 0, '11': 0, '12': 0 }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettingsAudioRecording', 'getSettingsWeather', 'getSettingsAddons', 'getScreenSize'])),
    methods: {
        onSubmit: function onSubmit() {
            console.log('submit!');
        },

        getClass: function getClass(menu) {
            if (this.getSettingsAddons[menu] == '0') return 'disabled-button';
            return '';
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (this.getSettingsAudioRecording.threshold1[0] == -20) this.threshold1LowerEnabled = false;

        setTimeout(function () {
            var counter = 0;
            var delayedLoadingInterval = setInterval(function () {
                _this.delayedLoading[counter] = true;
                counter++;
                if (counter > 13) clearInterval(delayedLoadingInterval);
            }, 0);
        }, 500);
    }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            deleteLoading: false,
            form: {
                AutoDelete: '',
                ManualDelete: {
                    From: new Date(),
                    To: new Date(),
                    Range: [new Date(), new Date()]
                },
                Values: {
                    Measurements: false,
                    Audio: false,
                    Weather: false,
                    IntegralValues: false,
                    Logs: false,
                    Statistics: false,
                    ADIO: false
                }
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettingsSystem', 'getSettingsAddons'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['deleteOnInterval']), {
        onSubmit: function onSubmit() {
            var _this = this;

            this.deleteLoading = true;
            setTimeout(function () {
                var values = _this.getSettingsSystem.delvalsel.filter(function (val) {
                    return val.enabled;
                }).map(function (val) {
                    return val.name;
                }).join(',');
                _this.deleteOnInterval({
                    From: _this.form.ManualDelete.From,
                    To: _this.form.ManualDelete.To,
                    Values: values
                });
                _this.deleteLoading = false;
            }, 1500);
        }
    })
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			restartLoading: false,
			instrumentLoading: false,
			formatSDLoading: false,
			checkSpaceLoading: false,
			formatSDdialog: false,
			testOptionsValue: '',
			delayedLoading: { '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '7': 0, '8': 0, '9': 0, '10': 0 }
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getSettingsDevice', 'getSettingsInterface', 'getSettingsSpecval', 'getUnsavedLocalSettings', 'getStatus', 'getScreenSize', 'getSettingsStartstop'])),
	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['updateStartstopSettings']), {
		onSubmit: function onSubmit() {
			console.log('submit!');
		},
		setInstrument: function setInstrument() {
			var _this = this;

			this.instrumentLoading = true;
			setTimeout(function () {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["setNoise"])(_this.$store).then(function (data) {
					if (data.error == 110) {
						//errror on Nor140 connection
						_this.$message({
							message: _this.$l('codes/97'),
							type: 'error'
						});
					} else {
						_this.$message({
							//message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status,
							message: _this.$l('settings/device/instrumentSent'),
							type: 'success'
							//customClass:'error-message-one'
						});
					}
					_this.instrumentLoading = false;
				}).catch(function (err) {
					_this.instrumentLoading = false;
				});
			}, 1500);
		},
		restartNoiseClick: function restartNoiseClick() {
			var _this2 = this;

			this.$confirm(this.$l('settings/device/restartNoise'), this.$l('settings/warning'), {
				confirmButtonText: this.$l('settings/continue'),
				cancelButtonText: this.$l('settings/cancel'),
				type: 'warning'
			}).then(function () {

				_this2.$notify({
					title: _this2.$l('common/Warning'),
					message: _this2.$l('settings/status/Restart Warning'),
					type: 'warning'
				});

				_this2.restartLoading = true;
				setTimeout(function () {

					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["restartNoise"])(_this2.$store).catch(function () {}).then(function (data) {
						if (data.error == 110) {
							//errror on Nor140 connection
							_this2.$message({
								message: _this2.$l('codes/97'),
								type: 'error'
							});
						} else {
							_this2.$message({
								type: 'success',
								//message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status, //Ce obstaja prevod prevedi, drugače izpisi
								message: _this2.$l('settings/status/Restart success')
							});
						}
						_this2.restartLoading = false;
					});
				}, 1000);
			}).catch(function () {
				_this2.$message({
					type: 'info',
					message: _this2.$l('settings/status/Restart cancel')
				});
			});
		},
		formatSD: function formatSD() {
			var _this3 = this;

			this.$confirm(this.$l('settings/device/formatSDdialog'), this.$l('settings/warning'), {
				confirmButtonText: this.$l('settings/continue'),
				cancelButtonText: this.$l('settings/cancel'),
				type: 'warning'
			}).then(function () {
				_this3.formatSDLoading = true;

				_this3.$notify({
					title: _this3.$l('common/Warning'),
					message: _this3.$l('settings/video/formatSDWarning'),
					type: 'warning'
				});
				setTimeout(function () {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["sdFormatNoise"])(_this3.$store);
					/*.catch(()=>{})
     .then(()=>{
     	this.$message({
     		type: 'success',
     		message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status, //Ce obstaja prevod prevedi, drugače izpisi
     		//message: this.$l('settings/status/Restart success')
     	});*/
					_this3.formatSDLoading = false;
					//})
				}, 1500);
			}).catch(function () {
				_this3.$message({
					type: 'info',
					message: _this3.$l('settings/status/Restart cancel')
				});
			});
		},
		checkSD: function checkSD() {
			var _this4 = this;

			this.checkSpaceLoading = true;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["sdFreeNoise"])(this.$store).then(function (data) {
				setTimeout(function () {
					if (data.error == 110) {
						//errror on Nor140 connection
						_this4.$message({
							message: _this4.$l('codes/97'),
							type: 'error'
						});
					} else {
						_this4.$message({
							message: _this4.$l('settings/device/freeSpace') + data.data,
							//message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status, //Ce obstaja prevod prevedi, drugače izpisi
							type: 'success',
							customClass: 'error-message-one'
						});
					}
					_this4.checkSpaceLoading = false;
				}, 1500);
			}).catch(function () {
				_this4.checkSpaceLoading = false;
			});
		},
		testOptions: function testOptions() {
			var _this5 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["testOptions"])(this.$store).then(function (data) {
				_this5.testOptionsValue = data.data;
			});
		},
		getDeviceValueName: function getDeviceValueName(value) {
			switch (value.length) {
				case 3:
					var valueArray = value[0].split('');
					valueArray.splice(2, 1);
					return valueArray.join('');
				case 2:
				case 1:
					return value[0];

			}
		},
		increaseClicked: function increaseClicked() {
			var _this6 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["increaseVolume"])(this.$store).then(function (data) {
				if (data.error == 110) {
					//errror on Nor140 connection
					_this6.$message({
						message: _this6.$l('codes/97'),
						type: 'error'
					});
				} else {
					_this6.getSettingsDevice.meterscale = parseInt(_this6.getSettingsDevice.meterscale) + 10;
					_this6.$message({
						message: _this6.$l('settings/device/increasedVol'),
						//message: this.$l(`common/${data.status}`),
						type: 'success'
						//customClass:'error-message-one'
					});
				}
			});
		},
		decreaseClicked: function decreaseClicked() {
			var _this7 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_actions__["decreaseVolume"])(this.$store).then(function (data) {
				if (data.error == 110) {
					//errror on Nor140 connection
					_this7.$message({
						message: _this7.$l('codes/97'),
						type: 'error'
					});
				} else {
					_this7.getSettingsDevice.meterscale = parseInt(_this7.getSettingsDevice.meterscale) - 10;
					_this7.$message({
						message: _this7.$l('settings/device/decreasedVol'),
						//message: this.$l(`common/${data.status}`),
						type: 'success'
						//customClass:'error-message-one'
					});
				}
			});
		},
		checkboxChanged: function checkboxChanged(value) {
			var spectCount = 0;
			var ltCount = 0;
			this.getSettingsDevice.valsel.forEach(function (item) {
				if (item.indexOf('f') > -1) {
					spectCount++;
				} else {
					ltCount++;
				}
			});
			var spectMax = 0;
			var ltMax = 0;
			switch (this.getSettingsDevice.resolution) {
				case 'UN50':
				case 'UN125':
				case 'UN500':
					{
						ltMax = 4;
						spectMax = 1;
						break;
					}
				default:
					{
						ltMax = 8;
						spectMax = 2;
						break;
					}
			}
			for (var i = 0; i < ltCount - ltMax; i++) {
				var item = this.getSettingsDevice.valsel.find(function (item) {
					return item.indexOf('f') == -1;
				});
				var index = this.getSettingsDevice.valsel.indexOf(item);
				if (index != -1) this.getSettingsDevice.valsel.splice(index, 1);
			}
			for (var i = 0; i < spectCount - spectMax; i++) {
				var item = this.getSettingsDevice.valsel.find(function (item) {
					return item.indexOf('f') > -1;
				});
				var index = this.getSettingsDevice.valsel.indexOf(item);
				if (index != -1) this.getSettingsDevice.valsel.splice(index, 1);
			}
			if (this.getStatus.noise) {
				this.$message({
					message: this.$l('settings/device/warningMeasRunning'),
					type: 'warning'
				});
			}
		},

		addStartstopGroup: function addStartstopGroup() {
			var groupId = 1;
			this.getSettingsStartstop.groups.forEach(function (g) {
				var id = parseInt(g.replace('gr', ''));
				if (id >= groupId) {
					groupId = id + 1;
				}
			});

			this.getSettingsStartstop.groups.push('gr' + groupId);
			this.getSettingsStartstop['daysgr' + groupId] = [];
			this.getSettingsStartstop['typesgr' + groupId] = [];
			this.getSettingsStartstop['startgr' + groupId] = '06:00';
			this.getSettingsStartstop['stopgr' + groupId] = '21:00';
			this.getSettingsStartstop['enablegr' + groupId] = false;

			this.updateStartstopSettings(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getSettingsStartstop)));
		},
		deleteStartstopGroup: function deleteStartstopGroup(group) {
			var index = this.getSettingsStartstop.groups.indexOf(group);
			if (index > -1) {
				this.getSettingsStartstop.groups.splice(index, 1);
				delete this.getSettingsStartstop['days' + group];
				delete this.getSettingsStartstop['types' + group];
				delete this.getSettingsStartstop['start' + group];
				delete this.getSettingsStartstop['stop' + group];
				delete this.getSettingsStartstop['enable' + group];
			}
		}

	}),
	mounted: function mounted() {
		var _this8 = this;

		setTimeout(function () {
			var counter = 0;
			var delayedLoadingInterval = setInterval(function () {
				_this8.delayedLoading[counter] = true;
				counter++;
				if (counter > 5) clearInterval(delayedLoadingInterval);
			}, 0);
		}, 500);
	}
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            delayedLoading: { '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '7': 0, '8': 0, '9': 0, '10': 0 }

        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettingsDownload', 'getSettingsDevice', 'getSettingsWeather', 'getUnsavedLocalSettings', 'getSettingsSpecval', 'getSettingsAddons', 'getScreenSize'])),
    methods: {
        getClass: function getClass(menu) {
            if (this.getSettingsAddons[menu] == '0') return 'disabled-button';
            return '';
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            var counter = 0;
            var delayedLoadingInterval = setInterval(function () {
                _this.delayedLoading[counter] = true;
                counter++;
                if (counter > 5) clearInterval(delayedLoadingInterval);
            }, 0);
        }, 500);
    }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showPassword: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettingsDynamicDNS', 'getSettingsAddons'])),
    methods: {
        onSubmit: function onSubmit() {
            console.log('submit!');
        }
    }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            testButtonLoading: false,
            delayedLoading: { '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '7': 0, '8': 0, '9': 0, '10': 0 },
            showPassword: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettingsFTPSending', 'getSettingsAddons', 'getScreenSize'])),
    methods: {
        onSubmit: function onSubmit() {
            console.log('submit!');
        },
        testButtonClicked: function testButtonClicked() {
            var _this = this;

            this.testButtonLoading = true;
            if (this.getSettingsFTPSending.address != "") {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["ftpTestConn"])(this, this.getSettingsFTPSending.address + ":" + this.getSettingsFTPSending.port, "upwd", this.getSettingsFTPSending.user, this.getSettingsFTPSending.password).then(function (data) {
                    if (data.data.indexOf("Connection OK") > -1) {
                        _this.$message({
                            type: 'success',
                            message: data.data
                        });
                    } else {
                        _this.$message({
                            type: 'error',
                            message: data.data
                        });
                    }
                    _this.testButtonLoading = false;
                });
            } else {
                this.$message({
                    type: 'error',
                    message: this.$l('settings/FTPSending/FTP Address')
                });
                this.testButtonLoading = false;
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        setTimeout(function () {
            var counter = 0;
            var delayedLoadingInterval = setInterval(function () {
                _this2.delayedLoading[counter] = true;
                counter++;
                if (counter > 7) clearInterval(delayedLoadingInterval);
            }, 0);
        }, 500);
    }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var VueGoogleMaps = __webpack_require__(490);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyD5orU1Ahsfs8wZ-RwDIEf5cL-23ij44bc',
        v: '3'
    }
});

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            markers: []
        };
    },

    methods: {
        changePos: function changePos(pos) {
            this.getSettingsGeographicalPosition.lat = pos.latLng.lat();
            this.getSettingsGeographicalPosition.lon = pos.latLng.lng();
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getSettingsGeographicalPosition']), {
        location: function location() {
            var location = { lat: 0, lng: 0 };
            if (this.getSettingsGeographicalPosition.lat) {
                location.lat = parseFloat(this.getSettingsGeographicalPosition.lat);
                location.lng = parseFloat(this.getSettingsGeographicalPosition.lon);
            }
            this.markers = [{ position: { lat: location.lat, lng: location.lng } }];
            return location;
        }
    })
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    //How to gray out / disable inputs
    data: function data() {
        return {
            delayedLoading: { '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '7': 0, '8': 0, '9': 0, '10': 0 }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettingsInterface', 'getSettingsAddons', 'getScreenSize'])),
    methods: {
        onSubmit: function onSubmit() {
            console.log('submit!');
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            var counter = 0;
            var delayedLoadingInterval = setInterval(function () {
                _this.delayedLoading[counter] = true;
                counter++;
                if (counter > 10) clearInterval(delayedLoadingInterval);
            }, 0);
        }, 500);
    }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettingsAdio', 'getSettingsVideo', 'getSettingsNorCloud', 'getSettingsDevice', 'getSettingsAddons'])),
    methods: {
        onSubmit: function onSubmit() {
            var item;
            console.log('submit!');
        }
    }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            weekDays: [{ value: "1", label: this.$l('common/graph_day_name')[1] }, { value: "2", label: this.$l('common/graph_day_name')[2] }, { value: "3", label: this.$l('common/graph_day_name')[3] }, { value: "4", label: this.$l('common/graph_day_name')[4] }, { value: "5", label: this.$l('common/graph_day_name')[5] }, { value: "6", label: this.$l('common/graph_day_name')[6] }, { value: "7", label: this.$l('common/graph_day_name')[0] }],
            deleteLoading: false,
            form: {
                AutoDelete: '',
                ManualDelete: {
                    From: new Date(),
                    To: new Date()
                },
                Values: {
                    Measurements: false,
                    Audio: false,
                    Weather: false,
                    IntegralValues: false,
                    Logs: false,
                    Statistics: false
                }
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getSettingsSystem', 'getSettingsAddons', 'getSettingsDownload', 'getSettingsDevice', 'getSettingsWeather', 'getUnsavedLocalSettings', 'getSettingsSpecval', 'getSettingsAddons', 'getScreenSize', 'getSettingsStatistics']), {
        getId: function getId(group) {
            return group.replace('st', '');
        },
        mappedStatisticTemplates: function mappedStatisticTemplates() {
            var _this = this;

            var templates = this.getSettingsStatistics.vallAll.split(',');
            var mapping = templates.map(function (t) {
                var out = {
                    value: t,
                    label: t
                };
                try {
                    if (_this.getUnsavedLocalSettings.download.statistics.mapping[t]) {
                        out.label = _this.getUnsavedLocalSettings.download.statistics.mapping[t];
                    }
                } catch (err) {
                    console.error(err);
                }
                return out;
            });
            return mapping;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['deleteOnInterval', 'updateStatisticsSettings']), {
        onSubmit: function onSubmit() {
            var _this2 = this;

            this.deleteLoading = true;
            setTimeout(function () {
                var values = getSettingsSystem.delvalsel.filter(function (val) {
                    return val.enabled;
                }).map(function (val) {
                    return val.name;
                }).join(',');
                _this2.deleteOnInterval({
                    From: _this2.form.ManualDelete.From,
                    To: _this2.form.ManualDelete.To,
                    Values: values
                });
                _this2.deleteLoading = false;
            }, 1500);
        },
        alertGroupDeleted: function alertGroupDeleted(group) {
            var id = group.replace('st', '');
            var index = this.getSettingsStatistics.allgroups.indexOf(group);
            this.getSettingsStatistics.allgroups.splice(index, 1);

            delete this.getSettingsStatistics['templs' + id];
            delete this.getSettingsStatistics['titles' + id];
            delete this.getSettingsStatistics['durs' + id];
            delete this.getSettingsStatistics['hours' + id];
            delete this.getSettingsStatistics['dayss' + id];
            delete this.getSettingsStatistics['ranges' + id];
            delete this.getSettingsStatistics['recps' + id];
            delete this.getSettingsStatistics['langs' + id];
        },
        addNewGroup: function addNewGroup() {
            var id = 1;
            this.getSettingsStatistics.allgroups.forEach(function (group) {
                var gId = parseInt(group.replace('st', ''));
                if (gId >= id) {
                    id = gId + 1;
                }
            });
            this.getSettingsStatistics.allgroups.push('st' + id);
            this.getSettingsStatistics['templs' + id] = 'Template1';
            this.getSettingsStatistics['titles' + id] = '';
            this.getSettingsStatistics['durs' + id] = 'Daily';
            this.getSettingsStatistics['hours' + id] = '08:00';
            this.getSettingsStatistics['dayss' + id] = ['1'];
            this.getSettingsStatistics['ranges' + id] = [0, 0];
            this.getSettingsStatistics['recps' + id] = '';
            this.getSettingsStatistics['langs' + id] = 'en';
            //this.getSettingsStatistics = JSON.parse(JSON.stringify(this.getSettingsStatistics));
            this.updateStatisticsSettings(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getSettingsStatistics)));
        }
    })
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            rebootLoading: false,
            logTypes: [],
            selectedLog: '',
            logs: [],
            logsLoading: false,
            showPassword: {
                admin: false,
                user: false,
                guest: false
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getSystemStatus', 'getFirmware', 'getSettingsSystem', 'getSettingsUsers', 'getSettingsAddons'])),
    methods: {
        onSubmit: function onSubmit() {
            console.log('submit!');
        },
        rebootSystemMessage: function rebootSystemMessage() {
            var _this = this;

            this.$confirm(this.$l('settings/status/Reboot confirm'), this.$l('settings/warning'), {
                confirmButtonText: this.$l('settings/continue'),
                cancelButtonText: this.$l('settings/cancel'),
                type: 'Warning'
            }).then(function () {
                _this.rebootLoading = true;
                setTimeout(function () {
                    _this.$message({
                        type: 'success',
                        message: _this.$l('settings/status/Reboot success')
                    });
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_actions__["rebootSys"])(_this.$store);
                    _this.rebootLoading = false;
                }, 1500);
            }).catch(function () {
                _this.$message({
                    type: 'info',
                    message: _this.$l('settings/status/Reboot cancel')
                });
            });
        },
        downloadClicked: function downloadClicked() {
            var _this2 = this;

            //window.location = '/api/logs-download&file='+this.selectedLog;
            this.setDownloading({ enabled: true, progress: 0, preparing: true });
            api.getFileAction('/api/logs-download&file=' + this.selectedLog + '&time=' + Date.now(), 'GET', '', function (progress) {
                var percentage = Math.round(progress.loaded / progress.total * 100);
                _this2.setDownloadingProgress(percentage);
            }).then(function () {
                _this2.setDownloading({ enabled: false, progress: 0 });
            }).catch(function () {
                _this2.setDownloading({ enabled: false, progress: 0 });
            });
        }
    },
    watch: {
        selectedLog: function selectedLog(newLog) {
            var _this3 = this;

            this.logsLoading = true;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_actions__["getLogs"])(this.$store, newLog).then(function (data) {
                _this3.logs = data.split('\n').reverse();
                _this3.logsLoading = false;
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_actions__["logsList"])(this.$store).then(function (logs) {
            _this4.logTypes = logs;
        });
    }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            formatSDLoading: false,
            setDeviceLoading: false,
            formatSDdialog: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getSettingsVideo'])),
    methods: {
        setDevice: function setDevice() {
            var _this = this;

            this.setDeviceLoading = true;
            setTimeout(function () {
                //api/set-video
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_actions__["saveSettings"])(_this.$store).then(function (data) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_actions__["setVideo"])(_this.$store).catch(function () {}).then(function (data) {
                        _this.$message({
                            type: 'success',
                            message: _this.$l('settings/device/instrumentSent')
                            //message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status, //Ce obstaja prevod prevedi, drugače izpisi
                            //message: this.$l('settings/status/Restart success')
                        });
                        _this.setDeviceLoading = false;
                    });
                });
            }, 1500);
        },
        formatSD: function formatSD() {
            var _this2 = this;

            //api/sdformat-video
            this.formatSDLoading = true;
            this.$notify({
                title: this.$l('common/Warning'),
                message: this.$l('settings/video/formatSDWarning'),
                type: 'warning'
            });

            setTimeout(function () {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_actions__["formatVideoSD"])(_this2.$store);
                /*.catch(()=>{})
                .then(()=>{
                    this.$message({
                type: 'success',
                message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status, //Ce obstaja prevod prevedi, drugače izpisi
                //message: this.$l('settings/status/Restart success')
                });*/
                _this2.formatSDLoading = false;
                //})
            }, 1500);
        }
    }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            setDeviceLoading: false,
            delayedLoading: { '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '7': 0, '8': 0, '9': 0, '10': 0 }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getSettings', 'getSettingsWeather', 'getSettingsInterface', 'getUnsavedLocalSettings', 'getScreenSize'])),
    methods: {
        onSubmit: function onSubmit() {
            console.log('submit!');
        },
        setDevice: function setDevice() {
            var _this = this;

            this.setDeviceLoading = true;
            //save
            /*
                gumb sproži akcijo save settings in ponovno get settings. 
                Če je bila vmes spremenjena vremenska postaja bo get settings že vrnil nove vrednosti
            */
            //api/set-weather
            setTimeout(function () {
                _this.saveSettings().then(function () {
                    debugger;
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["getSettings"])(_this.$store);
                }).then(function () {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["setWeather"])(_this.$store);
                    _this.setDeviceLoading = false;
                });
            }, 1500);
        },
        saveSettings: function saveSettings() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["saveLocalSettings"])(this.$store, this.$localStorage, this.getUnsavedLocalSettings);
            var settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils__["b" /* demutateSettings */])(this.getSettings);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_actions__["saveSettings"])(this.$store, settings);
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        setTimeout(function () {
            var counter = 0;
            var delayedLoadingInterval = setInterval(function () {
                _this2.delayedLoading[counter] = true;
                counter++;
                if (counter > 7) clearInterval(delayedLoadingInterval);
            }, 0);
        }, 500);
    }
});

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noise", function() { return noise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "weather", function() { return weather; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spectogram", function() { return spectogram; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "adio", function() { return adio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "statistics", function() { return statistics; });
var noise = {
	showOnDay: true,
	graphType: 'noise',
	chart: {
		type: 'line',
		zoomType: 'x',
		marginTop: 0,
		plotBands: null,
		panning: true,
		panKey: 'shift',
		events: {
			redraw: function redraw() {},
			selection: function selection(event) {},
			click: function click(event) {}
		},
		resetZoomButton: {
			theme: {
				display: 'none'
			}
		}

	},
	credits: {
		enabled: false
	},
	title: {
		text: ''
	},
	xAxis: {
		type: 'datetime',
		minTickInterval: 1000,
		events: {
			setExtremes: function setExtremes(event) {}
		},
		plotBands: []
	},
	yAxis: {
		title: {
			text: ''
		},
		min: null,
		max: null,
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function tickPositioner() {
			var positions = [],
			    tick = Math.floor(this.dataMin),
			    increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment > 0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	},
	exporting: {
		buttons: {
			contextButton: {
				enabled: false
			}
		},
		enabled: true,
		filename: 'test',
		width: 1920,
		height: 1080
	},
	plotOptions: {
		line: {
			enableMouseTracking: true,
			marker: {
				radius: 0
			},
			lineWidth: 1,
			animation: true
		},
		series: {
			pointInterval: 1000,
			events: {
				legendItemClick: function legendItemClick(event) {},
				click: function click(event) {}
			}
		}
	},
	tooltip: {
		shared: true,
		crosshairs: true,
		valueSuffix: ' dB',
		followTouchMove: true
	}
};

var weather = {
	showOnDay: true,
	graphType: 'weath',

	chart: {
		type: 'line',
		zoomType: 'x',
		marginTop: 0,
		plotBands: null,
		panning: true,
		panKey: 'shift',
		events: {
			redraw: function redraw() {},
			selection: function selection(event) {}
		},
		resetZoomButton: {
			theme: {
				display: 'none'
			}
		}
	},
	credits: {
		enabled: false
	},
	title: {
		text: ''
	},
	xAxis: {
		type: 'datetime',
		minTickInterval: 1000,
		events: {
			setExtremes: function setExtremes(event) {}
		},
		plotBands: []
	},
	yAxis: {
		title: {
			text: ''
		},
		min: null,
		max: null,
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function tickPositioner() {
			var positions = [],
			    tick = Math.floor(this.dataMin),
			    increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment > 0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	},
	exporting: {
		buttons: {
			contextButton: {
				enabled: false
			}
		},
		enabled: true,
		filename: 'test',
		width: 1920,
		height: 1080
	},
	plotOptions: {
		line: {
			enableMouseTracking: true,
			marker: {
				radius: 0
			},
			lineWidth: 1,
			animation: true
		},
		series: {
			pointInterval: 1000,
			events: {}
		}
	},
	tooltip: {
		shared: true,
		crosshairs: true,
		followTouchMove: true
	}
};

var spectogram = {
	showOnDay: false,
	graphType: 'spect',
	frequencies: ["6.3 Hz", "8.0 Hz", "10.0 Hz", "12.5 Hz", "16.0 Hz", "20.0 Hz", "25.0 Hz", "31.5 Hz", "40.0 Hz", "50.0 Hz", "63.0 Hz", "80.0 Hz", "100.0 Hz", "125.0 Hz", "160.0 Hz", "200.0 Hz", "250.0 Hz", "315.0 Hz", "400.0 Hz", "500.0 Hz", "630.0 Hz", "800.0 Hz", "1.0k Hz", "1.25k Hz", "1.6k Hz", "2.0k Hz", "2.5k Hz", "3.15k Hz", "4.0k Hz", "5.0k Hz", "6.3k Hz", "8.0k Hz", "10.0k Hz", "12.5k Hz", "16.0k Hz", "20.0k Hz", "", "LEQ"],
	chart: {
		type: 'column',
		zoomType: '',
		marginTop: 0,
		animation: false,
		panning: true,
		events: {
			redraw: function redraw() {},
			selection: function selection(event) {}
		}
	},
	credits: {
		enabled: false
	},
	title: {
		text: ''
	},
	xAxis: {
		type: 'category',
		labels: {
			style: {
				fontSize: '13px',
				fontFamily: 'Verdana, sans-serif'
			}
		}
	},
	yAxis: {
		title: {
			text: ''
		},
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function tickPositioner() {
			var positions = [],
			    tick = Math.floor(this.dataMin),
			    increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment > 0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	},
	exporting: {
		buttons: {
			contextButton: {
				enabled: false
			}
		},
		enabled: true,
		filename: 'test',
		width: 1920,
		height: 1080
	},
	plotOptions: {
		series: {
			events: {}
		}
	},
	/*series: [{
 	name: 'Spectrum',
 	data: [],
 	color: '#ff0000',
 	visible: true,
 },{
 	name: 'A Spectrum',
 	data: [],
 	color: '#ff00ff',
 	visible: true,
 }],*/
	tooltip: {
		shared: true,
		crosshairs: true,
		followTouchMove: true,
		valueSuffix: ' dB'
	},
	legend: {
		floating: true,
		align: 'right',
		verticalAlign: 'top',
		x: -50,
		y: -15
	}
};

var adio = {
	showOnDay: true,
	graphType: 'adio',
	chart: {
		type: 'line',
		zoomType: 'x',
		marginTop: 0,
		plotBands: null,
		panning: true,
		events: {
			redraw: function redraw() {},
			selection: function selection(event) {}
		},
		resetZoomButton: {
			theme: {
				display: 'none'
			}
		}

	},
	credits: {
		enabled: false
	},
	title: {
		text: ''
	},
	xAxis: {
		type: 'datetime',
		minTickInterval: 1000,
		events: {
			setExtremes: function setExtremes(event) {}
		},
		plotBands: []
	},
	yAxis: [{
		title: {
			text: ''
		},
		min: null,
		max: null,
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function tickPositioner() {
			var positions = [],
			    tick = Math.floor(this.dataMin),
			    increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment > 0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	}, {
		opposite: true,
		title: {
			text: ''
		},
		min: null,
		max: null,
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function tickPositioner() {
			var positions = [],
			    tick = Math.floor(this.dataMin),
			    increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment > 0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	}],
	exporting: {
		buttons: {
			contextButton: {
				enabled: false
			}
		},
		enabled: true,
		filename: 'test',
		width: 1920,
		height: 1080
	},
	plotOptions: {
		line: {
			enableMouseTracking: true,
			marker: {
				radius: 0
			},
			lineWidth: 1,
			animation: true
		},
		series: {
			pointInterval: 1000,
			events: {
				legendItemClick: function legendItemClick(event) {}
			}
		}
	},
	tooltip: {
		shared: true,
		crosshairs: true,
		valueSuffix: ' ',
		followTouchMove: true
	}
};

var statistics = {

	showOnDay: true,
	graphType: 'statistics',
	title: {
		text: ''
	},
	global: {
		setUTC: false
	},
	chart: {
		panning: true,
		events: {},
		resetZoomButton: {
			theme: {
				display: 'none'
			}
		}

	},
	credits: {
		enabled: false
	},
	xAxis: {
		type: 'datetime',
		labels: {
			format: '{value:%H}'
		},
		tickInterval: 3600000,
		events: {}
	},
	yAxis: {
		title: {
			text: ''
		},
		min: null,
		max: null,
		startOnTick: false,
		endOnTick: false,
		tickPositioner: function tickPositioner() {
			var positions = [],
			    tick = Math.floor(this.dataMin),
			    increment = Math.ceil((this.dataMax - this.dataMin) / 5);
			if (this.dataMax !== null && this.dataMin !== null && increment > 0) {
				for (tick; tick - increment <= this.dataMax; tick += increment) {
					positions.push(tick);
				}
			} else {
				positions.push(50);
				positions.push(140);
			}
			return positions;
		}
	},
	exporting: {
		buttons: {
			contextButton: {
				enabled: false
			}
		},
		enabled: true,
		filename: 'test',
		width: 1920,
		height: 1080
	},
	plotOptions: {
		line: {
			dataLabels: {
				enabled: false
			},
			enableMouseTracking: true,
			marker: {
				radius: 0
			},
			lineWidth: 1,
			animation: false
		},
		series: {
			//pointStart: Date.parse(line[0].substr(0,10)),
			pointInterval: 3600 * 1000,
			events: {}
		}
	},
	tooltip: {
		shared: true,
		crosshairs: true,
		valueSuffix: ' dB'
	}
	/*measurement = "2018-01-30"
 line = array(data)
 graph = $('#graph').highcharts({
 title: {
 	text: measurement
 },
 global: {
 	setUTC: false
 },
  xAxis: {
 	type: 'datetime',
 	labels: {
 		format: '{value:%H}',
 	},
 	tickInterval: 3600000
 },
 yAxis: {
 	title: {
 		text: ''
 	},
 	min: null,
 	max: null,
 	startOnTick: false,
 	endOnTick: false,
 },
 exporting: {
 		enabled: true,
 		filename: measurement + '_statistic',
 		width: 1920,
 		height: 1080,
 	},
 plotOptions: {
 	line: {
 		dataLabels: {
 			enabled: false
 		},
 		enableMouseTracking: true,
 		marker: {
 			radius: 0
 		},
 		lineWidth: 1,
 		animation: false
 	},
 	series: {
 		pointStart: Date.parse(line[0].substr(0,10)),
 		pointInterval: 3600 * 1000 
 	}
 },
 tooltip: {
 	shared: true,
 	crosshairs: true,
 	valueSuffix: ' dB'
 },
 series: [{
 	type: 'line',
 	name: 'Leq',
 	step: 'Leq',
 	data: leq,
 	color: 'red',
 	lineWidth: 1,
 	},{
 	name: 'L1%',
 	step: 'L1%',
 	data: l1,
 	lineWidth: 1,
 	color: '#7cb5ec',
 },{
 	name: 'L95%',
 	step: 'L95%',
 	data: l95,
 	lineWidth: 1,
 	color: 'green'
 }]
 }).highcharts(); */
};

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__local_DE_js__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__local_AT_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__local_EN_js__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_FR_js__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__local_SL_js__ = __webpack_require__(266);






/* harmony default export */ __webpack_exports__["a"] = ({
    'en': __WEBPACK_IMPORTED_MODULE_2__local_EN_js__["a" /* default */],
    'de': __WEBPACK_IMPORTED_MODULE_0__local_DE_js__["a" /* default */],
    'fr': __WEBPACK_IMPORTED_MODULE_3__local_FR_js__["a" /* default */],
    'sl': __WEBPACK_IMPORTED_MODULE_4__local_SL_js__["a" /* default */],
    'at': __WEBPACK_IMPORTED_MODULE_1__local_AT_js__["a" /* default */]
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	'common': {
		'select': 'Auswählen',
		'graph_loading': "Daten werden geladen...",
		'month_Names': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		'graph_shortMonths': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		'graph_day_name': ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
		'graph_export': "Exportieren",
		'graph_printButt': "Drucken",
		'graph_down_PNG': "Download als PNG-Bild",
		'graph_down_JPG': "Download als JPEG-Bild",
		'graph_down_PDF': "Download als PDF-Dokument",
		'graph_down_SVG': "Download als SVG-Bild",
		'graph_zoom_reset': "Zoom zurücksetzen",
		'Valid request.': 'gültige Anfrage.',
		'Warning': 'Warnung'
	},
	'main': {
		'titleStatistics': 'Statistiken',
		'titleManual': 'Benutzerhandbuch',
		'titleDownload': 'Download',
		'titleArchives': 'Archive',
		'titleStream': 'Stream',
		'titleRealtime': 'Echtzeit',
		'titlePlay': 'Start',
		'titleDanger': 'Fehler/Messung gestoppt',
		'titleWarning': 'Im Betrieb',
		'titleSettings': 'Einstellungen',
		'titleSD': 'SD frei:',
		'titleHDD': 'SSD frei:',
		'titleCamera': 'Kamera:',
		'titleLogout': 'Abmelden',
		'status': 'Status',
		'error': 'Fehler',
		'running': 'Im Betrieb',
		'notRunning': 'Messung gestoppt',
		'downloadingFile': 'Datei heruntergeladen',
		'preparingFile': 'Datei wird vorbereitet'
	},
	'login': {
		'Username': 'Benutzername',
		'Password': 'Passwort',
		'Login': 'Anmelden'
	},
	'dashboard': {
		'measuringTgl': 'Messung',
		'noiseTgl': 'Pegel',
		'weatherTgl': 'Wetter',
		'adioTgl': 'ADIO'
	},
	'graphs': {
		'export': {
			'Print chart': 'Grafik downloaden',
			'Download': 'Download',
			'image': 'Bild'
		},
		'nodata': "KEINE DATEN",
		'errNoise': "Problem mit Nor140",
		'errWeath': "Problem mit Wetterstation",
		'errAdio': "Problem mit ADIO",
		'NOISE': 'Pegel',
		'SPECTRUM': 'Spektrum',
		'WEATHER': 'Wetter',
		'ADIO': 'ADIO',
		'STATISTICS': 'Statistik',
		'statTitle': 'Titel',
		'statFrom': 'Von',
		'statTo': 'Bis',
		'load': 'Laden',
		'markers': 'Marker',
		'dailyNotes': 'Tägliche Notizen',
		'preload': 'Grafik manualladen',
		'sync': 'Grafik synchrosieren',
		'reset': 'Zoom zurücksetzen',
		'exportGraph': 'Grafik exportieren',
		'hideShow': 'Verbergen / Anzeigen',
		'markersCat': {
			'type': 'Type',
			'color': 'Farbe',
			'single': 'Punkt',
			'toggle': 'Bereich',
			'keybind': 'Tastenkombination',
			'learn': 'Lernen',
			'shift': 'Shift',
			'alt': 'Alt',
			'delete': 'Löschen',
			'save': 'Speichern',
			'note': 'Notizen'
		},
		'markersTable': {
			'name': 'Name',
			'startTime': 'Start Zeit',
			'endTime': 'Stop Zeit',
			'type': 'Type'
		}
	},
	'calendar': {
		'title': 'Kalender',
		'noise': 'Pegel',
		'audio': 'Audio',
		'weather': 'Wetter',
		'video': 'Video',
		'adio': 'ADIO'
	},
	'streamPopover': {
		'title': 'Streams',
		'Audio': 'Audio',
		'Video': 'Video',
		'StartManRec': 'Manuelle Aufzeichnung',
		'StopManRec': 'Aufzeichnung beenden',
		'StartStream': 'Start Stream',
		'StopStream': 'Stop Stream'
	},
	'download': {
		'title': 'Downloads',
		'popOver': {
			'XML': 'Export XML Daten',
			'XMLWeekly': 'Export wöchentliche XML Daten',
			'Raw': 'Rohdaten',
			'Global': 'Global Werte',
			'weather': 'TXT Wetter'
		}
	},
	'archives': {
		'popOver': {
			'Global': 'Global Werte',
			'Noise': 'Pegel',
			'Audio': 'Audio',
			'Video': 'Video',
			'Weather': 'Wetter',
			'Adio': 'ADIO',
			'Compressed': 'Komprimiert'
		},
		'audioPopOver': {
			'downlRec': 'Download Aufzeichnung',
			'range': 'Messbereich'
		},
		'video': 'Video',
		'global': 'Global Werte',
		'weather': 'Wetter',
		'noise': 'Pegel',
		'audio': 'Audio',
		'name': 'Archive',
		'Delete': 'Löschen',
		'Download': 'Download',
		'NorReview': 'NorReview',
		'Thumbnail': 'Bild',
		'Filename': 'Dateiname',
		'Duration': 'Dauer',
		'Size': 'Größe',
		'Close': 'Schließen',
		'adio': 'ADIO',
		'compressed': 'KOMPRIMIERTE DATEIEN'
	},
	'settings': {
		'name': 'Einstellungen',
		'save': 'Speichern',
		'addButt': "Hinzufügen",
		'preTrigg': 'Vor-Trigger',
		'Trigg': 'Trigger',
		'postTrigg': 'Nach-Trigger',
		'warning': 'Warnung',
		'continue': 'Weiter',
		'cancel': 'Abbrechen',

		'interface': {
			'settingsName': 'Ansicht',
			'Realtime display': 'Echtzeitanzeige [sec]',
			'Language': 'Sprache',
			'Lt': 'Pegelschrieb-Messbereich',
			'Spectrum': 'Spektrum-Messbereich',
			'Weather': 'Wetter-Messbereich',
			'Adio': 'ADIO-Messbereich',
			'Manual': 'Manueller Messbereich',
			'Dynamic': 'Automatischer Messbereich',
			'noiseTriggerLevel': 'Triggerschwelle im Pegelschrieb anzeigen',
			'spectrumTriggerLevel': 'Triggerschwelle im Spektrum anzeigen',
			//Options
			'english': 'Englisch (EN)',
			'austria': 'Deutsch (AT)',
			'german': 'Deutsch (DE)',
			'french': 'Französisch (FR)',
			'slovensko': 'Slowenisch (SLO)'
		},
		'download': {
			'settingsName': 'Download',
			'Compression': 'Komprimierung',
			'No compression': 'Keine Komprimierung',
			'Zip compression': 'Zip-Komprimierung (Datenvolumen sparen)',
			'Noise': 'Pegel',
			'Weather': 'Wetter',
			'Global Values': 'Global Werte',
			'Special values': 'Spezial Funktionen',
			'Audio': 'Audio',
			'Video': 'Video',
			'Markers': 'Markers',
			'Statistics': 'Statistik',
			'statisticsTemplate': 'Vorlage',
			'statisticsRename': "Vorlage umbenennen"
		},
		'audioRecording': {
			'settingsName': 'Audio Aufzeichnung',
			'Format': 'Format',
			'Audio Offset': 'Audio Vor-Trigger [sec]',
			'Day': 'Tag',
			'Night': 'Nacht',
			'Optional 1': 'Optional 1',
			'Optional 2': 'Optional 2',
			'RecDur': 'Aufzeichnungsdauer [sec]',
			'Threshold': 'Überschreitungspegel [dBA]',
			'Start': 'Start Zeit [HH]',
			'Stop': 'Stop Zeit [HH]',
			'Weather': 'Wetter Trigger',
			'Windspeed': 'Windgeschwindigkeit',
			'Temperature': 'Temperatur',
			'Air': 'Luftdruck',
			'Precipitation': 'Niederschlag',
			'Humidity': 'Feuchtigkeit',
			//Options
			'Disable': 'Deaktiviert',
			'Lower': 'Kleiner als',
			'Greater': 'Größer als',
			'Both': 'Gleich',
			'lowerThan': 'Kleiner als',
			'greaterThan': 'Größer als'
		},
		'dynamicDns': {
			'settingsName': 'Dynamic Dns',
			'Address': 'Adresse',
			'Provider': 'Provider',
			'Username': 'Benutzername',
			'Password': 'Passwort',
			'IP': 'IP'
		},
		'alertMessaging': {
			'settingsName': 'Alarm Meldung',
			'createGroupButton': 'Neue Gruppe erstellen',
			'createGroupDialog': 'Möchten Sie wirklich eine neue Gruppe erstellen?',
			'deleteGroupDialog': 'Bestätigen Sie hier die Löschung von Gruppe ',
			'deleteEmailDialog': 'Möchten Sie wirklich diese E-Mail/Mobilnummer löschen?',
			'dialogConfirm': 'Bestätigen',
			'dialogContinue': 'Weiter',
			'dialogCancel': 'Abbrechen',
			'MSISDN-E-Mail': 'Zu welcher/n Gruppe(n) möchten Sie den Empfänger hinzufügen?',
			'Add MSISDN': 'Mobilnummer hinzufügen',
			'Add E-mail': 'E-Mail Adresse hinzufügen',
			'DeleteButton': 'Löschen',
			'DeleteGroup': 'Gruppe löschen',
			'DeleteRecip': 'Empfänger löschen',
			'DeleteEmail': 'E-Mail/Mobilnummer löschen',
			'TestEmail': 'Test E-Mail/SMS senden',
			'Resend after': 'Erneut senden nach',
			'Threshold day': 'Überschreitung Tag',
			'Threshold Night': 'Überschreitung Nacht',
			'Threshold Opt 1': 'Überschreitung Opt. 1',
			'Threshold Opt 2': 'Überschreitung Opt. 2',
			'Running Average Level': 'Running Average Level',
			'Weather trigger': 'Überschreitung Wetter',
			'System reboot': 'System neu starten',
			'Connection with meter lost': 'Verbindung zum Nor140 verloren',
			'FTP server error': 'FTP-Server Fehler',
			'Critical memory on meter': 'Kritischer Speicherplatz Nor140 (SD-Karte)',
			'Critical disk space': 'Kritischer Speicherplatz SSD',
			'Microphone check error': 'Mikrofon Check Fehler',
			'Battery mode': 'Batteriemodus',
			'Connection with Weather station lost': 'Verbindung zur Wetterstation verloren',
			'LEQ': 'Leq Tag',
			'Inbound (MSISDN)': 'Anfragen per SMS:',
			'Status': 'Status',
			'GPS': 'GPS:',
			'Threshold change': 'Überschreitungspegel ändern:',
			'Email settings': 'E-Mail Einstellungen',
			'Sender Email': 'Absender E-Mail',
			'Password': 'Passwort',
			'SMTP server': 'SMTP Server',
			'SMTP port': 'SMTP Port',
			'noRepeat': 'Keine Wiederholung',
			'resendAft': 'Erneut senden nach',
			//Options
			'min': 'Min',
			'disabled': 'Deaktivieren',
			'groupsError': 'Bitte wählen Sie die Gruppen aus!',
			'emailSent': 'Nachricht gesendet'
		},
		'FTPSending': {
			'settingsName': 'FTP',
			'FTP Address': 'FTP-Adresse',
			'Refresh Rate': 'Aktualisierungsrate',
			'Username': 'Benutzername',
			'Password': 'Passwort',
			'Port': 'Port',
			'Values': 'Messwerte',
			//Options
			'Disable': 'Deaktivieren',
			'sec': 'Sek.',
			'min': 'Min.',
			'hour': 'Stunde',
			'measur': 'Pegel',
			'weath': 'Wetter',
			'audio': 'Audio',
			'global': 'Global Werte',
			'video': 'Video'
		},
		'geographicPosition': {
			'settingsName': 'Geografische Position',
			'Latitude': 'Geografische Breite [°]',
			'Longitude': 'Geografische Länge [°]',
			'Height': 'Höhe [m]'
		},
		'weather': {
			'settingsName': 'Wetter',
			'Weather': 'Wetterstation',
			'values': 'Messwerte',
			'SetDevice': 'Wetterstation auswählen',
			//Options
			'NoWeather': 'Keine Wetterstation',
			'reinhardt': 'Reinhardt MWS 5MV',
			'reinhardtRain': 'Reinhardt MWS 5MV mit Regen',
			'thiesClima': 'Thies Clima Sensor US',
			'vaisala': 'Vaisala WXT520',
			'kw360': 'ONWA KW-360'
		},
		'delete': {
			'settingsName': 'Löschen/Kompresse',
			'autoDelete': 'Automatisch löschen älter als',
			'autoCompress': 'Automatisch komprimieren älter als',
			'Disable': 'Deaktivieren',
			'Manual delete': 'Manuel löschen',
			'Values': 'Messwerte',
			'Delete': 'Löschen',
			//Options
			'day': 'Tag(e)',
			'week': 'Woche(n)',
			'month': 'Monat(e)',
			'measur': 'Pegel',
			'weath': 'Wetter',
			'audio': 'Audio',
			'global': 'Global Werte',
			'logs': 'Logs',
			'statistics': 'Statistiken',
			'video': 'Video',
			'adio': 'ADIO'
		},
		'device': {
			'settingsName': 'Nor140',
			'Selection': 'Mikrofon',
			'Polarisation': 'Polarisationsspannung',
			'Frequency': 'Frequenz Modus',
			'Resolution': 'Auflösung',
			'Duration': 'Messdauer',
			'Meter': 'Nor140 Messbereich',
			'Values': 'Messwerte',
			'Special': 'Spezial Parameter',
			'Advance': 'Weitere Einstellungen',
			'Mic check': 'Mik. Check Pegel [dB]:',
			'Mic check time': 'Mik. Check um [HH]:',
			'SDFreeSpace': 'Meldung freier Speicherplatz SD-Karte [%]',
			'Restart': 'Nor140 neu starten',
			'Set instrument': 'Nor140 einstellen',
			'Format': 'SD-Karte formatieren',
			'CheckSD': 'Freier Speicherplatz SD-Karte prüfen',
			'formatSDdialog': 'Die Formatierung kann bis zu 5 Minuten dauern, möchten Sie wirklich fortfahren?',
			'decrease': 'Lautstärke erhöhen',
			'increase': 'Lautstärke verringern',
			'value': 'Messwerte',
			'threshold': 'Überschreitungspegel (dBA)',
			'timeControlled': 'Zeitgesteuert',
			'measurementControlled': 'Messgesteuert',
			'start_stop': 'Start Zeit/Stop Zeit',
			'startTime': 'Start Zeit',
			'endTime': 'Endzeit',
			'trigger': 'Trigger',
			'duration': 'Messdauer',
			'test': 'Überprüfen',
			'testOpt': 'Überprüfen der installierten Optionen',
			'restartNoise': 'Nor140 neu starten',
			'increasedVol': 'Lautstärke verringert',
			'decreasedVol': 'Lautstärke erhöht',
			'autostart': 'Auto Start-Stop',
			//Options
			'On': 'Ein',
			'Off': 'Aus',
			'Standard': 'Standard',
			'Disable': 'Deaktivieren',
			'iepe': 'IEPE',
			'line': 'Line',
			'horizontal': '1214/16/17 Horizontal',
			'vertical': '1214/16/17 Vertikal',
			'11octave': '1/1 Oktav',
			'13octave': '1/3 Oktav',
			'11wOctave': '1/1w Oktav',
			'13wOctave': '1/3w Oktav',
			'movingAverage': 'Moving Average',
			'movingValue': 'Moving value',
			'midnight': "Mitternacht - 00h",
			'noon': "Mittag - 12h",
			'freeSpace': 'Speicherplatz SD-Karte: ',
			'instrumentSent': 'Nor140 eingestellt',
			'start': 'Start',
			'stop': 'Stop',
			'days': 'Tage',
			'types': 'Typen',
			'startstopActive': 'Aktiv',
			'warningMeasRunning': 'Einstellungen werden während einer laufenden Messung nicht übernommen!'
		},
		'video': {
			'settingsName': 'Video',
			'Present': 'Videokamera',
			'Manual': 'Manuelle Aufzeichnung',
			'Triggering': 'Überschreitungspegel Video',
			'Moving detection': 'Bewegungserkennung',
			'Settings': 'Einstellungen',
			'Pre': 'Vor-Trigger',
			'Post': 'Post-Trigger',
			'No device': 'Keine Videokamera',
			'Video camera': 'Videokamera',
			'SetDevice': 'Gerät einstellen',
			'formatSDWarning': 'Bitte warten Sie, bis die SD-Karte auf 100% steht'
		},
		'adio': {
			'settingsName': 'ADIO',
			'Present': 'ADIO',
			'ADIO': 'ADIO Box',
			'NoDevice': 'Kein ADIO',
			'DigitalOut': 'Digital Out',
			'DigitalIn': 'Digital In',
			'AnalogIn': 'Analog In',
			'AnalogOut': 'Analog Out',
			'AnalogLowerLimit': 'Analog unteres Limit 0V/4mA',
			'AnalogUpperLimit': 'Analog oberes Limit 10V/20mA',
			'Please input': '"Bitte eingeben"',
			//Options
			'On': 'Ein',
			'Off': 'Aus'
		},
		'norcloud': {
			'settingsName': 'NorCloud',
			'IdNor': 'Nor140 ID',
			'syncTime': 'Aktualisierungsrate',
			'syncData': 'Pegel senden',
			'syncRec': 'Audio senden',
			'sendAlerts': 'Alarm senden',
			'recSett': 'Einstellungen empfangen',
			'applySett': 'Empfangene Einstellungen übernehmen',
			//Options
			'On': 'Ein',
			'Off': 'Aus',
			'disable': 'Deaktivieren',
			'min': 'min',
			'hour': 'Stunde',
			'now': 'Wenn Einstellungen empfangen wurden',
			'fhour': 'Zur vollen Stunde',
			'break': 'Wenn Mikrofon Check durchgeführt wurde'
		},
		'statistics': {
			'settingsName': 'Statistik',
			'reportSending': {
				'settingsName': 'Automatisches Senden von Berichten',
				'Name': 'Vorlage',
				'Title': 'Titel',
				'Duration': 'Berichtart',
				'Days': 'Senden am',
				'Hours': 'Senden um',
				'Range': 'Letzten Tage',
				'Email': 'E-Mail',
				'Language': 'Sprache'
			},
			'options': {
				'Range': 'Bereich',
				'Daily': 'Täglich',
				'On Event': 'Ereignis'
			}
		},
		'status': {
			'settingsName': 'System',
			'Reboot': 'System neu starten',
			'Reboot confirm': 'Möchten Sie das System wirklich neu starten?',
			'Reboot success': 'Weniger als 1 Minute bis zum Neustart!',
			'Reboot cancel': 'Neustart abgebrochen',
			'Restart confirm': 'Möchten Sie den Nor140 wirklich neu starten?',
			'Restart Warning': 'Nor140 wird in 1min wieder online sein!',
			'Restart success': 'Nor140 online!',
			'Restart cancel': 'Abgebrochen',
			'Version': 'Version',
			'Release': 'Veröffentlichungsdatum',
			'PCFree': 'PC Speicher [%]',
			'SDD': 'SSD',
			'memory': 'Speicher',
			'camera': 'Videokamera SD-Karte',
			'n140': 'Nor140 SD-Karte',
			'cpu': 'CPU Leistung',
			'firmware': 'Firmware',
			'logs': 'Logs',
			'download': 'Download',
			'total': 'Gesamt',
			'free': 'Frei',
			'used': 'Belegt',
			'gbOrMore': '2GB oder mehr',
			'of': 'of',
			'users': 'Benutzer',
			'username': 'Benutzername',
			'password': 'Passwort',
			'adminUsr': 'Admin',
			'noiseUsr': 'Benutzer',
			'guestUsr': 'Gast'
		}
	},
	'errors': {
		'n140': 'Nor140',
		'weather': 'Wetter',
		'adio': 'ADIO',
		'cameraSD': 'Kamera SD-Karte über 80% voll!'
	},
	'codes': {
		"13": "Keine Serielle Verbindung",
		"16": "Software Optionen fehlen",
		"64": "OK - Kein Fehler",
		"89": "Messzeit zu lang für Synchro",
		"90": "Befehl Unbekannt",
		"91": "Option nicht verfügbar",
		"92": "I/O gesperrt",
		"93": "Keine Marker für die ausgewählte Datei",
		"94": "Befehlszeichenfolge zu lang ohne Trennzeichen",
		"97": "Geräte-Fehler",
		"99": "Kein DECT Modul gefunden",
		"100": "Keine Zahl gelesen",
		"101": "Zahl ist nicht zulässig",
		"102": "Text zu Lang",
		"104": "Keine gültigen Daten",
		"105": "Zahl ist außerhalb des Messbereichs",
		"106": "Messung nicht gestartet",
		"108": "Zeitüberschreitung auf String-Parameter zu einen Befehl",
		"109": "Software V2.X Option nicht installiert",
		"110": "Fehler im Textformat",
		"111": "Software V3.x Option nicht installiert",
		"112": "Speicher Voll",
		"116": "Alle Speichervorgänge blockiert aufgrund von Speicherfehlern",
		"117": "Audiometer Kalibrierung Fehler",
		"118": "Undefinierter Fehler",
		"119": "Undefinierter Fehler",
		"121": "Ordner nicht eingestellt",
		"122": "Ordner nicht gefunden",
		"123": "Speicherprüfung OK",
		"124": "SD-Karte nicht vorhanden",
		"125": "SD-Karte nicht unterstüzt",
		"126": "SD-Karte schreibgeschützt"
	}
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	'common': {
		'select': 'Auswählen',
		'graph_loading': "Daten werden geladen...",
		'month_Names': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		'graph_shortMonths': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		'graph_day_name': ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
		'graph_export': "Exportieren",
		'graph_printButt': "Drucken",
		'graph_down_PNG': "Download als PNG-Bild",
		'graph_down_JPG': "Download als JPEG-Bild",
		'graph_down_PDF': "Download als PDF-Dokument",
		'graph_down_SVG': "Download als SVG-Bild",
		'graph_zoom_reset': "Zoom zurücksetze",
		'Valid request.': 'gültige Anfrage.',
		'Warning': 'Warnung'
	},
	'main': {
		'titleStatistics': 'Statistik',
		'titleManual': 'Manuell',
		'titleDownload': 'Download',
		'titleArchives': 'Archive',
		'titleStream': 'Stream',
		'titleRealtime': 'Echtzeit',
		'titlePlay': 'Start',
		'titleDanger': 'Fehler/Nicht laufen',
		'titleWarning': 'Im Betrieb',
		'titleSettings': 'Einstellungen',
		'titleSD': 'SD frei:',
		'titleHDD': 'SSD frei:',
		'titleCamera': 'Kamera:',
		'titleLogout': 'Ausloggen',
		'status': 'Status',
		'error': 'Fehler',
		'running': 'Laufen',
		'notRunning': 'Nicht laufen',
		'downloadingFile': 'Datei heruntergeladen',
		'preparingFile': 'Datei vorbereiten'
	},
	'login': {
		'Username': 'Benutzername',
		'Password': 'Passwort',
		'Login': 'Login'
	},
	'dashboard': {
		'measuringTgl': 'Messung',
		'noiseTgl': 'Pegel',
		'weatherTgl': 'Wetter',
		'adioTgl': 'ADIO'
	},
	'graphs': {
		'export': {
			'Print chart': 'Ansicht anzeigen',
			'Download': 'Download',
			'image': 'Bild'
		},
		'nodata': "KEINE DATEN",
		'errNoise': "Problem mit Nor140",
		'errWeath': "Problem mit Wetter",
		'errAdio': "Problem mit ADIO",
		'NOISE': 'Pegel',
		'SPECTRUM': 'Spektrum',
		'WEATHER': 'Wetter',
		'ADIO': 'ADIO',
		'STATISTICS': 'STATISTIK',
		'statTitle': 'Titel',
		'statFrom': 'Von',
		'statTo': 'Bis',
		'load': 'Laden',
		'markers': 'Marker',
		'dailyNotes': 'Tägliche Notizen',
		'preload': 'Grafik manualladen',
		'sync': 'Grafik synchrosieren',
		'reset': 'Zoom zurücksetzen',
		'exportGraph': 'Grafik exportieren',
		'hideShow': 'Verbergen / Anzeigen',
		'markersCat': {
			'type': 'Type',
			'color': 'Farbe',
			'single': 'Punkt',
			'toggle': 'Bereich',
			'keybind': 'Tastenkombination',
			'learn': 'Lernen',
			'shift': 'Shift',
			'alt': 'Alt',
			'delete': 'Löschen',
			'save': 'Speichern',
			'note': 'Notizen'
		},
		'markersTable': {
			'name': 'Name',
			'startTime': 'Start Zeit',
			'endTime': 'Stop Zeit',
			'type': 'Type'
		}
	},
	'calendar': {
		'title': 'Kalender',
		'noise': 'Pegel',
		'audio': 'Audio',
		'weather': 'Wetter',
		'video': 'Video',
		'adio': 'ADIO'
	},
	'streamPopover': {
		'title': 'Streams',
		'Audio': 'Audio',
		'Video': 'Video',
		'StartManRec': 'Manuelle Aufzeichnung',
		'StopManRec': 'Aufzeichnung beenden',
		'StartStream': 'Start Stream',
		'StopStream': 'Stop Stream'
	},
	'download': {
		'title': 'Downloads',
		'popOver': {
			'XML': 'Export NorReview',
			'XMLWeekly': 'Wöchentliche Daten exportieren',
			'Raw': 'Raw daten',
			'Global': 'Globale Ergebnisse',
			'weather': 'TXT Wetter'
		}
	},
	'archives': {
		'popOver': {
			'Global': 'Global Ergebnisse',
			'Noise': 'Pegel',
			'Audio': 'Audio',
			'Video': 'Video',
			'Weather': 'Wetter',
			'Adio': 'ADIO',
			'Compressed': 'Komprimiert'
		},
		'audioPopOver': {
			'downlRec': 'Download Aufzeichnung',
			'range': 'Angebot'
		},
		'video': 'Video',
		'global': 'Globale Ergebnisse',
		'weather': 'Wetter',
		'noise': 'Pegel',
		'audio': 'Audio',
		'name': 'Archive',
		'Delete': 'Löschen',
		'Download': 'Download',
		'NorReview': 'NorReview',
		'Thumbnail': 'Vorschaubild',
		'Filename': 'Dateiname',
		'Duration': 'Dauer',
		'Size': 'Größe',
		'Close': 'schliessen',
		'adio': 'ADIO',
		'compressed': 'KOMPRIMIERTE DATEIEN'
	},
	'settings': {
		'name': 'Einstellungen',
		'save': 'Speichern',
		'addButt': "Hinzufügen",
		'preTrigg': 'Vor-Trigger',
		'Trigg': 'Trigger',
		'postTrigg': 'Nach-Trigger',
		'warning': 'Warnung',
		'continue': 'Weiter',
		'cancel': 'Abbruch',

		'interface': {
			'settingsName': 'Ansicht',
			'Realtime display': 'Echtzeitanzeige [sec]',
			'Language': 'Sprache',
			'Lt': 'L/t Bereich wählen',
			'Spectrum': 'L/f Bereich wählen',
			'Weather': 'Wetter Bereich wählen',
			'Adio': 'ADIO Bereich wählen',
			'Manual': 'Manueller Bereich',
			'Dynamic': 'Automatischer Bereich',
			'noiseTriggerLevel': 'Triggerschwelle im Pegel anzeigen',
			'spectrumTriggerLevel': 'Spektrum trigger level',
			//Options
			'english': 'Englisch (EN)',
			'austria': 'Deutsch (AT)',
			'german': 'Deutsch (DE)',
			'french': 'Französisch (FR)',
			'slovensko': 'Slowenisch (SLO)'
		},
		'download': {
			'settingsName': 'Download',
			'Compression': 'Komprimierung',
			'No compression': 'Keine Komprimierung',
			'Zip compression': 'Zip Komprimierung (spart Datenvolumen)',
			'Noise': 'Pegel',
			'Weather': 'Wetter',
			'Global Values': 'Globale Ergebnisse',
			'Special values': 'Zusatz Werte',
			'Audio': 'Audio',
			'Video': 'Video',
			'Markers': 'Markers',
			'Statistics': 'Statistik',
			'statisticsTemplate': 'Vorlage',
			'statisticsRename': "Vorlage umbenennen"
		},
		'audioRecording': {
			'settingsName': 'Audio aufzeichnung',
			'Format': 'Format',
			'Audio Offset': 'Vor-Trigger: [s]',
			'Day': 'Tag',
			'Night': 'Nacht',
			'Optional 1': 'Optional 1',
			'Optional 2': 'Optional 2',
			'RecDur': 'Aufzeichnungsdauer (s)',
			'Threshold': 'Überschreitungspegel (dBA)',
			'Start': 'Start Zeit (HH)',
			'Stop': 'Stop Zeit (HH)',
			'Weather': 'Wetter Trigger',
			'Windspeed': 'Windgeschwindigkeit',
			'Temperature': 'Temperatur',
			'Air': 'Luftdruck',
			'Precipitation': 'Precipitation',
			'Humidity': 'Feuchtigkeit',
			//Options
			'Disable': 'Deaktiviert',
			'Lower': 'Kleiner als',
			'Greater': 'Größer als',
			'Both': 'Gleich',
			'lowerThan': 'Kleiner als',
			'greaterThan': 'Größer als'
		},
		'dynamicDns': {
			'settingsName': 'Dynamic Dns',
			'Address': 'Adresse',
			'Provider': 'Anbieter',
			'Username': 'Benutzername',
			'Password': 'Kennwort',
			'IP': 'IP'
		},
		'alertMessaging': {
			'settingsName': 'Alarm Meldung',
			'createGroupButton': 'Neue Gruppe erstellen',
			'createGroupDialog': 'Möchten Sie wirklich eine neue Gruppe erstellen?',
			'deleteGroupDialog': 'Bestätigen Sie hier die Löschung von Gruppe ',
			'deleteEmailDialog': 'Möchten Sie wirklich diese E-Mail/Mobilnummer löschen?',
			'dialogConfirm': 'Bestätigen',
			'dialogContinue': 'Weiter',
			'dialogCancel': 'Abbruch',
			'MSISDN-E-Mail': 'Mobilnummer/E-Mail',
			'Add MSISDN': 'Mobilnummer hinzufügen',
			'Add E-mail': 'E-Mail Adresse hinzufügen',
			'DeleteButton': 'Löschen',
			'DeleteGroup': 'Gruppe löschen',
			'DeleteRecip': 'Empänger löschen',
			'DeleteEmail': 'E-Mail Mobilnummer löschen',
			'TestEmail': 'Test E-Mail / SMS senden',
			'Resend after': 'Erneut senden nach',
			'Threshold day': 'Überschreitung Tag',
			'Threshold Night': 'Überschreitung Nacht',
			'Threshold Opt 1': 'Überschreitung Opt. 1',
			'Threshold Opt 2': 'Überschreitung Opt. 2',
			'Running Average Level': 'laufender LAeq',
			'Weather trigger': 'Überschreitung Wetter',
			'System reboot': 'System Neustart',
			'Connection with meter lost': 'Verbindung zum Nor140 verloren',
			'FTP server error': 'FTP-Server Error',
			'Critical memory on meter': 'Geringer Speicherplatz SD-Karte Nor140',
			'Critical disk space': 'Geringer Speicherpaltz HDD',
			'Microphone check error': 'Mikrofon Check',
			'Battery mode': '230V verloren',
			'Connection with Weather station lost': 'Verbindung zur Wetterstation verloren',
			'LEQ': 'Leq Tag',
			'Inbound (MSISDN)': 'SMS Anfragen:',
			'Status': 'Status',
			'GPS': 'GPS:',
			'Threshold change': 'Überschreitungspegel ändern:',
			'Email settings': 'E-Mail einstellungen',
			'Sender Email': 'Absender E-Mail',
			'Password': 'Passwort',
			'SMTP server': 'SMTP server',
			'SMTP port': 'SMTP port',
			'noRepeat': 'keine Wiederholung',
			'resendAft': 'erneut senden',
			//Options
			'min': 'min',
			'disabled': 'Deativieren',
			'groupsError': 'Bitte wählen Sie Gruppen!',
			'emailSent': 'Nachricht gesendet'
		},
		'FTPSending': {
			'settingsName': 'FTP-Daten senden',
			'FTP Address': 'FTP-Adresse',
			'Refresh Rate': 'Aktualisierungsrate',
			'Username': 'Benutzername',
			'Password': 'Passwort',
			'Port': 'Port',
			'Values': 'Messdaten die versendet werden sollen',
			//Options
			'Disable': 'Deaktivieren',
			'sec': 'Sek.',
			'min': 'Min',
			'hour': 'Stunde',
			'measur': 'Pegel',
			'weath': 'Wetter',
			'audio': 'Audio',
			'global': 'Global Ergebnisse',
			'video': 'Video'
		},
		'geographicPosition': {
			'settingsName': 'Geografische Position',
			'Latitude': 'Geografische Breite[°]',
			'Longitude': 'Geografische Länge[°]',
			'Height': 'Höhe[m]'
		},
		'weather': {
			'settingsName': 'Wetter',
			'Weather': 'Wetterstation',
			'values': 'Messdaten',
			'SetDevice': 'Wetterstations Model',
			//Options
			'NoWeather': 'Keine Wetterstation',
			'reinhardt': 'Reinhardt MWS 5MV',
			'reinhardtRain': 'Reinhardt MWS 5MV mit Regen',
			'thiesClima': 'Thies Clima Sensor US',
			'vaisala': 'Vaisala WXT520',
			'kw360': 'ONWA KW-360'
		},
		'delete': {
			'settingsName': 'Löschen/Kompresse',
			'autoDelete': 'Automatisch löschen älter als',
			'autoCompress': 'Automatisch komprimieren älter als',
			'Disable': 'Deaktiviert',
			'Manual delete': 'Manuel löschen',
			'Values': 'Ergebnisse',
			'Delete': 'Löschen',
			//Options
			'day': 'Tag(e)',
			'week': 'Woche(n)',
			'month': 'Monat(e)',
			'measur': 'Pegel',
			'weath': 'Wetter',
			'audio': 'Audio',
			'global': 'Global Ergebnisse',
			'logs': 'Logs',
			'statistics': 'Statistik',
			'video': 'Video',
			'adio': 'ADIO'
		},
		'device': {
			'settingsName': 'Nor140',
			'Selection': 'Mikrofon Auswahl',
			'Polarisation': 'Polarisations Spannung',
			'Frequency': 'Frequenz Modus',
			'Resolution': 'Auflösung',
			'Duration': 'Messzeit',
			'Meter': 'Audioausgang Skala',
			'Values': 'Messwerte',
			'Special': 'Zusatz Werte',
			'Advance': 'Erweitert',
			'Mic check': 'Mik. Check Level [dB]:',
			'Mic check time': 'Mik. Check um [HH]:',
			'SDFreeSpace': 'Meldung freier Speicherplatz SD-Karte [%]',
			'Restart': 'Nor140 neustarten',
			'Set instrument': 'Einstellungen setzen',
			'Format': 'SD-Karte formatieren',
			'CheckSD': 'SD-Karte prüfen',
			'formatSDdialog': 'Die Formatierung kann bis zu 5 Minuten dauern, möchten Sie wirklich formatieren ?',
			'decrease': 'Lautstärke runter',
			'increase': 'Lautstärke hoch',
			'value': 'Zeitraum',
			'threshold': 'Ãœberschreitungspegel (dBA)',
			'timeControlled': 'Zeitgesteuert',
			'measurementControlled': 'Messung kontrolliert',
			'start_stop': 'Start Zeit / Stop Zeit',
			'startTime': 'Start Zeit',
			'endTime': 'Endzeit',
			'trigger': 'Trigger',
			'duration': 'Messzeit',
			'test': 'Test',
			'testOpt': 'Test auf installierte Optionen',
			'restartNoise': 'Nor140 neu starten',
			'increasedVol': 'Lautstärke verringert',
			'decreasedVol': 'Lautstärke erhöht',
			'autostart': 'Auto Start-Stop',
			//Options
			'On': 'Ein',
			'Off': 'Aus',
			'Standard': 'Standard',
			'Disable': 'Deaktivieren',
			'iepe': 'IEPE',
			'line': 'Line',
			'horizontal': '1214/16/17 Horizontal',
			'vertical': '1214/16/17 Vertical',
			'11octave': '1/1 Octave',
			'13octave': '1/3 Octave',
			'11wOctave': '1/1w Octave',
			'13wOctave': '1/3w Octave',
			'movingAverage': 'Moving Average',
			'movingValue': 'Moving value',
			'midnight': "Mitternacht - 00h",
			'noon': "Mittag - 12h",
			'freeSpace': 'Freiraum: ',
			'instrumentSent': 'Instrumentenset',
			'start': 'Start',
			'stop': 'Stop',
			'days': 'Tage',
			'types': 'Typen',
			'startstopActive': 'Aktiv',
			'warningMeasRunning': 'Einstellungen werden während einer laufenden Messung nicht übernommen!'
		},
		'video': {
			'settingsName': 'Video',
			'Present': 'Gegenwärtiges Gerät',
			'Manual': 'Manuelle Aufzeichnung',
			'Triggering': 'Überschreitungspegel Video',
			'Moving detection': 'Bewegungserkennung',
			'Settings': 'Einstellungen',
			'Pre': 'Vor-Trigger',
			'Post': 'Aufzeichnugsdauer',
			'No device': 'Keine Kamera',
			'Video camera': 'Videokamera',
			'SetDevice': 'Gerät einstellen',
			'formatSDWarning': 'Bitte warten Sie, bis die SD-Karte auf 100% steht'
		},
		'adio': {
			'settingsName': 'ADIO',
			'Present': 'Gegenwärtiges Gerät',
			'ADIO': 'ADIO Box',
			'NoDevice': 'Kein ADIO',
			'DigitalOut': 'Digital Aus',
			'DigitalIn': 'Digital In',
			'AnalogIn': 'Analog In',
			'AnalogOut': 'Analog Aus',
			'AnalogLowerLimit': 'Analog unteres Limit 0V / 4mA',
			'AnalogUpperLimit': 'Analog unteres Limit 10V / 20mA',
			'Please input': '"Bitte eingeben"',
			//Options
			'On': 'Ein',
			'Off': 'Aus'
		},
		'norcloud': {
			'settingsName': 'NorCloud',
			'IdNor': 'Nor140 ID',
			'syncTime': 'Aktualisierungsrate',
			'syncData': 'Pegel senden',
			'syncRec': 'Audio senden',
			'sendAlerts': 'Alarm senden',
			'recSett': 'Einstellungen empfangen',
			'applySett': 'Empfangene Einstellungen übernehmen',
			//Options
			'On': 'On',
			'Off': 'Off',
			'disable': 'Disable',
			'min': 'min',
			'hour': 'hour',
			'now': 'When settings are recevied',
			'fhour': 'At full hour',
			'break': 'When Automic check is performed'
		},
		'statistics': {
			'settingsName': 'Statistik',
			'reportSending': {
				'settingsName': 'Automatic Report Sending',
				'Name': 'Name',
				'Title': 'Title',
				'Duration': 'Report type',
				'Days': 'Sending days',
				'Hours': 'Send at',
				'Range': 'Past days',
				'Email': 'E-mail',
				'Language': 'Sprache'
			},
			'options': {
				'Range': 'Range',
				'Daily': 'Daily',
				'On Event': 'On Event'
			}
		},
		'status': {
			'settingsName': 'System',
			'Reboot': 'System neustart',
			'Reboot confirm': 'Möchten Sie das System wirklich neu starten?',
			'Reboot success': 'Weniger als 1 Minute bis zum Neustart!',
			'Reboot cancel': 'Neustart abgebrochen',
			'Restart confirm': 'Möchten Sie den N140 wirklich neu starten?',
			'Restart Warning': 'N140 wird in 1min wieder online sein!',
			'Restart success': 'N140 online!',
			'Restart cancel': 'Abgebrochen',
			'Version': 'Version',
			'Release': 'Veröffentlichungsdatum',
			'PCFree': 'PC Speicher[%]',
			'SDD': 'SDD',
			'memory': 'Speicher',
			'camera': 'Kamera SD',
			'n140': 'Nor140 SD',
			'cpu': 'CPU Leistung',
			'firmware': 'Firmware',
			'logs': 'Logs',
			'download': 'Download',
			'total': 'Gesamt',
			'free': 'Frei',
			'used': 'Belegt',
			'gbOrMore': '2GB oder mehr',
			'of': 'of',
			'users': 'Benutzer',
			'username': 'Benutzername',
			'password': 'Passwort',
			'adminUsr': 'Admin',
			'noiseUsr': 'Benutzer',
			'guestUsr': 'Gast'
		}
	},
	'errors': {
		'n140': 'Nor140',
		'weather': 'Wetter',
		'adio': 'ADIO',
		'cameraSD': 'CAMERA SD-Karte über 80% voll!'
	},
	'codes': {
		"13": "Keine Serielle Verbindung",
		"16": "Software Option fehlt",
		"64": "OK - Kein Fehler",
		"89": "Messzeit zu lang für Sync.",
		"90": "Befehl Unbekannt",
		"91": "Option nicht verfügbar",
		"92": "I/O ",
		"93": "Keine Marker für den ausgewählten Bereich",
		"94": "Befehlszeichenfolge ohne Begrenzer lang",
		"97": "Geräte Fehler",
		"99": "Kein DECT Modul gefunden",
		"100": "No digit read",
		"101": "Nummer ist nicht aktzeptiert",
		"102": "Text zu Lang",
		"104": "Keine Daten",
		"105": "Zahl ist außerhalb des Bereichs",
		"106": "Messung nicht gestartet",
		"108": "Timeout on string parameter to a command",
		"109": "Software V2.X nicht Installiert",
		"110": "Fehler im Text format",
		"111": "Software V3.x nicht installiert",
		"112": "Speicher Voll",
		"116": "Speicher Fehler",
		"117": "Audiometer Calibration parameter error",
		"118": "Undefinierter Fehler (118)",
		"119": "Undefinierter Fehler (119)",
		"121": "Ordner nicht gesetzt",
		"122": "Ordner nicht gefunden",
		"123": "Speicher Prüfung OK",
		"124": "SD-Karte nicht vorhanden",
		"125": "SD-Karte nicht Unterstüzt",
		"126": "SD-Karte schreibgeschützt"
	}
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	'common': {
		'select': 'Select',
		'graph_loading': "Loading the data...",
		'month_Names': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		'graph_shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		'graph_day_name': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		'graph_export': "Export",
		'graph_printButt': "Print chart",
		'graph_down_PNG': "Download PNG image",
		'graph_down_JPG': "Download JPEG image",
		'graph_down_PDF': "Download PDF document",
		'graph_down_SVG': "Download SVG vector",
		'graph_zoom_reset': "Reset zoom",
		'Valid request.': 'Valid request.',
		'Warning': 'Warning'
	},
	'main': {
		'titleStatistics': 'Statistics',
		'titleManual': 'Manual',
		'titleDownload': 'Download',
		'titleArchives': 'Archives',
		'titleStream': 'Stream',
		'titleRealtime': 'Realtime',
		'titlePlay': 'Running',
		'titleDanger': 'Error/Not Running',
		'titleWarning': 'Running',
		'titleSettings': 'Settings',
		'titleSD': 'SD free:',
		'titleHDD': 'SSD free:',
		'titleCamera': 'CAMERA:',
		'titleLogout': 'Logout',
		'status': 'Status',
		'error': 'Error',
		'running': 'Running',
		'notRunning': 'Not Running',
		'downloadingFile': 'Downloading file',
		'preparingFile': 'Preparing file'
	},
	'login': {
		'Username': 'Username',
		'Password': 'Password',
		'Login': 'Login'
	},
	'dashboard': {
		'measuringTgl': 'MEASURING',
		'noiseTgl': 'NOISE',
		'weatherTgl': 'WEATHER',
		'adioTgl': 'ADIO'
	},
	'graphs': {
		'export': {
			'Print chart': 'Print chart',
			'Download': 'Download',
			'image': 'image'
		},
		'nodata': "NO DATA",
		'errNoise': "Problem with Nor140 device",
		'errWeath': "Problem with Weather device",
		'errAdio': "Problem with ADIO device",
		'NOISE': 'NOISE',
		'SPECTRUM': 'SPECTRUM',
		'WEATHER': 'WEATHER',
		'ADIO': 'ADIO',
		'STATISTICS': 'STATISTICS',
		'statTitle': 'Title',
		'statFrom': 'From',
		'statTo': 'To',
		'load': 'Load',
		'markers': 'Markers',
		'dailyNotes': 'Daily notes',
		'preload': 'Manual graph load',
		'sync': 'Sync graphs',
		'reset': 'Reset zoom',
		'exportGraph': 'Export graph',
		'hideShow': 'Hide / Show',
		'markersCat': {
			'type': 'Type',
			'color': 'Color',
			'single': 'single',
			'toggle': 'toggle',
			'keybind': 'Keybind',
			'learn': 'Learn',
			'shift': 'Shift',
			'alt': 'Alt',
			'delete': 'Delete',
			'save': 'Save',
			'note': 'Notes'
		},
		'markersTable': {
			'name': 'Name',
			'startTime': 'Start time',
			'endTime': 'End time',
			'type': 'Type'
		}
	},
	'calendar': {
		'title': 'Calendar',
		'noise': 'Noise',
		'audio': 'Audio',
		'weather': 'Weather',
		'video': 'Video',
		'adio': 'ADIO'
	},
	'streamPopover': {
		'title': 'Streams',
		'Audio': 'Audio',
		'Video': 'Video',
		'StartManRec': 'Manual Recording',
		'StopManRec': 'Stop recording',
		'StartStream': 'Start Stream',
		'StopStream': 'Stop stream'
	},
	'download': {
		'title': 'Downloads',
		'popOver': {
			'XML': 'XML data',
			'XMLWeekly': 'XML weekly data',
			'Raw': 'Raw data',
			'Global': 'Global values',
			'weather': 'TXT Weather'
		}
	},
	'archives': {
		'popOver': {
			'Global': 'Global values',
			'Noise': 'Noise',
			'Audio': 'Audio',
			'Video': 'Video',
			'Weather': 'Weather',
			'Adio': 'ADIO',
			'Compressed': 'Compressed'
		},
		'audioPopOver': {
			'downlRec': 'Download recording',
			'range': 'Range'
		},
		'video': 'VIDEO',
		'global': 'GLOBAL VALUES',
		'weather': 'WEATHER',
		'noise': 'NOISE',
		'audio': 'AUDIO',
		'name': 'Archives',
		'Delete': 'Delete',
		'Download': 'Download',
		'NorReview': 'NorReview',
		'Thumbnail': 'Picture',
		'Filename': 'Filename',
		'Duration': 'Duration',
		'Size': 'Size',
		'Close': 'Close',
		'adio': 'ADIO',
		'compressed': 'COMPRESSED FILES'
	},
	'settings': {
		'name': 'SETTINGS',
		'save': 'SAVE',
		'addButt': 'ADD',
		'preTrigg': 'Pre-Trigger',
		'Trigg': 'Trigger',
		'postTrigg': 'Post-Trigger',
		'warning': 'Warning',
		'continue': 'Continue',
		'cancel': 'Cancel',

		'interface': {
			'settingsName': 'View',
			'Realtime display': 'Realtime display [sec]',
			'Language': 'Language',
			'Lt': 'Noise graph y-range',
			'Spectrum': 'Spectrum graph y-range',
			'Weather': 'Weather graph y-range',
			'Adio': 'ADIO IN graph y-range',
			'Manual': 'Manual range',
			'Dynamic': 'Dynamic range',
			'noiseTriggerLevel': 'Noise trigger level',
			'spectrumTriggerLevel': 'Spectrum trigger level',
			//Options
			'english': 'English (EN)',
			'austria': 'German (AT)',
			'german': 'German (DE)',
			'french': 'French (FR)',
			'slovensko': 'Slovenian (SLO)'
		},
		'download': {
			'settingsName': 'Download',
			'Compression': 'Compression',
			'No compression': 'No compression',
			'Zip compression': 'Zip compression (saves bandwidth)',
			'Noise': 'Noise',
			'Weather': 'Weather',
			'Global Values': 'Global Values',
			'Special values': 'Special values',
			'Audio': 'Audio',
			'Video': 'Video',
			'Markers': 'Markers',
			'Statistics': 'Statistics',
			'statisticsTemplate': 'Template',
			'statisticsRename': "Rename Template"
		},
		'audioRecording': {
			'settingsName': 'Audio recording',
			'Format': 'Format',
			'Audio Offset': 'Audio pre-trigger: [s]',
			'Day': 'Day',
			'Night': 'Night',
			'Optional 1': 'Optional 1',
			'Optional 2': 'Optional 2',
			'RecDur': 'Rec dur (s)',
			'Threshold': 'Threshold (dBA)',
			'Start': 'Start time (HH)',
			'Stop': 'Stop time (HH)',
			'Weather': 'Weather trigger',
			'Windspeed': 'Windspeed',
			'Temperature': 'Temperature',
			'Air': 'Air pressure',
			'Precipitation': 'Precipitation',
			'Humidity': 'Humidity',
			//Options
			'Disable': 'Disabled',
			'Lower': 'Lower than',
			'Greater': 'Greater than',
			'Both': 'Both',
			'lowerThan': 'Lower than',
			'greaterThan': 'Greater than'
		},
		'dynamicDns': {
			'settingsName': 'Dynamic Dns',
			'Address': 'Address',
			'Provider': 'Provider',
			'Username': 'Username',
			'Password': 'Password',
			'IP': 'IP'
		},
		'alertMessaging': {
			'settingsName': 'Alert messaging',
			'createGroupButton': 'Create new group',
			'createGroupDialog': 'Are you sure you want to create a new Group?',
			'deleteGroupDialog': 'Are you sure you want to delete Group ',
			'deleteEmailDialog': 'Are you sure you want to delete this E-mail / Telephone number ?',
			'dialogConfirm': 'Confirm',
			'dialogContinue': 'Continue',
			'dialogCancel': 'Cancel',
			'MSISDN-E-Mail': 'To which group(s) do you want to add recipient?',
			'Add MSISDN': 'Add Telephone number',
			'Add E-mail': 'Add E-mail',
			'DeleteButton': 'Delete',
			'DeleteGroup': 'Delete group',
			'DeleteRecip': 'Delete Recipient',
			'DeleteEmail': 'Delete E-mail / Telephone number',
			'TestEmail': 'Send test E-mail / SMS',
			'Resend after': 'Resend after',
			'Threshold day': 'Threshold day',
			'Threshold Night': 'Threshold Night',
			'Threshold Opt 1': 'Threshold Opt 1',
			'Threshold Opt 2': 'Threshold Opt 2',
			'Running Average Level': 'Moving value Level',
			'Weather trigger': 'Weather Trigger',
			'System reboot': 'System reboot',
			'Connection with meter lost': 'Connection with Nor140 lost',
			'FTP server error': 'FTP server error',
			'Critical memory on meter': 'Critical memory on Nor140',
			'Critical disk space': 'Critical disk space',
			'Microphone check error': 'Microphone check error',
			'Battery mode': 'Battery mode',
			'Connection with Weather station lost': 'Connection with Weather station lost',
			'LEQ': 'LEQ Day',
			'Inbound (MSISDN)': 'Inbound (SMS)',
			'Status': 'Status:',
			'GPS': 'GPS:',
			'Threshold change': 'Threshold change:',
			'Email settings': 'Email settings:',
			'Sender Email': 'Sender Email',
			'Password': 'Password',
			'SMTP server': 'SMTP server',
			'SMTP port': 'SMTP port',
			'noRepeat': 'No repeat',
			'resendAft': 'Resend after',
			//Options
			'min': 'min',
			'disabled': 'Disable',
			'groupsError': 'Please select groups!',
			'emailSent': 'Message successfuly sent'
		},
		'FTPSending': {
			'settingsName': 'FTP sending',
			'FTP Address': 'FTP Address',
			'Refresh Rate': 'Refresh Rate',
			'Username': 'Username',
			'Password': 'Password',
			'Port': 'Port',
			'Values': 'Values to send',
			//Options
			'Disable': 'Disable',
			'sec': 'sec',
			'min': 'min',
			'hour': 'hour',
			'measur': 'Noise',
			'weath': 'Weather',
			'audio': 'Audio',
			'global': 'Global',
			'video': 'Video'
		},
		'geographicPosition': {
			'settingsName': 'Geographic position',
			'Latitude': 'Latitude[°]',
			'Longitude': 'Longitude[°]',
			'Height': 'Height[m]'
		},
		'weather': {
			'settingsName': 'Weather',
			'Weather': 'Weather station',
			'values': 'Values',
			'SetDevice': 'Set Device',
			//Options
			'NoWeather': 'No weather station',
			'reinhardt': 'Reinhardt MWS 5MV',
			'reinhardtRain': 'Reinhardt MWS 5MV with Rain',
			'thiesClima': 'Thies Clima sensor US',
			'vaisala': 'Vaisala WXT520',
			'kw360': 'ONWA KW-360'
		},
		'delete': {
			'settingsName': 'Delete/Compress',
			'autoDelete': 'Auto-delete older than',
			'autoCompress': 'Auto-compress older than',
			'Disable': 'Disable',
			'Manual delete': 'Manual delete',
			'Values': 'Values',
			'Delete': 'Delete',
			//Options
			'day': 'day',
			'week': 'week',
			'month': 'month',
			'measur': 'Noise',
			'weath': 'Weather',
			'audio': 'Audio',
			'global': 'Global',
			'logs': 'Logs',
			'statistics': 'Statistics',
			'video': 'Video',
			'adio': 'ADIO'
		},
		'device': {
			'settingsName': 'Nor 140',
			'Selection': 'MIC Selection',
			'Polarisation': 'MIC Polarisation',
			'Frequency': 'Frequency mode',
			'Resolution': 'Resolution',
			'Duration': 'Duration',
			'Meter': 'Meter scale',
			'Values': 'Values',
			'Special': 'Special parameters',
			'Advance': 'Advance',
			'Mic check': 'Mic check value [dB]:',
			'Mic check time': 'MIC check at [HH]:',
			'SDFreeSpace': 'SD Free space alert [%]',
			'Restart': 'Restart noise',
			'Set instrument': 'Set instrument',
			'Format': 'Format SD',
			'CheckSD': 'Check SD Free space',
			'formatSDdialog': 'This action can take up to 5 minutes, do you still wish to continue?',
			'decrease': 'Decrease',
			'increase': 'Increase',
			'value': 'Value',
			'threshold': 'Threshold (dBA)',
			'timeControlled': 'Time controlled',
			'measurementControlled': 'Measurement controlled',
			'start_stop': 'Start time / Stop time',
			'startTime': 'Start time',
			'endTime': 'End time',
			'trigger': 'Trigger',
			'duration': 'Duration',
			'test': 'Test',
			'testOpt': 'Test for installed options',
			'restartNoise': 'Restart noise',
			'increasedVol': 'Increased Volume',
			'decreasedVol': 'Decreased volume',
			'autostart': 'Auto Start-Stop',
			//Options
			'On': 'On',
			'Off': 'Off',
			'Standard': 'Standard',
			'Disable': 'Disable',
			'iepe': 'IEPE',
			'line': 'Line',
			'horizontal': '1214/16/17 Horizontal',
			'vertical': '1214/16/17 Vertical',
			'11octave': '1/1 Octave',
			'13octave': '1/3 Octave',
			'11wOctave': '1/1w Octave',
			'13wOctave': '1/3w Octave',
			'movingAverage': 'Moving Average',
			'movingValue': 'Moving value',
			'midnight': "Midnight - 00h",
			'noon': "Noon - 12h",
			'freeSpace': 'SD Free space: ',
			'instrumentSent': 'Instrument set',
			'start': 'Start',
			'stop': 'Stop',
			'days': 'Days',
			'types': 'Types',
			'startstopActive': 'Active',
			'warningMeasRunning': 'Values will not be sent to instrument if the measurement is running!'
		},
		'video': {
			'settingsName': 'Video',
			'Present': 'Present',
			'Manual': 'Manual recording',
			'Triggering': 'Threshold triggering video',
			'Moving detection': 'Moving detection',
			'Settings': 'Settings',
			'Pre': 'Pre-record',
			'Post': 'Post-record',
			'No device': 'No device',
			'Video camera': 'Video camera',
			'SetDevice': 'Set Device',
			'formatSDWarning': 'Please wait until SD card free space indicatior is on 100%'
		},
		'adio': {
			'settingsName': 'ADIO',
			'Present': 'Present',
			'ADIO': 'ADIO Box',
			'NoDevice': 'No device',
			'DigitalOut': 'Digital Out',
			'DigitalIn': 'Digital In',
			'AnalogIn': 'Analog In',
			'AnalogOut': 'Analog Out',
			'AnalogLowerLimit': 'Analog lower limit 0V / 4mA',
			'AnalogUpperLimit': 'Analog upper limit 10V / 20mA',
			'Pleaseinput': '"Please input"',
			//Options
			'On': 'On',
			'Off': 'Off'
		},
		'norcloud': {
			'settingsName': 'NorCloud',
			'IdNor': 'Nor140 ID',
			'syncTime': 'Synchronization Time',
			'syncData': 'Send Noise Data',
			'syncRec': 'Send Audio Recordings',
			'sendAlerts': 'Send Alerts',
			'recSett': 'Receive Settings',
			'applySett': 'Apply Received Settings',
			//Options
			'On': 'On',
			'Off': 'Off',
			'disable': 'Disable',
			'min': 'min',
			'hour': 'hour',
			'now': 'When settings are recevied',
			'fhour': 'At full hour',
			'break': 'When Automic check is performed'
		},
		'statistics': {
			'settingsName': 'Statistics',
			'reportSending': {
				'settingsName': 'Automatic Report Sending',
				'Name': 'Name',
				'Title': 'Title',
				'Duration': 'Report type',
				'Days': 'Sending days',
				'Hours': 'Send at',
				'Range': 'Past days',
				'Email': 'E-mail',
				'Language': 'Language'
			},
			'options': {
				'Range': 'Range',
				'Daily': 'Daily',
				'On Event': 'On Event'
			}
		},
		'status': {
			'settingsName': 'System',
			'Reboot': 'Reboot System',
			'Reboot confirm': 'Are you sure you want to reboot system?',
			'Reboot success': 'Less than 1min to Reboot!',
			'Reboot cancel': 'Reboot canceled',
			'Restart confirm': 'Are you sure you want to Restart N140?',
			'Restart Warning': 'N140 will be back online in 1min!',
			'Restart success': 'N140 is back online!',
			'Restart cancel': 'Canceled',
			'Version': 'Version',
			'Release': 'Release date',
			'PCFree': 'PC free space alert [%]',
			'SDD': 'SSD',
			'memory': 'Memory',
			'camera': 'Camera SD',
			'n140': 'Nor140 SD',
			'cpu': 'CPU Percent',
			'firmware': 'Firmware',
			'logs': 'Logs',
			'download': 'Download',
			'total': 'TOTAL',
			'free': 'FREE',
			'used': 'USED',
			'gbOrMore': '2GB or more',
			'of': 'of',
			'users': 'Users',
			'username': 'Username',
			'password': 'Password',
			'adminUsr': 'Admin',
			'noiseUsr': 'Normal',
			'guestUsr': 'Guest'
		}
	},
	'errors': {
		'n140': 'Nor140',
		'weather': 'WEATHER STATION',
		'adio': 'ADIO',
		'cameraSD': 'CAMERA SD Card over 80% full!'
	},
	'codes': {
		"13": "No serial connection",
		"16": "Software options missing",
		"64": "OK-no error",
		"89": "Measurement time too long for Synchro",
		"90": "Command unknown",
		"91": "Option not present",
		"92": "I/O locked",
		"93": "No marker table for selected file",
		"94": "Command string to long without delimiters",
		"97": "Device error",
		"99": "No DECT module detected",
		"100": "No digit read",
		"101": "Number is illegal",
		"102": "Text string too long",
		"104": "No data valid",
		"105": "Number out of range",
		"106": "Measurement not started",
		"108": "Timeout on string parameter to a command",
		"109": "Software v2.x option no present (118)",
		"110": "Error in text format",
		"111": "Software v3.x option not present (118)",
		"112": "Memory full",
		"116": "All memory operations blocked due to memory errors",
		"117": "Audiometer Calibration parameter error",
		"118": "Not define error",
		"119": "Not define error",
		"121": "Directory NOT set",
		"122": "Directory NOT found",
		"123": "Memory operation OK",
		"124": "SD Card NOT present",
		"125": "SD Card NOT powered",
		"126": "SD Card write protected"
	}
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	'common': {
		'select': 'sélectionner',
		'graph_loading': "Chargement des données...",
		'month_Names': ['Janv', 'Févr', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
		'graph_shortMonths': ['Janv', 'Févr', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
		'graph_day_name': ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
		'graph_export': "Export",
		'graph_printButt': "Imprimer le graphique",
		'graph_down_PNG': "Télécharger l'image PNG",
		'graph_down_JPG': "Télécharger l'image JPEG",
		'graph_down_PDF': "Télécharger le document PDF",
		'graph_down_SVG': "Télécharger le vecteur SVG",
		'graph_zoom_reset': "Réinitialiser le zoom",
		'Valid request.': 'Valid request.',
		'Warning': 'Warning'
	},
	'main': {
		'titleStatistics': 'statistique',
		'titleManual': 'manuel',
		'titleDownload': 'téléchargement',
		'titleArchives': 'archives',
		'titleStream': 'stream',
		'titleRealtime': 'temps réel',
		'titlePlay': 'jouer',
		'titleDanger': 'erreur/Ne pas courrir',
		'titleWarning': 'en cours',
		'titleSettings': 'ajustage',
		'titleSD': 'disponible sur SD:',
		'titleHDD': 'disponible sur SSD:',
		'titleCamera': 'CAMERA:',
		'titleLogout': 'Connectez - Out',
		'status': 'l’état',
		'error': 'erreur',
		'running': 'en cours',
		'notRunning': 'Ne pas courrir',
		'downloadingFile': 'Téléchargement du fichier',
		'preparingFile': 'Préparation du fichier'
	},
	'login': {
		'Username': 'utilisateur',
		'Password': 'mot de passe',
		'Login': 'Login'
	},
	'dashboard': {
		'measuringTgl': 'mesurage',
		'noiseTgl': 'bruit',
		'weatherTgl': 'météo',
		'adioTgl': 'ADIO'
	},
	'graphs': {
		'export': {
			'Print chart': 'imprimer graphique',
			'Download': 'téléchargement',
			'image': 'image'
		},
		'nodata': "NO DATA",
		'errNoise': "Problem with noise device",
		'errWeath': "Problem with weather device",
		'errAdio': "Problem with ADIO device",
		'NOISE': 'bruit',
		'SPECTRUM': 'spectre',
		'WEATHER': 'météo',
		'ADIO': 'ADIO',
		'STATISTICS': 'statistique',
		'statTitle': 'Titre',
		'statFrom': 'de',
		'statTo': 'à',
		'load': 'charge',
		'markers': 'Markers',
		'dailyNotes': 'Daily notes',
		'preload': 'Manual graph loading',
		'sync': 'Sync graphs',
		'reset': 'Reset zoom',
		'exportGraph': 'Export graph',
		'hideShow': 'Hide / Show',
		'markersCat': {
			'type': 'Type',
			'color': 'Color',
			'single': 'single',
			'toggle': 'toggle',
			'keybind': 'Keybind',
			'learn': 'Learn',
			'shift': 'Shift',
			'alt': 'Alt',
			'delete': 'Delete',
			'save': 'Save',
			'note': 'Notes'
		},
		'markersTable': {
			'name': 'Name',
			'startTime': 'Start time',
			'endTime': 'End time',
			'type': 'Type'
		}
	},
	'calendar': {
		'title': 'calendrier',
		'noise': 'bruit',
		'audio': 'audio',
		'weather': 'météo',
		'video': 'video',
		'adio': 'ADIO'
	},
	'streamPopover': {
		'title': 'stream',
		'Audio': 'audio',
		'Video': 'video',
		'StartManRec': 'Manual Recording',
		'StopManRec': 'Stop recording',
		'StartStream': 'Start Stream',
		'StopStream': 'Stop stream'
	},
	'download': {
		'title': 'téléchargement',
		'popOver': {
			'XML': 'donnée XML',
			'XMLWeekly': 'donnée XML par semaine',
			'Raw': 'donnée RAW',
			'Global': 'donnée global',
			'weather': 'TXT météo'
		}
	},
	'archives': {
		'popOver': {
			'Global': 'donnée global',
			'Noise': 'bruit',
			'Audio': 'audio',
			'Video': 'video',
			'Weather': 'météo',
			'Adio': 'ADIO',
			'Compressed': 'comprimé'
		},
		'audioPopOver': {
			'downlRec': 'Télécharger l\'enregistrement',
			'range': 'gamme'
		},
		'video': 'video',
		'global': 'donnée global',
		'weather': 'météo',
		'noise': 'bruit',
		'audio': 'audio',
		'name': 'archive',
		'Delete': 'effacer',
		'Download': 'téléchargement',
		'NorReview': 'NorReview',
		'Thumbnail': 'miniature',
		'Filename': 'fichier',
		'Duration': 'durée',
		'Size': 'dimension',
		'Close': 'fermer',
		'adio': 'ADIO',
		'compressed': 'FICHIERS COMPRESSÉS'
	},
	'settings': {
		'name': 'Ajustage',
		'save': 'enregistrer',
		'addButt': 'ajouter',
		'preTrigg': 'pré-déclenchement',
		'Trigg': 'déclencher',
		'postTrigg': 'post-déclenchement',
		'warning': 'Attention',
		'continue': 'continuer',
		'cancel': 'Annuler',

		'interface': {
			'settingsName': 'VUE',
			'Realtime display': 'indication en temp réel [s]',
			'Language': 'langue',
			'Lt': 'selection zone L/t',
			'Spectrum': 'selection zone spectrale',
			'Weather': 'selection zone météo',
			'Adio': 'selection zone ADIO',
			'Manual': 'definition zone manuel',
			'Dynamic': 'definition zone dynamique',
			'noiseTriggerLevel': 'barrière sonore de déclenchement',
			'spectrumTriggerLevel': 'barrière spectrale de déclenchement',
			//Options
			'english': 'Anglais (EN)',
			'austria': 'Allemand (AT)',
			'german': 'Allemand (DE)',
			'french': 'français (FR)',
			'slovensko': 'Slovensko (SI)'
		},
		'download': {
			'settingsName': 'Téléchargement',
			'Compression': 'compression',
			'No compression': 'sans compression',
			'Zip compression': 'compression ZIP ( économise largeur de bande)',
			'Noise': 'bruit',
			'Weather': 'météo',
			'Global Values': 'donnée global',
			'Special values': 'donnée special',
			'Audio': 'audio',
			'Video': 'video',
			'Markers': 'Marqueurs',
			'Statistics': 'statistique',
			'statisticsTemplate': 'modèle',
			'statisticsRename': "renommer le modèle"
		},
		'audioRecording': {
			'settingsName': 'Phonogramme',
			'Format': 'format',
			'Audio Offset': 'près-déclanhement pour phonogramme [s]',
			'Day': 'jour',
			'Night': 'nuit',
			'Optional 1': 'option 1',
			'Optional 2': 'option 2',
			'RecDur': 'durée du phonogramme [s]',
			'Threshold': 'valeur de seuil (dBA)',
			'Start': 'temps de déclanchement (HH)',
			'Stop': 'temps de l\'arrêt (HH)',
			'Weather': 'barrière de déclanchement météo',
			'Windspeed': 'vitesse du vent',
			'Temperature': 'température',
			'Air': 'pression d\'air',
			'Precipitation': 'précipitation',
			'Humidity': 'humidité',
			//Options
			'Disable': 'désactiver',
			'Lower': 'au-dessous',
			'Greater': 'au-dessus',
			'Both': 'les deux',
			'lowerThan': 'au-dessous',
			'greaterThan': 'au-dessus'
		},
		'dynamicDns': {
			'settingsName': 'DNS dynamique',
			'Address': 'adresse',
			'Provider': 'fournisseur de services',
			'Username': 'utilisateur',
			'Password': 'mot de passe',
			'IP': 'IP'
		},
		'alertMessaging': {
			'settingsName': 'Avertissement',
			'createGroupButton': 'creation d\'une nouvelle groupe',
			'createGroupDialog': 'Êtes-vous sûr de créer une nouvelle groupe?',
			'deleteGroupDialog': 'Êtes-vous sûr de supprimer une groupe?',
			'deleteEmailDialog': 'Êtes-vous sûr de supprimer cet e-mail/MISISDN?',
			'dialogConfirm': 'valider',
			'dialogContinue': 'continuer',
			'dialogCancel': 'annuler',
			'MSISDN-E-Mail': 'À quel (s) groupe (s) souhaitez-vous ajouter le destinataire?',
			'Add MSISDN': 'ajouter MSISDN',
			'Add E-mail': 'ajouter E-mail',
			'DeleteButton': 'effacer',
			'DeleteGroup': 'supprimer groupe',
			'DeleteRecip': 'supprimer le destinataire',
			'DeleteEmail': 'supprimer E-mail / MSISDN',
			'TestEmail': 'Envoyer un e-mail / SMS de test',
			'Resend after': 'renvoyer après',
			'Threshold day': 'valeur de seuil pour jour',
			'Threshold Night': 'valeur de seuil pour nuit',
			'Threshold Opt 1': 'valeur de seuil pour Opt. 1',
			'Threshold Opt 2': 'valeur de seuil pour Opt. 2',
			'Running Average Level': 'niveau moyen courant',
			'Weather trigger': 'valeur de seuil pour météo',
			'System reboot': 'redémarrage du système',
			'Connection with meter lost': 'Connexion avec sonomètre perdu',
			'FTP server error': 'Erreur de server FTP',
			'Critical memory on meter': 'mémoire critique au sonomètre Nor140',
			'Critical disk space': 'mémoire critique sur l\'ordinateure',
			'Microphone check error': 'Erreur de Microphon-Check',
			'Battery mode': 'mode batterie',
			'Connection with Weather station lost': 'connection avec station météo perdu',
			'LEQ': 'LEQ jour',
			'Inbound (MSISDN)': 'entrée (SMS):',
			'Status': 'etat:',
			'GPS': 'GPS:',
			'Threshold change': 'changement du valeur de seuil:',
			'Email settings': 'ajustage e-mail',
			'Sender Email': 'e-mail de l\'expéditeur',
			'Password': 'mot de passe',
			'SMTP server': 'server SMTP',
			'SMTP port': 'port pour SMTP',
			'noRepeat': 'pas de répétition',
			'resendAft': 'Renvoyer après',
			//Options
			'min': 'minimum',
			'disabled': 'désactiver',
			'groupsError': 'Veuillez sélectionner des groupes!',
			'emailSent': 'Message envoyé avec succès'
		},
		'FTPSending': {
			'settingsName': 'Envoyer FTP',
			'FTP Address': 'adress FTP',
			'Refresh Rate': 'fréquence de rafraîchissement',
			'Username': 'utilisateur',
			'Password': 'mot de passe',
			'Port': 'porte',
			'Values': 'valeurs à envoyer',
			//Options
			'Disable': 'désactiver',
			'sec': 'seconde',
			'min': 'minute',
			'hour': 'heure',
			'measur': 'bruit',
			'weath': 'météo',
			'audio': 'audio',
			'global': 'global',
			'video': 'video'
		},
		'geographicPosition': {
			'settingsName': 'Position géographique',
			'Latitude': 'latitude[°]',
			'Longitude': 'longitude[°]',
			'Height': 'altitude[m]'
		},
		'weather': {
			'settingsName': 'Météo',
			'Weather': 'station de météo',
			'values': 'valeur',
			'SetDevice': 'définir le périphérique',
			//Options
			'NoWeather': 'pas de station météo',
			'reinhardt': 'Reinhardt MWS 5MV',
			'reinhardtRain': 'Reinhardt MWS 5MV avec de la pluie',
			'thiesClima': 'Thies Clima sensor US',
			'vaisala': 'Vaisala WXT520',
			'kw360': 'ONWA KW-360'
		},
		'delete': {
			'settingsName': 'Supprimer/Compresse',
			'autoDelete': 'supprimer automatiquemen les donnée plus vieilles que',
			'autoCompress': 'Compression automatique les donnée plus vieilles que',
			'Disable': 'désactiver',
			'Manual delete': 'supprimer manualement',
			'Values': 'valeur',
			'Delete': 'supprimer',
			//Options
			'day': 'jour',
			'week': 'semaine',
			'month': 'mois',
			'measur': 'bruit',
			'weath': 'météo',
			'audio': 'audio',
			'global': 'global',
			'logs': 'enregistrements',
			'statistics': 'statistique',
			'video': 'video',
			'adio': 'ADIO'
		},
		'device': {
			'settingsName': 'Nor 140',
			'Selection': 'selection du microphone',
			'Polarisation': 'polarisation du microphone',
			'Frequency': 'mode fréquence',
			'Resolution': 'résolution',
			'Duration': 'durée',
			'Meter': 'Meter scale',
			'Values': 'valeur',
			'Special': 'paramètres speciaux',
			'Advance': 'avance',
			'Mic check': 'valeur du Mic-Check [dB]:',
			'Mic check time': 'Mic-Check à [HH]:',
			'SDFreeSpace': 'alarme  pour capacitée libre sur la carte SD [%]',
			'Restart': 'redémarrer bruit',
			'Set instrument': 'installer sonomètre',
			'Format': 'format de la carte SD',
			'CheckSD': 'vérifier capacitée libre de la carte SD',
			'formatSDdialog': 'cette action utilise jusque à 5 minutes! Souhaitez-vous toujours continuer?',
			'decrease': 'diminution',
			'increase': 'augmentation',
			'value': 'valeur',
			'threshold': 'valeur de seuil (dBA)',
			'timeControlled': 'contrôlé par temps',
			'measurementControlled': 'contrôlé par mesure',
			'start_stop': 'temps de démarration / temps d\'arrêt',
			'startTime': 'temps de démarration',
			'endTime': 'temps d\'arrêt',
			'trigger': 'déclencheur',
			'duration': 'durée',
			'test': 'teste',
			'testOpt': 'Test for installed options',
			'restartNoise': 'redémarrer bruit',
			'increasedVol': 'volume accru',
			'decreasedVol': 'diminution du volume',
			'autostart': 'Auto Start-Stop',
			//Options
			'On': 'allumé',
			'Off': 'éteint',
			'Standard': 'standard',
			'Disable': 'désactiver',
			'iepe': 'IEPE',
			'line': 'Line',
			'horizontal': '1214/16/17 horizontal',
			'vertical': '1214/16/17 vertical',
			'11octave': '1/1 octave',
			'13octave': '1/3 octave',
			'11wOctave': '1/1w octave',
			'13wOctave': '1/3w octave',
			'movingAverage': 'moyenne mobile',
			'movingValue': 'valeur mobile',
			'midnight': "minuit - 00h",
			'noon': "midi - 12h",
			'freeSpace': 'Espace libre: ',
			'instrumentSent': 'Jeu d\'instrumentst',
			'start': 'Start',
			'stop': 'Stop',
			'days': 'Days',
			'types': 'Types',
			'startstopActive': 'Active',
			'warningMeasRunning': 'Les valeurs ne seront pas envoyées à l\'instrument si la mesure est en cours!'
		},
		'video': {
			'settingsName': 'Video',
			'Present': 'presenter',
			'Manual': 'enregistrement manuel',
			'Triggering': 'Seuil de déclenchement vidéo',
			'Moving detection': 'détection en mouvement',
			'Settings': 'ajustage',
			'Pre': 'pre-enregistrement',
			'Post': 'post-enregistrement',
			'No device': 'pas d\'appareil',
			'Video camera': 'camera de video',
			'SetDevice': 'définir le périphérique',
			'formatSDWarning': 'Please wait until SD card free space indicatior is on 100%'
		},
		'adio': {
			'settingsName': 'ADIO',
			'Present': 'présent',
			'ADIO': 'ADIO boîte',
			'NoDevice': 'pas d\'appareil',
			'DigitalOut': 'entrée digital',
			'DigitalIn': 'sortie digital',
			'AnalogIn': 'entrée analogue',
			'AnalogOut': 'sortie analogue',
			'AnalogLowerLimit': 'limite inférieure analogue 0V / 4mA',
			'AnalogUpperLimit': 'limite supérieure analogue 10V / 20mA',
			'Pleaseinput': '"demande d\'entrer"',
			//Options
			'On': 'allumé',
			'Off': 'éteint'
		},
		'norcloud': {
			'settingsName': 'NorCloud',
			'IdNor': 'Nor140 ID',
			'syncTime': 'Synchronization Time',
			'syncData': 'Send Noise Data',
			'syncRec': 'Send Audio Recordings',
			'sendAlerts': 'Send Alerts',
			'recSett': 'Receive Settings',
			'applySett': 'Apply Received Settings',
			//Options
			'On': 'On',
			'Off': 'Off',
			'disable': 'Disable',
			'min': 'min',
			'hour': 'hour',
			'now': 'When settings are recevied',
			'fhour': 'At full hour',
			'break': 'When Automic check is performed'
		},
		'statistics': {
			'settingsName': 'Statistiques',
			'reportSending': {
				'settingsName': 'Automatic Report Sending',
				'Name': 'Name',
				'Title': 'Title',
				'Duration': 'Report type',
				'Days': 'Days to send',
				'Hours': 'Send at',
				'Range': 'Past days',
				'Email': 'E-mail',
				'Language': 'langue'
			},
			'options': {
				'Range': 'Range',
				'Daily': 'Daily',
				'On Event': 'On Event'
			}
		},
		'status': {
			'settingsName': 'Systeme',
			'Reboot': 'redemarrer le systeme',
			'Reboot confirm': 'Êtes-vous sûr de vouloir redémarrer le système?',
			'Reboot success': 'Moins de 1 minute pour redémarrer!',
			'Reboot cancel': 'Redémarrage annulé',
			'Restart confirm': 'Êtes-vous sûr de vouloir redémarrer N140?',
			'Restart Warning': 'N140 sera de retour en ligne dans 1min!',
			'Restart success': 'N140 is back online!',
			'Restart cancel': 'Annulé',
			'Version': 'version',
			'Release': 'date de sortie',
			'PCFree': 'alarme  pour capacitée libre sur le PC [%]',
			'SDD': 'SSD',
			'memory': 'mémoire',
			'camera': 'camera SD',
			'n140': 'Nor140 SD',
			'cpu': 'CPU pourcentage',
			'firmware': 'logiciel interne',
			'logs': 'enregistrement historique',
			'download': 'téléchargement',
			'total': 'totale',
			'free': 'libre',
			'used': 'utilisé',
			'gbOrMore': '2GB ou plus',
			'of': 'de',
			'users': 'utilisateurs',
			'username': 'Nom d\'utilisateur',
			'password': 'mot de passe',
			'adminUsr': 'Administrator',
			'noiseUsr': 'Ordinaire',
			'guestUsr': 'Client'
		}
	},
	'errors': {
		'n140': 'Nor140',
		'weather': 'météo',
		'adio': 'ADIO',
		'cameraSD': 'CAMERA SD Card over 80% full!'
	},
	'codes': {
		"13": "pas de connection au port serielle",
		"16": "une ou plusieures options ne sont pas retrouvé",
		"64": "OK - pas d'erreurs",
		"89": "temps de mesure trop long  pour Synchro",
		"90": "entrée inconnu",
		"91": "option pas installée",
		"92": "I/O bloqué",
		"93": "aucune table de marqueur pour le fichier sélectionné",
		"94": "expression trop long sans leimiteurs",
		"97": "erreur dans l'appareil",
		"99": "pas de module DECT trouvé",
		"100": "pas de character lu",
		"101": "nombre pas accepté",
		"102": "expression trop long",
		"104": "données pas valide",
		"105": "numéro hors de portée",
		"106": "pas de mesur démarré",
		"108": "délai sur le paramètre de chaîne à une commande",
		"109": "software v2.x pas installé (Nor118)",
		"110": "erreur au format du texte",
		"111": "software v3.x pas installé (Nor118)",
		"112": "mémoire pleine",
		"116": "tous les operation memoire bloqué pour raison d'erreur au memoir",
		"117": "erreur de paramètre pendant calibration du sonomètre",
		"118": "erreur inconnu",
		"119": "erreur inconnu",
		"121": "dossier pas défini",
		"122": "dossier pas trouvé",
		"123": "operation du memoir OK",
		"124": "carte SD pas présent",
		"125": "carte SD non alimentée",
		"126": "carte SD protégée en écriture"
	}
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	'common': {
		'select': 'Izberi',
		'graph_loading': "Nalaganje...",
		'month_Names': ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
		'graph_shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
		'graph_day_name': ['Nedelja', 'Ponedeljek', 'Torek', 'Sreda', 'Četrtek', 'Petek', 'Sobota'],
		'graph_export': "Izvozi",
		'graph_printButt': "Natisni graf",
		'graph_down_PNG': "Shrani kot PNG",
		'graph_down_JPG': "Shrani kot JPEG",
		'graph_down_PDF': "Shrani kot PDF",
		'graph_down_SVG': "Shrani kot SVG",
		'graph_zoom_reset': "Resetiraj zoom",
		'Valid request.': 'Zahteva sprejeta',
		'Warning': 'Opozorilo'
	},
	'main': {
		'titleStatistics': 'Statistika',
		'titleManual': 'Navodila',
		'titleDownload': 'Prenesi',
		'titleArchives': 'Arhiv',
		'titleStream': 'V Živo',
		'titleRealtime': 'Realna meritev',
		'titlePlay': 'Predvajaj',
		'titleDanger': 'Napaka/Ne meri',
		'titleWarning': 'Predvajaj',
		'titleSettings': 'Nastavitve',
		'titleSD': 'SD prosto:',
		'titleHDD': 'SSD prosto:',
		'titleCamera': 'KAMERA:',
		'titleLogout': 'Odjavi',
		'status': 'Status',
		'error': 'Napaka',
		'running': 'Merjenje',
		'notRunning': 'Ne meri',
		'downloadingFile': 'Prenašanje datoteke',
		'preparingFile': 'Datoteka se pripravlja'
	},
	'login': {
		'Username': 'Up. Ime',
		'Password': 'Geslo',
		'Login': 'Vstopi'
	},
	'dashboard': {
		'measuringTgl': 'MERITEV',
		'noiseTgl': 'HRUP',
		'weatherTgl': 'VREME',
		'adioTgl': 'ADIO'
	},
	'graphs': {
		'export': {
			'Print chart': 'Natisni graf',
			'Download': 'Prenesi',
			'image': 'sliko'
		},
		'nodata': "NI PODATKOV",
		'errNoise': "Problem z Nor140 napravo",
		'errWeath': "Problem z Vremensko postajo",
		'errAdio': "Problem z ADIO napravi",
		'NOISE': 'HRUP',
		'SPECTRUM': 'SPEKTER',
		'WEATHER': 'VREME',
		'ADIO': 'ADIO',
		'STATISTICS': 'STATISTIKA',
		'statTitle': 'Naslov',
		'statFrom': 'Od',
		'statTo': 'Do',
		'load': 'Naloži',
		'markers': 'Markerji',
		'dailyNotes': 'Dnevni zaznamki',
		'preload': 'Ročno nalaganje grafa',
		'sync': 'Sinhroniziraj grafe',
		'reset': 'Resetiraj zoom',
		'exportGraph': 'Izvozi graf',
		'hideShow': 'Skrij / Prikaži',
		'markersCat': {
			'type': 'Tip',
			'color': 'Barva',
			'single': 'Točkovni',
			'toggle': 'Območje',
			'keybind': 'Bližnjica',
			'learn': 'Learn',
			'shift': 'Shift',
			'alt': 'Alt',
			'delete': 'Delete',
			'save': 'Shrani',
			'note': 'Zaznamki'
		},
		'markersTable': {
			'name': 'Ime',
			'startTime': 'Začetni čas',
			'endTime': 'Konči čas',
			'type': 'Tip'
		}
	},
	'calendar': {
		'title': 'Koledar',
		'noise': 'Hrup',
		'audio': 'Avdio',
		'weather': 'Vreme',
		'video': 'Video',
		'adio': 'ADIO'
	},
	'streamPopover': {
		'title': 'V Živo',
		'Audio': 'Avdio',
		'Video': 'Video',
		'StartManRec': 'Ročno snemanje',
		'StopManRec': 'Ustavi snemanje',
		'StartStream': 'Predvajaj',
		'StopStream': 'Ustavi predvajanje'
	},
	'download': {
		'title': 'Prenesi',
		'popOver': {
			'XML': 'XML podatki',
			'XMLWeekly': 'tedenski XML podatki',
			'Raw': 'Surovi podatki',
			'Global': 'Globalne vrednosti',
			'weather': 'TXT vremenski podatki'
		}
	},
	'archives': {
		'popOver': {
			'Global': 'Globalne vrednosti',
			'Noise': 'Hrup',
			'Audio': 'Avdio',
			'Video': 'Video',
			'Weather': 'Vreme',
			'Adio': 'ADIO',
			'Compressed': 'KOMPRIMIRANO'
		},
		'audioPopOver': {
			'downlRec': 'Prenesi posnetek',
			'range': 'Območje'
		},
		'video': 'VIDEO',
		'global': 'GLOBALNE VREDNOSTI',
		'weather': 'VREME',
		'noise': 'HRUP',
		'audio': 'AVDIO',
		'name': 'Arhiv',
		'Delete': 'Izbriši',
		'Download': 'Prenesi',
		'NorReview': 'NorReview',
		'Thumbnail': 'Slika',
		'Filename': 'Datoteke',
		'Duration': 'Dolžina',
		'Size': 'Velikost',
		'Close': 'Zapri',
		'adio': 'ADIO',
		'compressed': 'KOMPRIMIRANI PODATKI'
	},
	'settings': {
		'name': 'NASTAVITVE',
		'save': 'SHRANI',
		'addButt': 'DODAJ',
		'preTrigg': 'Pred-Sprožilec',
		'Trigg': 'Sprožilec',
		'postTrigg': 'Po-Sprožilec',
		'warning': 'Obvestilo',
		'continue': 'Nadaljuj',
		'cancel': 'Prekliči',

		'interface': {
			'settingsName': 'Grafični vmesnik',
			'Realtime display': 'Dolžina relanega prikaza [sek]',
			'Language': 'Jezik',
			'Lt': 'Y-območje za graf hrupa',
			'Spectrum': 'Y-območje spektra',
			'Weather': 'Y-območje vremenskih podatkov',
			'Adio': 'Y-območje ADIO naprave',
			'Manual': 'Ročno območje',
			'Dynamic': 'Dinamično Območje',
			'noiseTriggerLevel': 'Sprožilec ravni hrupa',
			'spectrumTriggerLevel': 'Sprožilec ravni spektra',
			//Options
			'english': 'Angleščina (EN)',
			'austria': 'Nemščina (AT)',
			'german': 'Nemščina (DE)',
			'french': 'Francoščina (FR)',
			'slovensko': 'Slovenščina (SLO)'
		},
		'download': {
			'settingsName': 'Prenosi',
			'Compression': 'Kompresija podatkov',
			'No compression': 'Brez kompresije',
			'Zip compression': 'Zip kompresija podatkov (prihrani pasovno širino)',
			'Noise': 'Hrup',
			'Weather': 'Vremenski podatki',
			'Global Values': 'Globalne vrednosti',
			'Special values': 'Posebne vednosti',
			'Audio': 'Avdio',
			'Video': 'Video',
			'Markers': 'Markerji',
			'Statistics': 'Statistika',
			'statisticsTemplate': 'Oblika',
			'statisticsRename': "Preimenuj Obliko"
		},
		'audioRecording': {
			'settingsName': 'Avdio snemanje',
			'Format': 'Avdio format',
			'Audio Offset': 'Avdio pred-snemanje: [s]',
			'Day': 'Dnevni sprožilec',
			'Night': 'Nočni sprožilec',
			'Optional 1': 'Opcijski sprožilec 1',
			'Optional 2': 'Opcijski sprožilec 2',
			'RecDur': 'Dolžina posnetka (s)',
			'Threshold': 'Raven (dBA)',
			'Start': 'Začetni čas (HH)',
			'Stop': 'Končni čas (HH)',
			'Weather': 'Vremenski sprožilci',
			'Windspeed': 'Hitros vetra',
			'Temperature': 'Temperatura',
			'Air': 'Zračni pritisk',
			'Precipitation': 'Padavine',
			'Humidity': 'Vlažnost',
			//Options
			'Disable': 'Izklopi',
			'Lower': 'Nižja kot',
			'Greater': 'Višja kot',
			'Both': 'Dvojni sprožilec',
			'lowerThan': 'Nižja kot',
			'greaterThan': 'Višja kot'
		},
		'dynamicDns': {
			'settingsName': 'Dinamični DNS',
			'Address': 'Naslov',
			'Provider': 'Ponudnik',
			'Username': 'Up. ime',
			'Password': 'Geslo',
			'IP': 'IP'
		},
		'alertMessaging': {
			'settingsName': 'Pošiljanje obvestil',
			'createGroupButton': 'Ustvari novo skupino',
			'createGroupDialog': 'Ali ste prepričani da želite ustvariti novo skupino?',
			'deleteGroupDialog': 'Ali ste prepričani da želite izbrisati skupino?',
			'deleteEmailDialog': 'Ali ste prepričani da želiet izbrisati E-mail/telefonsko številko?',
			'dialogConfirm': 'Potrdi',
			'dialogContinue': 'Nadaljuj',
			'dialogCancel': 'Prekliči',
			'MSISDN-E-Mail': 'V katero skupino/e želite dodati prejemnika/e?',
			'Add MSISDN': 'Dodaj mobilno številko (MSISDN)',
			'Add E-mail': 'Dodaj E-mail',
			'DeleteButton': 'Izbriši',
			'DeleteGroup': 'Izbriši skupino',
			'DeleteRecip': 'Izbriši prejemnika',
			'DeleteEmail': 'Izbriši E-mail / Telefonsko št.',
			'TestEmail': 'Pošlji testni E-mail',
			'Resend after': 'Ponovno pošlji',
			'Threshold day': 'Dnevni sprožilec',
			'Threshold Night': 'Nočni sprožilec',
			'Threshold Opt 1': 'Opcijski sprožilec 1',
			'Threshold Opt 2': 'Opcijski sprožilec 2',
			'Running Average Level': 'Raven drsečega povprečja',
			'Weather trigger': 'Vremenski sprožilec',
			'System reboot': 'Ponovni zagon',
			'Connection with meter lost': 'Napaka v komunikaciji z Nor140',
			'FTP server error': 'Napaka v FTP povezavi',
			'Critical memory on meter': 'Polna spominska kartica na Nor140',
			'Critical disk space': 'Polni Disk',
			'Microphone check error': 'Napaka pri preverjanju mikrofona',
			'Battery mode': 'Baterijski način',
			'Connection with Weather station lost': 'Napaka v komunikaciji z vremensko postajo',
			'LEQ': 'LEQ Day',
			'Inbound (MSISDN)': 'Dohodna sporočila (MSISDN):',
			'Status': 'Status:',
			'GPS': 'GPS:',
			'Threshold change': 'Raven sprožilca:',
			'Email settings': 'Email nastavitve',
			'Sender Email': 'Email pošiljatelja',
			'Password': 'Geslo',
			'SMTP server': 'SMTP strežnik',
			'SMTP port': 'SMTP vrata',
			'noRepeat': 'Ne ponavljaj',
			'resendAft': 'Ponovno pošlji',
			//Options
			'min': 'min',
			'disabled': 'Izklopi',
			'groupsError': 'Izberi Skupino/e!',
			'emailSent': 'Email/SMS uspešno poslan'
		},
		'FTPSending': {
			'settingsName': 'FTP sinhronizacija',
			'FTP Address': 'FTP Naslov',
			'Refresh Rate': 'Hitrost osveževanja',
			'Username': 'Up. ime',
			'Password': 'Geslo',
			'Port': 'Vrata',
			'Values': 'Vrednosti za pošiljanje',
			//Options
			'Disable': 'Izklopi',
			'sec': 'sek',
			'min': 'min',
			'hour': 'ure',
			'measur': 'Hrup',
			'weath': 'Vreme',
			'audio': 'Avdio',
			'global': 'Globalne vrednosti',
			'video': 'Video'
		},
		'geographicPosition': {
			'settingsName': 'Geografski položaj',
			'Latitude': 'Zemljepisna širina [°]',
			'Longitude': 'Zemljepisna dolžina [°]',
			'Height': 'Višina [m]'
		},
		'weather': {
			'settingsName': 'Vreme',
			'Weather': 'Vremenska postaja',
			'values': 'Vrednosti',
			'SetDevice': 'Nastavi napravo',
			//Options
			'NoWeather': 'Brez vremenske postaje',
			'reinhardt': 'Reinhardt MWS 5MV',
			'reinhardtRain': 'Reinhardt MWS 5MV s senzorjem za dež',
			'thiesClima': 'Thies Clima sensor US',
			'vaisala': 'Vaisala WXT520',
			'kw360': 'ONWA KW-360'
		},
		'delete': {
			'settingsName': 'Izbriši/Komprimiraj',
			'autoDelete': 'Samodejno brisanje podatkov starejših od',
			'autoCompress': 'Samodejno komprimiranje podatkov starejših od',
			'Disable': 'Izključi',
			'Manual delete': 'Ročno brisanje',
			'Values': 'Vrednosti',
			'Delete': 'Izbriši',
			//Options
			'day': 'dan',
			'week': 'teden',
			'month': 'mesec',
			'measur': 'Hrup',
			'weath': 'Vreme',
			'audio': 'Avdio',
			'global': 'Globalne vrednosti',
			'logs': 'Dnevnik logov',
			'statistics': 'Statistika',
			'video': 'Video',
			'adio': 'ADIO'
		},
		'device': {
			'settingsName': 'Nor 140',
			'Selection': 'Tip mikrofona',
			'Polarisation': 'Polarizacija mikrofona',
			'Frequency': 'Frekvenčni filter',
			'Resolution': 'Ločljivost',
			'Duration': 'Trajanje',
			'Meter': 'Meter scale',
			'Values': 'Vrednosti',
			'Special': 'Posebni parametri',
			'Advance': 'Napredno',
			'Mic check': 'Vrednost auto-kalibracije [dB]:',
			'Mic check time': 'Auto-kalibracija ob [HH]:',
			'SDFreeSpace': 'Opozorilo: SD prosto [%]',
			'Restart': 'Resetiraj Nor140',
			'Set instrument': 'Nastavi napravo',
			'Format': 'Formatiraj SD',
			'CheckSD': 'Zasedenost SD',
			'formatSDdialog': 'Formatiranje SD kartice lahko traja več kot 5min, ste prepričani da želite nadaljevati?',
			'decrease': 'Znižaj',
			'increase': 'Zvišaj',
			'value': 'Način povprečenja',
			'threshold': 'Raven (dBA)',
			'timeControlled': 'Časovno povprečje',
			'measurementControlled': 'Povprečje meritve',
			'start_stop': 'Začetni / Končni čas',
			'startTime': 'Začetni čas',
			'endTime': 'Končni čas',
			'trigger': 'Sprožilec',
			'duration': 'Trajanje [s]',
			'test': 'Testiraj',
			'testOpt': 'Testiraj opcije Nor140',
			'restartNoise': 'Resetiraj Nor140',
			'increasedVol': 'Povečana glasnost',
			'decreasedVol': 'Zamanjšana glasnost',
			'autostart': 'Auto Start-Stop',
			//Options
			'On': 'Vklopljena',
			'Off': 'Izklopljena',
			'Standard': 'Standardni',
			'Disable': 'Izklopi',
			'iepe': 'IEPE',
			'line': 'Linijski',
			'horizontal': '1214/16/17 Horizontalni',
			'vertical': '1214/16/17 Vertikalni',
			'11octave': '1/1 Oktava',
			'13octave': '1/3 Oktava',
			'11wOctave': '1/1w Oktava',
			'13wOctave': '1/3w Oktava',
			'movingAverage': 'Drseče povprečje',
			'movingValue': 'Drseča vrednost',
			'midnight': "Polnoči - 00h",
			'noon': "Poldan - 12h",
			'freeSpace': 'SD Prosto: ',
			'instrumentSent': 'Naprava nastavljena',
			'start': 'Start',
			'stop': 'Stop',
			'days': 'Dan',
			'types': 'Tip meritve',
			'startstopActive': 'Aktiviraj',
			'warningMeasRunning': 'Instrument ne bo nastavljen, ker je meritev aktivna!'
		},
		'video': {
			'settingsName': 'Video',
			'Present': 'Naprava',
			'Manual': 'Ročno snemanje',
			'Triggering': 'Video snemanje s sprožilci hrupa',
			'Moving detection': 'Detekcija gibanja',
			'Settings': 'Nastavitve',
			'Pre': 'Pred-snemanje',
			'Post': 'Po-snemanje',
			'No device': 'Brez naprave',
			'Video camera': 'Video kamera',
			'SetDevice': 'Pošlji nastavitve',
			'formatSDWarning': 'Prosimo počakajte dokler ne vidite SD Prosto: 100%'
		},
		'adio': {
			'settingsName': 'ADIO',
			'Present': 'Naprava',
			'ADIO': 'ADIO Naprava',
			'NoDevice': 'Brez naprave',
			'DigitalOut': 'Digitalni izhod',
			'DigitalIn': 'Digitalni vhod',
			'AnalogIn': 'Analogni vhod',
			'AnalogOut': 'Analog izhod',
			'AnalogLowerLimit': 'Spodnja meja analognega kanala 0V / 4mA',
			'AnalogUpperLimit': 'Zgornja meja analognega kanala 10V / 20mA',
			'Pleaseinput': '"Prosim vnesite"',
			//Options
			'On': 'On',
			'Off': 'Off'
		},
		'norcloud': {
			'settingsName': 'NorCloud',
			'IdNor': 'Nor140 ID',
			'syncTime': 'Interval pošiljanja',
			'syncData': 'Pošlji podatke o hrupu',
			'syncRec': 'Pošlji Audio posnetke',
			'sendAlerts': 'Pošlji obvestila',
			'recSett': 'Sprejmi nastavitve iz serverja',
			'applySett': 'Posodobi sprejete nastavitve ',
			//Options
			'On': 'Vklopljen',
			'Off': 'Izklopljen',
			'disable': 'Ne pošiljaj',
			'min': 'minut',
			'hour': 'ur',
			'now': 'Takoj, ob sprejetju',
			'fhour': 'Ob polni uri',
			'break': 'Ko se izvede Automic check'
		},
		'statistics': {
			'settingsName': 'Statistika',
			'reportSending': {
				'settingsName': 'Avtomatsko pošiljanje Poročil',
				'Name': 'Ime',
				'Title': 'Naslov',
				'Duration': 'Dogodek',
				'Days': 'Pošlji ob dnevih',
				'Hours': 'Pošlji ob uri',
				'Range': 'Dnevi nazaj',
				'Email': 'E-mail',
				'Language': 'Jezik'
			},
			'options': {
				'Range': 'Od-Do',
				'Daily': 'Dnevno',
				'On Event': 'Ob dogodku'
			}
		},
		'status': {
			'settingsName': 'Sistem',
			'Reboot': 'Ponovni zagon sistema',
			'Reboot confirm': 'Ali ste prepričani da želite ponovno zagnati sistem?',
			'Reboot success': 'Manj kot 1min do ponovnega zagona!',
			'Reboot cancel': 'Ponovni zagon preklican',
			'Restart confirm': 'Ali ste prepričani da želite ponovno zagnati N140?',
			'Restart Warning': 'N140 bo ponovno dosegljiv v 1min!',
			'Restart success': 'N140 je ponovno dosegljiv!',
			'Restart cancel': 'Operacija preklicana',
			'Version': 'Verzija',
			'Release': 'Datum izdaje',
			'PCFree': 'Opozorilo: disk PC-ja [%]',
			'SDD': 'SSD',
			'memory': 'Pomnilnik',
			'camera': 'Kamera SD',
			'n140': 'Nor140 SD',
			'cpu': 'Obremenjenost CPE',
			'firmware': 'Firmware',
			'logs': 'Dnevnik dogodkov',
			'download': 'Prenesi',
			'total': 'SKUPAJ',
			'free': 'PROSTO',
			'used': 'ZASEDENO',
			'gbOrMore': '2GB ali več',
			'of': 'od',
			'users': 'Uporabniki',
			'username': 'Up. Ime',
			'password': 'Geslo',
			'adminUsr': 'Admin',
			'noiseUsr': 'Uporabnik',
			'guestUsr': 'Gost'
		}
	},
	'errors': {
		'n140': 'Nor140',
		'weather': 'VREMENSKA POSTAJA',
		'adio': 'ADIO',
		'cameraSD': 'CAMERA SD Kartica je zasedena več kot 80%!'
	},
	'codes': {
		"13": "Ni serijske povezave",
		"16": "Nanjkajoče programske opcije",
		"64": "OK-brez napak",
		"89": "Čas meritve predolg za Synchro opcijo",
		"90": "Nepoznani ukaz",
		"91": "Opcija ni prisotna",
		"92": "I/O zaklenjen",
		"93": "No marker table for selected file",
		"94": "Predolg ukaz brez ločilnih znakov",
		"97": "Nepoznana naprava",
		"99": "Manjkajoči DECT modul",
		"100": "Ni digitalnega signala",
		"101": "Nepravilna številka ukaza",
		"102": "Predolg Text",
		"104": "Neveljavni podatki",
		"105": "Številka izven dovoljenega območja",
		"106": "Meritev ne deluje",
		"108": "Čas je potekel za izvedbo ukaza",
		"109": "Software v2.x option no present (118)",
		"110": "Napaka v tekstovnem formatu",
		"111": "Software v3.x option not present (118)",
		"112": "Poln Pomnilnik",
		"116": "Vse operacije onemogočene zaradi napak v pomnilniku",
		"117": "Napak pri kalibraciji merilnika",
		"118": "Nepoznana napaka",
		"119": "Nepoznana napaka",
		"121": "Direktorij ni nastavljen",
		"122": "Manjkajoči direktorij",
		"123": "Oprecije pomnilnika OK",
		"124": "Manjkajoča SD Kartica",
		"125": "SD Kartica nima napajanja",
		"126": "SD Kartica zaklenjena za pisanje"
	}
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_media_query__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_de__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_fr__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_sl__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_sl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_sl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_localstorage__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_highcharts__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_highcharts_highcharts__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_highcharts_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_highcharts_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_highcharts_modules_exporting__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_highcharts_modules_exporting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_highcharts_modules_exporting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_default_index_css__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__localization__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__users__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_awesome_icons_download__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_awesome_icons_volume_up__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_awesome_icons_cloud__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_awesome_icons_refresh__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_awesome_icons_line_chart__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_awesome_icons_question__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_awesome_icons_plus__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_awesome_icons_close__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_awesome_icons_sign_out__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_awesome_icons_eye__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_awesome_icons_chevron_down__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_awesome_icons_chevron_up__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_awesome_icons_file_word_o__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_awesome_icons_hourglass_half__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_awesome_icons_thumb_tack__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_awesome_icons_sticky_note__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_awesome_components_Icon__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vue_awesome_components_Icon__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_33_vue_awesome_components_Icon___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_localstorage___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_v_media_query___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__localization__["a" /* default */], { locale: __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default.a, EN: __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default.a, AT: __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_de___default.a, DE: __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_de___default.a, FR: __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_fr___default.a, SL: __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_sl___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16__users__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(173));

setGraphLanguage(__WEBPACK_IMPORTED_MODULE_12_highcharts_highcharts___default.a, __WEBPACK_IMPORTED_MODULE_15__localization__["a" /* default */].getTranslations());

__WEBPACK_IMPORTED_MODULE_13_highcharts_modules_exporting___default()(__WEBPACK_IMPORTED_MODULE_12_highcharts_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_highcharts__["a" /* default */], { Highcharts: __WEBPACK_IMPORTED_MODULE_12_highcharts_highcharts___default.a });

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

function setGraphLanguage(hcharts, languages) {
  try {
    var language = 'en';
    if (window.localStorage.settings) {
      var settings = JSON.parse(window.localStorage.settings);
      if (settings && settings.interface && settings.interface.language) {
        language = settings.interface.language;
      }
      //language = JSON.parse(window.localStorage.settings);
    }
    var languagePack = languages[language];

    hcharts.setOptions({
      lang: {
        loading: languagePack.common.graph_loading,
        months: languagePack.common.month_Names,
        shortMonths: languagePack.common.graph_shortMonths,
        weekdays: languagePack.common.graph_day_name,
        exportButtonTitle: languagePack.common.graph_export,
        printButtonTitle: languagePack.common.graph_printButt,
        downloadPNG: languagePack.common.graph_down_PNG,
        downloadJPEG: languagePack.common.graph_down_JPG,
        downloadPDF: languagePack.common.graph_down_PDF,
        downloadSVG: languagePack.common.graph_down_SVG,
        resetZoom: languagePack.common.graph_zoom_reset,
        resetZoomTitle: languagePack.common.graph_zoom_reset
      }
    });
  } catch (err) {
    console.error(err);
  }
}

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMounted", function() { return getMounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getScreenSize", function() { return getScreenSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActiveDays", function() { return getActiveDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedDayHours", function() { return getSelectedDayHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedHour", function() { return getSelectedHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedDay", function() { return getSelectedDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSidebarVisible", function() { return getSidebarVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStatus", function() { return getStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedInterval", function() { return getSelectedInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRealtimeEnabled", function() { return getRealtimeEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocalSettings", function() { return getLocalSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLanguage", function() { return getLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnsavedLocalSettings", function() { return getUnsavedLocalSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettings", function() { return getSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsAlertMessaging", function() { return getSettingsAlertMessaging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsAudioRecording", function() { return getSettingsAudioRecording; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsDelete", function() { return getSettingsDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsDevice", function() { return getSettingsDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsDownload", function() { return getSettingsDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsDynamicDNS", function() { return getSettingsDynamicDNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsFTPSending", function() { return getSettingsFTPSending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsGeographicalPosition", function() { return getSettingsGeographicalPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSystemStatus", function() { return getSystemStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFirmware", function() { return getFirmware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsInterface", function() { return getSettingsInterface; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsAddons", function() { return getSettingsAddons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsWeather", function() { return getSettingsWeather; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsSystem", function() { return getSettingsSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsUsers", function() { return getSettingsUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsSpecval", function() { return getSettingsSpecval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsVideo", function() { return getSettingsVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsAdio", function() { return getSettingsAdio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsNorCloud", function() { return getSettingsNorCloud; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsEmail", function() { return getSettingsEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsStatistics", function() { return getSettingsStatistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSettingsStartstop", function() { return getSettingsStartstop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDownloading", function() { return getDownloading; });
var getMounted = function getMounted(state) {
    return state.mounted;
};

var getScreenSize = function getScreenSize(state) {
    return state.screenSize;
};

var getUser = function getUser(state) {
    return state.user;
};

var getActiveDays = function getActiveDays(state) {
    return state.activeDays;
};

var getSelectedDayHours = function getSelectedDayHours(state) {
    return state.selectedDayHours;
};

var getSelectedHour = function getSelectedHour(state) {
    return state.selectedHour;
};
var getSelectedDay = function getSelectedDay(state) {
    return state.selectedDay;
};
var getSidebarVisible = function getSidebarVisible(state) {
    return state.sidebarVisible;
};

var getStatus = function getStatus(state) {
    return state.status;
};

var getSelectedInterval = function getSelectedInterval(state) {
    return state.selectedInterval;
};

var getRealtimeEnabled = function getRealtimeEnabled(state) {
    return state.realtimeEnabled;
};

var getLocalSettings = function getLocalSettings(state) {
    return state.localSettings;
};
var getLanguage = function getLanguage(state) {
    if (state.localSettings.interface) return state.localSettings.interface.language;
    return "en";
};
var getUnsavedLocalSettings = function getUnsavedLocalSettings(state) {
    return state.unsavedLocalSettings;
};

/*SETTINGS */
var getSettings = function getSettings(state) {
    return state.settings;
};

//Alert messaging
var getSettingsAlertMessaging = function getSettingsAlertMessaging(state) {
    if (state.settings.alerts) return state.settings.alerts;
    return {};
};
//Audio
var getSettingsAudioRecording = function getSettingsAudioRecording(state) {
    if (state.settings.audio) return state.settings.audio;
    return {};
};
//Delete
var getSettingsDelete = function getSettingsDelete(state) {
    if (state.settings.delete)
        //return state.settings.delete; //ne najdem
        return {};
};
//Device
var getSettingsDevice = function getSettingsDevice(state) {
    if (state.settings.device) return state.settings.device;
    return {};
};
//Download
var getSettingsDownload = function getSettingsDownload(state) {
    if (state.settings.download) return state.settings.download;
    return {
        downloadValues: {},
        downloadwValues: {},
        globalValues: {}
    };
};
//DNS
var getSettingsDynamicDNS = function getSettingsDynamicDNS(state) {
    if (state.settings.dyndns) return state.settings.dyndns;
    return {};
};
//FTP
var getSettingsFTPSending = function getSettingsFTPSending(state) {
    if (state.settings.ftp) return state.settings.ftp;
    return {
        valuesValues: {}
    };
};
//GPS
var getSettingsGeographicalPosition = function getSettingsGeographicalPosition(state) {
    if (state.settings.gps) return state.settings.gps;
    return {};
};
//Interface
var getSystemStatus = function getSystemStatus(state) {
    return state.systemStatus;
};
var getFirmware = function getFirmware(state) {
    return state.firmware;
}; //ADDED

var getSettingsInterface = function getSettingsInterface(state) {
    if (state.unsavedLocalSettings.interface) return state.unsavedLocalSettings.interface;
    return {};
};
//Addons
var getSettingsAddons = function getSettingsAddons(state) {
    if (state.settings.addons) return state.settings.addons;
    return {};
};
//Weather
var getSettingsWeather = function getSettingsWeather(state) {
    if (state.settings.weather) return state.settings.weather;
    return {
        valselValues: {}
    };
};
//System
var getSettingsSystem = function getSettingsSystem(state) {
    if (state.settings.system) return state.settings.system;
    return {};
};

var getSettingsUsers = function getSettingsUsers(state) {
    if (state.settings.users) return state.settings.users;
    return {};
};

//Specvall
var getSettingsSpecval = function getSettingsSpecval(state) {
    if (state.settings.specval) return state.settings.specval;
    return {};
};

var getSettingsVideo = function getSettingsVideo(state) {
    return state.settings.video;
};

var getSettingsAdio = function getSettingsAdio(state) {
    return state.settings.adio;
};

var getSettingsNorCloud = function getSettingsNorCloud(state) {
    return state.settings.norcloud;
};

var getSettingsEmail = function getSettingsEmail(state) {
    return state.settings.email;
};

var getSettingsStatistics = function getSettingsStatistics(state) {
    return state.settings.statistics;
};

var getSettingsStartstop = function getSettingsStartstop(state) {
    return state.settings.startstop;
};
var getDownloading = function getDownloading(state) {
    return state.isDownloading;
};

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeMounted", function() { return storeMounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeScreenSize", function() { return storeScreenSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeUser", function() { return storeUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeDays", function() { return storeDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeSelectedDayHours", function() { return storeSelectedDayHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeSelectedHour", function() { return storeSelectedHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeSelectedDay", function() { return storeSelectedDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeSidebarVisible", function() { return storeSidebarVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeStatus", function() { return storeStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeWeatherStatus", function() { return storeWeatherStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeNoiseStatus", function() { return storeNoiseStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeAdioStatus", function() { return storeAdioStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeSystemStatus", function() { return storeSystemStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeFirmware", function() { return storeFirmware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeSelectedInterval", function() { return storeSelectedInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeRealtimeEnabled", function() { return storeRealtimeEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeDownloading", function() { return storeDownloading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeDownloadingProgress", function() { return storeDownloadingProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeLocalSettings", function() { return storeLocalSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUnsavedLocalSettings", function() { return createUnsavedLocalSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeSettings", function() { return storeSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "status", function() { return status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateStatisticsSettings", function() { return updateStatisticsSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateStartstopSettings", function() { return updateStartstopSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var storeMounted = function storeMounted(state) {
    state.mounted = true;
};

var storeScreenSize = function storeScreenSize(state, size) {
    state.screenSize = size;
};

var storeUser = function storeUser(state, user) {
    state.user = user;
};

var storeDays = function storeDays(state, activeDays) {
    state.activeDays = activeDays;
};

var storeSelectedDayHours = function storeSelectedDayHours(state, hours) {
    //state.selectedHour = '';//(hours[0]) ? hours[0].split('-')[3]: '00';
    state.selectedDayHours = hours;
};

var storeSelectedHour = function storeSelectedHour(state, data) {
    if (state.selectedHour == data.hour) {
        state.selectedHour = state.selectedHour + ' ';
    } else state.selectedHour = data.hour;

    //if(!data.loading && state.mounted)
    //    state.realtimeEnabled = false;
};
var storeSelectedDay = function storeSelectedDay(state, data) {
    state.selectedHour = '';
    state.selectedDay = data.day;
    //if(!data.loading && state.mounted)
    //   state.realtimeEnabled = false;
};
var storeSidebarVisible = function storeSidebarVisible(state, visible) {
    state.sidebarVisible = visible;
};

var storeStatus = function storeStatus(state, status) {
    state.status.noiseError = status['noise-status'] == 'error';
    state.status.noise = status['noise-status'] == 'active' || state.status.noiseError;

    state.status.weatherError = status['weather-status'] == 'error';

    state.status.noiseErrorMessage = status['noise-err'];
    state.status.noiseCode = status['noise-err_c'];
    state.status.weatherErrorMessage = status['weather-err'];
    state.status.weatherCode = status['weather-err_c'];

    state.status.adioError = status['adio-status'] == 'error';
    state.status.adioError = status['adio-status'] == 'error';

    state.status.adio = status['adio-status'] == 'active' || state.status.adioError;
    state.status.adioErrorMessage = status['adio-err'];
    state.status.adioCode = status['adio-err_c'];

    //DEVELOPTMEN
    //state.status.weatherError = (Math.random()>0.5);

    state.status.weather = status['weather-status'] == 'active' || state.status.weatherError;

    state.status = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.status));
};
var storeWeatherStatus = function storeWeatherStatus(state, status) {
    state.status.weather = status;
};
var storeNoiseStatus = function storeNoiseStatus(state, status) {
    state.status.noise = status;
};
var storeAdioStatus = function storeAdioStatus(state, status) {
    state.status.adio = status;
};

var storeSystemStatus = function storeSystemStatus(state, status) {
    //status.cam_sd_percent = 90;
    state.systemStatus = status;
};

var storeFirmware = function storeFirmware(state, status) {
    //ADDED
    state.firmware = status;
};

var storeSelectedInterval = function storeSelectedInterval(state, selectedInterval) {
    state.selectedInterval = selectedInterval;
};

var storeRealtimeEnabled = function storeRealtimeEnabled(state, enabled) {
    state.realtimeEnabled = enabled;
};

var storeDownloading = function storeDownloading(state, isDownloading) {
    state.isDownloading = isDownloading;
};
var storeDownloadingProgress = function storeDownloadingProgress(state, progress) {
    state.isDownloading.progress = progress;
    state.isDownloading.preparing = false;
};

/*SETTINGS */
var storeLocalSettings = function storeLocalSettings(state, data) {
    var localStorage = data.localStorage;
    var settings = data.settings;

    if (settings && !settings.markers) {
        settings.markers = [];
    }

    localStorage.set('settings', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(settings));
    localStorage.set('settingsV', state.firmware.epoch);

    state.localSettings = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(settings));
    state.unsavedLocalSettings = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(settings));
};
var createUnsavedLocalSettings = function createUnsavedLocalSettings(state) {
    state.unsavedLocalSettings = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.localSettings));
};

var storeSettings = function storeSettings(state, settings) {
    if (settings && settings.ftp) {
        mutateSettingsFTPSending(settings.ftp);
    }
    if (settings && settings.device && settings.device.valsel) {
        mutateSettingsDevice(settings.device, state);
    }
    if (settings && settings.weather) {
        mutateSettingsWeather(settings.weather, state);
    }
    if (settings && !settings.startstop) {
        settings.startstop = {};
    }
    mutateSettingsAudio(settings.audio, settings.weather);
    mutateSettingsSystem(settings.system);
    mutateSettingsSpecval(settings.specval, state);
    mutateSettingsAlerts(settings.alerts, state);

    if (!settings.statistics) {
        settings.statistics = {};
    }
    mutateSettingsStatistics(settings.statistics, state);
    mutateSettingsStartstop(settings.startstop, state);

    //settings.addons.weather = 0;
    //settings.addons.video = 0;
    //settings.addons.markers = '1';

    if (!settings.adio) settings.adio = {
        digitalOut1: undefined,
        digitalOut2: undefined,
        digitalIn1: undefined,
        digitalIn2: undefined,
        analogOut: undefined,
        analogIn: undefined,
        analogLower: 30,
        analogUpper: 150
    };

    state.settings = settings;
};

var status = function status(state, systemStatus) {
    state.systemStatus = systemStatus;
};

var updateStatisticsSettings = function updateStatisticsSettings(state, statisticsSettings) {
    state.settings.statistics = statisticsSettings;
};

var updateStartstopSettings = function updateStartstopSettings(state, startstopSettings) {
    state.settings.startstop = startstopSettings;
};

function mutateSettingsStartstop(settings, state) {
    //settings.groups = 'gr1,gr2';
    if (settings.groups != '') {
        settings.groups = settings.groups.split(',');
        settings.groups.forEach(function (g) {
            if (settings['days' + g] == "") {
                settings['days' + g] = [];
            } else {
                settings['days' + g] = settings['days' + g].split(',');
            }
            //settings['start'+g] = '12:00';
            //settings['stop'+g] = '22:00';
            if (settings['types' + g] == "") {
                settings['types' + g] = [];
            } else {
                settings['types' + g] = settings['types' + g].split(',');
            }

            settings['enable' + g] = settings['enable' + g] == '1' ? true : false;
        });
    } else {
        settings.groups = [];
    }
}

function mutateSettingsStatistics(settings, state) {
    if (!settings) settings = {};
    if (!settings.groups) settings.groups = '';

    settings.allgroups = settings.groups.split(',');

    //FIX 
    //settings.allgroups = "";
    //settings.vallAll = ''

    if (settings.allgroups != "") {
        settings.allgroups.forEach(function (g) {

            var id = g.replace('st', '');

            var dayss = settings['dayss' + id].split(',');
            if (dayss == undefined || dayss.length == 1 && dayss[0] == '') dayss = [];
            settings['dayss' + id] = dayss;

            var ranges = settings['ranges' + id].split(',');
            if (ranges == undefined) ranges = [];
            settings['ranges' + id] = ranges;
        });
    } else {
        settings.allgroups = [];
    }
}

//DEMUTATE TREBA NAPISAT ZA MUTATE KJER JE ADDED DOPISAN
function mutateSettingsWeather(settings, state) {
    settings.windsptrig = settings.windsptrig.split(',').map(function (num) {
        return parseFloat(num);
    }); // ADDED
    settings.temptrig = settings.temptrig.split(',').map(function (num) {
        return parseFloat(num);
    }); // ADDED
    settings.humidtrig = settings.humidtrig.split(',').map(function (num) {
        return parseFloat(num);
    }); // ADDED
    settings.airprtrig = settings.airprtrig.split(',').map(function (num) {
        return parseFloat(num);
    }); // ADDED
    settings.precipittrig = settings.precipittrig.split(',').map(function (num) {
        return parseFloat(num);
    }); // ADDED

    settings.windsptrigtype = getThresholdType(settings.windsptrig); // ADDED
    settings.temptrigtype = getThresholdType(settings.temptrig); // ADDED
    settings.humidtrigtype = getThresholdType(settings.humidtrig); // ADDED
    settings.airprtrigtype = getThresholdType(settings.airprtrig); // ADDED
    settings.precipittrigtype = getThresholdType(settings.precipittrig); // ADDED


    settings.valall = settings.valall.split(',');
    var valsel = [];
    var valselSplit = settings.valsel.split(',');

    var downlweath = state.localSettings.download.downlweath;
    state.localSettings.interface.colorsWeather = {};
    var count = 0;
    settings.valall.forEach(function (item) {
        if (valselSplit.indexOf(item) > -1) {
            valsel.push({ name: item, enabled: true });
        } else {
            valsel.push({ name: item, enabled: false });
        }

        if (!downlweath[item]) {
            downlweath[item] = '';
        }

        if (state.localSettings.interface.colorsweath[count]) {
            state.localSettings.interface.colorsWeather[item] = state.localSettings.interface.colorsweath[count];
        }
        count++;
    });
    settings.oldValsel = settings.valsel;
    settings.valsel = valsel;
    state.localSettings.download.downlweath = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(downlweath));
}

function mutateSettingsFTPSending(FTPSending) {
    try {
        FTPSending.valall = FTPSending.valall.split(',');
        var valsel = [];
        var valselSplit = FTPSending.valsel.split(',');
        FTPSending.valall.forEach(function (item) {
            if (valselSplit.indexOf(item) > -1) {
                valsel.push({ name: item, enabled: true });
            } else {
                valsel.push({ name: item, enabled: false });
            }
        });
        FTPSending.oldValsel = FTPSending.valsel;
        FTPSending.valsel = valsel;
    } catch (err) {}
}

function mutateSettingsDevice(device, state) {
    device.valall = device.valall.split(',');
    device.valsel = device.valsel.split(',');

    var valuesAll = [];
    for (var i = 0; i < device.valall.length; i++) {
        var value = device.valall[i];
        switch (value[2]) {
            case 'F':
                valuesAll.push([device.valall[i], device.valall[i + 1], device.valall[i + 2]]);
                i += 2;
                break;
            case 'E':
                valuesAll.push([device.valall[i], device.valall[i + 1]]);
                i += 1;
                break;
            case 'P':
                valuesAll.push([device.valall[i]]);
                break;
        }
    }
    device.valuesAll = valuesAll;
    if (state.localSettings.download) {
        var downlnoise = state.localSettings.download.downlnoise;

        device.valall.forEach(function (item) {
            if (!downlnoise[item]) {
                downlnoise[item] = '';
            }
        });
        state.localSettings.download.downlnoise = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(downlnoise));
    }

    if (state.localSettings.interface) {
        state.localSettings.interface.noiseValues = valuesAll;
    }
    /*[['LAFSPL', 'LASSPL', 'LAISPL'],
    ['LAEQ', 'LAIEQ'],
    ['LAFMAX', 'LASMAX', 'LAIMAX'],
    ['LAFMIN', 'LASMIN', 'LAIMIN'],
    ['LCFSPL', 'LCSSPL', 'LCISPL'],
    ['LCEQ', 'LCIEQ'],
    ['LCFMAX', 'LCSMAX', 'LCIMAX'],
    ['LCFMIN', 'LCSMIN', 'LCIMIN'],
    ['LAE', 'LAIE'],
    ['LfFSPL', 'LfSSPL', 'LfISPL'],
    ['LfEQ', 'LfIEQ'],
    ['LfFMAX', 'LfSMAX', 'LfIMAX'],
    ['LfFMIN', 'LfSMIN', 'LfIMIN'],
    ['LAPeak'],
    ['LCPeak'],
    ['LCE', 'LCIE'],
    ['LFE', 'LFIE']]*/
}

function mutateSettingsAudio(audio, weather) {
    //DEMUTATE TREBA NAPISAT ZA MUTATE KJER JE ADDED DOPISAN
    audio.threshold1 = audio.threshold1.split(',').map(function (num) {
        return parseFloat(num);
    }); // ADDED
    audio.threshold2 = audio.threshold2.split(',').map(function (num) {
        return parseFloat(num);
    }); // ADDED
    audio.threshold3 = audio.threshold3.split(',').map(function (num) {
        return parseFloat(num);
    }); // ADDED
    audio.threshold4 = audio.threshold4.split(',').map(function (num) {
        return parseFloat(num);
    }); // ADDED

    audio.threshold1type = getThresholdType(audio.threshold1); // ADDED
    audio.threshold2type = getThresholdType(audio.threshold2); // ADDED
    audio.threshold3type = getThresholdType(audio.threshold3); // ADDED
    audio.threshold4type = getThresholdType(audio.threshold4); // ADDED

    audio.duration1Picker = new Date(2017, 1, 1, 0, 0, audio.duration1);
    audio.duration2Picker = new Date(2017, 1, 1, 0, 0, audio.duration2);
    audio.duration3Picker = new Date(2017, 1, 1, 0, 0, audio.duration3);
    audio.duration4Picker = new Date(2017, 1, 1, 0, 0, audio.duration4);
    weather.rectimePicker = new Date(2017, 1, 1, 0, 0, weather.rectime);
}

//Used twice for getting weather types and audio type, in weather disabled means -100 in audio it means -20
function getThresholdType(numbers) {
    var counter = 0;
    /*
        for(var i = 0; i < numbers.length; i++){
            if(counter == 0 && numbers[i] == -10){
                return 0;
            }
            else if(numbers[i] == -20 || numbers[i] ==  -100){
                switch(counter){
                    case 0: return 2;
                    case 1: return 1;
                }
            }
            else{
                counter++;
            }
        }
        return 3;
    */
    if (numbers.length > 1) {
        if (numbers[0] == -20 || numbers[0] == -100) {
            if (numbers[1] == -100 || numbers[1] == 140) {
                return 0;
            } else {
                return 2;
            }
        } else if (numbers[1] == -100 || numbers[1] == 140) {
            return 1;
        } else {
            return 3;
        }
    }
    return 0;
}

function mutateSettingsSystem(settings) {
    try {
        settings.delvalall = settings.delvalall.split(',');
        var delvalsel = [];
        var delvalselSplit = settings.delvalsel.split(',');
        settings.delvalall.forEach(function (item) {
            delvalsel.push({ name: item, enabled: delvalselSplit.indexOf(item) > -1 });
        });
        settings.delvalselOld = settings.delvalsel;
        settings.delvalsel = delvalsel;
    } catch (err) {}
}

function mutateSettingsSpecval(specval, state) {
    //DEMUTATE TREBA NAPISAT ZA MUTATE KJER JE ADDED DOPISAN
    specval.mavallevel = specval.mavallevel.split(','); // ADDED
    specval.mavalltype = getThresholdType(specval.mavallevel);

    specval.valallsp = specval.valallsp.split(',');
    if (specval.valallsp.indexOf('MV') == -1) specval.valallsp.push('MV');

    var valselsp = [];
    var valselspSplit = specval.valselsp.split(',');
    specval.valallsp.forEach(function (item) {
        valselsp.push({ name: item, enabled: valselspSplit.indexOf(item) > -1 });
    });
    specval.oldvalselsp = specval.valselsp;
    specval.valselsp = valselsp;
    specval.global = specval.global.split(',');

    var downlGlobal = state.localSettings.download.downlGlobal;

    specval.global.forEach(function (item) {
        if (typeof downlGlobal[item] == 'undefined') downlGlobal[item] = true;
    });
    state.unsavedLocalSettings.download.downlGlobal = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(downlGlobal));

    specval.mavaldurationPicker = new Date(2017, 1, 1, 0, 0, specval.mavalduration);
}

function mutateSettingsAlerts(alerts, state) {
    var allAlerts = ["threshday", "threshnight", "threshopt1", "threshopt2", "threshweath", "mav", "reboot", "n140", "ftperr", "n140sd", "discerr", "micerr", "battmode", "weather", "weatTrig", "videotrig", "videoerr", "leqday"];

    if (alerts.groups == "") {
        alerts.groups = [];
    } else {
        alerts.groups = alerts.groups.split(',');
    }

    alerts.groups.forEach(function (group) {
        var id = group.replace('gr', '');

        //region alerts
        if (!alerts['alg' + id]) alerts['alg' + id] = '';

        alerts['alg' + id] = alerts['alg' + id].split(',');

        var gAlerts = {};
        allAlerts.forEach(function (alert) {
            if (alerts['alg' + id].indexOf(alert) > -1) {
                gAlerts[alert] = true;
            } else {
                gAlerts[alert] = false;
            }
        });
        alerts['alg' + id] = gAlerts;
        //endregion

        alerts['leqdg' + id] = alerts['leqdg' + id].split(',');
        alerts['recpg' + id] = alerts['recpg' + id].split(',').filter(function (a) {
            return a != "";
        });

        alerts['del' + id] = [];

        //day,night, opt1,opt2, running, LEQDay
        if (!alerts['repg' + id]) alerts['repg' + id] = '0,0,0,0,0,0,0';
        alerts['repg' + id] = alerts['repg' + id].split(',');

        if (!alerts['lqtg' + id]) alerts['lqtg' + id] = 'true,true,true';
        alerts['lqtg' + id] = alerts['lqtg' + id].split(',').map(function (a) {
            return a == 'true';
        });
    });
}

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	'graphsexport': true,
	'download': true,
	'archives': true,
	'streamPopover': {
		'enabled': true,
		'audio': true,
		'video': true
	},
	'realtime': true,
	'measurement': {
		'enabled': true,
		'measurement': true
	},
	'settings': {
		'enabled': true,
		'interface': true,
		'download': true,
		'audioRecording': true,
		'dynamicDns': {
			'enabled': true,
			'address': true,
			'provider': true,
			'username': true,
			'password': true,
			'ip': true
		},
		'alertMessaging': {
			'enabled': true,
			'emailsett': true,
			'sender': true,
			'password': true,
			'smtp': true
		},
		'FTPSending': {
			'enabled': true,
			'address': true,
			'refresh': true,
			'username': true,
			'password': true,
			'port': true,
			'values': true,
			'zipped': true
		},
		'geographicPosition': true,
		'weather': true,
		'delete': true,
		'device': true,
		'video': true,
		'adio': true,
		'norcloud': true,
		'status': {
			'enabled': true,
			'gauges': true,
			'logs': true,
			'users': true,
			'userAdmin': true,
			'userOper': true,
			'userGuest': true
		}
	}
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	'graphsexport': false,
	'download': false,
	'archives': false,
	'streamPopover': {
		'enabled': true,
		'audio': true,
		'video': true
	},
	'realtime': true,
	'measurement': {
		'enabled': true,
		'measurement': false
	},
	'settings': {
		'enabled': false,
		'interface': false,
		'download': false,
		'audioRecording': false,
		'dynamicDns': {
			'enabled': false,
			'address': false,
			'provider': false,
			'username': false,
			'password': false,
			'ip': false
		},
		'alertMessaging': {
			'enabled': false,
			'emailsett': false,
			'sender': false,
			'password': false,
			'smtp': false
		},
		'FTPSending': {
			'enabled': false,
			'address': false,
			'refresh': false,
			'username': false,
			'password': false,
			'port': false,
			'values': false,
			'zipped': false
		},
		'geographicPosition': false,
		'weather': false,
		'delete': false,
		'device': false,
		'video': false,
		'adio': false,
		'norcloud': false,
		'status': {
			'enabled': false,
			'gauges': false,
			'logs': false,
			'users': false,
			'userAdmin': false,
			'userOper': false,
			'userGuest': false
		}
	}
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	'graphsexport': true,
	'download': true,
	'archives': true,
	'streamPopover': {
		'enabled': true,
		'audio': true,
		'video': true
	},
	'realtime': true,
	'measurement': {
		'enabled': true,
		'measurement': true
	},
	'settings': {
		'enabled': true,
		'interface': true,
		'download': true,
		'audioRecording': true,
		'dynamicDns': {
			'enabled': true,
			'address': true,
			'provider': false,
			'username': false,
			'password': false,
			'ip': true
		},
		'alertMessaging': {
			'enabled': true,
			'emailsett': true,
			'sender': true,
			'password': false,
			'smtp': false
		},
		'FTPSending': {
			'enabled': true,
			'address': true,
			'refresh': true,
			'username': false,
			'password': false,
			'port': false,
			'values': true,
			'zipped': true
		},
		'geographicPosition': true,
		'weather': true,
		'delete': true,
		'device': true,
		'video': true,
		'adio': true,
		'norcloud': true,
		'status': {
			'enabled': true,
			'gauges': true,
			'logs': true,
			'users': true,
			'userAdmin': false,
			'userOper': true,
			'userGuest': true
		}
	}
});

/***/ }),
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/n2n.2345578.png";

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sync.3e647c1.png";

/***/ }),
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(474),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(472),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(378)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(479),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(353)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(452),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(454),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e68cc2d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(467),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-711f737d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(481),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(451),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(468),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(456),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(463),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(379)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(480),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ed1d5ec4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(372)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(471),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(446),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fb7eb18",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(447),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(341)
  __webpack_require__(340)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(440),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04549a1e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(450),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(442),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(439),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-037a5518",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(466),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e42075c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(478),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(361)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(460),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(465),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e0249b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(373)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(473),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78811eea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(453),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(475),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-99d5f2b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(461),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-608172a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(449),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(457),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(444),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1579e8f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(458),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(455),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(462),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64b6e198",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(441),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(476),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-adf2cc66",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(445),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19280080",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(349)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(448),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(344)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(443),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-149b26e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(464),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(437),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[3]),
      expression: "getScreenSize < 2 && !delayedLoading[3]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/weather/Weather')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.device),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "device", $$v)
      },
      expression: "getSettingsWeather.device"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/NoWeather'),
      "value": "NaN"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/reinhardt'),
      "value": "5MV"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/reinhardtRain'),
      "value": "5MVRain"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/thiesClima'),
      "value": "THIES"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/vaisala'),
      "value": "WXT520"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/kw360'),
      "value": "KW360"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-form-item', {
    staticClass: "el-form-item-full pixel"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.setDeviceLoading
    },
    on: {
      "click": function($event) {
        return _vm.setDevice()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/weather/SetDevice')))])], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-row', [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/weather/values')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsWeather.valsel), function(item, i) {
    return _c('el-col', {
      key: item.name,
      attrs: {
        "md": 12,
        "lg": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": item.name
      }
    }, [_c('el-color-picker', {
      model: {
        value: (_vm.getUnsavedLocalSettings.interface.colorsweath[i]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.interface.colorsweath, i, $$v)
        },
        expression: "getUnsavedLocalSettings.interface.colorsweath[i]"
      }
    }), _vm._v(" "), _c('el-switch', {
      staticClass: "switch-align",
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (item.enabled),
        callback: function($$v) {
          _vm.$set(item, "enabled", $$v)
        },
        expression: "item.enabled"
      }
    })], 1)], 1)
  }), 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$l('archives/name')))]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [(_vm.getSettingsAddons.noise == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('noise'),
    on: {
      "click": function($event) {
        return _vm.clicked('global')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Global')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsAddons.noise == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('noise'),
    on: {
      "click": function($event) {
        return _vm.clicked('noise')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Noise')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsAddons.noise == '1') ? _c('div', {
    staticClass: "option",
    on: {
      "click": function($event) {
        return _vm.clicked('audio')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Audio')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsAddons.video == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('video'),
    on: {
      "click": function($event) {
        return _vm.clicked('video')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Video')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsAddons.weather == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('weather'),
    on: {
      "click": function($event) {
        return _vm.clicked('weather')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Weather')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsAddons.adio == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('adio'),
    on: {
      "click": function($event) {
        return _vm.clicked('adio')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Adio')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "option",
    class: _vm.getClass('compressed'),
    on: {
      "click": function($event) {
        return _vm.clicked('compressed')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Compressed')))])])])
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markers-container"
  }, [_c('div', {
    staticClass: "markers-title"
  }, [_vm._v(_vm._s(_vm.$l('graphs/markers')))]), _vm._v(" "), _c('div', {
    staticClass: "markers-add-button",
    on: {
      "click": _vm.addMarkerClicked
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "markers-close-button",
    on: {
      "click": function($event) {
        _vm.data.visible = false
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.getLocalSettings.markers), function(marker) {
    return _c('div', {
      key: marker.id,
      staticClass: "marker-item"
    }, [_c('div', {
      staticClass: "marker-item-title",
      class: {
        enabled: _vm.editingMarker == marker.id, activated: _vm.activeToggleMarkers[marker.id] == true
      }
    }, [(_vm.editingMarker != marker.id) ? _c('div', {
      directives: [{
        name: "shortkey",
        rawName: "v-shortkey",
        value: ([marker.keyCombo.modifier, marker.keyCombo.key]),
        expression: "[marker.keyCombo.modifier, marker.keyCombo.key]"
      }],
      staticClass: "marker-click-hotspot",
      on: {
        "shortkey": function($event) {
          return _vm.markerClicked(marker.id)
        },
        "click": function($event) {
          return _vm.markerClicked(marker.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "marker-color",
      style: ({
        backgroundColor: marker.color
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "marker-name"
    }, [(_vm.editingMarker != marker.id) ? _c('div', [_vm._v("\n                    " + _vm._s(marker.name) + " \n                    "), _c('span', {
      staticClass: "marker-name-type"
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/' + (marker.type ? 'toggle' : 'single'))))])]) : _vm._e(), _vm._v(" "), (_vm.editingMarker == marker.id) ? _c('div', [_c('el-input', {
      staticClass: "marker-name-input",
      attrs: {
        "size": "small"
      },
      model: {
        value: (marker.name),
        callback: function($$v) {
          _vm.$set(marker, "name", $$v)
        },
        expression: "marker.name"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "marker-name-input-line"
    })], 1) : _vm._e()]), _vm._v(" "), (_vm.editingMarker != marker.id) ? _c('el-button', {
      staticClass: "marker-edit-button",
      attrs: {
        "type": "primary",
        "size": "mini",
        "icon": "edit"
      },
      on: {
        "click": function($event) {
          return _vm.editMarker(marker.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.editingMarker == marker.id) ? _c('el-button', {
      staticClass: "marker-edit-button visible-button",
      attrs: {
        "type": "success",
        "size": "mini",
        "icon": "check"
      },
      on: {
        "click": function($event) {
          return _vm.editMarker(marker.id)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editingMarker == marker.id),
        expression: "editingMarker == marker.id"
      }],
      staticClass: "marker-item-edit"
    }, [_c('el-row', {
      staticClass: "marker-item-edit-row"
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_vm._v("\n                          \n                        "), _c('div', {
      staticClass: "marker-item-edit-title vertical-align"
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/type')) + ":")])]), _vm._v(" "), _c('el-col', {
      staticClass: "center-align",
      attrs: {
        "span": 12
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.$l('graphs/markersCat/single')) + "\n                            "), _c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (marker.type),
        callback: function($$v) {
          _vm.$set(marker, "type", $$v)
        },
        expression: "marker.type"
      }
    }), _vm._v("\n                            " + _vm._s(_vm.$l('graphs/markersCat/toggle')) + "\n                    ")], 1)], 1), _vm._v(" "), _c('el-row', {
      staticClass: "marker-item-edit-row"
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_vm._v("\n                          \n                        "), _c('div', {
      staticClass: "marker-item-edit-title vertical-align"
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/color')) + ":")])]), _vm._v(" "), _c('el-col', {
      staticClass: "center-align",
      attrs: {
        "span": 12
      }
    }, [_c('el-color-picker', {
      staticClass: "marker-color-picker",
      model: {
        value: (marker.color),
        callback: function($$v) {
          _vm.$set(marker, "color", $$v)
        },
        expression: "marker.color"
      }
    })], 1)], 1), _vm._v(" "), _c('el-row', {
      staticClass: "marker-item-edit-row"
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_vm._v("\n                          \n                        "), _c('div', {
      staticClass: "marker-item-edit-title vertical-align"
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/keybind')) + ":")])]), _vm._v(" "), _c('el-col', {
      staticClass: "center-align",
      attrs: {
        "span": 12
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-select', {
      attrs: {
        "size": "mini",
        "filterable": "",
        "placeholder": "Select"
      },
      model: {
        value: (marker.keyCombo.modifier),
        callback: function($$v) {
          _vm.$set(marker.keyCombo, "modifier", $$v)
        },
        expression: "marker.keyCombo.modifier"
      }
    }, [_c('el-option', {
      key: "alt",
      attrs: {
        "label": _vm.$l('graphs/markersCat/alt'),
        "value": "alt"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "shift",
      attrs: {
        "label": _vm.$l('graphs/markersCat/shift'),
        "value": "shift"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-select', {
      attrs: {
        "size": "mini",
        "filterable": "",
        "placeholder": "Select"
      },
      model: {
        value: (marker.keyCombo.key),
        callback: function($$v) {
          _vm.$set(marker.keyCombo, "key", $$v)
        },
        expression: "marker.keyCombo.key"
      }
    }, _vm._l((_vm.keys), function(key) {
      return _c('el-option', {
        key: key,
        attrs: {
          "label": key,
          "value": key
        }
      })
    }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
      staticClass: "marker-item-edit-row buttons"
    }, [_c('el-col', {
      staticClass: "delete-button",
      attrs: {
        "span": 11
      }
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "icon": "delete",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.deleteClicked(marker.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/delete')))])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "save-button",
      attrs: {
        "span": 11
      }
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "icon": "check",
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.editMarker(marker.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/save')))])], 1)], 1)], 1)])], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "250px"
    },
    attrs: {
      "center": _vm.location,
      "zoom": 12,
      "map-type-id": "terrain"
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": _vm.getSettingsGeographicalPosition.present == 0
      },
      on: {
        "dragend": _vm.changePos
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/geographicPosition/Latitude')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.getSettingsGeographicalPosition.present == 1
    },
    model: {
      value: (_vm.getSettingsGeographicalPosition.lat),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsGeographicalPosition, "lat", $$v)
      },
      expression: "getSettingsGeographicalPosition.lat"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/geographicPosition/Longitude')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.getSettingsGeographicalPosition.present == 1
    },
    model: {
      value: (_vm.getSettingsGeographicalPosition.lon),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsGeographicalPosition, "lon", $$v)
      },
      expression: "getSettingsGeographicalPosition.lon"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/geographicPosition/Height')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.getSettingsGeographicalPosition.present == 1
    },
    model: {
      value: (_vm.getSettingsGeographicalPosition.height),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsGeographicalPosition, "height", $$v)
      },
      expression: "getSettingsGeographicalPosition.height"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "page",
    attrs: {
      "type": "flex",
      "gutter": 10,
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "login-form",
    attrs: {
      "xs": 14,
      "sm": 8,
      "md": 7,
      "lg": 6
    }
  }, [_c('div', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(389)
    }
  })]), _vm._v(" "), _c('el-form', {
    staticClass: "login-form-form",
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    },
    model: {
      value: (_vm.loginData),
      callback: function($$v) {
        _vm.loginData = $$v
      },
      expression: "loginData"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": _vm.$l('login/Username')
    }
  }, [_c('el-input', {
    staticClass: "form-item",
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.loginData.username),
      callback: function($$v) {
        _vm.$set(_vm.loginData, "username", $$v)
      },
      expression: "loginData.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": _vm.$l('login/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.loginData.password),
      callback: function($$v) {
        _vm.$set(_vm.loginData, "password", $$v)
      },
      expression: "loginData.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "button-item login-button"
  }, [_c('el-button', {
    attrs: {
      "native-type": "submit",
      "type": "primary"
    },
    on: {
      "click": _vm.loginSubmit
    }
  }, [_vm._v(_vm._s(_vm.$l('login/Login')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form"
  }, [(_vm.$p('settings/status/gauges')) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "Status"
    }
  }, [_c('el-row', {
    attrs: {
      "justify": "space-between",
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 8,
      "md": 12,
      "sm": 8,
      "xs": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/SDD')) + " ")])])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.getSystemStatus.hdd_percent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/total')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.hdd_total) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/free')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.hdd_free) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/used')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.hdd_used) + " GB")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "md": 12,
      "sm": 8,
      "xs": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/memory')) + " ")])])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.getSystemStatus.mem_percent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/total')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.mem_total) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/free')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.mem_free) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/used')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.mem_used) + " GB")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "md": 12,
      "sm": 8,
      "xs": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/camera')))])])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.getSystemStatus.cam_sd_percent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/total')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.cam_sd_size) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/free')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.cam_sd_free) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/used')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.cam_sd_used) + " GB")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "md": 12,
      "sm": 8,
      "xs": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card-unique"
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/n140')) + " ")])])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.getSystemStatus.n140_sd_percent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/total')) + ": ")]), _vm._v(" " + _vm._s(_vm.$l('settings/status/gbOrMore')))]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/free')) + ": ")]), _vm._v(" " + _vm._s(Math.round((100 - _vm.getSystemStatus.n140_sd_percent) * 10) / 10) + "% " + _vm._s(_vm.$l('settings/status/of')) + " 2GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/used')) + ": ")]), _vm._v(" " + _vm._s(Math.round((_vm.getSystemStatus.n140_sd_percent) * 10) / 10) + "% " + _vm._s(_vm.$l('settings/status/of')) + " 2GB")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "md": 12,
      "sm": 8,
      "xs": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card-unique"
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/cpu')) + " ")])])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.getSystemStatus.cpu_percent
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 8
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$l('settings/status/firmware')))])])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/status/Version') + ' :'
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getFirmware.version),
      callback: function($$v) {
        _vm.$set(_vm.getFirmware, "version", $$v)
      },
      expression: "getFirmware.version"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/status/Release') + ' :'
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getFirmware.release),
      callback: function($$v) {
        _vm.$set(_vm.getFirmware, "release", $$v)
      },
      expression: "getFirmware.release"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/status/PCFree') + ' :'
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getSettingsSystem.pchddlimit),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsSystem, "pchddlimit", $$v)
      },
      expression: "getSettingsSystem.pchddlimit"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$p('settings/status/logs')) ? _c('el-col', {
    attrs: {
      "lg": 16
    }
  }, [_c('el-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.logs == '1'),
      expression: "getSettingsAddons.logs == '1'"
    }]
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$l('settings/status/logs')))])])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 19
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.selectedLog),
      callback: function($$v) {
        _vm.selectedLog = $$v
      },
      expression: "selectedLog"
    }
  }, _vm._l((_vm.logTypes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 5
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.selectedLog
    },
    on: {
      "click": _vm.downloadClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/status/download')))])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.logsLoading),
      expression: "logsLoading"
    }],
    staticClass: "logsCard",
    attrs: {
      "gutter": 25
    }
  }, _vm._l((_vm.logs), function(item, i) {
    return _c('div', {
      key: i
    }, [_vm._v(_vm._s(item))])
  }), 0)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$p('settings/status/users')) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('div', {
    staticClass: "users-title"
  }, [_vm._v(_vm._s(_vm.$l('settings/status/users')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8
    }
  }, [(_vm.$p('settings/status/userAdmin')) ? _c('el-card', [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$l('settings/status/adminUsr')))])])]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.$l('settings/status/username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsUsers.userAdmin),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "userAdmin", $$v)
      },
      expression: "getSettingsUsers.userAdmin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword.admin ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsUsers.pwdAdmin),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "pwdAdmin", $$v)
      },
      expression: "getSettingsUsers.pwdAdmin"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword.admin = !_vm.showPassword.admin
      }
    },
    slot: "append"
  }, [_c('icon', {
    staticClass: "show-password-icon",
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8
    }
  }, [(_vm.$p('settings/status/userOper')) ? _c('el-card', [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$l('settings/status/noiseUsr')))])])]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.$l('settings/status/username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsUsers.userNoise),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "userNoise", $$v)
      },
      expression: "getSettingsUsers.userNoise"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword.user ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsUsers.pwdNoise),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "pwdNoise", $$v)
      },
      expression: "getSettingsUsers.pwdNoise"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword.user = !_vm.showPassword.user
      }
    },
    slot: "append"
  }, [_c('icon', {
    staticClass: "show-password-icon",
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8
    }
  }, [(_vm.$p('settings/status/userGuest')) ? _c('el-card', [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$l('settings/status/guestUsr')))])])]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.$l('settings/status/username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsUsers.userGuest),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "userGuest", $$v)
      },
      expression: "getSettingsUsers.userGuest"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword.guest ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsUsers.pwdGuest),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "pwdGuest", $$v)
      },
      expression: "getSettingsUsers.pwdGuest"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword.guest = !_vm.showPassword.guest
      }
    },
    slot: "append"
  }, [_c('icon', {
    staticClass: "show-password-icon",
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.rebootLoading
    },
    on: {
      "click": function($event) {
        return _vm.rebootSystemMessage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/status/Reboot')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[5]),
      expression: "getScreenSize < 2 && !delayedLoading[5]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Selection')
    }
  }, [_c('el-select', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.mic),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "mic", $$v)
      },
      expression: "getSettingsDevice.mic"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/Standard'),
      "value": "IN0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/iepe'),
      "value": "IN1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/line'),
      "value": "IN2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/horizontal'),
      "value": "IN3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/vertical'),
      "value": "IN4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Polarisation')
    }
  }, [_c('el-select', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.micpol),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "micpol", $$v)
      },
      expression: "getSettingsDevice.micpol"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/On'),
      "value": "VS1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/Off'),
      "value": "VS0"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Frequency')
    }
  }, [_c('el-select', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.freqmode),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "freqmode", $$v)
      },
      expression: "getSettingsDevice.freqmode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/Disable'),
      "value": "SC0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/11octave'),
      "value": "SC1FA0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/13octave'),
      "value": "SC1FA1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/11wOctave'),
      "value": "SC1FA2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/13wOctave'),
      "value": "SC1FA3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Resolution')
    }
  }, [_c('el-select', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.resolution),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "resolution", $$v)
      },
      expression: "getSettingsDevice.resolution"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "50 ms",
      "value": "UN50"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "100 ms",
      "value": "UN100"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "125 ms",
      "value": "UN125"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "500 ms",
      "value": "UN500"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "1 s",
      "value": "US01"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "5 s",
      "value": "US05"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "1 min",
      "value": "US60"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "10 min",
      "value": "US600"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Duration')
    }
  }, [_c('el-select', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.duration),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "duration", $$v)
      },
      expression: "getSettingsDevice.duration"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "24 h",
      "value": "H24"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "1 h",
      "value": "H01"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "infoContainer"
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "title": _vm.$l('settings/device/Meter')
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.getSettingsDevice.meterscale <= 70
    },
    on: {
      "click": _vm.decreaseClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/decrease')))])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-size": "16px"
    },
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.getSettingsDevice.meterscale - 80) + " dB / " + _vm._s(_vm.getSettingsDevice.meterscale) + " dB \n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.getSettingsDevice.meterscale >= 130
    },
    on: {
      "click": _vm.increaseClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/increase')))])], 1)], 1)], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "value": "1",
      "title": _vm.$l('settings/device/Values')
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("F")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("S")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("I")])], 1), _vm._v(" "), _vm._l((_vm.getSettingsDevice.valuesAll), function(value, i) {
    return _c('el-row', {
      key: value[0]
    }, [_c('el-col', {
      attrs: {
        "span": (value.length == 3) ? 6 : 9
      }
    }, [_c('el-color-picker', {
      model: {
        value: (_vm.getUnsavedLocalSettings.interface.colorsnoise[i]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.interface.colorsnoise, i, $$v)
        },
        expression: "getUnsavedLocalSettings.interface.colorsnoise[i]"
      }
    }), _c('div', {
      staticClass: "value-name"
    }, [_vm._v(_vm._s(_vm.getDeviceValueName(value)))])], 1), _vm._v(" "), _c('el-checkbox-group', {
      staticClass: "value-checkbox",
      model: {
        value: (_vm.getSettingsDevice.valsel),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsDevice, "valsel", $$v)
        },
        expression: "getSettingsDevice.valsel"
      }
    }, _vm._l((value), function(subvalue) {
      return _c('el-col', {
        key: subvalue,
        attrs: {
          "span": 6
        }
      }, [_c('el-checkbox', {
        attrs: {
          "label": subvalue
        },
        on: {
          "change": function($event) {
            return _vm.checkboxChanged(subvalue)
          }
        }
      })], 1)
    }), 1)], 1)
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/device/Special')
    }
  }, _vm._l((_vm.getSettingsSpecval.valselsp), function(item) {
    return _c('el-row', {
      key: item.name,
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "lg": 2
      }
    }, [(item.name == 'MV') ? _c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/movingValue')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (item.enabled),
        callback: function($$v) {
          _vm.$set(item, "enabled", $$v)
        },
        expression: "item.enabled"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.name != 'MV') ? _c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": item.name
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (item.enabled),
        callback: function($$v) {
          _vm.$set(item, "enabled", $$v)
        },
        expression: "item.enabled"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 22
      }
    }, [(item.name == 'LEQDay' && item.enabled) ? _c('el-form-item', {
      staticClass: "el-form-item-full"
    }, [_c('div', {
      staticClass: "LEQDayContainer"
    }, [_c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "sm": 8,
        "md": 8,
        "lg": 6
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/value')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsSpecval.leqday),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "leqday", $$v)
        },
        expression: "getSettingsSpecval.leqday"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/device/timeControlled'),
        "value": "tc"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/device/measurementControlled'),
        "value": "mc"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 8,
        "md": 8,
        "lg": 11
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/start_stop')
      }
    }, [_c('el-row', [_c('el-col', [_c('el-time-select', {
      attrs: {
        "disabled": _vm.getSettingsSpecval.leqday == 'mc',
        "placeholder": _vm.$l('settings/device/startTime'),
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '24:00'
        }
      },
      model: {
        value: (_vm.getSettingsSpecval.leqdaystart),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "leqdaystart", $$v)
        },
        expression: "getSettingsSpecval.leqdaystart"
      }
    }), _vm._v(" "), _c('el-time-select', {
      attrs: {
        "disabled": _vm.getSettingsSpecval.leqday == 'mc',
        "placeholder": _vm.$l('settings/device/endTime'),
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '24:00',
          minTime: _vm.getSettingsSpecval.leqdaystart
        }
      },
      model: {
        value: (_vm.getSettingsSpecval.leqdaystop),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "leqdaystop", $$v)
        },
        expression: "getSettingsSpecval.leqdaystop"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 3,
        "md": 3,
        "lg": 3
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/trigger')
      }
    }, [_c('el-row', [_c('el-col', [_c('el-input-number', {
      model: {
        value: (_vm.getSettingsSpecval.leqdayval),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "leqdayval", $$v)
        },
        expression: "getSettingsSpecval.leqdayval"
      }
    })], 1)], 1)], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (item.name == 'MV' && item.enabled) ? _c('el-form-item', {
      staticClass: "el-form-item-full"
    }, [_c('div', {
      staticClass: "LEQDayContainer"
    }, [_c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "lg": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/value')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsSpecval.maval),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "maval", $$v)
        },
        expression: "getSettingsSpecval.maval"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/device/movingAverage'),
        "value": "ma"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "L95",
        "value": "l95"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "L50",
        "value": "l50"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "L1",
        "value": "l1"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/duration')
      }
    }, [_c('el-time-picker', {
      attrs: {
        "picker-options": {
          selectableRange: '00:00:00 - 01:00:00'
        }
      },
      model: {
        value: (_vm.getSettingsSpecval.mavaldurationPicker),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "mavaldurationPicker", $$v)
        },
        expression: "getSettingsSpecval.mavaldurationPicker"
      }
    }), _vm._v(" "), _c('el-input-number', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticStyle: {
        "width": "100%"
      },
      model: {
        value: (_vm.getSettingsSpecval.mavalduration),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "mavalduration", $$v)
        },
        expression: "getSettingsSpecval.mavalduration"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "sm": 12,
        "md": 12,
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/device/threshold')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsSpecval.mavalltype),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval, "mavalltype", $$v)
        },
        expression: "getSettingsSpecval.mavalltype"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/audioRecording/Disable'),
        "value": 0
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/audioRecording/Lower'),
        "value": 1
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/audioRecording/Greater'),
        "value": 2
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/audioRecording/Both'),
        "value": 3
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "sm": 11,
        "lg": 11
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full pixel",
      attrs: {
        "label": _vm.$l('settings/audioRecording/lowerThan')
      }
    }, [_c('el-input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.getSettingsSpecval.mavalltype == 0 || _vm.getSettingsSpecval.mavalltype == 2,
        "min": 0,
        "max": 150
      },
      model: {
        value: (_vm.getSettingsSpecval.mavallevel[0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval.mavallevel, 0, $$v)
        },
        expression: "getSettingsSpecval.mavallevel[0]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      staticClass: "line",
      attrs: {
        "sm": 2,
        "lg": 2
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full pixel",
      attrs: {
        "label": " "
      }
    }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 11,
        "lg": 11
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full pixel",
      attrs: {
        "label": _vm.$l('settings/audioRecording/greaterThan')
      }
    }, [_c('el-input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.getSettingsSpecval.mavalltype == 0 || _vm.getSettingsSpecval.mavalltype == 1,
        "min": 0,
        "max": 150
      },
      model: {
        value: (_vm.getSettingsSpecval.mavallevel[1]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsSpecval.mavallevel, 1, $$v)
        },
        expression: "getSettingsSpecval.mavallevel[1]"
      }
    })], 1)], 1)], 1)], 1)], 1)], 1)]) : _vm._e()], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[4]) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/device/Advance')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Mic check')
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": -10,
      "max": 140,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsDevice.miccheckvalue),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "miccheckvalue", $$v)
      },
      expression: "getSettingsDevice.miccheckvalue"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/Mic check time')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDevice.micchecktime),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "micchecktime", $$v)
      },
      expression: "getSettingsDevice.micchecktime"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/midnight'),
      "value": "23"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/device/noon'),
      "value": "11"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/testOpt')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.testOptionsValue),
      callback: function($$v) {
        _vm.testOptionsValue = $$v
      },
      expression: "testOptionsValue"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "pixel",
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.testOptions()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/test')))])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "pixel",
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/device/SDFreeSpace')
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.getSettingsDevice.sdfreelimit),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "sdfreelimit", $$v)
      },
      expression: "getSettingsDevice.sdfreelimit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    staticClass: "startstop-title",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/autostart')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "right-pull",
    attrs: {
      "size": "mini",
      "type": "success",
      "icon": "plus"
    },
    on: {
      "click": _vm.addStartstopGroup
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.getSettingsStartstop.groups), function(group, index) {
    return _c('el-collapse-item', {
      key: group,
      attrs: {
        "title": 'Group ' + (index + 1)
      }
    }, [_c('el-row', [_c('div', {
      staticClass: "remove-startstop-button"
    }, [_c('el-button', {
      staticClass: "right-pull",
      attrs: {
        "size": "mini",
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteStartstopGroup(group)
        }
      }
    })], 1)]), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "md": 4
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/device/startstopActive')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsStartstop['enable' + group]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStartstop, 'enable' + group, $$v)
        },
        expression: "getSettingsStartstop['enable'+group]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 10
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/device/days')
      }
    }, [_c('el-select', {
      attrs: {
        "disabled": !_vm.getSettingsStartstop['enable' + group],
        "multiple": ""
      },
      model: {
        value: (_vm.getSettingsStartstop['days' + group]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStartstop, 'days' + group, $$v)
        },
        expression: "getSettingsStartstop['days'+group]"
      }
    }, [_c('el-option', {
      key: "1",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[1],
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "2",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[2],
        "value": "2"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "3",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[3],
        "value": "3"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "4",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[4],
        "value": "4"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "5",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[5],
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "6",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[6],
        "value": "6"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "7",
      attrs: {
        "label": _vm.$l('common/graph_day_name')[0],
        "value": "7"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 10
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/device/types')
      }
    }, [_c('el-select', {
      attrs: {
        "disabled": !_vm.getSettingsStartstop['enable' + group],
        "multiple": ""
      },
      model: {
        value: (_vm.getSettingsStartstop['types' + group]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStartstop, 'types' + group, $$v)
        },
        expression: "getSettingsStartstop['types'+group]"
      }
    }, [_c('el-option', {
      key: "noise",
      attrs: {
        "label": _vm.$l('calendar/noise'),
        "value": "noise"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "weather",
      attrs: {
        "label": _vm.$l('calendar/weather'),
        "value": "weather"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "adio",
      attrs: {
        "label": _vm.$l('calendar/adio'),
        "value": "adio"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "md": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/device/start')
      }
    }, [_c('el-time-select', {
      attrs: {
        "disabled": !_vm.getSettingsStartstop['enable' + group],
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '23:45'
        }
      },
      model: {
        value: (_vm.getSettingsStartstop['start' + group]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStartstop, 'start' + group, $$v)
        },
        expression: "getSettingsStartstop['start'+group]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/device/stop')
      }
    }, [_c('el-time-select', {
      attrs: {
        "disabled": !_vm.getSettingsStartstop['enable' + group],
        "picker-options": {
          start: _vm.getSettingsStartstop['start' + group],
          step: '00:15',
          end: '23:45'
        }
      },
      model: {
        value: (_vm.getSettingsStartstop['stop' + group]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStartstop, 'stop' + group, $$v)
        },
        expression: "getSettingsStartstop['stop'+group]"
      }
    })], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Format SD",
      "visible": _vm.formatSDdialog,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.formatSDdialog = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$l('settings/device/formatSDdialog')) + " ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer dialog-footer"
    },
    slot: "footer dialog-footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.formatSDdialog = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogCancel')) + " ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.formatSDdialog = false, _vm.formatSD()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogContinue')) + " ")])], 1)]), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[5]) ? _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.restartLoading,
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.restartNoiseClick()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/Restart')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.instrumentLoading,
      "disabled": _vm.getStatus.noise,
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.setInstrument()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/Set instrument')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.formatSDLoading,
      "disabled": _vm.getStatus.noise,
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.formatSD()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/Format')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.checkSpaceLoading,
      "disabled": _vm.getStatus.noise,
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.checkSD()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/CheckSD')))])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "span": "24"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.getSettingsAddons.norcloud > 0) ? _c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/IdNor')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getSettingsDevice.devid),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "devid", $$v)
      },
      expression: "getSettingsDevice.devid"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/syncTime')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons.norcloud == '0',
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsNorCloud.sendTime),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "sendTime", $$v)
      },
      expression: "getSettingsNorCloud.sendTime"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/norcloud/disable'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/norcloud/hour'),
      "value": "60"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '12 ' + _vm.$l('settings/norcloud/hour'),
      "value": "720"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '24 ' + _vm.$l('settings/norcloud/hour'),
      "value": "1440"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/syncData')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsNorCloud.sendData),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "sendData", $$v)
      },
      expression: "getSettingsNorCloud.sendData"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/syncRec')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsNorCloud.sendRec),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "sendRec", $$v)
      },
      expression: "getSettingsNorCloud.sendRec"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/sendAlerts')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsNorCloud.sendAlerts),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "sendAlerts", $$v)
      },
      expression: "getSettingsNorCloud.sendAlerts"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/recSett')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsNorCloud.receiveSett),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "receiveSett", $$v)
      },
      expression: "getSettingsNorCloud.receiveSett"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 12,
      "lg": 12
    }
  }, [(_vm.getSettingsNorCloud.receiveSett == '1') ? _c('el-form-item', {
    staticClass: "el-form-item-full"
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/applySett')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsNorCloud.updSett),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "updSett", $$v)
      },
      expression: "getSettingsNorCloud.updSett"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/norcloud/now'),
      "value": "now"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/norcloud/fhour'),
      "value": "fhour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/norcloud/break'),
      "value": "break"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notes-container"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px",
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.data.value == _vm.previousValue,
      "type": "success",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.saveClicked()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/save')))])], 1)
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.graphsLoading),
      expression: "graphsLoading"
    }],
    class: _vm.containerClassName
  }, [_c('el-row', [_c('graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStatistics),
      expression: "isStatistics"
    }],
    ref: "statisticsGraph",
    attrs: {
      "title": _vm.$l('graphs/STATISTICS'),
      "data": _vm.statistics,
      "config": _vm.configs.statistics
    }
  }), _vm._v(" "), _c('graph', {
    ref: "noiseGraph",
    attrs: {
      "title": _vm.$l('graphs/NOISE'),
      "shared": _vm.shared,
      "data": _vm.noise,
      "config": _vm.configs.noise
    }
  }), _vm._v(" "), _c('graph', {
    ref: "spectGraph",
    attrs: {
      "title": _vm.$l('graphs/SPECTRUM'),
      "shared": _vm.shared,
      "data": _vm.spectogram,
      "config": _vm.configs.spectogram
    }
  }), _vm._v(" "), (!_vm.getRealtimeEnabled || _vm.getSettingsWeather.device != 'NaN') ? _c('graph', {
    ref: "weathGraph",
    attrs: {
      "title": _vm.$l('graphs/WEATHER'),
      "shared": _vm.shared,
      "data": _vm.weather,
      "config": _vm.configs.weather
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.getRealtimeEnabled || _vm.getSettingsAdio && (_vm.getSettingsAdio.AI == 1 || _vm.getSettingsAdio.DI1 == 1 || _vm.getSettingsAdio.DI2 == 1) && _vm.getSettingsAdio.present == 1) ? _c('graph', {
    ref: "adioGraph",
    attrs: {
      "title": _vm.$l('graphs/ADIO'),
      "shared": _vm.shared,
      "data": _vm.adio,
      "config": _vm.configs.adio
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 6
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/statisticsTemplate')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getUnsavedLocalSettings.download.downlStatistic),
      callback: function($$v) {
        _vm.$set(_vm.getUnsavedLocalSettings.download, "downlStatistic", $$v)
      },
      expression: "getUnsavedLocalSettings.download.downlStatistic"
    }
  }, _vm._l((_vm.mappedStatisticTemplates), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$l('settings/download/statisticsRename')))]), _vm._v(" "), _vm._l((_vm.mappedStatisticTemplates), function(item) {
    return _c('el-form-item', {
      key: item.value,
      staticClass: "el-form-item-full",
      attrs: {
        "label": item.value
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": _vm.$l('settings/statistics/reportSending/Name')
      },
      model: {
        value: (_vm.getUnsavedLocalSettings.download.statistics.mapping[item.value]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.download.statistics.mapping, item.value, $$v)
        },
        expression: "getUnsavedLocalSettings.download.statistics.mapping[item.value]"
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('el-row', [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/statistics/reportSending/settingsName')
    }
  }, [_c('el-row', [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px",
      "padding-bottom": "5px",
      "border-bottom": "1px solid rgba(0,0,0,0.1)"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "md": 1
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small",
      "type": "success",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.addNewGroup()
      }
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.getSettingsStatistics.allgroups), function(group) {
    return _c('el-form-item', {
      key: group,
      class: (_vm.getScreenSize > 2) ? 'statiststics-table-item-container' : ''
    }, [_c('el-row', {
      class: (_vm.getScreenSize > 2) ? 'statistics-table-item' : '',
      staticStyle: {
        "border-bottom": "1px solid rgba(0,0,0,0.2)"
      },
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "lg": 15
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "md": 24,
        "lg": 6
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Name')))]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsStatistics['templs' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'templs' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['templs'+group.replace('st','')]"
      }
    }, _vm._l((_vm.mappedStatisticTemplates), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "value": item.value,
          "label": item.label
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 7
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Title')))]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": _vm.$l('settings/statistics/reportSending/Title')
      },
      model: {
        value: (_vm.getSettingsStatistics['titles' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'titles' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['titles'+group.replace('st','')]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 5
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Language')))]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsStatistics['langs' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'langs' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['langs'+group.replace('st','')]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/interface/english'),
        "value": "en"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/interface/austria'),
        "value": "at"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/interface/german'),
        "value": "de"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/interface/french'),
        "value": "fr"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/interface/slovensko'),
        "value": "sl"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 6
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Duration')))]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsStatistics['durs' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'durs' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['durs'+group.replace('st','')]"
      }
    }, _vm._l((_vm.getSettingsStatistics.durations.split(',')), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "value": item,
          "label": _vm.$l('settings/statistics/options/' + item)
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "margin-top": "10px",
        "margin-bottom": "10px"
      },
      attrs: {
        "gutter": 10
      }
    }, [(_vm.getSettingsStatistics['durs' + group.replace('st', '')] == 'Range') ? _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 6
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Range')))]), _vm._v(" "), _c('div', [_c('el-input-number', {
      staticClass: "range-numbers",
      attrs: {
        "step": 1,
        "max": 31,
        "min": 1
      },
      model: {
        value: (_vm.getSettingsStatistics['ranges' + group.replace('st', '')][0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics['ranges' + group.replace('st', '')], 0, $$v)
        },
        expression: "getSettingsStatistics['ranges'+group.replace('st','')][0]"
      }
    })], 1)], 1) : _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 6
      }
    }, [(_vm.getSettingsStatistics['durs' + group.replace('st', '')] == 'Range') ? _c('div', [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Range')))]), _vm._v(" "), _c('el-input-number', {
      staticClass: "range-numbers",
      attrs: {
        "step": 1,
        "max": 31,
        "min": 1
      },
      model: {
        value: (_vm.getSettingsStatistics['ranges' + group.replace('st', '')][0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics['ranges' + group.replace('st', '')], 0, $$v)
        },
        expression: "getSettingsStatistics['ranges'+group.replace('st','')][0]"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 6
      }
    }, [(_vm.getSettingsStatistics['durs' + group.replace('st', '')] != 'On Event') ? _c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Hours')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsStatistics['durs' + group.replace('st', '')] != 'On Event') ? _c('el-time-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "picker-options": {
          start: '00:00',
          step: '01:00',
          end: '24:00'
        },
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsStatistics['hours' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'hours' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['hours'+group.replace('st','')]"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 8
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Email')))]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": _vm.$l('settings/statistics/reportSending/Email')
      },
      model: {
        value: (_vm.getSettingsStatistics['recps' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'recps' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['recps'+group.replace('st','')]"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-bottom": "10px",
        "padding": "0px"
      },
      attrs: {
        "lg": 9
      }
    }, [_c('el-col', {
      attrs: {
        "md": 24
      }
    }, [(_vm.getSettingsStatistics['durs' + group.replace('st', '')] != 'On Event') ? _c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Days')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsStatistics['durs' + group.replace('st', '')] != 'On Event') ? _c('el-select', {
      attrs: {
        "multiple": "",
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsStatistics['dayss' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'dayss' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['dayss'+group.replace('st','')]"
      }
    }, _vm._l((_vm.weekDays), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', [_c('div', {
      staticClass: "delete-button-absolute",
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_c('el-button', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "size": "small",
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.alertGroupDeleted(group)
        }
      }
    })], 1)])], 1)], 1)
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[12]),
      expression: "getScreenSize < 2 && !delayedLoading[12]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[0]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Format')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAudioRecording.format),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "format", $$v)
      },
      expression: "getSettingsAudioRecording.format"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Wav",
      "value": "wav"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Mp3",
      "value": "mp3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Raw",
      "value": "raw"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Ogg Vorbis",
      "value": "ogg"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Audio Offset')
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 30
    },
    model: {
      value: (_vm.getSettingsAudioRecording.offset),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "offset", $$v)
      },
      expression: "getSettingsAudioRecording.offset"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-collapse', [_c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/audioRecording/Day')
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/RecDur')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:05 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration1Picker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration1Picker", $$v)
      },
      expression: "getSettingsAudioRecording.duration1Picker"
    }
  }), _vm._v(" "), _c('el-input-number', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 3600
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration1),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration1", $$v)
      },
      expression: "getSettingsAudioRecording.duration1"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Threshold')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold1type),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "threshold1type", $$v)
      },
      expression: "getSettingsAudioRecording.threshold1type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold1type == 0 || _vm.getSettingsAudioRecording.threshold1type == 2,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold1[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold1, 0, $$v)
      },
      expression: "getSettingsAudioRecording.threshold1[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold1type == 0 || _vm.getSettingsAudioRecording.threshold1type == 1,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold1[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold1, 1, $$v)
      },
      expression: "getSettingsAudioRecording.threshold1[1]"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Start')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time1),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time1", $$v)
      },
      expression: "getSettingsAudioRecording.time1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Stop')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time1stop),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time1stop", $$v)
      },
      expression: "getSettingsAudioRecording.time1stop"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-collapse', [_c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/audioRecording/Night')
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/RecDur')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:00 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration2Picker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration2Picker", $$v)
      },
      expression: "getSettingsAudioRecording.duration2Picker"
    }
  }), _vm._v(" "), _c('el-input-number', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 3600
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration2),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration2", $$v)
      },
      expression: "getSettingsAudioRecording.duration2"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Threshold')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold2type),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "threshold2type", $$v)
      },
      expression: "getSettingsAudioRecording.threshold2type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold2type == 0 || _vm.getSettingsAudioRecording.threshold2type == 2,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold2[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold2, 0, $$v)
      },
      expression: "getSettingsAudioRecording.threshold2[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold2type == 0 || _vm.getSettingsAudioRecording.threshold2type == 1,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold2[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold2, 1, $$v)
      },
      expression: "getSettingsAudioRecording.threshold2[1]"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Start')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24,
      "step": 1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time1stop),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time1stop", $$v)
      },
      expression: "getSettingsAudioRecording.time1stop"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Stop')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time1),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time1", $$v)
      },
      expression: "getSettingsAudioRecording.time1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[4]) ? _c('el-collapse', [_c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/audioRecording/Optional 1')
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/RecDur')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:05 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration3Picker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration3Picker", $$v)
      },
      expression: "getSettingsAudioRecording.duration3Picker"
    }
  }), _vm._v(" "), _c('el-input-number', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 3600
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration3),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration3", $$v)
      },
      expression: "getSettingsAudioRecording.duration3"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Threshold')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold3type),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "threshold3type", $$v)
      },
      expression: "getSettingsAudioRecording.threshold3type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold3type == 0 || _vm.getSettingsAudioRecording.threshold3type == 2,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold3[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold3, 0, $$v)
      },
      expression: "getSettingsAudioRecording.threshold3[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold3type == 0 || _vm.getSettingsAudioRecording.threshold3type == 1,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold3[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold3, 1, $$v)
      },
      expression: "getSettingsAudioRecording.threshold3[1]"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Start')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24,
      "step": 1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time3),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time3", $$v)
      },
      expression: "getSettingsAudioRecording.time3"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Stop')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24,
      "step": 1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time3stop),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time3stop", $$v)
      },
      expression: "getSettingsAudioRecording.time3stop"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[5]) ? _c('el-collapse', [_c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/audioRecording/Optional 2')
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/RecDur')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:05 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration4Picker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration4Picker", $$v)
      },
      expression: "getSettingsAudioRecording.duration4Picker"
    }
  }), _vm._v(" "), _c('el-input-number', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 3600
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration4),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration4", $$v)
      },
      expression: "getSettingsAudioRecording.duration4"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Threshold')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold4type),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "threshold4type", $$v)
      },
      expression: "getSettingsAudioRecording.threshold4type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold4type == 0 || _vm.getSettingsAudioRecording.threshold4type == 2,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold4[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold4, 0, $$v)
      },
      expression: "getSettingsAudioRecording.threshold4[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold4type == 0 || _vm.getSettingsAudioRecording.threshold4type == 1,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold4[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold4, 1, $$v)
      },
      expression: "getSettingsAudioRecording.threshold4[1]"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Start')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24,
      "step": 1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time4),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time4", $$v)
      },
      expression: "getSettingsAudioRecording.time4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Stop')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24,
      "step": 1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time4stop),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time4stop", $$v)
      },
      expression: "getSettingsAudioRecording.time4stop"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[6]) ? _c('el-collapse', [_c('el-collapse-item', {
    class: _vm.getClass('weather'),
    attrs: {
      "title": _vm.$l('settings/audioRecording/Weather')
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[7]) ? _c('el-row', [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/RecDur')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:05 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsWeather.rectimePicker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "rectimePicker", $$v)
      },
      expression: "getSettingsWeather.rectimePicker"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    model: {
      value: (_vm.getSettingsWeather.rectime),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "rectime", $$v)
      },
      expression: "getSettingsWeather.rectime"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[8]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Windspeed')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.windsptrigtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "windsptrigtype", $$v)
      },
      expression: "getSettingsWeather.windsptrigtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.windsptrigtype == 0 || _vm.getSettingsWeather.windsptrigtype == 2,
      "min": 0,
      "max": 150
    },
    model: {
      value: (_vm.getSettingsWeather.windsptrig[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.windsptrig, 0, $$v)
      },
      expression: "getSettingsWeather.windsptrig[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.windsptrigtype == 0 || _vm.getSettingsWeather.windsptrigtype == 1,
      "min": 0,
      "max": 150
    },
    model: {
      value: (_vm.getSettingsWeather.windsptrig[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.windsptrig, 1, $$v)
      },
      expression: "getSettingsWeather.windsptrig[1]"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[9]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Temperature')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.temptrigtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "temptrigtype", $$v)
      },
      expression: "getSettingsWeather.temptrigtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.temptrigtype == 0 || _vm.getSettingsWeather.temptrigtype == 2,
      "min": -40,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.temptrig[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.temptrig, 0, $$v)
      },
      expression: "getSettingsWeather.temptrig[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.temptrigtype == 0 || _vm.getSettingsWeather.temptrigtype == 1,
      "min": -40,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.temptrig[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.temptrig, 1, $$v)
      },
      expression: "getSettingsWeather.temptrig[1]"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[10]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Air')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.airprtrigtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "airprtrigtype", $$v)
      },
      expression: "getSettingsWeather.airprtrigtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.airprtrigtype == 0 || _vm.getSettingsWeather.airprtrigtype == 2,
      "min": 300,
      "max": 1200
    },
    model: {
      value: (_vm.getSettingsWeather.airprtrig[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.airprtrig, 0, $$v)
      },
      expression: "getSettingsWeather.airprtrig[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.airprtrigtype == 0 || _vm.getSettingsWeather.airprtrigtype == 1,
      "min": 300,
      "max": 1200
    },
    model: {
      value: (_vm.getSettingsWeather.airprtrig[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.airprtrig, 1, $$v)
      },
      expression: "getSettingsWeather.airprtrig[1]"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[11]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Humidity')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.humidtrigtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "humidtrigtype", $$v)
      },
      expression: "getSettingsWeather.humidtrigtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.humidtrigtype == 0 || _vm.getSettingsWeather.humidtrigtype == 2,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.humidtrig[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.humidtrig, 0, $$v)
      },
      expression: "getSettingsWeather.humidtrig[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.humidtrigtype == 0 || _vm.getSettingsWeather.humidtrigtype == 1,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.humidtrig[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.humidtrig, 1, $$v)
      },
      expression: "getSettingsWeather.humidtrig[1]"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[12]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Precipitation')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.precipittrigtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "precipittrigtype", $$v)
      },
      expression: "getSettingsWeather.precipittrigtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.precipittrigtype == 0 || _vm.getSettingsWeather.precipittrigtype == 2,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.precipittrig[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.precipittrig, 0, $$v)
      },
      expression: "getSettingsWeather.precipittrig[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.precipittrigtype == 0 || _vm.getSettingsWeather.precipittrigtype == 1,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.precipittrig[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.precipittrig, 1, $$v)
      },
      expression: "getSettingsWeather.precipittrig[1]"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "full-dialog",
      "title": _vm.$l('streamPopover/Audio') + ' - ' + _vm.data.filename,
      "visible": _vm.data.visible,
      "size": "auto"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.data, "visible", $event)
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.data.filename) ? _c('audio', {
    ref: "audioController",
    staticClass: "audio-controller",
    attrs: {
      "controls": ""
    },
    on: {
      "loadeddata": _vm.audioLoaded
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.fileSource
    }
  })]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "img-popup",
    attrs: {
      "src": _vm.imgSource
    },
    on: {
      "click": _vm.setImgBig
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('img', {
    staticClass: "img-big",
    attrs: {
      "src": _vm.imgSourceBig
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/Close')))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show) ? _c('video', {
    staticClass: "audioControls",
    attrs: {
      "controls": "controls",
      "preload": "none"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.src,
      "type": "video/mp4"
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenSize > 1),
      expression: "screenSize>1"
    }],
    staticClass: "settingsMenuContainer"
  }, [_c('div', {
    staticClass: "settingsMenuItemTitle"
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/name')) + "  ")]), _vm._v(" "), (_vm.$p('settings/interface')) ? _c('div', {
    class: _vm.getClass('interface'),
    on: {
      "click": function($event) {
        return _vm.navigate('interface')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.$l('settings/interface/settingsName')) + " "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/download')) ? _c('div', {
    class: _vm.getClass('download'),
    on: {
      "click": function($event) {
        return _vm.navigate('download')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/download/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/audioRecording')) ? _c('div', {
    class: _vm.getClass('audioRecording'),
    on: {
      "click": function($event) {
        return _vm.navigate('audioRecording')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/audioRecording/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/dynamicDns/enabled')) ? _c('div', {
    class: _vm.getClass('dynamicDns'),
    on: {
      "click": function($event) {
        return _vm.navigate('dynamicDns')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/dynamicDns/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/enabled')) ? _c('div', {
    class: _vm.getClass('alertMessaging'),
    on: {
      "click": function($event) {
        return _vm.navigate('alertMessaging')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/enabled')) ? _c('div', {
    class: _vm.getClass('FTPSending'),
    on: {
      "click": function($event) {
        return _vm.navigate('FTPSending')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/FTPSending/settingsName')) + "  "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/geographicPosition')) ? _c('div', {
    class: _vm.getClass('geographicPosition'),
    on: {
      "click": function($event) {
        return _vm.navigate('geographicPosition')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/geographicPosition/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/weather') && _vm.getSettingsAddons.weather == '1') ? _c('div', {
    class: _vm.getClass('weather'),
    on: {
      "click": function($event) {
        return _vm.navigate('weather')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/weather/settingsName')) + "  "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/delete')) ? _c('div', {
    class: _vm.getClass('delete'),
    on: {
      "click": function($event) {
        return _vm.navigate('delete')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/delete/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/device') && _vm.getSettingsAddons.noise == '1') ? _c('div', {
    class: _vm.getClass('device'),
    on: {
      "click": function($event) {
        return _vm.navigate('device')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/device/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/video') && _vm.getSettingsAddons.video == '1') ? _c('div', {
    class: _vm.getClass('video'),
    on: {
      "click": function($event) {
        return _vm.navigate('video')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/video/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/adio') && _vm.getSettingsAddons.adio == '1') ? _c('div', {
    class: _vm.getClass('adio'),
    on: {
      "click": function($event) {
        return _vm.navigate('adio')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/adio/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/norcloud')) ? _c('div', {
    class: _vm.getClass('norcloud'),
    on: {
      "click": function($event) {
        return _vm.navigate('norcloud')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/norcloud/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.getClass('statistics'),
    on: {
      "click": function($event) {
        return _vm.navigate('statistics')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/statistics/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]), _vm._v(" "), (_vm.$p('settings/status/enabled')) ? _c('div', {
    class: _vm.getClass('status'),
    on: {
      "click": function($event) {
        return _vm.navigate('status')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/status/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "settings-menu-top-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenSize < 2),
      expression: "screenSize<2"
    }],
    staticClass: "settings-menu-top"
  }, [_c('div', {
    staticClass: "settingsMenuItemTitle settings-top-title",
    on: {
      "click": function($event) {
        _vm.menuVisible = !_vm.menuVisible
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/name')) + " \n                "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.menuVisible),
      expression: "!menuVisible"
    }],
    staticClass: "el-icon-arrow-right pull-right settings-menu-top-icon"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuVisible),
      expression: "menuVisible"
    }],
    staticClass: "el-icon-arrow-down pull-right settings-menu-top-icon"
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuVisible),
      expression: "menuVisible"
    }],
    staticClass: "settings-menu-top-real"
  }, [_c('div', {
    staticClass: "settings-menu-items"
  }, [(_vm.$p('settings/interface')) ? _c('div', {
    class: _vm.getClass('interface'),
    on: {
      "click": function($event) {
        return _vm.navigate('interface')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.$l('settings/interface/settingsName')) + "  "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/download')) ? _c('div', {
    class: _vm.getClass('download'),
    on: {
      "click": function($event) {
        return _vm.navigate('download')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/download/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/audioRecording')) ? _c('div', {
    class: _vm.getClass('audioRecording'),
    on: {
      "click": function($event) {
        return _vm.navigate('audioRecording')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/audioRecording/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/dynamicDns/enabled')) ? _c('div', {
    class: _vm.getClass('dynamicDns'),
    on: {
      "click": function($event) {
        return _vm.navigate('dynamicDns')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/dynamicDns/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/enabled')) ? _c('div', {
    class: _vm.getClass('alertMessaging'),
    on: {
      "click": function($event) {
        return _vm.navigate('alertMessaging')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/enabled')) ? _c('div', {
    class: _vm.getClass('FTPSending'),
    on: {
      "click": function($event) {
        return _vm.navigate('FTPSending')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/FTPSending/settingsName')) + "  "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/geographicPosition')) ? _c('div', {
    class: _vm.getClass('geographicPosition'),
    on: {
      "click": function($event) {
        return _vm.navigate('geographicPosition')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/geographicPosition/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/weather')) ? _c('div', {
    class: _vm.getClass('weather'),
    on: {
      "click": function($event) {
        return _vm.navigate('weather')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/weather/settingsName')) + "  "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/delete')) ? _c('div', {
    class: _vm.getClass('delete'),
    on: {
      "click": function($event) {
        return _vm.navigate('delete')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/delete/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/device')) ? _c('div', {
    class: _vm.getClass('device'),
    on: {
      "click": function($event) {
        return _vm.navigate('device')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/device/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/video')) ? _c('div', {
    class: _vm.getClass('video'),
    on: {
      "click": function($event) {
        return _vm.navigate('video')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/video/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/adio')) ? _c('div', {
    class: _vm.getClass('adio'),
    on: {
      "click": function($event) {
        return _vm.navigate('adio')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/adio/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/norcloud')) ? _c('div', {
    class: _vm.getClass('norcloud'),
    on: {
      "click": function($event) {
        return _vm.navigate('norcloud')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/norcloud/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.getClass('statistics'),
    on: {
      "click": function($event) {
        return _vm.navigate('statistics')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/statistics/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]), _vm._v(" "), (_vm.$p('settings/status/enabled')) ? _c('div', {
    class: _vm.getClass('status'),
    on: {
      "click": function($event) {
        return _vm.navigate('status')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/status/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e()])])])], 1)]), _vm._v(" "), _c('el-row', {
    staticClass: "save-button-container",
    class: {
      'sidebar-margin': this.screenSize > 1, 'save-margin-top': this.screenSize <= 1
    }
  }, [_c('el-button', {
    staticClass: "save-button",
    attrs: {
      "type": _vm.saving ? 'default' : 'primary',
      "icon": _vm.saving ? 'loading' : ''
    },
    on: {
      "click": _vm.saveClicked
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$l('settings/save')) + " ")])])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    class: _vm.containerClass
  }, [_c('keep-alive', [(_vm.loaded) ? _c('router-view') : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [(_vm.$p('settings/dynamicDns/address')) ? _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/dynamicDns/Address')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.getSettingsAddons.dns == '0'
    },
    model: {
      value: (_vm.getSettingsDynamicDNS.host),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDynamicDNS, "host", $$v)
      },
      expression: "getSettingsDynamicDNS.host"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$p('settings/dynamicDns/provider')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.dns == '1'),
      expression: "getSettingsAddons.dns == '1'"
    }],
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/dynamicDns/Provider')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDynamicDNS.provider),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDynamicDNS, "provider", $$v)
      },
      expression: "getSettingsDynamicDNS.provider"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Dyn DNS",
      "value": "dyndns"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "NO-IP",
      "value": "noip"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Dynu",
      "value": "dynu"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/dynamicDns/username')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.dns == '1'),
      expression: "getSettingsAddons.dns == '1'"
    }],
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/dynamicDns/Username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsDynamicDNS.user),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDynamicDNS, "user", $$v)
      },
      expression: "getSettingsDynamicDNS.user"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/dynamicDns/password')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.dns == '1'),
      expression: "getSettingsAddons.dns == '1'"
    }],
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/dynamicDns/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsDynamicDNS.password),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDynamicDNS, "password", $$v)
      },
      expression: "getSettingsDynamicDNS.password"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    slot: "append"
  }, [_c('icon', {
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/dynamicDns/ip')) ? _c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/dynamicDns/IP')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.getSettingsAddons.dns == '0'
    },
    model: {
      value: (_vm.getSettingsDynamicDNS.ip),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDynamicDNS, "ip", $$v)
      },
      expression: "getSettingsDynamicDNS.ip"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className,
    attrs: {
      "title": _vm.title
    },
    on: {
      "click": _vm.dayClicked
    }
  }, [_c('div', {
    staticClass: "day-value"
  }, [_vm._v("\n        " + _vm._s(_vm.date.getDate()) + "\n        \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "has-data"
  }, [(_vm.hasNoise) ? _c('div', {
    staticClass: "has-noise"
  }) : _vm._e(), _vm._v(" "), (_vm.hasAudio) ? _c('div', {
    staticClass: "has-audio"
  }) : _vm._e(), _vm._v(" "), (_vm.hasWeather) ? _c('div', {
    staticClass: "has-weather"
  }) : _vm._e(), _vm._v(" "), (_vm.hasVideo) ? _c('div', {
    staticClass: "has-video"
  }) : _vm._e(), _vm._v(" "), (_vm.hasAdio) ? _c('div', {
    staticClass: "has-adio"
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/delete/autoDelete')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsSystem.deletedays),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsSystem, "deletedays", $$v)
      },
      expression: "getSettingsSystem.deletedays"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/delete/Disable'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/delete/week'),
      "value": "7 days"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '2 ' + _vm.$l('settings/delete/week'),
      "value": "14 days"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/delete/month'),
      "value": "1 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '2 ' + _vm.$l('settings/delete/month'),
      "value": "2 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '6 ' + _vm.$l('settings/delete/month'),
      "value": "6 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '12 ' + _vm.$l('settings/delete/month'),
      "value": "1 year"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/delete/Manual delete')
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.form.ManualDelete.From),
      callback: function($$v) {
        _vm.$set(_vm.form.ManualDelete, "From", $$v)
      },
      expression: "form.ManualDelete.From"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.form.ManualDelete.To),
      callback: function($$v) {
        _vm.$set(_vm.form.ManualDelete, "To", $$v)
      },
      expression: "form.ManualDelete.To"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/delete/autoCompress')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsSystem.compressdays),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsSystem, "compressdays", $$v)
      },
      expression: "getSettingsSystem.compressdays"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/delete/Disable'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/delete/week'),
      "value": "7 days"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '2 ' + _vm.$l('settings/delete/week'),
      "value": "14 days"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/delete/month'),
      "value": "1 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '2 ' + _vm.$l('settings/delete/month'),
      "value": "2 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '6 ' + _vm.$l('settings/delete/month'),
      "value": "6 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '12 ' + _vm.$l('settings/delete/month'),
      "value": "1 year"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full"
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "loading": _vm.deleteLoading,
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/delete/Delete')))])], 1)], 1)], 1), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/delete/Values')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsSystem.delvalsel), function(item) {
    return _c('el-col', {
      key: item.name,
      attrs: {
        "md": 12,
        "lg": 8
      }
    }, [_c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(item.name == 'logs' && !_vm.getSettingsAddons.logs)),
        expression: "!(item.name == 'logs' && !getSettingsAddons.logs)"
      }],
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/delete/' + item.name)
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (item.enabled),
        callback: function($$v) {
          _vm.$set(item, "enabled", $$v)
        },
        expression: "item.enabled"
      }
    })], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[5]),
      expression: "getScreenSize < 2 && !delayedLoading[5]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[0]) ? _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/Compression')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getUnsavedLocalSettings.download.downlzip),
      callback: function($$v) {
        _vm.$set(_vm.getUnsavedLocalSettings.download, "downlzip", $$v)
      },
      expression: "getUnsavedLocalSettings.download.downlzip"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/download/No compression'),
      "value": parseInt(0)
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/download/Zip compression'),
      "value": parseInt(1)
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/download/Noise')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsDevice.valsel), function(value) {
    return _c('el-col', {
      key: value,
      attrs: {
        "sm": 6,
        "lg": 4
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": value
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": "",
        "off-value": ""
      },
      model: {
        value: (_vm.getUnsavedLocalSettings.download.downlnoise[value]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.download.downlnoise, value, $$v)
        },
        expression: "getUnsavedLocalSettings.download.downlnoise[value]"
      }
    })], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-collapse-item', {
    class: _vm.getClass('weather'),
    attrs: {
      "title": _vm.$l('settings/download/Weather')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsWeather.valsel), function(item) {
    return (item.enabled) ? _c('el-col', {
      key: item.name,
      attrs: {
        "sm": 12,
        "lg": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": item.name
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getUnsavedLocalSettings.download.downlweath[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.download.downlweath, item.name, $$v)
        },
        expression: "getUnsavedLocalSettings.download.downlweath[item.name]"
      }
    })], 1)], 1) : _vm._e()
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/download/Global Values')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsSpecval.global), function(item) {
    return _c('el-col', {
      key: item,
      attrs: {
        "sm": 6,
        "lg": 4
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": item
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getUnsavedLocalSettings.download.downlGlobal[item]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.download.downlGlobal, item, $$v)
        },
        expression: "getUnsavedLocalSettings.download.downlGlobal[item]"
      }
    })], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[4]) ? _c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/download/Special values')
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "sm": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/Audio')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.getUnsavedLocalSettings.download.audio),
      callback: function($$v) {
        _vm.$set(_vm.getUnsavedLocalSettings.download, "audio", $$v)
      },
      expression: "getUnsavedLocalSettings.download.audio"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/Video')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.getUnsavedLocalSettings.download.video),
      callback: function($$v) {
        _vm.$set(_vm.getUnsavedLocalSettings.download, "video", $$v)
      },
      expression: "getUnsavedLocalSettings.download.video"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/Markers')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.getUnsavedLocalSettings.download.markers),
      callback: function($$v) {
        _vm.$set(_vm.getUnsavedLocalSettings.download, "markers", $$v)
      },
      expression: "getUnsavedLocalSettings.download.markers"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      login: _vm.$route.fullPath == '/login'
    },
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$p('measurement/measurement')) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "play-button-form"
  }, [_c('div', {
    staticClass: "play-button-header"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "play-button-label",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.$l('dashboard/measuringTgl')))]), _vm._v(" "), _c('el-col', {
    staticClass: "play-button-switch",
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onMeasuringChanged
    },
    model: {
      value: (_vm.measuringActive),
      callback: function($$v) {
        _vm.measuringActive = $$v
      },
      expression: "measuringActive"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "play-button-row"
  }, [_c('el-col', {
    staticClass: "play-button-label",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.$l('dashboard/noiseTgl')))]), _vm._v(" "), _c('el-col', {
    staticClass: "play-button-switch",
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getStatus.noiseError),
      expression: "!getStatus.noiseError"
    }],
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onNoiseChanged
    },
    model: {
      value: (_vm.noiseActive),
      callback: function($$v) {
        _vm.noiseActive = $$v
      },
      expression: "noiseActive"
    }
  }), _vm._v(" "), _c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getStatus.noiseError),
      expression: "getStatus.noiseError"
    }],
    attrs: {
      "on-color": "#e43a45",
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onNoiseChanged
    },
    model: {
      value: (_vm.noiseActive),
      callback: function($$v) {
        _vm.noiseActive = $$v
      },
      expression: "noiseActive"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "play-button-row"
  }, [_c('el-col', {
    staticClass: "play-button-label",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.$l('dashboard/weatherTgl')))]), _vm._v(" "), _c('el-col', {
    staticClass: "play-button-switch",
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getStatus.weatherError),
      expression: "!getStatus.weatherError"
    }],
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onWeatherChanged
    },
    model: {
      value: (_vm.weatherActive),
      callback: function($$v) {
        _vm.weatherActive = $$v
      },
      expression: "weatherActive"
    }
  }, [_vm._v("ja")]), _vm._v(" "), _c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getStatus.weatherError),
      expression: "getStatus.weatherError"
    }],
    attrs: {
      "on-color": "#e43a45",
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onWeatherChanged
    },
    model: {
      value: (_vm.weatherActive),
      callback: function($$v) {
        _vm.weatherActive = $$v
      },
      expression: "weatherActive"
    }
  }, [_vm._v("ne")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "play-button-row"
  }, [_c('el-col', {
    staticClass: "play-button-label",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.$l('dashboard/adioTgl')))]), _vm._v(" "), _c('el-col', {
    staticClass: "play-button-switch",
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getStatus.adioError),
      expression: "!getStatus.adioError"
    }],
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onAdioChanged
    },
    model: {
      value: (_vm.adioActive),
      callback: function($$v) {
        _vm.adioActive = $$v
      },
      expression: "adioActive"
    }
  }, [_vm._v("ja")]), _vm._v(" "), _c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getStatus.adioError),
      expression: "getStatus.adioError"
    }],
    attrs: {
      "on-color": "#e43a45",
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onAdioChanged
    },
    model: {
      value: (_vm.adioActive),
      callback: function($$v) {
        _vm.adioActive = $$v
      },
      expression: "adioActive"
    }
  }, [_vm._v("ne")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[6]),
      expression: "getScreenSize < 2 && !delayedLoading[6]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [_c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "New group",
      "visible": _vm.newGroup,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.newGroup = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/createGroupDialog')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.newGroup = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogCancel')) + " ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.newGroup = false;
        _vm.addGroup()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogConfirm')) + " ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/deleteGroupDialog')) + " " + _vm._s(_vm.deleteGroup.replace('gr', '')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogCancel')) + "  ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
        _vm.removeGroup(_vm.deleteGroup)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogConfirm')) + "  ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Tips",
      "visible": _vm.dialogVisible1,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible1 = $event
      }
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/deleteEmailDialog')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible1 = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogCancel')) + "  ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible1 = false, _vm.deleteRecipient(_vm.deleteRecipientGroup)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogConfirm')) + "  ")])], 1)]), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-form-item', {
    staticClass: "el-form-item-full"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.newGroup = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/createGroupButton')))])], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24,
      "md": 24,
      "sm": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/MSISDN-E-Mail')
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.selectedGroups),
      callback: function($$v) {
        _vm.selectedGroups = $$v
      },
      expression: "selectedGroups"
    }
  }, _vm._l((_vm.getSettingsAlertMessaging.groups), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": 'Group ' + item.replace('gr', ''),
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 10,
      "md": 9,
      "sm": 9
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/Add MSISDN')
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    model: {
      value: (_vm.selectedNumber),
      callback: function($$v) {
        _vm.selectedNumber = $$v
      },
      expression: "selectedNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 10,
      "md": 9,
      "sm": 9
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/Add E-mail')
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.selectedEmail),
      callback: function($$v) {
        _vm.selectedEmail = $$v
      },
      expression: "selectedEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 2,
      "md": 5,
      "sm": 5
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    staticClass: "AddEmailButton",
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "plus"
    },
    on: {
      "click": _vm.addRecipientClicked
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$l('settings/addButt')))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_vm._l((_vm.getSettingsAlertMessaging.groups), function(group, index) {
    return (_vm.getScreenSize > 1 || _vm.delayedLoading[4]) ? _c('el-collapse-item', {
      key: index,
      attrs: {
        "title": 'Group ' + (group.replace('gr', ''))
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "sm": 5,
        "md": 3
      }
    }, [_c('el-button', {
      staticClass: "buttons",
      attrs: {
        "title": _vm.$l('settings/alertMessaging/DeleteGroup'),
        "size": "mini",
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          _vm.dialogVisible = true;
          _vm.deleteGroup = group
        }
      }
    }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/DeleteGroup')) + " ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 3,
        "md": 3
      }
    }, [_c('el-button', {
      staticClass: "buttons",
      attrs: {
        "title": _vm.$l('settings/alertMessaging/TestEmail'),
        "size": "mini",
        "type": "success",
        "icon": "share"
      },
      on: {
        "click": function($event) {
          return _vm.sendTestMail(group)
        }
      }
    }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/TestEmail')))])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 19,
        "md": 19
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/DeleteRecip')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['del' + group.replace('gr', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging, 'del' + group.replace('gr', ''), $$v)
        },
        expression: "getSettingsAlertMessaging['del'+group.replace('gr','')]"
      }
    }, _vm._l((_vm.getSettingsAlertMessaging['recpg' + group.replace('gr', '')]), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 5,
        "md": 5,
        "sm": 5
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": " "
      }
    }, [_c('el-button', {
      staticClass: "DeleteEmailButton",
      attrs: {
        "size": "small",
        "type": "danger",
        "icon": "plus"
      },
      on: {
        "click": function($event) {
          _vm.dialogVisible1 = true;
          _vm.deleteRecipientGroup = group
        }
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/DeleteButton')))])])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Threshold day')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['threshday']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'threshday', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshday']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 0, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][0]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Threshold Night')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['threshnight']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'threshnight', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshnight']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][1]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 1, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][1]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Threshold Opt 1')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['threshopt1']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'threshopt1', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshopt1']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][2]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 2, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][2]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Threshold Opt 2')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['threshopt2']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'threshopt2', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshopt2']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][3]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 3, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][3]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Running Average Level')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['mav']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'mav', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['mav']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][4]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 4, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][4]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Weather trigger')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['weatTrig']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'weatTrig', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['weatTrig']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][5]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 5, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][5]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/System reboot')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['reboot']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'reboot', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['reboot']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Critical disk space')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['discerr']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'discerr', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['discerr']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Connection with meter lost')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['n140']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'n140', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['n140']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Critical memory on meter')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['n140sd']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'n140sd', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['n140sd']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Microphone check error')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['micerr']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'micerr', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['micerr']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/FTP server error')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['ftperr']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'ftperr', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['ftperr']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Battery mode')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['battmode']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'battmode', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['battmode']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Connection with Weather station lost')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['weather']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'weather', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['weather']"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "lg": 4
      }
    }, [_c('el-col', {
      attrs: {
        "lg": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/LEQ')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['leqday']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'leqday', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['leqday']"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 20
      }
    }, [(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['leqday']) ? _c('div', {
      staticClass: "LEQContainer"
    }, [_c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/resendAft')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][6]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 6, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][6]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_c('el-row', {
      attrs: {
        "type": "flex",
        "justify": "space-between",
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/preTrigg')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-checkbox', {
      model: {
        value: (_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')][0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')], 0, $$v)
        },
        expression: "getSettingsAlertMessaging['lqtg'+group.replace('gr','')][0]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "100%"
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['leqdg' + group.replace('gr', '')][0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['leqdg' + group.replace('gr', '')], 0, $$v)
        },
        expression: "getSettingsAlertMessaging['leqdg'+group.replace('gr','')][0]"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("-")])], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/Trigg')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-checkbox', {
      model: {
        value: (_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')][1]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')], 1, $$v)
        },
        expression: "getSettingsAlertMessaging['lqtg'+group.replace('gr','')][1]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": "",
        "value": _vm.getSettingsSpecval.leqdayval
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/postTrigg')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-checkbox', {
      model: {
        value: (_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')][2]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')], 2, $$v)
        },
        expression: "getSettingsAlertMessaging['lqtg'+group.replace('gr','')][2]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "100%"
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['leqdg' + group.replace('gr', '')][1]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['leqdg' + group.replace('gr', '')], 1, $$v)
        },
        expression: "getSettingsAlertMessaging['leqdg'+group.replace('gr','')][1]"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("+")])], 2)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()])], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[5]) ? _c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/alertMessaging/Inbound (MSISDN)')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24
    }
  }, [_c('div', {
    staticClass: "Container"
  }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/Status')) + " status")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24
    }
  }, [_c('div', {
    staticClass: "Container"
  }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/GPS')) + " gps")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24
    }
  }, [_c('div', {
    staticClass: "Container"
  }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/Threshold change')) + " threshold day/night/opt1/opt2 60 admin password")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/emailsett') && (_vm.getScreenSize > 1 || _vm.delayedLoading[6])) ? _c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/alertMessaging/Email settings')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [(_vm.$p('settings/alertMessaging/sender')) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/Sender Email')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.getSettingsAddons.email == '0'
    },
    model: {
      value: (_vm.getSettingsEmail.user),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsEmail, "user", $$v)
      },
      expression: "getSettingsEmail.user"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/password')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.email == '1'),
      expression: "getSettingsAddons.email == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsEmail.pwd),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsEmail, "pwd", $$v)
      },
      expression: "getSettingsEmail.pwd"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    slot: "append"
  }, [_c('icon', {
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/smtp')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.email == '1'),
      expression: "getSettingsAddons.email == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/SMTP server')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsEmail.smtp),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsEmail, "smtp", $$v)
      },
      expression: "getSettingsEmail.smtp"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/smtp')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.email == '1'),
      expression: "getSettingsAddons.email == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/SMTP port')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsEmail.port),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsEmail, "port", $$v)
      },
      expression: "getSettingsEmail.port"
    }
  })], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[7]),
      expression: "getScreenSize < 2 && !delayedLoading[7]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [(_vm.$p('settings/FTPSending/address') && (_vm.getScreenSize > 1 || _vm.delayedLoading[1])) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/FTP Address')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.getSettingsAddons.ftp == '0'
    },
    model: {
      value: (_vm.getSettingsFTPSending.address),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "address", $$v)
      },
      expression: "getSettingsFTPSending.address"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/refresh') && (_vm.getScreenSize > 1 || _vm.delayedLoading[2])) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Refresh Rate')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons.ftp == '0',
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsFTPSending.refresh),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "refresh", $$v)
      },
      expression: "getSettingsFTPSending.refresh"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/FTPSending/Disable'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/FTPSending/sec'),
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '5 ' + _vm.$l('settings/FTPSending/sec'),
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/FTPSending/min'),
      "value": "60"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '5 ' + _vm.$l('settings/FTPSending/min'),
      "value": "300"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '10 ' + _vm.$l('settings/FTPSending/min'),
      "value": "600"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '15 ' + _vm.$l('settings/FTPSending/min'),
      "value": "900"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/FTPSending/hour'),
      "value": "3600"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/username') && (_vm.getScreenSize > 1 || _vm.delayedLoading[3])) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.ftp == '1'),
      expression: "getSettingsAddons.ftp == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsFTPSending.user),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "user", $$v)
      },
      expression: "getSettingsFTPSending.user"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/password') && (_vm.getScreenSize > 1 || _vm.delayedLoading[4])) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.ftp == '1'),
      expression: "getSettingsAddons.ftp == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsFTPSending.password),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "password", $$v)
      },
      expression: "getSettingsFTPSending.password"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    slot: "append"
  }, [_c('icon', {
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/port') && (_vm.getScreenSize > 1 || _vm.delayedLoading[5])) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.ftp == '1'),
      expression: "getSettingsAddons.ftp == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Port')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsFTPSending.port),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "port", $$v)
      },
      expression: "getSettingsFTPSending.port"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/port') && (_vm.getScreenSize > 1 || _vm.delayedLoading[6])) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.ftp == '1'),
      expression: "getSettingsAddons.ftp == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    staticClass: "test-button",
    attrs: {
      "loading": _vm.testButtonLoading,
      "type": "primary"
    },
    on: {
      "click": _vm.testButtonClicked
    }
  }, [_vm._v("Test")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col'), _vm._v(" "), (_vm.$p('settings/FTPSending/zipped') && (_vm.getScreenSize > 1 || _vm.delayedLoading[7])) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.ftp == '1'),
      expression: "getSettingsAddons.ftp == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/Compression')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsFTPSending.zip),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "zip", $$v)
      },
      expression: "getSettingsFTPSending.zip"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/download/No compression'),
      "value": '0'
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/download/Zip compression'),
      "value": '1'
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$p('settings/FTPSending/values') && (_vm.getScreenSize > 1 || _vm.delayedLoading[7])) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/FTPSending/Values')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsFTPSending.valsel), function(item) {
    return _c('el-col', {
      key: item.name,
      attrs: {
        "md": 12,
        "lg": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/FTPSending/' + item.name)
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (item.enabled),
        callback: function($$v) {
          _vm.$set(item, "enabled", $$v)
        },
        expression: "item.enabled"
      }
    })], 1)], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className,
    on: {
      "click": _vm.onHourClick
    }
  }, [_vm._v(" \n  " + _vm._s(_vm.value) + "\n  "), _c('div', {
    staticClass: "dots"
  }, [(_vm.hasAdio) ? _c('div', {
    staticClass: "has-adio-h"
  }) : _vm._e(), _vm._v(" "), (_vm.hasVideo) ? _c('div', {
    staticClass: "has-video-h"
  }) : _vm._e(), _vm._v(" "), (_vm.hasWeather) ? _c('div', {
    staticClass: "has-weather-h"
  }) : _vm._e(), _vm._v(" "), (_vm.hasAudio) ? _c('div', {
    staticClass: "has-audio-h"
  }) : _vm._e(), _vm._v(" "), (_vm.hasNoise) ? _c('div', {
    staticClass: "has-noise-h"
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "span": "24"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Present')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsVideo.present),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "present", $$v)
      },
      expression: "getSettingsVideo.present"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/video/No device'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/video/Video camera'),
      "value": "1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Manual')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsVideo.manualrec),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "manualrec", $$v)
      },
      expression: "getSettingsVideo.manualrec"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Triggering')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsVideo.audiotrig),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "audiotrig", $$v)
      },
      expression: "getSettingsVideo.audiotrig"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Moving detection')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsVideo.movdetect),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "movdetect", $$v)
      },
      expression: "getSettingsVideo.movdetect"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/video/Settings')
    }
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Pre')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsVideo.pretime),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "pretime", $$v)
      },
      expression: "getSettingsVideo.pretime"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "no pre-record"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "5s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "10s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "15s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "4",
      "label": "20s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "5",
      "label": "25s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "6",
      "label": "30s"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Post')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsVideo.posttime),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "posttime", $$v)
      },
      expression: "getSettingsVideo.posttime"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "no post-record"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "10s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "30s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "1min"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "4",
      "label": "2min "
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "5",
      "label": "5min"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "6",
      "label": "10min"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Format SD",
      "visible": _vm.formatSDdialog,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.formatSDdialog = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$l('settings/device/formatSDdialog')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.formatSDdialog = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogCancel')) + " ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.formatSDdialog = false, _vm.formatSD()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogContinue')) + " ")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.formatSDLoading,
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.formatSDdialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/Format')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.setDeviceLoading,
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.setDevice()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/video/SetDevice')))])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.$l('streamPopover/title')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [(_vm.$p('streamPopover/audio')) ? _c('div', {
    staticClass: "option",
    on: {
      "click": _vm.audioClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('streamPopover/Audio')))]) : _vm._e(), _vm._v(" "), (_vm.url) ? _c('div', {
    staticClass: "audio-iframe"
  }, [_c('el-row', {
    staticClass: "audio-buttons",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "audio-button",
    attrs: {
      "disabled": !_vm.audioPlaying,
      "size": "small"
    },
    on: {
      "click": _vm.audioRecordingClicked
    }
  }, [_vm._v(_vm._s(_vm.$l(_vm.recordingButtonText)))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "audio-button",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.stopAudioStreamClicked
    }
  }, [_vm._v(_vm._s(_vm.$l(_vm.streamButtonText)))])], 1)], 1), _vm._v(" "), (_vm.audioPlaying) ? _c('audio', {
    ref: "audioController",
    staticClass: "audio-controller",
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.url
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$p('streamPopover/video') && _vm.getSettingsAddons.video == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('video'),
    on: {
      "click": _vm.videoClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('streamPopover/Video')))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$l('download/title')))]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option",
    on: {
      "click": _vm.xmlClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('download/popOver/XML')))]), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": _vm.xmlWeeklyClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('download/popOver/XMLWeekly')))]), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": _vm.rawClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('download/popOver/Raw')))]), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": _vm.globalClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('download/popOver/Global')))]), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": _vm.weathClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('download/popOver/weather')))])])])
},staticRenderFns: []}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$l('archives/audioPopOver/downlRec') + ' - ' + _vm.data.name,
      "visible": _vm.data.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.data, "visible", $event)
      }
    }
  }, [_c('el-form', [_c('el-row', [_c('el-col', {
    staticClass: "range-title",
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$l('archives/audioPopOver/range')) + "\n            ")]), _vm._v(" "), _c('el-col', {
    staticClass: "range-value",
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                0 s\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-slider', {
    attrs: {
      "range": "",
      "show-stops": "",
      "max": _vm.data.length
    },
    model: {
      value: (_vm.data.selection),
      callback: function($$v) {
        _vm.$set(_vm.data, "selection", $$v)
      },
      expression: "data.selection"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "range-value",
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                " + _vm._s(_vm.data.length) + " s\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Download')) + "  ")]), _vm._v(" "), _c('el-button', {
    staticClass: "close-button",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.data.visible = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Close')) + "  ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenSize > 1 && _vm.sidebarVisible),
      expression: "screenSize > 1 && sidebarVisible"
    }],
    staticClass: "sidebar",
    class: _vm.isDownloading ? 'sidebar-downloading' : ''
  }, [_c('div', {
    staticClass: "sidebar-calendar"
  }, [_c('calendar', {
    attrs: {
      "screenSize": _vm.screenSize,
      "current": _vm.current,
      "selectedDay": _vm.selectedDay
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sidebar-info"
  }, [_c('div', {
    staticClass: "sidebar-info-value"
  }, [_vm._v("\n                " + _vm._s(_vm.$l('main/titleSD'))), _c('span', {
    class: {
      red: _vm.isSizeBelowLimit
    }
  }, [_vm._v(" " + _vm._s(_vm.roundDecimal) + "% ")]), _vm._v(" (" + _vm._s(_vm.$l('settings/status/of')) + " 2 Gb)\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-status-value"
  }, [_vm._v("\n                " + _vm._s(_vm.$l('main/status')) + ": " + _vm._s(_vm.$l('main/' + _vm.statusSidebar)) + "\n            ")])])]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenSize < 2 && _vm.sidebarVisible),
      expression: "screenSize < 2 && sidebarVisible"
    }],
    staticClass: "sidebar-top-container"
  }, [_c('div', {
    staticClass: "sidebar-top"
  }, [_c('div', {
    staticClass: "sidebar-top-calendar"
  }, [_c('calendar', {
    attrs: {
      "small": true,
      "screenSize": _vm.screenSize,
      "current": _vm.current,
      "selectedDay": _vm.selectedDay
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sidebar-top-info"
  }, [_c('div', {
    staticClass: "sidebar-info-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.$l('main/titleSD'))), _c('span', {
    class: {
      red: _vm.isSizeBelowLimit
    }
  }, [_vm._v(" " + _vm._s(_vm.roundDecimal) + "% ")]), _vm._v(" (" + _vm._s(_vm.$l('settings/status/of')) + " 2 Gb)\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-status-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.$l('main/status')) + ": " + _vm._s(_vm.$l('main/' + _vm.statusSidebar)) + "\n                    ")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
    return _c('path', _vm._b({
      key: ("path-" + i)
    }, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
    return _c('polygon', _vm._b({
      key: ("polygon-" + i)
    }, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "calendar-container"
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 24,
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "calendar-top"
  }, [_c('el-popover', {
    ref: "info-button-popover",
    attrs: {
      "popper-class": "info-popover",
      "placement": "bottom",
      "trigger": "click"
    }
  }, [_c('calendar-legend-popover')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:info-button-popover",
      arg: "info-button-popover"
    }],
    staticClass: "info-button el-icon-information"
  }), _vm._v(" "), _c('div', {
    staticClass: "calendar-navigation calendar-year-left",
    on: {
      "click": _vm.previousYear
    }
  }, [_c('i', {
    staticClass: "el-icon-d-arrow-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calendar-navigation calendar-month-left",
    on: {
      "click": _vm.previousMonth
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calendar-date-top"
  }, [_vm._v(_vm._s(_vm.current.year) + " " + _vm._s(_vm.currentMonthName))]), _vm._v(" "), _c('div', {
    staticClass: "calendar-navigation calendar-month-right",
    on: {
      "click": _vm.nextMonth
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calendar-navigation calendar-year-right",
    on: {
      "click": _vm.nextYear
    }
  }, [_c('i', {
    staticClass: "el-icon-d-arrow-right"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "calendar-main"
  }, _vm._l((6), function(y) {
    return _c('div', {
      key: y,
      staticClass: "calendar-item-row"
    }, _vm._l((7), function(x) {
      return _c('calendar-day', {
        key: x,
        attrs: {
          "date": _vm.getDate(y, x),
          "current": _vm.current
        }
      })
    }), 1)
  }), 0)]), _vm._v(" "), _c('el-col', {
    class: _vm.calendarHoursContainerClass,
    attrs: {
      "sm": 12,
      "md": 24,
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "calendar-hours"
  }, [_c('el-row', _vm._l((_vm.getSelectedDayHours.values), function(hour) {
    return _c('el-col', {
      key: hour,
      attrs: {
        "sm": 11,
        "md": 24
      }
    }, [_c('calendar-hour', {
      attrs: {
        "hour": hour
      }
    })], 1)
  }), 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidden && !_vm.disabled),
      expression: "!hidden && !disabled"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph-container"
  }, [_c('div', {
    staticClass: "graph-title"
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n                "), _c('div', {
    staticClass: "graph-title-buttons"
  }, [_c('div', {
    staticClass: "graph-title-button",
    class: {
      'graph-title-button-active': _vm.isPreloading
    },
    staticStyle: {
      "font-size": "17px"
    },
    attrs: {
      "title": _vm.$l('graphs/preload')
    },
    on: {
      "click": _vm.onPreloadClicked
    }
  }, [_c('icon', {
    attrs: {
      "name": "hourglass-half"
    }
  })], 1), _vm._v(" "), (_vm.isReset) ? _c('div', {
    staticClass: "graph-title-button",
    attrs: {
      "title": _vm.$l('graphs/reset')
    },
    on: {
      "click": _vm.onResetClicked
    }
  }, [_c('i', {
    staticClass: "icon-sync"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.graphType != 'spect' && _vm.config.graphType != 'statistics'),
      expression: "config.graphType != 'spect' && config.graphType != 'statistics'"
    }],
    staticClass: "graph-title-button",
    attrs: {
      "title": _vm.$l('graphs/sync')
    },
    on: {
      "click": _vm.onSyncClicked
    }
  }, [_c('img', {
    staticClass: "weather-sync",
    class: {
      'button-active-bg': _vm.sync
    },
    attrs: {
      "src": __webpack_require__(390)
    }
  })]), _vm._v(" "), _c('el-popover', {
    ref: "export-noise-popover",
    attrs: {
      "placement": "bottom",
      "trigger": "click"
    }
  }, [_c('export-graph', {
    attrs: {
      "chart": _vm.$refs.chart
    }
  })], 1), _vm._v(" "), (_vm.$p('graphsexport')) ? _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:export-noise-popover",
      arg: "export-noise-popover"
    }],
    staticClass: "graph-title-button picture-image",
    attrs: {
      "title": _vm.$l('graphs/exportGraph')
    }
  }, [_c('i', {
    staticClass: "el-icon-picture"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "graph-title-button",
    attrs: {
      "title": _vm.$l('graphs/hideShow')
    },
    on: {
      "click": _vm.onHideGraphClicked
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    staticClass: "el-icon-arrow-down"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isVisible),
      expression: "!isVisible"
    }],
    staticClass: "el-icon-arrow-right"
  })])], 1), _vm._v(" "), (_vm.config.graphType == 'statistics') ? _c('div', {
    staticClass: "statistics-top"
  }, [_c('div', {
    staticClass: "download-top-bar"
  }, [_c('el-form', {
    staticClass: "inline-form-statistics",
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_c('div', {
    on: {
      "click": _vm.statDayDownloadClicked
    }
  }, [_c('el-button', {
    staticClass: "stat-form-item-button",
    attrs: {
      "size": "small"
    }
  }, [_c('icon', {
    staticClass: "download-stat-icon",
    attrs: {
      "name": "file-word-o"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-form-container"
  }, [_c('el-form', {
    staticClass: "inline-form-statistics",
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": _vm.$l('graphs/statTitle')
    },
    model: {
      value: (_vm.statform.title),
      callback: function($$v) {
        _vm.$set(_vm.statform, "title", $$v)
      },
      expression: "statform.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "picker-options": {
        firstDayOfWeek: 1
      },
      "size": "small",
      "type": "date",
      "placeholder": _vm.$l('graphs/statFrom')
    },
    model: {
      value: (_vm.statform.from),
      callback: function($$v) {
        _vm.$set(_vm.statform, "from", $$v)
      },
      expression: "statform.from"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "picker-options": {
        firstDayOfWeek: 1
      },
      "size": "small",
      "type": "date",
      "placeholder": _vm.$l('graphs/statTo')
    },
    model: {
      value: (_vm.statform.to),
      callback: function($$v) {
        _vm.$set(_vm.statform, "to", $$v)
      },
      expression: "statform.to"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_vm._v("\n                                    " + _vm._s(_vm.selectedStatisticsTemplate) + "\n                                ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_c('div', {
    on: {
      "click": _vm.stateRangeDownloadClicked
    }
  }, [_c('el-button', {
    staticClass: "stat-form-item-button",
    attrs: {
      "size": "small"
    }
  }, [_c('icon', {
    staticClass: "download-stat-icon",
    attrs: {
      "name": "download"
    }
  })], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "top-barier"
  })]) : _vm._e()]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.zoomLoading),
      expression: "zoomLoading"
    }],
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.isVisible && _vm.delayedLoading) ? _c('div', {
    staticClass: "delay-loading-container"
  }, [_c('div', {
    staticClass: "delay-loading-text",
    on: {
      "click": _vm.onDelayLoadingClick
    }
  }, [_vm._v(_vm._s(_vm.$l('graphs/load')))])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "real-time-seperator",
    class: {
      'hide-realtime': !_vm.realtimeActive || _vm.config.graphType == 'spect'
    },
    attrs: {
      "lg": 4
    }
  }, [_c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    staticClass: "graph-body real-time-container"
  }, [_c('el-row', _vm._l((_vm.latestDataRealtime), function(value, i) {
    return _c('el-col', {
      key: value.name,
      attrs: {
        "lg": 24,
        "sm": (i != 0) ? 8 : 24
      }
    }, [(i == 0) ? _c('div', {
      staticClass: "real-time-date"
    }, [_vm._v("\n                                        " + _vm._s(new Date(parseInt(value.data)).toISOString().slice(0, 10)) + " " + _vm._s(new Date(parseInt(value.data)).toISOString().slice(11, 19)) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (i > 0 && value.data != 'null') ? _c('div', {
      staticClass: "real-time-data"
    }, [_c('div', {
      staticClass: "real-time-data"
    }, [_c('span', {
      staticClass: "real-time-data-title"
    }, [_vm._v(_vm._s(value.name) + ": ")]), _vm._v(_vm._s(value.data) + "\n                                        ")])]) : _vm._e()])
  }), 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": (!_vm.realtimeActive || _vm.config.graphType == 'spect') ? 24 : 20
    }
  }, [_c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    staticClass: "graph-body"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "graph-error-message"
  }, [_c('div', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.$l(_vm.errorMessage)))])]) : _vm._e(), _vm._v(" "), (_vm.noData) ? _c('div', {
    staticClass: "graph-error-message"
  }, [_c('div', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.$l(_vm.noData)))])]) : _vm._e(), _vm._v(" "), _c('highcharts', {
    ref: "chart",
    staticClass: "graph",
    attrs: {
      "options": _vm.graphOptions
    }
  }), _vm._v(" "), (_vm.config.graphType == 'noise' && _vm.getSettingsAddons.markers == '1') ? _c('el-popover', {
    attrs: {
      "placement": "right",
      "value": _vm.markersData.visible,
      "trigger": "manual"
    }
  }, [_c('div', {
    staticClass: "markers-button",
    attrs: {
      "slot": "reference",
      "title": _vm.$l('graphs/markers')
    },
    on: {
      "click": function($event) {
        _vm.markersData.visible = !_vm.markersData.visible
      }
    },
    slot: "reference"
  }, [_c('icon', {
    attrs: {
      "name": "thumb-tack"
    }
  })], 1), _vm._v(" "), _c('markers-popover', {
    attrs: {
      "data": _vm.markersData
    },
    on: {
      "markerClicked": _vm.markerClicked
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.config.graphType == 'noise' && !_vm.realtimeActive && _vm.getSettingsAddons.markers == '1') ? _c('el-popover', {
    attrs: {
      "placement": "right",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "notes-button",
    attrs: {
      "slot": "reference",
      "title": _vm.$l('graphs/dailyNotes')
    },
    slot: "reference"
  }, [_c('icon', {
    attrs: {
      "name": "sticky-note"
    }
  })], 1), _vm._v(" "), _c('graph-notes', {
    attrs: {
      "data": _vm.notesData
    },
    on: {
      "saveClick": _vm.saveDailyNoteClicked
    }
  })], 1) : _vm._e()], 1)])], 1)], 1)], 1)]), _vm._v(" "), (_vm.config.graphType == 'noise' && _vm.graphMarkers.length > 0) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph-container markers-container"
  }, [_c('el-table', {
    staticClass: "markers-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": false,
      "data": _vm.graphMarkers
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$l('graphs/markersTable/name')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "marker-color-table",
          style: ({
            backgroundColor: scope.row.color
          })
        }), _vm._v("\n                            " + _vm._s(scope.row.name) + "\n                        ")]
      }
    }], null, false, 1890515269)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$l('graphs/markersTable/startTime')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\n                            " + _vm._s(new Date(scope.row.from).toLocaleString('de-AT', {
          timeZone: 'UTC'
        })) + "\n                        ")]
      }
    }], null, false, 465119353)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$l('graphs/markersTable/endTime')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\n                            " + _vm._s(new Date(scope.row.to).toLocaleString('de-AT', {
          timeZone: 'UTC'
        })) + "\n                        ")]
      }
    }], null, false, 958750644)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$l('graphs/markersTable/type')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\n                            " + _vm._s(scope.row.type ? _vm.$l('graphs/markersCat/toggle') : _vm.$l('graphs/markersCat/single')) + "\n                        ")]
      }
    }], null, false, 2717576922)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "left",
            "width": "400",
            "trigger": "click"
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text",
            "size": "mini"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/note')))]), _vm._v(" "), _c('el-input', {
          attrs: {
            "type": "textarea",
            "rows": 4
          },
          model: {
            value: (scope.row.note),
            callback: function($$v) {
              _vm.$set(scope.row, "note", $$v)
            },
            expression: "scope.row.note"
          }
        }), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-top": "10px",
            "width": "100%"
          },
          attrs: {
            "type": "success",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.saveMarkerNoteClicked(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/save')))])], 1), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "type": "danger",
            "icon": "delete",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.removeMarker(scope.row.id)
            }
          }
        })]
      }
    }], null, false, 1947296161)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "hourly-notes"
  }, [(_vm.config.graphType == 'noise' && !_vm.realtimeActive && _vm.getSelectedHour != '') ? _c('el-popover', {
    attrs: {
      "placement": "right",
      "trigger": "click"
    }
  }, [_c('el-button', {
    staticClass: "notes-hour-button",
    attrs: {
      "slot": "reference",
      "type": "text",
      "size": "mini"
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/note')))]), _vm._v(" "), _c('graph-notes', {
    attrs: {
      "data": _vm.notesHourlyData
    },
    on: {
      "saveClick": _vm.saveNoteClicked
    }
  })], 1) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.savedAudios.length > 0) ? _c('play-audio-dialog', {
    attrs: {
      "data": _vm.playAudioDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', [_c('div', {
    staticClass: "title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.getTitle(_vm.type)))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "buttonContainer"
  }, [_c('el-row', {
    attrs: {
      "justify": "end",
      "type": "flex",
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 3,
      "md": 4,
      "sm": 5,
      "xs": 24
    }
  }, [_c('el-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.Delete()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Delete')) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 3,
      "md": 4,
      "sm": 5,
      "xs": 24
    }
  }, [_c('el-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.Download()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Download')) + " ")])], 1)], 1)], 1), _vm._v(" "), (!_vm.isHours) ? _c('div', {
    staticClass: "containerArchive"
  }, [_c('el-row', {
    staticClass: "firstRow",
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    staticStyle: {
      "position": "absolute"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAllDays),
      callback: function($$v) {
        _vm.checkAllDays = $$v
      },
      expression: "checkAllDays"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 4,
      "md": 3,
      "lg": 2
    }
  }, [_vm._v("   ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Filename')) + " "), _c('div', {
    staticClass: "filter-icon",
    on: {
      "click": _vm.sortDaysByName
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checkedDays),
      callback: function($$v) {
        _vm.checkedDays = $$v
      },
      expression: "checkedDays"
    }
  }, _vm._l((_vm.days), function(day, index) {
    return _c('el-row', {
      key: index,
      staticClass: "dayRow",
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "xs": 6,
        "sm": 4,
        "md": 3,
        "lg": 2
      }
    }, [_c('el-checkbox', {
      key: index,
      staticClass: "checkbox-label",
      attrs: {
        "label": day
      }
    })], 1), _vm._v(" "), (!_vm.isGlobalValues && !_vm.isCompressed) ? _c('el-col', {
      attrs: {
        "xs": 9,
        "sm": 7,
        "md": 6,
        "lg": 6
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.goTo(day)
        }
      }
    }, [_vm._v(" " + _vm._s(day) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.isGlobalValues || _vm.isCompressed) ? _c('el-col', {
      attrs: {
        "xs": 9,
        "sm": 7,
        "md": 6,
        "lg": 6
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.downloadHour(day)
        }
      }
    }, [_vm._v(" " + _vm._s(day) + " ")])]) : _vm._e()], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isHours) ? _c('div', {
    staticClass: "containerArchive"
  }, [(_vm.isHours && (_vm.isAudio || _vm.isVideo)) ? _c('el-row', {
    staticClass: "firstRow",
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    staticStyle: {
      "position": "absolute",
      "width": "20px"
    }
  }, [_c('el-checkbox', {
    staticClass: "checkbox-label",
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAllHours),
      callback: function($$v) {
        _vm.checkAllHours = $$v
      },
      expression: "checkAllHours"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "25px",
      "position": "absolute",
      "width": "20px"
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-left go-parent",
    on: {
      "click": _vm.goParentClicked
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 3,
      "md": 4,
      "lg": 3,
      "offset": 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Thumbnail')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 9,
      "sm": 8,
      "md": 8,
      "lg": 7
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Filename')) + " "), _c('div', {
    staticClass: "filter-icon",
    on: {
      "click": _vm.sortHoursByName
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 3,
      "md": 3,
      "lg": 3
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Size')) + " "), _c('div', {
    staticClass: "filter-icon",
    on: {
      "click": _vm.sortHoursBySize
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down"
    }
  })], 1)]), _vm._v(" "), (_vm.isVideo && false) ? _c('el-col', {
    attrs: {
      "xs": 2,
      "sm": 6,
      "md": 6,
      "lg": 6
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Duration')) + " "), _c('div', {
    staticClass: "filter-icon",
    on: {
      "click": _vm.sortHoursByDuration
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down"
    }
  })], 1)]) : _vm._e()], 1) : _c('el-row', {
    staticClass: "firstRow",
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    staticStyle: {
      "position": "absolute",
      "width": "20px"
    }
  }, [_c('el-checkbox', {
    staticClass: "checkbox-label",
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAllHours),
      callback: function($$v) {
        _vm.checkAllHours = $$v
      },
      expression: "checkAllHours"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "25px",
      "position": "absolute",
      "width": "20px"
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-left go-parent",
    on: {
      "click": _vm.goParentClicked
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 8,
      "lg": 6,
      "offset": 3
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Filename')) + " "), _c('div', {
    staticClass: "filter-icon",
    on: {
      "click": _vm.sortHoursByName
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 4,
      "md": 4,
      "lg": 3
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Size')) + " "), _c('div', {
    staticClass: "filter-icon",
    on: {
      "click": _vm.sortHoursBySize
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.isHours && (_vm.isAudio || _vm.isVideo)) ? _c('el-checkbox-group', {
    model: {
      value: (_vm.checkedHours),
      callback: function($$v) {
        _vm.checkedHours = $$v
      },
      expression: "checkedHours"
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$l('archives/Thumbnail'),
      "visible": _vm.thumbnailVisible,
      "size": "auto"
    },
    on: {
      "update:visible": function($event) {
        _vm.thumbnailVisible = $event
      }
    }
  }, [_c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('img', {
    attrs: {
      "src": this.Image
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.thumbnailVisible = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('archives/Close')) + "  ")])], 1)]), _vm._v(" "), _c('audio-download-dialog', {
    attrs: {
      "data": _vm.audioDownloadDialog
    }
  }), _vm._v(" "), _vm._l((_vm.filterHours), function(hour, index) {
    return _c('el-row', {
      key: index,
      staticClass: "dayRow",
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "xs": 2,
        "sm": 2,
        "md": 2,
        "lg": 2
      }
    }, [_c('el-checkbox', {
      key: index,
      staticClass: "checkbox-label",
      attrs: {
        "label": hour[0]
      }
    })], 1), _vm._v(" "), (_vm.isAudio) ? _c('el-col', {
      attrs: {
        "xs": 3,
        "sm": 3,
        "md": 4,
        "lg": 3
      }
    }, [_c('img', {
      staticClass: "thumbnails",
      attrs: {
        "src": '/audio/audio/' + _vm.day + '/thumbnails/' + _vm.fileNameToPng(hour[0])
      },
      on: {
        "click": function($event) {
          _vm.thumbnailVisible = true, _vm.setImageAudio(_vm.day, hour[0])
        }
      }
    }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (_vm.isVideo) ? _c('el-col', {
      attrs: {
        "xs": 3,
        "sm": 3,
        "md": 4,
        "lg": 3
      }
    }, [_c('img', {
      staticClass: "thumbnails",
      attrs: {
        "src": '/video/video/' + _vm.day + '/thumbnails/' + _vm.fileNameToPng(hour[0])
      },
      on: {
        "click": function($event) {
          _vm.thumbnailVisible = true, _vm.setImageVideo(_vm.day, hour[0])
        }
      }
    }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (_vm.isAudio) ? _c('el-col', {
      attrs: {
        "xs": 15,
        "sm": 8,
        "md": 8,
        "lg": 7
      }
    }, [_c('div', {
      staticClass: "text",
      on: {
        "click": function($event) {
          return _vm.openDownloadAudioDialog(hour)
        }
      }
    }, [_vm._v(" " + _vm._s(hour[0]) + " "), _c('icon', {
      attrs: {
        "name": "download"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isVideo) ? _c('el-col', {
      attrs: {
        "xs": 15,
        "sm": 8,
        "md": 8,
        "lg": 7
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.downloadHour(hour)
        }
      }
    }, [_vm._v(" " + _vm._s(hour[0]) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.isAudio) ? _c('el-col', {
      attrs: {
        "xs": 2,
        "sm": 3,
        "md": 4,
        "lg": 3
      }
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v(" " + _vm._s(hour[1]) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.isVideo) ? _c('el-col', {
      attrs: {
        "xs": 2,
        "sm": 3,
        "md": 4,
        "lg": 3
      }
    }, [_c('div', [_vm._v(" " + _vm._s(hour[1]) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.isVideo) ? _c('el-col', {
      attrs: {
        "xs": 2,
        "sm": 6,
        "md": 6,
        "lg": 6
      }
    }, [_c('div')]) : _vm._e(), _vm._v(" "), (_vm.isAudio) ? _c('el-col', {
      attrs: {
        "xs": 24,
        "sm": 8,
        "md": 6,
        "lg": 9
      }
    }, [_c('audio-player', {
      attrs: {
        "src": '/audio/audio/' + _vm.day + '/' + hour[0]
      }
    })], 1) : _vm._e()], 1)
  })], 2) : _c('el-checkbox-group', {
    model: {
      value: (_vm.checkedHours),
      callback: function($$v) {
        _vm.checkedHours = $$v
      },
      expression: "checkedHours"
    }
  }, _vm._l((_vm.filterHours), function(hour, index) {
    return _c('el-row', {
      key: index,
      staticClass: "dayRow",
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "xs": 2,
        "sm": 2,
        "md": 2,
        "lg": 2
      }
    }, [_c('el-checkbox', {
      key: index,
      staticClass: "checkbox-label",
      attrs: {
        "label": hour[0]
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "xs": 15,
        "sm": 8,
        "md": 8,
        "lg": 6
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.downloadHour(hour)
        }
      }
    }, [_vm._v(" " + _vm._s(hour[0]) + " ")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "xs": 4,
        "sm": 4,
        "md": 4,
        "lg": 3
      }
    }, [_c('div', [_vm._v(" " + _vm._s(hour[1]) + " ")])])], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-bar"
  }, [(_vm.hours.length > 24) ? _c('el-button-group', [_c('el-button', {
    attrs: {
      "disabled": _vm.hoursOffset == 0,
      "size": "small",
      "type": "primary",
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.paginationBackClicked
    }
  }, [_vm._v("BACK")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.filterHours.length < 24,
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.paginationNextClicked
    }
  }, [_vm._v("NEXT "), _c('i', {
    staticClass: "el-icon-arrow-right el-icon-right"
  })])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "span": "24"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/Present')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAdio.present),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "present", $$v)
      },
      expression: "getSettingsAdio.present"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/adio/NoDevice'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/adio/ADIO'),
      "value": "1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/DigitalOut') + ' 0'
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.DO1),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "DO1", $$v)
      },
      expression: "getSettingsAdio.DO1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/DigitalIn') + ' 0'
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.DI1),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "DI1", $$v)
      },
      expression: "getSettingsAdio.DI1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/DigitalOut') + ' 1'
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.DO2),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "DO2", $$v)
      },
      expression: "getSettingsAdio.DO2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/DigitalIn') + ' 1'
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.DI2),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "DI2", $$v)
      },
      expression: "getSettingsAdio.DI2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogIn')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.AI),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AI", $$v)
      },
      expression: "getSettingsAdio.AI"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogOut')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.AO),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AO", $$v)
      },
      expression: "getSettingsAdio.AO"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogLowerLimit')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAdio.AI == 0
    },
    model: {
      value: (_vm.getSettingsAdio.AILower),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AILower", $$v)
      },
      expression: "getSettingsAdio.AILower"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogUpperLimit')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAdio.AI == 0
    },
    model: {
      value: (_vm.getSettingsAdio.AIUpp),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AIUpp", $$v)
      },
      expression: "getSettingsAdio.AIUpp"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogLowerLimit')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": -10,
      "max": 140,
      "disabled": _vm.getSettingsAdio.AO == 0
    },
    model: {
      value: (_vm.getSettingsAdio.AOLower),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AOLower", $$v)
      },
      expression: "getSettingsAdio.AOLower"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogUpperLimit')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": -10,
      "max": 140,
      "disabled": _vm.getSettingsAdio.AO == 0
    },
    model: {
      value: (_vm.getSettingsAdio.AOUpp),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AOUpp", $$v)
      },
      expression: "getSettingsAdio.AOUpp"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[10]),
      expression: "getScreenSize < 2 && !delayedLoading[10]"
    }],
    attrs: {
      "span": "24",
      "element-loading-text": "Loading..."
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[0]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Realtime display')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:00 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsInterface.rtvaluesPicker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "rtvaluesPicker", $$v)
      },
      expression: "getSettingsInterface.rtvaluesPicker"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    model: {
      value: (_vm.getSettingsInterface.rtvalues),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "rtvalues", $$v)
      },
      expression: "getSettingsInterface.rtvalues"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Language')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsInterface.language),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "language", $$v)
      },
      expression: "getSettingsInterface.language"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/english'),
      "value": "en"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/austria'),
      "value": "at"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/german'),
      "value": "de"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/french'),
      "value": "fr"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/slovensko'),
      "value": "sl"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Lt')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons['noise'] == 0,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsInterface.RangNOtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "RangNOtype", $$v)
      },
      expression: "getSettingsInterface.RangNOtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Manual'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Dynamic'),
      "value": "1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Manual')
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangNOtype == 1 || _vm.getSettingsAddons['noise'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangNO[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangNO, 0, $$v)
      },
      expression: "getSettingsInterface.RangNO[0]"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangNOtype == 1 || _vm.getSettingsAddons['noise'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangNO[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangNO, 1, $$v)
      },
      expression: "getSettingsInterface.RangNO[1]"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[4]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Spectrum'),
      "placeholder": _vm.$l('common/select')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons['noise'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangSPtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "RangSPtype", $$v)
      },
      expression: "getSettingsInterface.RangSPtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Manual'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Dynamic'),
      "value": "1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[5]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Manual')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangSPtype == 1 || _vm.getSettingsAddons['noise'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangSP[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangSP, 0, $$v)
      },
      expression: "getSettingsInterface.RangSP[0]"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangSPtype == 1 || _vm.getSettingsAddons['noise'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangSP[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangSP, 1, $$v)
      },
      expression: "getSettingsInterface.RangSP[1]"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[6]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Weather')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons['weather'] == 0,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsInterface.RangWEtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "RangWEtype", $$v)
      },
      expression: "getSettingsInterface.RangWEtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Manual'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Dynamic'),
      "value": "1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[7]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Manual')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangWEtype == 1 || _vm.getSettingsAddons['weather'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangWE[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangWE, 0, $$v)
      },
      expression: "getSettingsInterface.RangWE[0]"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangWEtype == 1 || _vm.getSettingsAddons['weather'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangWE[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangWE, 1, $$v)
      },
      expression: "getSettingsInterface.RangWE[1]"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[8]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Adio')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons['adio'] == 0,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsInterface.RangADIOtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "RangADIOtype", $$v)
      },
      expression: "getSettingsInterface.RangADIOtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Manual'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Dynamic'),
      "value": "1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[9]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Manual')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangADIOtype == 1 || _vm.getSettingsAddons['adio'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangADIO[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangADIO, 0, $$v)
      },
      expression: "getSettingsInterface.RangADIO[0]"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangADIOtype == 1 || _vm.getSettingsAddons['adio'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangADIO[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangADIO, 1, $$v)
      },
      expression: "getSettingsInterface.RangADIO[1]"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[10]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/noiseTriggerLevel')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.getSettingsInterface.showNoiseTriggerLevel),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "showNoiseTriggerLevel", $$v)
      },
      expression: "getSettingsInterface.showNoiseTriggerLevel"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "export"
  }, [_c('div', {
    staticClass: "export-download print",
    on: {
      "click": function($event) {
        return _vm.printChart()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('graphs/export/Print chart')) + " ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "export-download png-download",
    on: {
      "click": function($event) {
        return _vm.downloadPNG()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('graphs/export/Download')) + " PNG " + _vm._s(_vm.$l('graphs/export/image')) + "  ")]), _vm._v(" "), _c('div', {
    staticClass: "export-download jpeg-download",
    on: {
      "click": function($event) {
        return _vm.downloadJPEG()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('graphs/export/Download')) + " JPEG " + _vm._s(_vm.$l('graphs/export/image')) + "  ")]), _vm._v(" "), _c('div', {
    staticClass: "export-download pdf-download",
    on: {
      "click": function($event) {
        return _vm.downloadPDF()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('graphs/export/Download')) + " PDF  ")]), _vm._v(" "), _c('div', {
    staticClass: "export-download svg-download",
    on: {
      "click": function($event) {
        return _vm.downloadSVG()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('graphs/export/Download')) + " SVG " + _vm._s(_vm.$l('graphs/export/image')) + "  ")])])
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.isDownloading) ? _c('div', {
    staticClass: "downloading-bar"
  }, [_c('div', {
    staticClass: "download-content"
  }, [_c('el-progress', {
    staticClass: "download-progress",
    attrs: {
      "customClass": "download-progress",
      "width": 40,
      "type": "circle",
      "percentage": _vm.getDownloading.progress
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "download-title"
  }, [_vm._v(_vm._s((_vm.getDownloading.preparing) ? _vm.$l('main/preparingFile') : _vm.$l('main/downloadingFile')) + " ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header",
    class: _vm.isDownloading ? 'header-downloading' : ''
  }, [_c('div', {
    staticClass: "menu-icon",
    attrs: {
      "title": _vm.$l('calendar/title')
    },
    on: {
      "click": _vm.menuOnClick
    }
  }, [_c('i', {
    staticClass: "el-icon-menu"
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "download-button",
    attrs: {
      "title": _vm.$l('main/titleStatistics')
    },
    on: {
      "click": function($event) {
        return _vm.onStatisticsClick()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "line-chart"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "download-button",
    attrs: {
      "title": _vm.$l('main/titleManual')
    },
    on: {
      "click": function($event) {
        return _vm.goToManual()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "question"
    }
  })], 1), _vm._v(" "), _c('el-popover', {
    ref: "download-button-popover",
    attrs: {
      "placement": "bottom",
      "width": "150",
      "trigger": "click"
    }
  }, [_c('download-popover')], 1), _vm._v(" "), (_vm.$p('download')) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDownloads),
      expression: "showDownloads"
    }, {
      name: "popover",
      rawName: "v-popover:download-button-popover",
      arg: "download-button-popover"
    }],
    staticClass: "download-button",
    attrs: {
      "title": _vm.$l('main/titleDownload')
    }
  }, [_c('icon', {
    attrs: {
      "name": "download"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-popover', {
    ref: "archives-button-popover",
    attrs: {
      "placement": "bottom",
      "width": "150",
      "trigger": "click"
    }
  }, [_c('archive-popover')], 1), _vm._v(" "), (_vm.$p('archives')) ? _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:archives-button-popover",
      arg: "archives-button-popover"
    }],
    staticClass: "archives-button el-icon-document",
    class: {
      'menu-icon-enabled': _vm.isArchives
    },
    attrs: {
      "title": _vm.$l('main/titleArchives')
    }
  }) : _vm._e(), _vm._v(" "), _c('el-popover', {
    ref: "stream-button-popover",
    attrs: {
      "placement": "bottom",
      "width": "300",
      "trigger": "click"
    }
  }, [_c('stream-popover')], 1), _vm._v(" "), (_vm.$p('streamPopover/enabled')) ? _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:stream-button-popover",
      arg: "stream-button-popover"
    }],
    staticClass: "stream-button",
    attrs: {
      "title": _vm.$l('main/titleStream')
    }
  }, [_c('icon', {
    attrs: {
      "name": "volume-up"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-popover', {
    ref: "play-button-popover",
    attrs: {
      "placement": "bottom",
      "width": "150",
      "trigger": "click"
    }
  }, [_c('play-popover')], 1), _vm._v(" "), (_vm.$p('realtime')) ? _c('div', {
    staticClass: "realtime-button el-icon-time",
    class: {
      'realtime-enabled': _vm.getRealtimeEnabled
    },
    attrs: {
      "title": _vm.$l('main/titleRealtime')
    },
    on: {
      "click": _vm.toggleRealtime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$p('measurement/enabled')) ? _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:play-button-popover",
      arg: "play-button-popover"
    }],
    staticClass: "play-button",
    class: _vm.playButtonClass,
    attrs: {
      "title": (_vm.playButtonClass.danger) ? _vm.$l('main/titleDanger') : ((_vm.playButtonClass.warning) ? _vm.$l('main/titleWarning') : _vm.$l('main/titlePlay'))
    }
  }, [_c('div', {
    staticClass: "play-button-inside"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/enabled')) ? _c('div', {
    staticClass: "settings-button el-icon-setting",
    class: {
      'menu-icon-enabled': _vm.isSettings
    },
    attrs: {
      "title": _vm.$l('main/titleSettings')
    },
    on: {
      "click": function($event) {
        return _vm.navigateToSettings()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logout-button",
    attrs: {
      "title": _vm.$l('main/titleLogout')
    },
    on: {
      "click": function($event) {
        return _vm.logoutClicked()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "sign-out"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: _vm.isDownloading ? 'main-downloading' : ''
  }, [_c('calendar-container', {
    attrs: {
      "screenSize": _vm.screenSize,
      "sidebarVisible": _vm.sidebarVisible
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.contentClassname
  }, [(_vm.statusMessage) ? _c('div', {
    staticClass: "top-error-message"
  }, [_vm._v(_vm._s(_vm.$l('errors/' + _vm.statusMessage.split(":")[0]) + (_vm.statusMessage.indexOf(':') > -1 ? (": " + _vm.$l('codes/' + _vm.statusMessage.split(":")[1])) : '')))]) : _vm._e(), _vm._v(" "), (_vm.sdStatusMessage) ? _c('div', {
    staticClass: "top-error-message"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$l('main/titleSD'))), _c('span', [_vm._v(" " + _vm._s(_vm.roundDecimal) + "% ")]), _vm._v(" (" + _vm._s(_vm.$l('settings/status/of')) + " 2 Gb)")]) : _vm._e(), _vm._v(" "), (_vm.hddStatusMessage) ? _c('div', {
    staticClass: "top-error-message"
  }, [_vm._v(_vm._s(_vm.$l('main/titleHDD'))), _c('span', [_vm._v(" " + _vm._s(_vm.roundDecimalHDD) + "% ")])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "circle noise"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$l('calendar/noise')))])]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "circle audio"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$l('calendar/audio')))])]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "circle weather"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$l('calendar/weather')))])]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "circle video"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$l('calendar/video')))])]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "circle adio"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$l('calendar/adio')))])])])
},staticRenderFns: []}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show) ? _c('audio', {
    staticClass: "audioControls",
    attrs: {
      "controls": "controls",
      "preload": "none"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.src
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ })
],[267]);


// WEBPACK FOOTER //
// static/js/app.df1f1898ce704203b117.js